/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Instant Booking API
 * Spazious public JSON:API v3 specification
 *
 * The version of the OpenAPI document: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration.js';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common.js';
import type { RequestArgs } from './base.js';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base.js';

/**
 * 
 * @export
 * @interface AccountCommissionWrite
 */
export interface AccountCommissionWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof AccountCommissionWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof AccountCommissionWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof AccountCommissionWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {AccountCommissionWriteAttributes}
     * @memberof AccountCommissionWrite
     */
    'attributes'?: AccountCommissionWriteAttributes;
}
/**
 * 
 * @export
 * @interface AccountCommissionWriteAttributes
 */
export interface AccountCommissionWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof AccountCommissionWriteAttributes
     */
    'commissionAudiovisual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountCommissionWriteAttributes
     */
    'commissionExtraServices'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountCommissionWriteAttributes
     */
    'commissionFb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountCommissionWriteAttributes
     */
    'commissionGuestRoom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountCommissionWriteAttributes
     */
    'commissionMeetingRoom'?: string | null;
}
/**
 * 
 * @export
 * @interface AccountEmail
 */
export interface AccountEmail {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof AccountEmail
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof AccountEmail
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof AccountEmail
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {AccountEmailAttributes}
     * @memberof AccountEmail
     */
    'attributes'?: AccountEmailAttributes;
}
/**
 * 
 * @export
 * @interface AccountEmailAttributes
 */
export interface AccountEmailAttributes {
    /**
     * 
     * @type {Array<AccountEmailAttributesEmailsToNotifyInner>}
     * @memberof AccountEmailAttributes
     */
    'emailsToNotify': Array<AccountEmailAttributesEmailsToNotifyInner>;
}
/**
 * 
 * @export
 * @interface AccountEmailAttributesEmailsToNotifyInner
 */
export interface AccountEmailAttributesEmailsToNotifyInner {
    /**
     * 
     * @type {string}
     * @memberof AccountEmailAttributesEmailsToNotifyInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AccountEmailAttributesEmailsToNotifyInner
     */
    'language'?: AccountEmailAttributesEmailsToNotifyInnerLanguageEnum;
}

export const AccountEmailAttributesEmailsToNotifyInnerLanguageEnum = {
    En: 'en',
    Es: 'es'
} as const;

export type AccountEmailAttributesEmailsToNotifyInnerLanguageEnum = typeof AccountEmailAttributesEmailsToNotifyInnerLanguageEnum[keyof typeof AccountEmailAttributesEmailsToNotifyInnerLanguageEnum];

/**
 * 
 * @export
 * @interface AccountMerge
 */
export interface AccountMerge {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof AccountMerge
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof AccountMerge
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof AccountMerge
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {AccountMergeRelationships}
     * @memberof AccountMerge
     */
    'relationships'?: AccountMergeRelationships;
}
/**
 * 
 * @export
 * @interface AccountMergeRelationships
 */
export interface AccountMergeRelationships {
    /**
     * 
     * @type {Reltomany}
     * @memberof AccountMergeRelationships
     */
    'fromAccounts': Reltomany;
}
/**
 * 
 * @export
 * @interface AccountRead
 */
export interface AccountRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof AccountRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof AccountRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof AccountRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {AccountReadAttributes}
     * @memberof AccountRead
     */
    'attributes'?: AccountReadAttributes;
    /**
     * 
     * @type {AccountReadRelationships}
     * @memberof AccountRead
     */
    'relationships'?: AccountReadRelationships;
}
/**
 * 
 * @export
 * @interface AccountReadAttributes
 */
export interface AccountReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'accountType'?: AccountReadAttributesAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'commissionAudiovisual'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'commissionExtraServices'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'commissionFb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'commissionGuestRoom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'commissionMeetingRoom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'companyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'iataNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'status': AccountReadAttributesStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountReadAttributes
     */
    'taxId'?: string;
}

export const AccountReadAttributesAccountTypeEnum = {
    Agency: 'agency',
    Company: 'company',
    Individual: 'individual'
} as const;

export type AccountReadAttributesAccountTypeEnum = typeof AccountReadAttributesAccountTypeEnum[keyof typeof AccountReadAttributesAccountTypeEnum];
export const AccountReadAttributesStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;

export type AccountReadAttributesStatusEnum = typeof AccountReadAttributesStatusEnum[keyof typeof AccountReadAttributesStatusEnum];

/**
 * 
 * @export
 * @interface AccountReadRelationships
 */
export interface AccountReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof AccountReadRelationships
     */
    'city'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof AccountReadRelationships
     */
    'country'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof AccountReadRelationships
     */
    'hotelChain': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof AccountReadRelationships
     */
    'owner'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof AccountReadRelationships
     */
    'region'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof AccountReadRelationships
     */
    'segmentationType'?: Reltoone;
}
/**
 * 
 * @export
 * @interface AccountSegmentationTypeChoiceRead
 */
export interface AccountSegmentationTypeChoiceRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof AccountSegmentationTypeChoiceRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof AccountSegmentationTypeChoiceRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof AccountSegmentationTypeChoiceRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderIndustryTypeChoiceReadAttributes}
     * @memberof AccountSegmentationTypeChoiceRead
     */
    'attributes'?: OrderIndustryTypeChoiceReadAttributes;
    /**
     * 
     * @type {OrderCancelReasonChoiceReadRelationships}
     * @memberof AccountSegmentationTypeChoiceRead
     */
    'relationships'?: OrderCancelReasonChoiceReadRelationships;
}
/**
 * 
 * @export
 * @interface AccountSegmentationTypeChoiceWrite
 */
export interface AccountSegmentationTypeChoiceWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof AccountSegmentationTypeChoiceWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof AccountSegmentationTypeChoiceWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof AccountSegmentationTypeChoiceWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderIndustryTypeChoiceWriteAttributes}
     * @memberof AccountSegmentationTypeChoiceWrite
     */
    'attributes'?: OrderIndustryTypeChoiceWriteAttributes;
    /**
     * 
     * @type {OrderCancelReasonChoiceReadRelationships}
     * @memberof AccountSegmentationTypeChoiceWrite
     */
    'relationships'?: OrderCancelReasonChoiceReadRelationships;
}
/**
 * 
 * @export
 * @interface AccountWrite
 */
export interface AccountWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof AccountWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof AccountWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof AccountWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {AccountWriteAttributes}
     * @memberof AccountWrite
     */
    'attributes'?: AccountWriteAttributes;
    /**
     * 
     * @type {AccountWriteRelationships}
     * @memberof AccountWrite
     */
    'relationships'?: AccountWriteRelationships;
}
/**
 * 
 * @export
 * @interface AccountWriteAttributes
 */
export interface AccountWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof AccountWriteAttributes
     */
    'accountType'?: AccountWriteAttributesAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountWriteAttributes
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountWriteAttributes
     */
    'companyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountWriteAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountWriteAttributes
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountWriteAttributes
     */
    'iataNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountWriteAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AccountWriteAttributes
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountWriteAttributes
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountWriteAttributes
     */
    'status'?: AccountWriteAttributesStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountWriteAttributes
     */
    'taxId'?: string;
}

export const AccountWriteAttributesAccountTypeEnum = {
    Agency: 'agency',
    Company: 'company',
    Individual: 'individual'
} as const;

export type AccountWriteAttributesAccountTypeEnum = typeof AccountWriteAttributesAccountTypeEnum[keyof typeof AccountWriteAttributesAccountTypeEnum];
export const AccountWriteAttributesStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;

export type AccountWriteAttributesStatusEnum = typeof AccountWriteAttributesStatusEnum[keyof typeof AccountWriteAttributesStatusEnum];

/**
 * 
 * @export
 * @interface AccountWriteRelationships
 */
export interface AccountWriteRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof AccountWriteRelationships
     */
    'city'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof AccountWriteRelationships
     */
    'country'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof AccountWriteRelationships
     */
    'owner'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof AccountWriteRelationships
     */
    'region'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof AccountWriteRelationships
     */
    'segmentationType'?: Reltoone;
}
/**
 * 
 * @export
 * @interface CityRead
 */
export interface CityRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof CityRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof CityRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof CityRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {CityReadAttributes}
     * @memberof CityRead
     */
    'attributes'?: CityReadAttributes;
    /**
     * 
     * @type {CityReadRelationships}
     * @memberof CityRead
     */
    'relationships'?: CityReadRelationships;
}
/**
 * 
 * @export
 * @interface CityReadAttributes
 */
export interface CityReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof CityReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CityReadAttributes
     */
    'slug'?: string;
}
/**
 * 
 * @export
 * @interface CityReadRelationships
 */
export interface CityReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof CityReadRelationships
     */
    'country': Reltoone;
}
/**
 * 
 * @export
 * @interface ConfirmBookingCartIdConfirm201Response
 */
export interface ConfirmBookingCartIdConfirm201Response {
    /**
     * 
     * @type {GenericOrderConfirm}
     * @memberof ConfirmBookingCartIdConfirm201Response
     */
    'data': GenericOrderConfirm;
    /**
     * 
     * @type {Set<Include>}
     * @memberof ConfirmBookingCartIdConfirm201Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof ConfirmBookingCartIdConfirm201Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof ConfirmBookingCartIdConfirm201Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface ConfirmBookingCartIdConfirmRequest
 */
export interface ConfirmBookingCartIdConfirmRequest {
    /**
     * 
     * @type {ConfirmBookingCartIdConfirmRequestData}
     * @memberof ConfirmBookingCartIdConfirmRequest
     */
    'data': ConfirmBookingCartIdConfirmRequestData;
}
/**
 * 
 * @export
 * @interface ConfirmBookingCartIdConfirmRequestData
 */
export interface ConfirmBookingCartIdConfirmRequestData {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestData
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestData
     */
    'id'?: string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof ConfirmBookingCartIdConfirmRequestData
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {ConfirmBookingCartIdConfirmRequestDataAttributes}
     * @memberof ConfirmBookingCartIdConfirmRequestData
     */
    'attributes'?: ConfirmBookingCartIdConfirmRequestDataAttributes;
    /**
     * 
     * @type {ConfirmBookingCartIdConfirmRequestDataRelationships}
     * @memberof ConfirmBookingCartIdConfirmRequestData
     */
    'relationships'?: ConfirmBookingCartIdConfirmRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface ConfirmBookingCartIdConfirmRequestDataAttributes
 */
export interface ConfirmBookingCartIdConfirmRequestDataAttributes {
    /**
     * 
     * @type {number}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributes
     */
    'attendees'?: number | null;
    /**
     * 
     * @type {ConfirmBookingCartIdConfirmRequestDataAttributesContact}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributes
     */
    'contact': ConfirmBookingCartIdConfirmRequestDataAttributesContact;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributes
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributes
     */
    'recaptchaResponseToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributes
     */
    'segmentationType': ConfirmBookingCartIdConfirmRequestDataAttributesSegmentationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributes
     */
    'startDate'?: string | null;
}

export const ConfirmBookingCartIdConfirmRequestDataAttributesSegmentationTypeEnum = {
    Congress: 'CONGRESS',
    GroupTravel: 'GROUP_TRAVEL',
    Incentives: 'INCENTIVES',
    MeetingOrConference: 'MEETING_OR_CONFERENCE',
    SocialEvent: 'SOCIAL_EVENT',
    Wedding: 'WEDDING'
} as const;

export type ConfirmBookingCartIdConfirmRequestDataAttributesSegmentationTypeEnum = typeof ConfirmBookingCartIdConfirmRequestDataAttributesSegmentationTypeEnum[keyof typeof ConfirmBookingCartIdConfirmRequestDataAttributesSegmentationTypeEnum];

/**
 * 
 * @export
 * @interface ConfirmBookingCartIdConfirmRequestDataAttributesContact
 */
export interface ConfirmBookingCartIdConfirmRequestDataAttributesContact {
    /**
     * 
     * @type {ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContact
     */
    'account': ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContact
     */
    'address': string;
    /**
     * 
     * @type {number}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContact
     */
    'city': number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContact
     */
    'country': number | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContact
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContact
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContact
     */
    'lastName': string;
    /**
     * 
     * @type {number}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContact
     */
    'region': number | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContact
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContact
     */
    'postalCode': string;
}
/**
 * 
 * @export
 * @interface ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount
 */
export interface ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount {
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount
     */
    'accountType'?: ConfirmBookingCartIdConfirmRequestDataAttributesContactAccountAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount
     */
    'address'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount
     */
    'city'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount
     */
    'companyCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount
     */
    'country'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount
     */
    'iataNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount
     */
    'postalCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount
     */
    'region'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmBookingCartIdConfirmRequestDataAttributesContactAccount
     */
    'taxId'?: string;
}

export const ConfirmBookingCartIdConfirmRequestDataAttributesContactAccountAccountTypeEnum = {
    Agency: 'agency',
    Company: 'company',
    Individual: 'individual'
} as const;

export type ConfirmBookingCartIdConfirmRequestDataAttributesContactAccountAccountTypeEnum = typeof ConfirmBookingCartIdConfirmRequestDataAttributesContactAccountAccountTypeEnum[keyof typeof ConfirmBookingCartIdConfirmRequestDataAttributesContactAccountAccountTypeEnum];

/**
 * 
 * @export
 * @interface ConfirmBookingCartIdConfirmRequestDataRelationships
 */
export interface ConfirmBookingCartIdConfirmRequestDataRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof ConfirmBookingCartIdConfirmRequestDataRelationships
     */
    'clientCurrency': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof ConfirmBookingCartIdConfirmRequestDataRelationships
     */
    'paymentOption'?: Reltoone;
}
/**
 * 
 * @export
 * @interface ContactMoveAccount
 */
export interface ContactMoveAccount {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof ContactMoveAccount
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof ContactMoveAccount
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof ContactMoveAccount
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {ContactMoveAccountRelationships}
     * @memberof ContactMoveAccount
     */
    'relationships'?: ContactMoveAccountRelationships;
}
/**
 * 
 * @export
 * @interface ContactMoveAccountRelationships
 */
export interface ContactMoveAccountRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof ContactMoveAccountRelationships
     */
    'toAccount': Reltoone;
}
/**
 * 
 * @export
 * @interface ContactRead
 */
export interface ContactRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof ContactRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof ContactRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof ContactRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {ContactReadAttributes}
     * @memberof ContactRead
     */
    'attributes'?: ContactReadAttributes;
    /**
     * 
     * @type {ContactReadRelationships}
     * @memberof ContactRead
     */
    'relationships'?: ContactReadRelationships;
}
/**
 * 
 * @export
 * @interface ContactReadAttributes
 */
export interface ContactReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof ContactReadAttributes
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactReadAttributes
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ContactReadAttributes
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactReadAttributes
     */
    'lastName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContactReadAttributes
     */
    'notificationsEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContactReadAttributes
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactReadAttributes
     */
    'postalCode'?: string;
}
/**
 * 
 * @export
 * @interface ContactReadRelationships
 */
export interface ContactReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof ContactReadRelationships
     */
    'account': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof ContactReadRelationships
     */
    'city'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof ContactReadRelationships
     */
    'country'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof ContactReadRelationships
     */
    'region'?: Reltoone;
}
/**
 * 
 * @export
 * @interface ContactWrite
 */
export interface ContactWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof ContactWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof ContactWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof ContactWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {ContactReadAttributes}
     * @memberof ContactWrite
     */
    'attributes'?: ContactReadAttributes;
    /**
     * 
     * @type {ContactReadRelationships}
     * @memberof ContactWrite
     */
    'relationships'?: ContactReadRelationships;
}
/**
 * 
 * @export
 * @interface CreateBookingCart201Response
 */
export interface CreateBookingCart201Response {
    /**
     * 
     * @type {GenericOrderWrite}
     * @memberof CreateBookingCart201Response
     */
    'data': GenericOrderWrite;
    /**
     * 
     * @type {Set<Include>}
     * @memberof CreateBookingCart201Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof CreateBookingCart201Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof CreateBookingCart201Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface CreateBookingCartActivitiesRequest
 */
export interface CreateBookingCartActivitiesRequest {
    /**
     * 
     * @type {CreateBookingCartActivitiesRequestData}
     * @memberof CreateBookingCartActivitiesRequest
     */
    'data': CreateBookingCartActivitiesRequestData;
}
/**
 * 
 * @export
 * @interface CreateBookingCartActivitiesRequestData
 */
export interface CreateBookingCartActivitiesRequestData {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof CreateBookingCartActivitiesRequestData
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof CreateBookingCartActivitiesRequestData
     */
    'id'?: string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof CreateBookingCartActivitiesRequestData
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {CreateBookingCartActivitiesRequestDataAttributes}
     * @memberof CreateBookingCartActivitiesRequestData
     */
    'attributes'?: CreateBookingCartActivitiesRequestDataAttributes;
    /**
     * 
     * @type {CreateBookingCartActivitiesRequestDataRelationships}
     * @memberof CreateBookingCartActivitiesRequestData
     */
    'relationships'?: CreateBookingCartActivitiesRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface CreateBookingCartActivitiesRequestDataAttributes
 */
export interface CreateBookingCartActivitiesRequestDataAttributes {
    /**
     * 
     * @type {number}
     * @memberof CreateBookingCartActivitiesRequestDataAttributes
     */
    'attendees': number;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingCartActivitiesRequestDataAttributes
     */
    'checkInAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingCartActivitiesRequestDataAttributes
     */
    'checkOutAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingCartActivitiesRequestDataAttributes
     */
    'customerNotes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingCartActivitiesRequestDataAttributes
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateBookingCartActivitiesRequestDataRelationships
 */
export interface CreateBookingCartActivitiesRequestDataRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingCartActivitiesRequestDataRelationships
     */
    'hotel'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingCartActivitiesRequestDataRelationships
     */
    'meetingRoom': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingCartActivitiesRequestDataRelationships
     */
    'meetingRoomSetup'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingCartActivitiesRequestDataRelationships
     */
    'order': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingCartActivitiesRequestDataRelationships
     */
    'roomDiagram'?: Reltoone;
}
/**
 * 
 * @export
 * @interface CreateBookingCartEventPackagesRequest
 */
export interface CreateBookingCartEventPackagesRequest {
    /**
     * 
     * @type {CreateBookingCartEventPackagesRequestData}
     * @memberof CreateBookingCartEventPackagesRequest
     */
    'data': CreateBookingCartEventPackagesRequestData;
}
/**
 * 
 * @export
 * @interface CreateBookingCartEventPackagesRequestData
 */
export interface CreateBookingCartEventPackagesRequestData {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof CreateBookingCartEventPackagesRequestData
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof CreateBookingCartEventPackagesRequestData
     */
    'id'?: string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof CreateBookingCartEventPackagesRequestData
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {CreateBookingCartEventPackagesRequestDataAttributes}
     * @memberof CreateBookingCartEventPackagesRequestData
     */
    'attributes'?: CreateBookingCartEventPackagesRequestDataAttributes;
    /**
     * 
     * @type {CreateBookingCartEventPackagesRequestDataRelationships}
     * @memberof CreateBookingCartEventPackagesRequestData
     */
    'relationships'?: CreateBookingCartEventPackagesRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface CreateBookingCartEventPackagesRequestDataAttributes
 */
export interface CreateBookingCartEventPackagesRequestDataAttributes {
    /**
     * 
     * @type {number}
     * @memberof CreateBookingCartEventPackagesRequestDataAttributes
     */
    'attendees'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingCartEventPackagesRequestDataAttributes
     */
    'startDate': string;
}
/**
 * 
 * @export
 * @interface CreateBookingCartEventPackagesRequestDataRelationships
 */
export interface CreateBookingCartEventPackagesRequestDataRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingCartEventPackagesRequestDataRelationships
     */
    'eventPackage': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingCartEventPackagesRequestDataRelationships
     */
    'order': Reltoone;
}
/**
 * 
 * @export
 * @interface CreateBookingCartGuestRoomsRequest
 */
export interface CreateBookingCartGuestRoomsRequest {
    /**
     * 
     * @type {CreateBookingCartGuestRoomsRequestData}
     * @memberof CreateBookingCartGuestRoomsRequest
     */
    'data': CreateBookingCartGuestRoomsRequestData;
}
/**
 * 
 * @export
 * @interface CreateBookingCartGuestRoomsRequestData
 */
export interface CreateBookingCartGuestRoomsRequestData {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof CreateBookingCartGuestRoomsRequestData
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof CreateBookingCartGuestRoomsRequestData
     */
    'id'?: string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof CreateBookingCartGuestRoomsRequestData
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {CreateBookingCartGuestRoomsRequestDataAttributes}
     * @memberof CreateBookingCartGuestRoomsRequestData
     */
    'attributes'?: CreateBookingCartGuestRoomsRequestDataAttributes;
    /**
     * 
     * @type {CreateBookingCartGuestRoomsRequestDataRelationships}
     * @memberof CreateBookingCartGuestRoomsRequestData
     */
    'relationships'?: CreateBookingCartGuestRoomsRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface CreateBookingCartGuestRoomsRequestDataAttributes
 */
export interface CreateBookingCartGuestRoomsRequestDataAttributes {
    /**
     * 
     * @type {string}
     * @memberof CreateBookingCartGuestRoomsRequestDataAttributes
     */
    'checkIn': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingCartGuestRoomsRequestDataAttributes
     */
    'checkOut': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingCartGuestRoomsRequestDataAttributes
     */
    'occupancyType': CreateBookingCartGuestRoomsRequestDataAttributesOccupancyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingCartGuestRoomsRequestDataAttributes
     */
    'rentalType': CreateBookingCartGuestRoomsRequestDataAttributesRentalTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateBookingCartGuestRoomsRequestDataAttributes
     */
    'units'?: number;
}

export const CreateBookingCartGuestRoomsRequestDataAttributesOccupancyTypeEnum = {
    Single10: 'single-1-0',
    Double20: 'double-2-0',
    Double11: 'double-1-1',
    Triple30: 'triple-3-0',
    Triple21: 'triple-2-1',
    Triple12: 'triple-1-2',
    Quadruple40: 'quadruple-4-0',
    Quadruple31: 'quadruple-3-1',
    Quadruple22: 'quadruple-2-2',
    Quadruple13: 'quadruple-1-3',
    Quintuple50: 'quintuple-5-0',
    Quintuple41: 'quintuple-4-1',
    Quintuple32: 'quintuple-3-2',
    Quintuple23: 'quintuple-2-3',
    Quintuple14: 'quintuple-1-4'
} as const;

export type CreateBookingCartGuestRoomsRequestDataAttributesOccupancyTypeEnum = typeof CreateBookingCartGuestRoomsRequestDataAttributesOccupancyTypeEnum[keyof typeof CreateBookingCartGuestRoomsRequestDataAttributesOccupancyTypeEnum];
export const CreateBookingCartGuestRoomsRequestDataAttributesRentalTypeEnum = {
    Accommodation: 'accommodation',
    Breakfast: 'breakfast',
    FullBoard: 'full-board',
    HalfBoard: 'half-board',
    AllInclusive: 'all-inclusive'
} as const;

export type CreateBookingCartGuestRoomsRequestDataAttributesRentalTypeEnum = typeof CreateBookingCartGuestRoomsRequestDataAttributesRentalTypeEnum[keyof typeof CreateBookingCartGuestRoomsRequestDataAttributesRentalTypeEnum];

/**
 * 
 * @export
 * @interface CreateBookingCartGuestRoomsRequestDataRelationships
 */
export interface CreateBookingCartGuestRoomsRequestDataRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingCartGuestRoomsRequestDataRelationships
     */
    'guestRoom': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingCartGuestRoomsRequestDataRelationships
     */
    'order': Reltoone;
}
/**
 * 
 * @export
 * @interface CreateBookingCartRequest
 */
export interface CreateBookingCartRequest {
    /**
     * 
     * @type {CreateBookingCartRequestData}
     * @memberof CreateBookingCartRequest
     */
    'data': CreateBookingCartRequestData;
}
/**
 * 
 * @export
 * @interface CreateBookingCartRequestData
 */
export interface CreateBookingCartRequestData {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof CreateBookingCartRequestData
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof CreateBookingCartRequestData
     */
    'id'?: string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof CreateBookingCartRequestData
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {object}
     * @memberof CreateBookingCartRequestData
     */
    'attributes'?: object;
    /**
     * 
     * @type {CreateBookingCartRequestDataRelationships}
     * @memberof CreateBookingCartRequestData
     */
    'relationships'?: CreateBookingCartRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface CreateBookingCartRequestDataRelationships
 */
export interface CreateBookingCartRequestDataRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingCartRequestDataRelationships
     */
    'hotel': Reltoone;
}
/**
 * 
 * @export
 * @interface CreateBookingCartServicesRequest
 */
export interface CreateBookingCartServicesRequest {
    /**
     * 
     * @type {CreateBookingCartServicesRequestData}
     * @memberof CreateBookingCartServicesRequest
     */
    'data': CreateBookingCartServicesRequestData;
}
/**
 * 
 * @export
 * @interface CreateBookingCartServicesRequestData
 */
export interface CreateBookingCartServicesRequestData {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof CreateBookingCartServicesRequestData
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof CreateBookingCartServicesRequestData
     */
    'id'?: string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof CreateBookingCartServicesRequestData
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {PartialUpdateBookingCartServicesIdRequestDataAttributes}
     * @memberof CreateBookingCartServicesRequestData
     */
    'attributes'?: PartialUpdateBookingCartServicesIdRequestDataAttributes;
    /**
     * 
     * @type {CreateBookingCartServicesRequestDataRelationships}
     * @memberof CreateBookingCartServicesRequestData
     */
    'relationships'?: CreateBookingCartServicesRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface CreateBookingCartServicesRequestDataRelationships
 */
export interface CreateBookingCartServicesRequestDataRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingCartServicesRequestDataRelationships
     */
    'activity'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingCartServicesRequestDataRelationships
     */
    'hotel'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingCartServicesRequestDataRelationships
     */
    'order': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingCartServicesRequestDataRelationships
     */
    'service': Reltoone;
}
/**
 * 
 * @export
 * @interface CreateBookingPlannerRfp201Response
 */
export interface CreateBookingPlannerRfp201Response {
    /**
     * 
     * @type {PlannerRFP}
     * @memberof CreateBookingPlannerRfp201Response
     */
    'data': PlannerRFP;
    /**
     * 
     * @type {Set<Include>}
     * @memberof CreateBookingPlannerRfp201Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof CreateBookingPlannerRfp201Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof CreateBookingPlannerRfp201Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface CreateBookingPlannerRfpRequest
 */
export interface CreateBookingPlannerRfpRequest {
    /**
     * 
     * @type {CreateBookingPlannerRfpRequestData}
     * @memberof CreateBookingPlannerRfpRequest
     */
    'data': CreateBookingPlannerRfpRequestData;
}
/**
 * 
 * @export
 * @interface CreateBookingPlannerRfpRequestData
 */
export interface CreateBookingPlannerRfpRequestData {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof CreateBookingPlannerRfpRequestData
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof CreateBookingPlannerRfpRequestData
     */
    'id'?: string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof CreateBookingPlannerRfpRequestData
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {CreateBookingPlannerRfpRequestDataAttributes}
     * @memberof CreateBookingPlannerRfpRequestData
     */
    'attributes'?: CreateBookingPlannerRfpRequestDataAttributes;
    /**
     * 
     * @type {CreateBookingPlannerRfpRequestDataRelationships}
     * @memberof CreateBookingPlannerRfpRequestData
     */
    'relationships'?: CreateBookingPlannerRfpRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface CreateBookingPlannerRfpRequestDataAttributes
 */
export interface CreateBookingPlannerRfpRequestDataAttributes {
    /**
     * 
     * @type {string}
     * @memberof CreateBookingPlannerRfpRequestDataAttributes
     */
    'accountName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingPlannerRfpRequestDataAttributes
     */
    'accountType': CreateBookingPlannerRfpRequestDataAttributesAccountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateBookingPlannerRfpRequestDataAttributes
     */
    'attendees'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingPlannerRfpRequestDataAttributes
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingPlannerRfpRequestDataAttributes
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingPlannerRfpRequestDataAttributes
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {Array<PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributesFurnituresInner>}
     * @memberof CreateBookingPlannerRfpRequestDataAttributes
     */
    'furnitures'?: Array<PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributesFurnituresInner>;
    /**
     * 
     * @type {object}
     * @memberof CreateBookingPlannerRfpRequestDataAttributes
     */
    'graph': object;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingPlannerRfpRequestDataAttributes
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingPlannerRfpRequestDataAttributes
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingPlannerRfpRequestDataAttributes
     */
    'segmentationType'?: CreateBookingPlannerRfpRequestDataAttributesSegmentationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateBookingPlannerRfpRequestDataAttributes
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {Array<CreateBookingPlannerRfpRequestDataAttributesVirtualObjectsInner>}
     * @memberof CreateBookingPlannerRfpRequestDataAttributes
     */
    'virtualObjects'?: Array<CreateBookingPlannerRfpRequestDataAttributesVirtualObjectsInner>;
}

export const CreateBookingPlannerRfpRequestDataAttributesAccountTypeEnum = {
    Agency: 'agency',
    Company: 'company',
    Individual: 'individual'
} as const;

export type CreateBookingPlannerRfpRequestDataAttributesAccountTypeEnum = typeof CreateBookingPlannerRfpRequestDataAttributesAccountTypeEnum[keyof typeof CreateBookingPlannerRfpRequestDataAttributesAccountTypeEnum];
export const CreateBookingPlannerRfpRequestDataAttributesSegmentationTypeEnum = {
    Congress: 'CONGRESS',
    GroupTravel: 'GROUP_TRAVEL',
    Incentives: 'INCENTIVES',
    MeetingOrConference: 'MEETING_OR_CONFERENCE',
    SocialEvent: 'SOCIAL_EVENT',
    Wedding: 'WEDDING'
} as const;

export type CreateBookingPlannerRfpRequestDataAttributesSegmentationTypeEnum = typeof CreateBookingPlannerRfpRequestDataAttributesSegmentationTypeEnum[keyof typeof CreateBookingPlannerRfpRequestDataAttributesSegmentationTypeEnum];

/**
 * 
 * @export
 * @interface CreateBookingPlannerRfpRequestDataAttributesVirtualObjectsInner
 */
export interface CreateBookingPlannerRfpRequestDataAttributesVirtualObjectsInner {
    /**
     * 
     * @type {number}
     * @memberof CreateBookingPlannerRfpRequestDataAttributesVirtualObjectsInner
     */
    'virtualObject': number;
    /**
     * 
     * @type {number}
     * @memberof CreateBookingPlannerRfpRequestDataAttributesVirtualObjectsInner
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface CreateBookingPlannerRfpRequestDataRelationships
 */
export interface CreateBookingPlannerRfpRequestDataRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingPlannerRfpRequestDataRelationships
     */
    'hotel': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingPlannerRfpRequestDataRelationships
     */
    'subsegmentation'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof CreateBookingPlannerRfpRequestDataRelationships
     */
    'virtualMeetingRoom': Reltoone;
}
/**
 * 
 * @export
 * @interface CurrencyRead
 */
export interface CurrencyRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof CurrencyRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof CurrencyRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof CurrencyRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {CurrencyReadAttributes}
     * @memberof CurrencyRead
     */
    'attributes'?: CurrencyReadAttributes;
}
/**
 * 
 * @export
 * @interface CurrencyReadAttributes
 */
export interface CurrencyReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof CurrencyReadAttributes
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof CurrencyReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CurrencyReadAttributes
     */
    'leftSymbol'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrencyReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CurrencyReadAttributes
     */
    'symbol': string;
    /**
     * 
     * @type {string}
     * @memberof CurrencyReadAttributes
     */
    'updatedAt'?: string;
}
/**
 * singular item
 * @export
 * @interface Datum
 */
export interface Datum {
    /**
     * 
     * @type {Resource}
     * @memberof Datum
     */
    'data'?: Resource;
}
/**
 * 
 * @export
 * @interface DollhouseSchemaRead
 */
export interface DollhouseSchemaRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof DollhouseSchemaRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof DollhouseSchemaRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof DollhouseSchemaRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {DollhouseSchemaReadAttributes}
     * @memberof DollhouseSchemaRead
     */
    'attributes'?: DollhouseSchemaReadAttributes;
    /**
     * 
     * @type {DollhouseSchemaReadRelationships}
     * @memberof DollhouseSchemaRead
     */
    'relationships'?: DollhouseSchemaReadRelationships;
}
/**
 * 
 * @export
 * @interface DollhouseSchemaReadAttributes
 */
export interface DollhouseSchemaReadAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof DollhouseSchemaReadAttributes
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DollhouseSchemaReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {object}
     * @memberof DollhouseSchemaReadAttributes
     */
    'fields'?: object;
    /**
     * 
     * @type {string}
     * @memberof DollhouseSchemaReadAttributes
     */
    'schemaType': DollhouseSchemaReadAttributesSchemaTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DollhouseSchemaReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DollhouseSchemaReadAttributes
     */
    'uuid'?: string;
}

export const DollhouseSchemaReadAttributesSchemaTypeEnum = {
    TheaterArrangement: 'theater-arrangement',
    BoardroomArrangement: 'boardroom-arrangement',
    CabaretArrangement: 'cabaret-arrangement',
    ClassroomArrangement: 'classroom-arrangement',
    RoundArrangement: 'round-arrangement',
    CocktailArrangement: 'cocktail-arrangement',
    UShapeArrangement: 'u-shape-arrangement',
    BoardroomEnsemble: 'boardroom-ensemble',
    CabaretEnsemble: 'cabaret-ensemble',
    ClassroomEnsemble: 'classroom-ensemble',
    RoundEnsemble: 'round-ensemble'
} as const;

export type DollhouseSchemaReadAttributesSchemaTypeEnum = typeof DollhouseSchemaReadAttributesSchemaTypeEnum[keyof typeof DollhouseSchemaReadAttributesSchemaTypeEnum];

/**
 * 
 * @export
 * @interface DollhouseSchemaReadRelationships
 */
export interface DollhouseSchemaReadRelationships {
    /**
     * 
     * @type {Reltomany}
     * @memberof DollhouseSchemaReadRelationships
     */
    'furnitures'?: Reltomany;
    /**
     * 
     * @type {Reltoone}
     * @memberof DollhouseSchemaReadRelationships
     */
    'virtualMeetingRoom': Reltoone;
}
/**
 * 
 * @export
 * @interface EditorRFP
 */
export interface EditorRFP {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EditorRFP
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EditorRFP
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EditorRFP
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EditorRFPAttributes}
     * @memberof EditorRFP
     */
    'attributes'?: EditorRFPAttributes;
    /**
     * 
     * @type {CreateBookingPlannerRfpRequestDataRelationships}
     * @memberof EditorRFP
     */
    'relationships'?: CreateBookingPlannerRfpRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface EditorRFPAttributes
 */
export interface EditorRFPAttributes {
    /**
     * 
     * @type {string}
     * @memberof EditorRFPAttributes
     */
    'accountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditorRFPAttributes
     */
    'accountType'?: EditorRFPAttributesAccountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof EditorRFPAttributes
     */
    'attendees'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EditorRFPAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditorRFPAttributes
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditorRFPAttributes
     */
    'endDate': string | null;
    /**
     * 
     * @type {Array<PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributesFurnituresInner>}
     * @memberof EditorRFPAttributes
     */
    'furnitures'?: Array<PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributesFurnituresInner>;
    /**
     * 
     * @type {object}
     * @memberof EditorRFPAttributes
     */
    'graph': object;
    /**
     * 
     * @type {string}
     * @memberof EditorRFPAttributes
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditorRFPAttributes
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditorRFPAttributes
     */
    'requestsAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditorRFPAttributes
     */
    'segmentationType'?: EditorRFPAttributesSegmentationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EditorRFPAttributes
     */
    'startDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditorRFPAttributes
     */
    'uuid'?: string;
    /**
     * 
     * @type {Array<CreateBookingPlannerRfpRequestDataAttributesVirtualObjectsInner>}
     * @memberof EditorRFPAttributes
     */
    'virtualObjects'?: Array<CreateBookingPlannerRfpRequestDataAttributesVirtualObjectsInner>;
    /**
     * 
     * @type {string}
     * @memberof EditorRFPAttributes
     */
    'virtualMeetingRoomSetup'?: string;
}

export const EditorRFPAttributesAccountTypeEnum = {
    Agency: 'agency',
    Company: 'company',
    Individual: 'individual'
} as const;

export type EditorRFPAttributesAccountTypeEnum = typeof EditorRFPAttributesAccountTypeEnum[keyof typeof EditorRFPAttributesAccountTypeEnum];
export const EditorRFPAttributesSegmentationTypeEnum = {
    Congress: 'CONGRESS',
    GroupTravel: 'GROUP_TRAVEL',
    Incentives: 'INCENTIVES',
    MeetingOrConference: 'MEETING_OR_CONFERENCE',
    SocialEvent: 'SOCIAL_EVENT',
    Wedding: 'WEDDING'
} as const;

export type EditorRFPAttributesSegmentationTypeEnum = typeof EditorRFPAttributesSegmentationTypeEnum[keyof typeof EditorRFPAttributesSegmentationTypeEnum];

/**
 * 
 * @export
 * @interface ErrorSource
 */
export interface ErrorSource {
    /**
     * A [JSON Pointer](https://tools.ietf.org/html/rfc6901) to the associated entity in the request document [e.g. `/data` for a primary data object, or `/data/attributes/title` for a specific attribute.
     * @type {string}
     * @memberof ErrorSource
     */
    'pointer'?: string;
    /**
     * A string indicating which query parameter caused the error.
     * @type {string}
     * @memberof ErrorSource
     */
    'parameter'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ErrorSource
     */
    'meta'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface EventPackageActivityCreate
 */
export interface EventPackageActivityCreate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageActivityCreate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageActivityCreate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageActivityCreate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EventPackageActivityCreateAttributes}
     * @memberof EventPackageActivityCreate
     */
    'attributes'?: EventPackageActivityCreateAttributes;
    /**
     * 
     * @type {EventPackageActivityCreateRelationships}
     * @memberof EventPackageActivityCreate
     */
    'relationships'?: EventPackageActivityCreateRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageActivityCreateAttributes
 */
export interface EventPackageActivityCreateAttributes {
    /**
     * 
     * @type {string}
     * @memberof EventPackageActivityCreateAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageActivityCreateAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof EventPackageActivityCreateAttributes
     */
    'relativeDay': number;
    /**
     * 
     * @type {string}
     * @memberof EventPackageActivityCreateAttributes
     */
    'checkInTime': string;
    /**
     * 
     * @type {number}
     * @memberof EventPackageActivityCreateAttributes
     */
    'durationMinutes': number;
}
/**
 * 
 * @export
 * @interface EventPackageActivityCreateRelationships
 */
export interface EventPackageActivityCreateRelationships {
    /**
     * 
     * @type {Reltomany}
     * @memberof EventPackageActivityCreateRelationships
     */
    'meetingRooms': Reltomany;
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageActivityCreateRelationships
     */
    'eventPackage': Reltoone;
}
/**
 * 
 * @export
 * @interface EventPackageActivityRead
 */
export interface EventPackageActivityRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageActivityRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageActivityRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageActivityRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EventPackageActivityReadAttributes}
     * @memberof EventPackageActivityRead
     */
    'attributes'?: EventPackageActivityReadAttributes;
    /**
     * 
     * @type {EventPackageActivityReadRelationships}
     * @memberof EventPackageActivityRead
     */
    'relationships'?: EventPackageActivityReadRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageActivityReadAttributes
 */
export interface EventPackageActivityReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof EventPackageActivityReadAttributes
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageActivityReadAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof EventPackageActivityReadAttributes
     */
    'relativeDay': number;
    /**
     * 
     * @type {string}
     * @memberof EventPackageActivityReadAttributes
     */
    'checkInTime': string;
    /**
     * 
     * @type {number}
     * @memberof EventPackageActivityReadAttributes
     */
    'durationMinutes': number;
}
/**
 * 
 * @export
 * @interface EventPackageActivityReadRelationships
 */
export interface EventPackageActivityReadRelationships {
    /**
     * 
     * @type {Reltomany}
     * @memberof EventPackageActivityReadRelationships
     */
    'meetingRooms'?: Reltomany;
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageActivityReadRelationships
     */
    'eventPackage': Reltoone;
    /**
     * 
     * @type {Reltomany}
     * @memberof EventPackageActivityReadRelationships
     */
    'services'?: Reltomany;
    /**
     * 
     * @type {Reltomany}
     * @memberof EventPackageActivityReadRelationships
     */
    'translations': Reltomany;
}
/**
 * 
 * @export
 * @interface EventPackageActivityTranslationRead
 */
export interface EventPackageActivityTranslationRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageActivityTranslationRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageActivityTranslationRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageActivityTranslationRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomTranslationReadAttributes}
     * @memberof EventPackageActivityTranslationRead
     */
    'attributes'?: GuestRoomTranslationReadAttributes;
    /**
     * 
     * @type {EventPackageActivityTranslationReadRelationships}
     * @memberof EventPackageActivityTranslationRead
     */
    'relationships'?: EventPackageActivityTranslationReadRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageActivityTranslationReadRelationships
 */
export interface EventPackageActivityTranslationReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageActivityTranslationReadRelationships
     */
    'eventPackageActivity': Reltoone;
}
/**
 * 
 * @export
 * @interface EventPackageActivityTranslationWrite
 */
export interface EventPackageActivityTranslationWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageActivityTranslationWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageActivityTranslationWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageActivityTranslationWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomTranslationWriteAttributes}
     * @memberof EventPackageActivityTranslationWrite
     */
    'attributes'?: GuestRoomTranslationWriteAttributes;
    /**
     * 
     * @type {EventPackageActivityTranslationReadRelationships}
     * @memberof EventPackageActivityTranslationWrite
     */
    'relationships'?: EventPackageActivityTranslationReadRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageActivityUpdate
 */
export interface EventPackageActivityUpdate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageActivityUpdate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageActivityUpdate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageActivityUpdate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EventPackageActivityCreateAttributes}
     * @memberof EventPackageActivityUpdate
     */
    'attributes'?: EventPackageActivityCreateAttributes;
    /**
     * 
     * @type {EventPackageActivityUpdateRelationships}
     * @memberof EventPackageActivityUpdate
     */
    'relationships'?: EventPackageActivityUpdateRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageActivityUpdateRelationships
 */
export interface EventPackageActivityUpdateRelationships {
    /**
     * 
     * @type {Reltomany}
     * @memberof EventPackageActivityUpdateRelationships
     */
    'meetingRooms': Reltomany;
}
/**
 * 
 * @export
 * @interface EventPackageCreate
 */
export interface EventPackageCreate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageCreate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageCreate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageCreate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EventPackageCreateAttributes}
     * @memberof EventPackageCreate
     */
    'attributes'?: EventPackageCreateAttributes;
    /**
     * 
     * @type {CreateBookingCartRequestDataRelationships}
     * @memberof EventPackageCreate
     */
    'relationships'?: CreateBookingCartRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageCreateAttributes
 */
export interface EventPackageCreateAttributes {
    /**
     * 
     * @type {string}
     * @memberof EventPackageCreateAttributes
     */
    'availabilityStatus'?: EventPackageCreateAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof EventPackageCreateAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageCreateAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageCreateAttributes
     */
    'bookingWindowStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageCreateAttributes
     */
    'bookingWindowEndDate': string;
    /**
     * 
     * @type {number}
     * @memberof EventPackageCreateAttributes
     */
    'minAttendees': number;
    /**
     * 
     * @type {number}
     * @memberof EventPackageCreateAttributes
     */
    'maxAttendees': number;
    /**
     * 
     * @type {string}
     * @memberof EventPackageCreateAttributes
     */
    'travelWindowStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageCreateAttributes
     */
    'travelWindowEndDate': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventPackageCreateAttributes
     */
    'segmentationTypes'?: Array<EventPackageCreateAttributesSegmentationTypesEnum>;
}

export const EventPackageCreateAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type EventPackageCreateAttributesAvailabilityStatusEnum = typeof EventPackageCreateAttributesAvailabilityStatusEnum[keyof typeof EventPackageCreateAttributesAvailabilityStatusEnum];
export const EventPackageCreateAttributesSegmentationTypesEnum = {
    Congress: 'CONGRESS',
    GroupTravel: 'GROUP_TRAVEL',
    Incentives: 'INCENTIVES',
    MeetingOrConference: 'MEETING_OR_CONFERENCE',
    SocialEvent: 'SOCIAL_EVENT',
    Wedding: 'WEDDING'
} as const;

export type EventPackageCreateAttributesSegmentationTypesEnum = typeof EventPackageCreateAttributesSegmentationTypesEnum[keyof typeof EventPackageCreateAttributesSegmentationTypesEnum];

/**
 * 
 * @export
 * @interface EventPackageMediaCreateWrite
 */
export interface EventPackageMediaCreateWrite {
    /**
     * 
     * @type {File}
     * @memberof EventPackageMediaCreateWrite
     */
    'image': File;
    /**
     * 
     * @type {number}
     * @memberof EventPackageMediaCreateWrite
     */
    'index'?: number;
    /**
     * 
     * @type {number}
     * @memberof EventPackageMediaCreateWrite
     */
    'event_package': number;
}
/**
 * 
 * @export
 * @interface EventPackageMediaRead
 */
export interface EventPackageMediaRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageMediaRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageMediaRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageMediaRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EventPackageMediaReadAttributes}
     * @memberof EventPackageMediaRead
     */
    'attributes'?: EventPackageMediaReadAttributes;
    /**
     * 
     * @type {EventPackageMediaReadRelationships}
     * @memberof EventPackageMediaRead
     */
    'relationships'?: EventPackageMediaReadRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageMediaReadAttributes
 */
export interface EventPackageMediaReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof EventPackageMediaReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageMediaReadAttributes
     */
    'shortUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageMediaReadAttributes
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageMediaReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {File}
     * @memberof EventPackageMediaReadAttributes
     */
    'image': File;
    /**
     * 
     * @type {number}
     * @memberof EventPackageMediaReadAttributes
     */
    'index'?: number;
}
/**
 * 
 * @export
 * @interface EventPackageMediaReadRelationships
 */
export interface EventPackageMediaReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageMediaReadRelationships
     */
    'eventPackage': Reltoone;
}
/**
 * 
 * @export
 * @interface EventPackageMediaUpdateWrite
 */
export interface EventPackageMediaUpdateWrite {
    /**
     * 
     * @type {File}
     * @memberof EventPackageMediaUpdateWrite
     */
    'image': File;
    /**
     * 
     * @type {number}
     * @memberof EventPackageMediaUpdateWrite
     */
    'index'?: number;
}
/**
 * 
 * @export
 * @interface EventPackageRateCurrencyRead
 */
export interface EventPackageRateCurrencyRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageRateCurrencyRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageRateCurrencyRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageRateCurrencyRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EventPackageRateCurrencyReadAttributes}
     * @memberof EventPackageRateCurrencyRead
     */
    'attributes'?: EventPackageRateCurrencyReadAttributes;
    /**
     * 
     * @type {EventPackageRateCurrencyReadRelationships}
     * @memberof EventPackageRateCurrencyRead
     */
    'relationships'?: EventPackageRateCurrencyReadRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageRateCurrencyReadAttributes
 */
export interface EventPackageRateCurrencyReadAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof EventPackageRateCurrencyReadAttributes
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateCurrencyReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateCurrencyReadAttributes
     */
    'price': string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateCurrencyReadAttributes
     */
    'extraPersonPrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateCurrencyReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateCurrencyReadAttributes
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface EventPackageRateCurrencyReadRelationships
 */
export interface EventPackageRateCurrencyReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageRateCurrencyReadRelationships
     */
    'currency': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageRateCurrencyReadRelationships
     */
    'eventPackageRate': Reltoone;
}
/**
 * 
 * @export
 * @interface EventPackageRateCurrencyWrite
 */
export interface EventPackageRateCurrencyWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageRateCurrencyWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageRateCurrencyWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageRateCurrencyWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EventPackageRateCurrencyWriteAttributes}
     * @memberof EventPackageRateCurrencyWrite
     */
    'attributes'?: EventPackageRateCurrencyWriteAttributes;
    /**
     * 
     * @type {EventPackageRateCurrencyReadRelationships}
     * @memberof EventPackageRateCurrencyWrite
     */
    'relationships'?: EventPackageRateCurrencyReadRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageRateCurrencyWriteAttributes
 */
export interface EventPackageRateCurrencyWriteAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof EventPackageRateCurrencyWriteAttributes
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateCurrencyWriteAttributes
     */
    'price': string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateCurrencyWriteAttributes
     */
    'extraPersonPrice'?: string | null;
}
/**
 * 
 * @export
 * @interface EventPackageRateRead
 */
export interface EventPackageRateRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageRateRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageRateRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageRateRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EventPackageRateReadAttributes}
     * @memberof EventPackageRateRead
     */
    'attributes'?: EventPackageRateReadAttributes;
    /**
     * 
     * @type {EventPackageRateReadRelationships}
     * @memberof EventPackageRateRead
     */
    'relationships'?: EventPackageRateReadRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageRateReadAttributes
 */
export interface EventPackageRateReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateReadAttributes
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof EventPackageRateReadAttributes
     */
    'maxAttendees': number;
    /**
     * 
     * @type {number}
     * @memberof EventPackageRateReadAttributes
     */
    'minAttendees': number;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateReadAttributes
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateReadAttributes
     */
    'uuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof EventPackageRateReadAttributes
     */
    'priceAttendeesThreshold'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateReadAttributes
     */
    'chargeType': EventPackageRateReadAttributesChargeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateReadAttributes
     */
    'price'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateReadAttributes
     */
    'extraPersonPrice'?: string;
}

export const EventPackageRateReadAttributesChargeTypeEnum = {
    Fixed: 'fixed',
    Mix: 'mix',
    Person: 'person'
} as const;

export type EventPackageRateReadAttributesChargeTypeEnum = typeof EventPackageRateReadAttributesChargeTypeEnum[keyof typeof EventPackageRateReadAttributesChargeTypeEnum];

/**
 * 
 * @export
 * @interface EventPackageRateReadRelationships
 */
export interface EventPackageRateReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageRateReadRelationships
     */
    'eventPackage': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageRateReadRelationships
     */
    'rateCode': Reltoone;
}
/**
 * 
 * @export
 * @interface EventPackageRateWrite
 */
export interface EventPackageRateWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageRateWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageRateWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageRateWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EventPackageRateWriteAttributes}
     * @memberof EventPackageRateWrite
     */
    'attributes'?: EventPackageRateWriteAttributes;
    /**
     * 
     * @type {EventPackageRateReadRelationships}
     * @memberof EventPackageRateWrite
     */
    'relationships'?: EventPackageRateReadRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageRateWriteAttributes
 */
export interface EventPackageRateWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateWriteAttributes
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof EventPackageRateWriteAttributes
     */
    'maxAttendees': number;
    /**
     * 
     * @type {number}
     * @memberof EventPackageRateWriteAttributes
     */
    'minAttendees': number;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateWriteAttributes
     */
    'price': string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateWriteAttributes
     */
    'startDate': string;
    /**
     * 
     * @type {number}
     * @memberof EventPackageRateWriteAttributes
     */
    'priceAttendeesThreshold'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateWriteAttributes
     */
    'chargeType': EventPackageRateWriteAttributesChargeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EventPackageRateWriteAttributes
     */
    'extraPersonPrice'?: string;
}

export const EventPackageRateWriteAttributesChargeTypeEnum = {
    Fixed: 'fixed',
    Mix: 'mix',
    Person: 'person'
} as const;

export type EventPackageRateWriteAttributesChargeTypeEnum = typeof EventPackageRateWriteAttributesChargeTypeEnum[keyof typeof EventPackageRateWriteAttributesChargeTypeEnum];

/**
 * 
 * @export
 * @interface EventPackageRead
 */
export interface EventPackageRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EventPackageReadAttributes}
     * @memberof EventPackageRead
     */
    'attributes'?: EventPackageReadAttributes;
    /**
     * 
     * @type {EventPackageReadRelationships}
     * @memberof EventPackageRead
     */
    'relationships'?: EventPackageReadRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageReadAttributes
 */
export interface EventPackageReadAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof EventPackageReadAttributes
     */
    'available': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EventPackageReadAttributes
     */
    'bookingWindowEndDate': string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageReadAttributes
     */
    'bookingWindowStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageReadAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof EventPackageReadAttributes
     */
    'maxAttendees': number;
    /**
     * 
     * @type {number}
     * @memberof EventPackageReadAttributes
     */
    'minAttendees': number;
    /**
     * 
     * @type {string}
     * @memberof EventPackageReadAttributes
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageReadAttributes
     */
    'shortUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageReadAttributes
     */
    'travelWindowEndDate': string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageReadAttributes
     */
    'travelWindowStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageReadAttributes
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface EventPackageReadRelationships
 */
export interface EventPackageReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageReadRelationships
     */
    'hotel': Reltoone;
    /**
     * 
     * @type {Reltomany}
     * @memberof EventPackageReadRelationships
     */
    'eventPackageActivities': Reltomany;
    /**
     * 
     * @type {Reltomany}
     * @memberof EventPackageReadRelationships
     */
    'eventPackageMedias': Reltomany;
    /**
     * 
     * @type {Reltomany}
     * @memberof EventPackageReadRelationships
     */
    'eventPackageServices': Reltomany;
}
/**
 * 
 * @export
 * @interface EventPackageServiceCreate
 */
export interface EventPackageServiceCreate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageServiceCreate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageServiceCreate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageServiceCreate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EventPackageServiceCreateAttributes}
     * @memberof EventPackageServiceCreate
     */
    'attributes'?: EventPackageServiceCreateAttributes;
    /**
     * 
     * @type {EventPackageServiceCreateRelationships}
     * @memberof EventPackageServiceCreate
     */
    'relationships'?: EventPackageServiceCreateRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageServiceCreateAttributes
 */
export interface EventPackageServiceCreateAttributes {
    /**
     * 
     * @type {number}
     * @memberof EventPackageServiceCreateAttributes
     */
    'relativeDay': number;
    /**
     * 
     * @type {string}
     * @memberof EventPackageServiceCreateAttributes
     */
    'startsTime': string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageServiceCreateAttributes
     */
    'unitsType': EventPackageServiceCreateAttributesUnitsTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof EventPackageServiceCreateAttributes
     */
    'fixedUnits'?: number | null;
}

export const EventPackageServiceCreateAttributesUnitsTypeEnum = {
    Attendees: 'attendees',
    Fixed: 'fixed'
} as const;

export type EventPackageServiceCreateAttributesUnitsTypeEnum = typeof EventPackageServiceCreateAttributesUnitsTypeEnum[keyof typeof EventPackageServiceCreateAttributesUnitsTypeEnum];

/**
 * 
 * @export
 * @interface EventPackageServiceCreateRelationships
 */
export interface EventPackageServiceCreateRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageServiceCreateRelationships
     */
    'eventPackageActivity'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageServiceCreateRelationships
     */
    'service': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageServiceCreateRelationships
     */
    'eventPackage': Reltoone;
}
/**
 * 
 * @export
 * @interface EventPackageServiceRead
 */
export interface EventPackageServiceRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageServiceRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageServiceRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageServiceRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EventPackageServiceReadAttributes}
     * @memberof EventPackageServiceRead
     */
    'attributes'?: EventPackageServiceReadAttributes;
    /**
     * 
     * @type {EventPackageServiceReadRelationships}
     * @memberof EventPackageServiceRead
     */
    'relationships'?: EventPackageServiceReadRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageServiceReadAttributes
 */
export interface EventPackageServiceReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof EventPackageServiceReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageServiceReadAttributes
     */
    'shortUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageServiceReadAttributes
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageServiceReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof EventPackageServiceReadAttributes
     */
    'relativeDay': number;
    /**
     * 
     * @type {string}
     * @memberof EventPackageServiceReadAttributes
     */
    'startsTime': string;
    /**
     * 
     * @type {string}
     * @memberof EventPackageServiceReadAttributes
     */
    'unitsType': EventPackageServiceReadAttributesUnitsTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof EventPackageServiceReadAttributes
     */
    'fixedUnits'?: number | null;
}

export const EventPackageServiceReadAttributesUnitsTypeEnum = {
    Attendees: 'attendees',
    Fixed: 'fixed'
} as const;

export type EventPackageServiceReadAttributesUnitsTypeEnum = typeof EventPackageServiceReadAttributesUnitsTypeEnum[keyof typeof EventPackageServiceReadAttributesUnitsTypeEnum];

/**
 * 
 * @export
 * @interface EventPackageServiceReadRelationships
 */
export interface EventPackageServiceReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageServiceReadRelationships
     */
    'eventPackageActivity'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageServiceReadRelationships
     */
    'eventPackage': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageServiceReadRelationships
     */
    'service': Reltoone;
}
/**
 * 
 * @export
 * @interface EventPackageServiceUpdate
 */
export interface EventPackageServiceUpdate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageServiceUpdate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageServiceUpdate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageServiceUpdate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EventPackageServiceCreateAttributes}
     * @memberof EventPackageServiceUpdate
     */
    'attributes'?: EventPackageServiceCreateAttributes;
    /**
     * 
     * @type {EventPackageServiceUpdateRelationships}
     * @memberof EventPackageServiceUpdate
     */
    'relationships'?: EventPackageServiceUpdateRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageServiceUpdateRelationships
 */
export interface EventPackageServiceUpdateRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageServiceUpdateRelationships
     */
    'eventPackageActivity'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof EventPackageServiceUpdateRelationships
     */
    'service': Reltoone;
}
/**
 * 
 * @export
 * @interface EventPackageTranslationRead
 */
export interface EventPackageTranslationRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageTranslationRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageTranslationRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageTranslationRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomTranslationReadAttributes}
     * @memberof EventPackageTranslationRead
     */
    'attributes'?: GuestRoomTranslationReadAttributes;
    /**
     * 
     * @type {EventPackageMediaReadRelationships}
     * @memberof EventPackageTranslationRead
     */
    'relationships'?: EventPackageMediaReadRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageTranslationWrite
 */
export interface EventPackageTranslationWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageTranslationWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageTranslationWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageTranslationWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomTranslationWriteAttributes}
     * @memberof EventPackageTranslationWrite
     */
    'attributes'?: GuestRoomTranslationWriteAttributes;
    /**
     * 
     * @type {EventPackageMediaReadRelationships}
     * @memberof EventPackageTranslationWrite
     */
    'relationships'?: EventPackageMediaReadRelationships;
}
/**
 * 
 * @export
 * @interface EventPackageUpdate
 */
export interface EventPackageUpdate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof EventPackageUpdate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof EventPackageUpdate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof EventPackageUpdate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {EventPackageCreateAttributes}
     * @memberof EventPackageUpdate
     */
    'attributes'?: EventPackageCreateAttributes;
}
/**
 * 
 * @export
 * @interface Failure
 */
export interface Failure {
    /**
     * 
     * @type {Set<ModelError>}
     * @memberof Failure
     */
    'errors': Set<ModelError>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Failure
     */
    'meta'?: { [key: string]: any; };
    /**
     * 
     * @type {Jsonapi}
     * @memberof Failure
     */
    'jsonapi'?: Jsonapi;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof Failure
     */
    'links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface GenericGuestRoomRefreshPrices
 */
export interface GenericGuestRoomRefreshPrices {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericGuestRoomRefreshPrices
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericGuestRoomRefreshPrices
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericGuestRoomRefreshPrices
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
}
/**
 * 
 * @export
 * @interface GenericGuestRoomRequestApplyCommission
 */
export interface GenericGuestRoomRequestApplyCommission {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericGuestRoomRequestApplyCommission
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericGuestRoomRequestApplyCommission
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericGuestRoomRequestApplyCommission
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderActivityApplyCommissionAttributes}
     * @memberof GenericGuestRoomRequestApplyCommission
     */
    'attributes'?: GenericOrderActivityApplyCommissionAttributes;
}
/**
 * 
 * @export
 * @interface GenericGuestRoomRequestApplyDiscount
 */
export interface GenericGuestRoomRequestApplyDiscount {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericGuestRoomRequestApplyDiscount
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericGuestRoomRequestApplyDiscount
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericGuestRoomRequestApplyDiscount
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderActivityApplyDiscountAttributes}
     * @memberof GenericGuestRoomRequestApplyDiscount
     */
    'attributes'?: GenericOrderActivityApplyDiscountAttributes;
}
/**
 * 
 * @export
 * @interface GenericGuestRoomRequestOverridePrice
 */
export interface GenericGuestRoomRequestOverridePrice {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericGuestRoomRequestOverridePrice
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericGuestRoomRequestOverridePrice
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericGuestRoomRequestOverridePrice
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderActivityOverridePriceAttributes}
     * @memberof GenericGuestRoomRequestOverridePrice
     */
    'attributes'?: GenericOrderActivityOverridePriceAttributes;
}
/**
 * 
 * @export
 * @interface GenericGuestRoomRequestRead
 */
export interface GenericGuestRoomRequestRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericGuestRoomRequestRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericGuestRoomRequestRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericGuestRoomRequestRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericGuestRoomRequestReadAttributes}
     * @memberof GenericGuestRoomRequestRead
     */
    'attributes'?: GenericGuestRoomRequestReadAttributes;
    /**
     * 
     * @type {CreateBookingCartGuestRoomsRequestDataRelationships}
     * @memberof GenericGuestRoomRequestRead
     */
    'relationships'?: CreateBookingCartGuestRoomsRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface GenericGuestRoomRequestReadAttributes
 */
export interface GenericGuestRoomRequestReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof GenericGuestRoomRequestReadAttributes
     */
    'checkIn': string;
    /**
     * 
     * @type {string}
     * @memberof GenericGuestRoomRequestReadAttributes
     */
    'checkOut': string;
    /**
     * 
     * @type {string}
     * @memberof GenericGuestRoomRequestReadAttributes
     */
    'commission'?: string | null;
    /**
     * 
     * @type {GenericOrderActivityReadAttributesFrozenChargeType}
     * @memberof GenericGuestRoomRequestReadAttributes
     */
    'occupancyType': GenericOrderActivityReadAttributesFrozenChargeType;
    /**
     * 
     * @type {GenericOrderActivityReadAttributesFrozenChargeType}
     * @memberof GenericGuestRoomRequestReadAttributes
     */
    'rentalType': GenericOrderActivityReadAttributesFrozenChargeType;
    /**
     * 
     * @type {string}
     * @memberof GenericGuestRoomRequestReadAttributes
     */
    'subtotal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericGuestRoomRequestReadAttributes
     */
    'totalAmount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericGuestRoomRequestReadAttributes
     */
    'touristTaxAmount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericGuestRoomRequestReadAttributes
     */
    'itemPrice'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GenericGuestRoomRequestReadAttributes
     */
    'units'?: number;
}
/**
 * 
 * @export
 * @interface GenericGuestRoomRequestWrite
 */
export interface GenericGuestRoomRequestWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericGuestRoomRequestWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericGuestRoomRequestWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericGuestRoomRequestWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {CreateBookingCartGuestRoomsRequestDataAttributes}
     * @memberof GenericGuestRoomRequestWrite
     */
    'attributes'?: CreateBookingCartGuestRoomsRequestDataAttributes;
    /**
     * 
     * @type {CreateBookingCartGuestRoomsRequestDataRelationships}
     * @memberof GenericGuestRoomRequestWrite
     */
    'relationships'?: CreateBookingCartGuestRoomsRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface GenericOrderActivityApplyCommission
 */
export interface GenericOrderActivityApplyCommission {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderActivityApplyCommission
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderActivityApplyCommission
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderActivityApplyCommission
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderActivityApplyCommissionAttributes}
     * @memberof GenericOrderActivityApplyCommission
     */
    'attributes'?: GenericOrderActivityApplyCommissionAttributes;
}
/**
 * 
 * @export
 * @interface GenericOrderActivityApplyCommissionAttributes
 */
export interface GenericOrderActivityApplyCommissionAttributes {
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityApplyCommissionAttributes
     */
    'commission'?: string | null;
}
/**
 * 
 * @export
 * @interface GenericOrderActivityApplyDiscount
 */
export interface GenericOrderActivityApplyDiscount {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderActivityApplyDiscount
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderActivityApplyDiscount
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderActivityApplyDiscount
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderActivityApplyDiscountAttributes}
     * @memberof GenericOrderActivityApplyDiscount
     */
    'attributes'?: GenericOrderActivityApplyDiscountAttributes;
}
/**
 * 
 * @export
 * @interface GenericOrderActivityApplyDiscountAttributes
 */
export interface GenericOrderActivityApplyDiscountAttributes {
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityApplyDiscountAttributes
     */
    'discount'?: string | null;
}
/**
 * 
 * @export
 * @interface GenericOrderActivityOverridePrice
 */
export interface GenericOrderActivityOverridePrice {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderActivityOverridePrice
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderActivityOverridePrice
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderActivityOverridePrice
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderActivityOverridePriceAttributes}
     * @memberof GenericOrderActivityOverridePrice
     */
    'attributes'?: GenericOrderActivityOverridePriceAttributes;
}
/**
 * 
 * @export
 * @interface GenericOrderActivityOverridePriceAttributes
 */
export interface GenericOrderActivityOverridePriceAttributes {
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityOverridePriceAttributes
     */
    'customAmount'?: string | null;
}
/**
 * 
 * @export
 * @interface GenericOrderActivityRead
 */
export interface GenericOrderActivityRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderActivityRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderActivityRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderActivityRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderActivityReadAttributes}
     * @memberof GenericOrderActivityRead
     */
    'attributes'?: GenericOrderActivityReadAttributes;
    /**
     * 
     * @type {GenericOrderActivityReadRelationships}
     * @memberof GenericOrderActivityRead
     */
    'relationships'?: GenericOrderActivityReadRelationships;
}
/**
 * 
 * @export
 * @interface GenericOrderActivityReadAttributes
 */
export interface GenericOrderActivityReadAttributes {
    /**
     * 
     * @type {number}
     * @memberof GenericOrderActivityReadAttributes
     */
    'attendees': number;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityReadAttributes
     */
    'checkInAt': string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityReadAttributes
     */
    'checkOutAt': string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityReadAttributes
     */
    'commission'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityReadAttributes
     */
    'customerNotes'?: string | null;
    /**
     * 
     * @type {GenericOrderActivityReadAttributesFrozenChargeType}
     * @memberof GenericOrderActivityReadAttributes
     */
    'frozenChargeType': GenericOrderActivityReadAttributesFrozenChargeType;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityReadAttributes
     */
    'itemPrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityReadAttributes
     */
    'name'?: string | null;
    /**
     * Total without extras
     * @type {string}
     * @memberof GenericOrderActivityReadAttributes
     */
    'subtotal'?: string | null;
    /**
     * Total with extras
     * @type {string}
     * @memberof GenericOrderActivityReadAttributes
     */
    'total'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityReadAttributes
     */
    'totalAmount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityReadAttributes
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface GenericOrderActivityReadAttributesFrozenChargeType
 */
export interface GenericOrderActivityReadAttributesFrozenChargeType {
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityReadAttributesFrozenChargeType
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityReadAttributesFrozenChargeType
     */
    'valueDisplay'?: string;
}
/**
 * 
 * @export
 * @interface GenericOrderActivityReadRelationships
 */
export interface GenericOrderActivityReadRelationships {
    /**
     * 
     * @type {Reltomany}
     * @memberof GenericOrderActivityReadRelationships
     */
    'genericServices': Reltomany;
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericOrderActivityReadRelationships
     */
    'hotel': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericOrderActivityReadRelationships
     */
    'meetingRoom': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericOrderActivityReadRelationships
     */
    'meetingRoomSetup'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericOrderActivityReadRelationships
     */
    'order': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericOrderActivityReadRelationships
     */
    'virtualMeetingRoomSetup'?: Reltoone;
}
/**
 * 
 * @export
 * @interface GenericOrderActivityRefreshPrices
 */
export interface GenericOrderActivityRefreshPrices {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderActivityRefreshPrices
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderActivityRefreshPrices
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderActivityRefreshPrices
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
}
/**
 * 
 * @export
 * @interface GenericOrderActivityWrite
 */
export interface GenericOrderActivityWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderActivityWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderActivityWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderActivityWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderActivityWriteAttributes}
     * @memberof GenericOrderActivityWrite
     */
    'attributes'?: GenericOrderActivityWriteAttributes;
    /**
     * 
     * @type {CreateBookingCartActivitiesRequestDataRelationships}
     * @memberof GenericOrderActivityWrite
     */
    'relationships'?: CreateBookingCartActivitiesRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface GenericOrderActivityWriteAttributes
 */
export interface GenericOrderActivityWriteAttributes {
    /**
     * 
     * @type {number}
     * @memberof GenericOrderActivityWriteAttributes
     */
    'attendees': number;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityWriteAttributes
     */
    'checkInAt': string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityWriteAttributes
     */
    'checkOutAt': string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityWriteAttributes
     */
    'customerNotes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityWriteAttributes
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderActivityWriteAttributes
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface GenericOrderConfirm
 */
export interface GenericOrderConfirm {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderConfirm
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderConfirm
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderConfirm
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderConfirmAttributes}
     * @memberof GenericOrderConfirm
     */
    'attributes'?: GenericOrderConfirmAttributes;
    /**
     * 
     * @type {ConfirmBookingCartIdConfirmRequestDataRelationships}
     * @memberof GenericOrderConfirm
     */
    'relationships'?: ConfirmBookingCartIdConfirmRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface GenericOrderConfirmAttributes
 */
export interface GenericOrderConfirmAttributes {
    /**
     * 
     * @type {number}
     * @memberof GenericOrderConfirmAttributes
     */
    'attendees'?: number | null;
    /**
     * 
     * @type {ConfirmBookingCartIdConfirmRequestDataAttributesContact}
     * @memberof GenericOrderConfirmAttributes
     */
    'contact': ConfirmBookingCartIdConfirmRequestDataAttributesContact;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    'paymentIframe'?: string;
    /**
     * 
     * @type {object}
     * @memberof GenericOrderConfirmAttributes
     */
    'paymentIntegrationData'?: object;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    'paymentIntegrationType'?: GenericOrderConfirmAttributesPaymentIntegrationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    'recaptchaResponseToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    'segmentationType': GenericOrderConfirmAttributesSegmentationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    'startDate'?: string | null;
}

export const GenericOrderConfirmAttributesPaymentIntegrationTypeEnum = {
    Paycomet: 'paycomet',
    Freedompay: 'freedompay',
    Stripe: 'stripe'
} as const;

export type GenericOrderConfirmAttributesPaymentIntegrationTypeEnum = typeof GenericOrderConfirmAttributesPaymentIntegrationTypeEnum[keyof typeof GenericOrderConfirmAttributesPaymentIntegrationTypeEnum];
export const GenericOrderConfirmAttributesSegmentationTypeEnum = {
    Congress: 'CONGRESS',
    GroupTravel: 'GROUP_TRAVEL',
    Incentives: 'INCENTIVES',
    MeetingOrConference: 'MEETING_OR_CONFERENCE',
    SocialEvent: 'SOCIAL_EVENT',
    Wedding: 'WEDDING'
} as const;

export type GenericOrderConfirmAttributesSegmentationTypeEnum = typeof GenericOrderConfirmAttributesSegmentationTypeEnum[keyof typeof GenericOrderConfirmAttributesSegmentationTypeEnum];

/**
 * 
 * @export
 * @interface GenericOrderCurrency
 */
export interface GenericOrderCurrency {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderCurrency
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderCurrency
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderCurrency
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderCurrencyRelationships}
     * @memberof GenericOrderCurrency
     */
    'relationships'?: GenericOrderCurrencyRelationships;
}
/**
 * 
 * @export
 * @interface GenericOrderCurrencyRelationships
 */
export interface GenericOrderCurrencyRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericOrderCurrencyRelationships
     */
    'currency'?: Reltoone;
}
/**
 * 
 * @export
 * @interface GenericOrderDiscount
 */
export interface GenericOrderDiscount {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderDiscount
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderDiscount
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderDiscount
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderDiscountAttributes}
     * @memberof GenericOrderDiscount
     */
    'attributes'?: GenericOrderDiscountAttributes;
}
/**
 * 
 * @export
 * @interface GenericOrderDiscountAttributes
 */
export interface GenericOrderDiscountAttributes {
    /**
     * 
     * @type {string}
     * @memberof GenericOrderDiscountAttributes
     */
    'discount': string | null;
}
/**
 * 
 * @export
 * @interface GenericOrderDuplicate
 */
export interface GenericOrderDuplicate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderDuplicate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderDuplicate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderDuplicate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderDuplicateAttributes}
     * @memberof GenericOrderDuplicate
     */
    'attributes'?: GenericOrderDuplicateAttributes;
}
/**
 * 
 * @export
 * @interface GenericOrderDuplicateAttributes
 */
export interface GenericOrderDuplicateAttributes {
    /**
     * 
     * @type {string}
     * @memberof GenericOrderDuplicateAttributes
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface GenericOrderExport
 */
export interface GenericOrderExport {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderExport
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderExport
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderExport
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderExportAttributes}
     * @memberof GenericOrderExport
     */
    'attributes'?: GenericOrderExportAttributes;
}
/**
 * 
 * @export
 * @interface GenericOrderExportAttributes
 */
export interface GenericOrderExportAttributes {
    /**
     * 
     * @type {Array<boolean>}
     * @memberof GenericOrderExportAttributes
     */
    'fieldsToExport'?: Array<boolean>;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderExportAttributes
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderExportAttributes
     */
    'fileType'?: GenericOrderExportAttributesFileTypeEnum;
}

export const GenericOrderExportAttributesFileTypeEnum = {
    Csv: 'csv',
    Excel: 'excel'
} as const;

export type GenericOrderExportAttributesFileTypeEnum = typeof GenericOrderExportAttributesFileTypeEnum[keyof typeof GenericOrderExportAttributesFileTypeEnum];

/**
 * 
 * @export
 * @interface GenericOrderRead
 */
export interface GenericOrderRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderReadAttributes}
     * @memberof GenericOrderRead
     */
    'attributes'?: GenericOrderReadAttributes;
    /**
     * 
     * @type {GenericOrderReadRelationships}
     * @memberof GenericOrderRead
     */
    'relationships'?: GenericOrderReadRelationships;
}
/**
 * 
 * @export
 * @interface GenericOrderReadAttributes
 */
export interface GenericOrderReadAttributes {
    /**
     * 
     * @type {number}
     * @memberof GenericOrderReadAttributes
     */
    'attendees'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    'amount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    'discount': string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    'orderReference'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    'orderTracker'?: string;
    /**
     * 
     * @type {GenericOrderActivityReadAttributesFrozenChargeType}
     * @memberof GenericOrderReadAttributes
     */
    'segmentationType': GenericOrderActivityReadAttributesFrozenChargeType;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    'shortUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {GenericOrderActivityReadAttributesFrozenChargeType}
     * @memberof GenericOrderReadAttributes
     */
    'status': GenericOrderActivityReadAttributesFrozenChargeType;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    'totalAmount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributes
     */
    'amountPaid'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GenericOrderReadAttributes
     */
    'touristTaxAmount'?: Array<string>;
    /**
     * 
     * @type {Array<GenericOrderReadAttributesPaymentOptionsInner>}
     * @memberof GenericOrderReadAttributes
     */
    'paymentOptions'?: Array<GenericOrderReadAttributesPaymentOptionsInner>;
    /**
     * 
     * @type {number}
     * @memberof GenericOrderReadAttributes
     */
    'priceDurationDays'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GenericOrderReadAttributes
     */
    'requireRecaptcha'?: boolean;
}
/**
 * 
 * @export
 * @interface GenericOrderReadAttributesPaymentOptionsInner
 */
export interface GenericOrderReadAttributesPaymentOptionsInner {
    /**
     * 
     * @type {number}
     * @memberof GenericOrderReadAttributesPaymentOptionsInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributesPaymentOptionsInner
     */
    'partialPercentage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributesPaymentOptionsInner
     */
    'paymentMethod': GenericOrderReadAttributesPaymentOptionsInnerPaymentMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof GenericOrderReadAttributesPaymentOptionsInner
     */
    'hotel'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderReadAttributesPaymentOptionsInner
     */
    'amount': string;
}

export const GenericOrderReadAttributesPaymentOptionsInnerPaymentMethodEnum = {
    CreditCard: 'CREDIT_CARD',
    RequestForProposal: 'REQUEST_FOR_PROPOSAL'
} as const;

export type GenericOrderReadAttributesPaymentOptionsInnerPaymentMethodEnum = typeof GenericOrderReadAttributesPaymentOptionsInnerPaymentMethodEnum[keyof typeof GenericOrderReadAttributesPaymentOptionsInnerPaymentMethodEnum];

/**
 * 
 * @export
 * @interface GenericOrderReadRelationships
 */
export interface GenericOrderReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericOrderReadRelationships
     */
    'clientCurrency'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericOrderReadRelationships
     */
    'contact'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericOrderReadRelationships
     */
    'currency'?: Reltoone;
    /**
     * 
     * @type {Reltomany}
     * @memberof GenericOrderReadRelationships
     */
    'genericActivities': Reltomany;
    /**
     * 
     * @type {Reltomany}
     * @memberof GenericOrderReadRelationships
     */
    'genericServices': Reltomany;
    /**
     * 
     * @type {Reltomany}
     * @memberof GenericOrderReadRelationships
     */
    'genericGuestRoomRequests': Reltomany;
    /**
     * 
     * @type {Reltomany}
     * @memberof GenericOrderReadRelationships
     */
    'orderEventPackages': Reltomany;
    /**
     * 
     * @type {Reltomany}
     * @memberof GenericOrderReadRelationships
     */
    'payments': Reltomany;
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericOrderReadRelationships
     */
    'paymentOption'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericOrderReadRelationships
     */
    'proposal'?: Reltoone;
    /**
     * 
     * @type {Reltomany}
     * @memberof GenericOrderReadRelationships
     */
    'hotels'?: Reltomany;
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericOrderReadRelationships
     */
    'hotel': Reltoone;
}
/**
 * 
 * @export
 * @interface GenericOrderRefreshPrices
 */
export interface GenericOrderRefreshPrices {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderRefreshPrices
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderRefreshPrices
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderRefreshPrices
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderRefreshPricesAttributes}
     * @memberof GenericOrderRefreshPrices
     */
    'attributes'?: GenericOrderRefreshPricesAttributes;
}
/**
 * 
 * @export
 * @interface GenericOrderRefreshPricesAttributes
 */
export interface GenericOrderRefreshPricesAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof GenericOrderRefreshPricesAttributes
     */
    'refreshCustomAmount': boolean;
}
/**
 * 
 * @export
 * @interface GenericOrderSendEmail
 */
export interface GenericOrderSendEmail {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderSendEmail
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderSendEmail
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderSendEmail
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderSendEmailAttributes}
     * @memberof GenericOrderSendEmail
     */
    'attributes'?: GenericOrderSendEmailAttributes;
}
/**
 * 
 * @export
 * @interface GenericOrderSendEmailAttributes
 */
export interface GenericOrderSendEmailAttributes {
    /**
     * 
     * @type {Array<GenericOrderSendEmailAttributesRecipientsInner>}
     * @memberof GenericOrderSendEmailAttributes
     */
    'recipients': Array<GenericOrderSendEmailAttributesRecipientsInner>;
}
/**
 * 
 * @export
 * @interface GenericOrderSendEmailAttributesRecipientsInner
 */
export interface GenericOrderSendEmailAttributesRecipientsInner {
    /**
     * 
     * @type {string}
     * @memberof GenericOrderSendEmailAttributesRecipientsInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderSendEmailAttributesRecipientsInner
     */
    'language': GenericOrderSendEmailAttributesRecipientsInnerLanguageEnum;
}

export const GenericOrderSendEmailAttributesRecipientsInnerLanguageEnum = {
    En: 'en',
    Es: 'es'
} as const;

export type GenericOrderSendEmailAttributesRecipientsInnerLanguageEnum = typeof GenericOrderSendEmailAttributesRecipientsInnerLanguageEnum[keyof typeof GenericOrderSendEmailAttributesRecipientsInnerLanguageEnum];

/**
 * 
 * @export
 * @interface GenericOrderStatus
 */
export interface GenericOrderStatus {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderStatus
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderStatus
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderStatus
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderStatusAttributes}
     * @memberof GenericOrderStatus
     */
    'attributes'?: GenericOrderStatusAttributes;
    /**
     * 
     * @type {GenericOrderStatusRelationships}
     * @memberof GenericOrderStatus
     */
    'relationships'?: GenericOrderStatusRelationships;
}
/**
 * 
 * @export
 * @interface GenericOrderStatusAttributes
 */
export interface GenericOrderStatusAttributes {
    /**
     * 
     * @type {string}
     * @memberof GenericOrderStatusAttributes
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderStatusAttributes
     */
    'status': GenericOrderStatusAttributesStatusEnum;
}

export const GenericOrderStatusAttributesStatusEnum = {
    Blocked: 'blocked',
    Canceled: 'canceled',
    Confirmed: 'confirmed',
    Closed: 'closed',
    DraftBackoffice: 'draft-backoffice',
    Option: 'option',
    Potential: 'potential',
    Tentative: 'tentative',
    Turndown: 'turndown'
} as const;

export type GenericOrderStatusAttributesStatusEnum = typeof GenericOrderStatusAttributesStatusEnum[keyof typeof GenericOrderStatusAttributesStatusEnum];

/**
 * 
 * @export
 * @interface GenericOrderStatusRelationships
 */
export interface GenericOrderStatusRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericOrderStatusRelationships
     */
    'cancelReason'?: Reltoone;
}
/**
 * 
 * @export
 * @interface GenericOrderWrite
 */
export interface GenericOrderWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericOrderWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericOrderWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericOrderWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderWriteAttributes}
     * @memberof GenericOrderWrite
     */
    'attributes'?: GenericOrderWriteAttributes;
    /**
     * 
     * @type {CreateBookingCartRequestDataRelationships}
     * @memberof GenericOrderWrite
     */
    'relationships'?: CreateBookingCartRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface GenericOrderWriteAttributes
 */
export interface GenericOrderWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof GenericOrderWriteAttributes
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface GenericServiceApplyCommission
 */
export interface GenericServiceApplyCommission {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericServiceApplyCommission
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericServiceApplyCommission
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericServiceApplyCommission
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderActivityApplyCommissionAttributes}
     * @memberof GenericServiceApplyCommission
     */
    'attributes'?: GenericOrderActivityApplyCommissionAttributes;
}
/**
 * 
 * @export
 * @interface GenericServiceApplyDiscount
 */
export interface GenericServiceApplyDiscount {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericServiceApplyDiscount
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericServiceApplyDiscount
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericServiceApplyDiscount
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderActivityApplyDiscountAttributes}
     * @memberof GenericServiceApplyDiscount
     */
    'attributes'?: GenericOrderActivityApplyDiscountAttributes;
}
/**
 * 
 * @export
 * @interface GenericServiceOverridePrice
 */
export interface GenericServiceOverridePrice {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericServiceOverridePrice
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericServiceOverridePrice
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericServiceOverridePrice
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderActivityOverridePriceAttributes}
     * @memberof GenericServiceOverridePrice
     */
    'attributes'?: GenericOrderActivityOverridePriceAttributes;
}
/**
 * 
 * @export
 * @interface GenericServiceRead
 */
export interface GenericServiceRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericServiceRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericServiceRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericServiceRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericServiceReadAttributes}
     * @memberof GenericServiceRead
     */
    'attributes'?: GenericServiceReadAttributes;
    /**
     * 
     * @type {GenericServiceReadRelationships}
     * @memberof GenericServiceRead
     */
    'relationships'?: GenericServiceReadRelationships;
}
/**
 * 
 * @export
 * @interface GenericServiceReadAttributes
 */
export interface GenericServiceReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof GenericServiceReadAttributes
     */
    'commission'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericServiceReadAttributes
     */
    'endsAt'?: string | null;
    /**
     * 
     * @type {GenericOrderActivityReadAttributesFrozenChargeType}
     * @memberof GenericServiceReadAttributes
     */
    'frozenChargeType': GenericOrderActivityReadAttributesFrozenChargeType;
    /**
     * 
     * @type {string}
     * @memberof GenericServiceReadAttributes
     */
    'itemPrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericServiceReadAttributes
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof GenericServiceReadAttributes
     */
    'startsAt': string;
    /**
     * 
     * @type {string}
     * @memberof GenericServiceReadAttributes
     */
    'subtotal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericServiceReadAttributes
     */
    'totalAmount'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GenericServiceReadAttributes
     */
    'units'?: number;
}
/**
 * 
 * @export
 * @interface GenericServiceReadRelationships
 */
export interface GenericServiceReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericServiceReadRelationships
     */
    'activity'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericServiceReadRelationships
     */
    'hotel': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericServiceReadRelationships
     */
    'order': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof GenericServiceReadRelationships
     */
    'service': Reltoone;
}
/**
 * 
 * @export
 * @interface GenericServiceRefreshPrices
 */
export interface GenericServiceRefreshPrices {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericServiceRefreshPrices
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericServiceRefreshPrices
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericServiceRefreshPrices
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
}
/**
 * 
 * @export
 * @interface GenericServiceWrite
 */
export interface GenericServiceWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GenericServiceWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GenericServiceWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GenericServiceWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {PartialUpdateBookingCartServicesIdRequestDataAttributes}
     * @memberof GenericServiceWrite
     */
    'attributes'?: PartialUpdateBookingCartServicesIdRequestDataAttributes;
    /**
     * 
     * @type {CreateBookingCartServicesRequestDataRelationships}
     * @memberof GenericServiceWrite
     */
    'relationships'?: CreateBookingCartServicesRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface GroupByOrdersDetail
 */
export interface GroupByOrdersDetail {
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'account'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'account_pk'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'hotel'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'hotel_pk'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'assignee'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'assignee_pk'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'owner'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'owner_pk'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'segmentation_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'account_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'country'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupByOrdersDetail
     */
    'total_amount': number;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'activities_amount': string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'guest_rooms_amount': string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'food_beverages_amount': string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'audiovisuals_amount': string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'extra_services_amount': string;
    /**
     * 
     * @type {number}
     * @memberof GroupByOrdersDetail
     */
    'total_count': number;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'lead_time': string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'booking_pase': string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'response_time': string;
    /**
     * 
     * @type {string}
     * @memberof GroupByOrdersDetail
     */
    'average_daily_rate': string;
}
/**
 * 
 * @export
 * @interface GroupBySetupsDetail
 */
export interface GroupBySetupsDetail {
    /**
     * 
     * @type {string}
     * @memberof GroupBySetupsDetail
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBySetupsDetail
     */
    'hotel'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBySetupsDetail
     */
    'hotel_pk'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBySetupsDetail
     */
    'meeting_room'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBySetupsDetail
     */
    'meeting_room_pk'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBySetupsDetail
     */
    'owner'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBySetupsDetail
     */
    'owner_pk'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBySetupsDetail
     */
    'permission'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBySetupsDetail
     */
    'segmentation_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupBySetupsDetail
     */
    'total_count': number;
}
/**
 * 
 * @export
 * @interface GuestRoomAllotmentCreate
 */
export interface GuestRoomAllotmentCreate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GuestRoomAllotmentCreate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GuestRoomAllotmentCreate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GuestRoomAllotmentCreate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomAllotmentCreateAttributes}
     * @memberof GuestRoomAllotmentCreate
     */
    'attributes'?: GuestRoomAllotmentCreateAttributes;
    /**
     * 
     * @type {GuestRoomTranslationReadRelationships}
     * @memberof GuestRoomAllotmentCreate
     */
    'relationships'?: GuestRoomTranslationReadRelationships;
}
/**
 * 
 * @export
 * @interface GuestRoomAllotmentCreateAttributes
 */
export interface GuestRoomAllotmentCreateAttributes {
    /**
     * 
     * @type {string}
     * @memberof GuestRoomAllotmentCreateAttributes
     */
    'allotmentDate': string;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomAllotmentCreateAttributes
     */
    'allotmentQuota': number;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomAllotmentCreateAttributes
     */
    'minNights'?: number;
}
/**
 * 
 * @export
 * @interface GuestRoomAllotmentRead
 */
export interface GuestRoomAllotmentRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GuestRoomAllotmentRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GuestRoomAllotmentRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GuestRoomAllotmentRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomAllotmentReadAttributes}
     * @memberof GuestRoomAllotmentRead
     */
    'attributes'?: GuestRoomAllotmentReadAttributes;
    /**
     * 
     * @type {GuestRoomTranslationReadRelationships}
     * @memberof GuestRoomAllotmentRead
     */
    'relationships'?: GuestRoomTranslationReadRelationships;
}
/**
 * 
 * @export
 * @interface GuestRoomAllotmentReadAttributes
 */
export interface GuestRoomAllotmentReadAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof GuestRoomAllotmentReadAttributes
     */
    'closed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomAllotmentReadAttributes
     */
    'allotmentDate': string;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomAllotmentReadAttributes
     */
    'allotmentQuota': number;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomAllotmentReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomAllotmentReadAttributes
     */
    'minNights'?: number;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomAllotmentReadAttributes
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface GuestRoomAllotmentUpdate
 */
export interface GuestRoomAllotmentUpdate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GuestRoomAllotmentUpdate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GuestRoomAllotmentUpdate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GuestRoomAllotmentUpdate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomAllotmentCreateAttributes}
     * @memberof GuestRoomAllotmentUpdate
     */
    'attributes'?: GuestRoomAllotmentCreateAttributes;
}
/**
 * 
 * @export
 * @interface GuestRoomAllotmentUpload
 */
export interface GuestRoomAllotmentUpload {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GuestRoomAllotmentUpload
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GuestRoomAllotmentUpload
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GuestRoomAllotmentUpload
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomAllotmentUploadAttributes}
     * @memberof GuestRoomAllotmentUpload
     */
    'attributes'?: GuestRoomAllotmentUploadAttributes;
    /**
     * 
     * @type {GuestRoomTranslationReadRelationships}
     * @memberof GuestRoomAllotmentUpload
     */
    'relationships'?: GuestRoomTranslationReadRelationships;
}
/**
 * 
 * @export
 * @interface GuestRoomAllotmentUploadAttributes
 */
export interface GuestRoomAllotmentUploadAttributes {
    /**
     * 
     * @type {string}
     * @memberof GuestRoomAllotmentUploadAttributes
     */
    'allotmentEndDate': string;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomAllotmentUploadAttributes
     */
    'allotmentQuota'?: number;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomAllotmentUploadAttributes
     */
    'allotmentStartDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof GuestRoomAllotmentUploadAttributes
     */
    'closed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomAllotmentUploadAttributes
     */
    'minNights'?: number;
}
/**
 * 
 * @export
 * @interface GuestRoomRateCurrencyRead
 */
export interface GuestRoomRateCurrencyRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GuestRoomRateCurrencyRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GuestRoomRateCurrencyRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GuestRoomRateCurrencyRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomRateCurrencyReadAttributes}
     * @memberof GuestRoomRateCurrencyRead
     */
    'attributes'?: GuestRoomRateCurrencyReadAttributes;
    /**
     * 
     * @type {GuestRoomRateCurrencyReadRelationships}
     * @memberof GuestRoomRateCurrencyRead
     */
    'relationships'?: GuestRoomRateCurrencyReadRelationships;
}
/**
 * 
 * @export
 * @interface GuestRoomRateCurrencyReadAttributes
 */
export interface GuestRoomRateCurrencyReadAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof GuestRoomRateCurrencyReadAttributes
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateCurrencyReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateCurrencyReadAttributes
     */
    'price': string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateCurrencyReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateCurrencyReadAttributes
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface GuestRoomRateCurrencyReadRelationships
 */
export interface GuestRoomRateCurrencyReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof GuestRoomRateCurrencyReadRelationships
     */
    'currency': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof GuestRoomRateCurrencyReadRelationships
     */
    'guestRoomRate': Reltoone;
}
/**
 * 
 * @export
 * @interface GuestRoomRateCurrencyWrite
 */
export interface GuestRoomRateCurrencyWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GuestRoomRateCurrencyWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GuestRoomRateCurrencyWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GuestRoomRateCurrencyWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomRateCurrencyWriteAttributes}
     * @memberof GuestRoomRateCurrencyWrite
     */
    'attributes'?: GuestRoomRateCurrencyWriteAttributes;
    /**
     * 
     * @type {GuestRoomRateCurrencyReadRelationships}
     * @memberof GuestRoomRateCurrencyWrite
     */
    'relationships'?: GuestRoomRateCurrencyReadRelationships;
}
/**
 * 
 * @export
 * @interface GuestRoomRateCurrencyWriteAttributes
 */
export interface GuestRoomRateCurrencyWriteAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof GuestRoomRateCurrencyWriteAttributes
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateCurrencyWriteAttributes
     */
    'price': string;
}
/**
 * 
 * @export
 * @interface GuestRoomRateRead
 */
export interface GuestRoomRateRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GuestRoomRateRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GuestRoomRateRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GuestRoomRateRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomRateReadAttributes}
     * @memberof GuestRoomRateRead
     */
    'attributes'?: GuestRoomRateReadAttributes;
    /**
     * 
     * @type {GuestRoomRateReadRelationships}
     * @memberof GuestRoomRateRead
     */
    'relationships'?: GuestRoomRateReadRelationships;
}
/**
 * 
 * @export
 * @interface GuestRoomRateReadAttributes
 */
export interface GuestRoomRateReadAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof GuestRoomRateReadAttributes
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateReadAttributes
     */
    'price': string | null;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateReadAttributes
     */
    'occupancyType': GuestRoomRateReadAttributesOccupancyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateReadAttributes
     */
    'rateDate': string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateReadAttributes
     */
    'rentalType': GuestRoomRateReadAttributesRentalTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateReadAttributes
     */
    'updatedAt'?: string;
}

export const GuestRoomRateReadAttributesOccupancyTypeEnum = {
    Single10: 'single-1-0',
    Double20: 'double-2-0',
    Double11: 'double-1-1',
    Triple30: 'triple-3-0',
    Triple21: 'triple-2-1',
    Triple12: 'triple-1-2',
    Quadruple40: 'quadruple-4-0',
    Quadruple31: 'quadruple-3-1',
    Quadruple22: 'quadruple-2-2',
    Quadruple13: 'quadruple-1-3',
    Quintuple50: 'quintuple-5-0',
    Quintuple41: 'quintuple-4-1',
    Quintuple32: 'quintuple-3-2',
    Quintuple23: 'quintuple-2-3',
    Quintuple14: 'quintuple-1-4'
} as const;

export type GuestRoomRateReadAttributesOccupancyTypeEnum = typeof GuestRoomRateReadAttributesOccupancyTypeEnum[keyof typeof GuestRoomRateReadAttributesOccupancyTypeEnum];
export const GuestRoomRateReadAttributesRentalTypeEnum = {
    Accommodation: 'accommodation',
    Breakfast: 'breakfast',
    FullBoard: 'full-board',
    HalfBoard: 'half-board',
    AllInclusive: 'all-inclusive'
} as const;

export type GuestRoomRateReadAttributesRentalTypeEnum = typeof GuestRoomRateReadAttributesRentalTypeEnum[keyof typeof GuestRoomRateReadAttributesRentalTypeEnum];

/**
 * 
 * @export
 * @interface GuestRoomRateReadRelationships
 */
export interface GuestRoomRateReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof GuestRoomRateReadRelationships
     */
    'guestRoom': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof GuestRoomRateReadRelationships
     */
    'rateCode': Reltoone;
    /**
     * 
     * @type {Reltomany}
     * @memberof GuestRoomRateReadRelationships
     */
    'guestRoomRateCurrencies': Reltomany;
}
/**
 * 
 * @export
 * @interface GuestRoomRateUpload
 */
export interface GuestRoomRateUpload {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GuestRoomRateUpload
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GuestRoomRateUpload
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GuestRoomRateUpload
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomRateUploadAttributes}
     * @memberof GuestRoomRateUpload
     */
    'attributes'?: GuestRoomRateUploadAttributes;
    /**
     * 
     * @type {GuestRoomRateUploadRelationships}
     * @memberof GuestRoomRateUpload
     */
    'relationships'?: GuestRoomRateUploadRelationships;
}
/**
 * 
 * @export
 * @interface GuestRoomRateUploadAttributes
 */
export interface GuestRoomRateUploadAttributes {
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateUploadAttributes
     */
    'occupancyType': GuestRoomRateUploadAttributesOccupancyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateUploadAttributes
     */
    'price': string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateUploadAttributes
     */
    'rateEndDate': string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateUploadAttributes
     */
    'rateStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateUploadAttributes
     */
    'rentalType': GuestRoomRateUploadAttributesRentalTypeEnum;
}

export const GuestRoomRateUploadAttributesOccupancyTypeEnum = {
    Single10: 'single-1-0',
    Double20: 'double-2-0',
    Double11: 'double-1-1',
    Triple30: 'triple-3-0',
    Triple21: 'triple-2-1',
    Triple12: 'triple-1-2',
    Quadruple40: 'quadruple-4-0',
    Quadruple31: 'quadruple-3-1',
    Quadruple22: 'quadruple-2-2',
    Quadruple13: 'quadruple-1-3',
    Quintuple50: 'quintuple-5-0',
    Quintuple41: 'quintuple-4-1',
    Quintuple32: 'quintuple-3-2',
    Quintuple23: 'quintuple-2-3',
    Quintuple14: 'quintuple-1-4'
} as const;

export type GuestRoomRateUploadAttributesOccupancyTypeEnum = typeof GuestRoomRateUploadAttributesOccupancyTypeEnum[keyof typeof GuestRoomRateUploadAttributesOccupancyTypeEnum];
export const GuestRoomRateUploadAttributesRentalTypeEnum = {
    Accommodation: 'accommodation',
    Breakfast: 'breakfast',
    FullBoard: 'full-board',
    HalfBoard: 'half-board',
    AllInclusive: 'all-inclusive'
} as const;

export type GuestRoomRateUploadAttributesRentalTypeEnum = typeof GuestRoomRateUploadAttributesRentalTypeEnum[keyof typeof GuestRoomRateUploadAttributesRentalTypeEnum];

/**
 * 
 * @export
 * @interface GuestRoomRateUploadRelationships
 */
export interface GuestRoomRateUploadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof GuestRoomRateUploadRelationships
     */
    'guestRoom': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof GuestRoomRateUploadRelationships
     */
    'currency'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof GuestRoomRateUploadRelationships
     */
    'rateCode': Reltoone;
}
/**
 * 
 * @export
 * @interface GuestRoomRateWrite
 */
export interface GuestRoomRateWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GuestRoomRateWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GuestRoomRateWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GuestRoomRateWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomRateWriteAttributes}
     * @memberof GuestRoomRateWrite
     */
    'attributes'?: GuestRoomRateWriteAttributes;
}
/**
 * 
 * @export
 * @interface GuestRoomRateWriteAttributes
 */
export interface GuestRoomRateWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateWriteAttributes
     */
    'price': string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateWriteAttributes
     */
    'occupancyType': GuestRoomRateWriteAttributesOccupancyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateWriteAttributes
     */
    'rateDate': string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomRateWriteAttributes
     */
    'rentalType': GuestRoomRateWriteAttributesRentalTypeEnum;
}

export const GuestRoomRateWriteAttributesOccupancyTypeEnum = {
    Single10: 'single-1-0',
    Double20: 'double-2-0',
    Double11: 'double-1-1',
    Triple30: 'triple-3-0',
    Triple21: 'triple-2-1',
    Triple12: 'triple-1-2',
    Quadruple40: 'quadruple-4-0',
    Quadruple31: 'quadruple-3-1',
    Quadruple22: 'quadruple-2-2',
    Quadruple13: 'quadruple-1-3',
    Quintuple50: 'quintuple-5-0',
    Quintuple41: 'quintuple-4-1',
    Quintuple32: 'quintuple-3-2',
    Quintuple23: 'quintuple-2-3',
    Quintuple14: 'quintuple-1-4'
} as const;

export type GuestRoomRateWriteAttributesOccupancyTypeEnum = typeof GuestRoomRateWriteAttributesOccupancyTypeEnum[keyof typeof GuestRoomRateWriteAttributesOccupancyTypeEnum];
export const GuestRoomRateWriteAttributesRentalTypeEnum = {
    Accommodation: 'accommodation',
    Breakfast: 'breakfast',
    FullBoard: 'full-board',
    HalfBoard: 'half-board',
    AllInclusive: 'all-inclusive'
} as const;

export type GuestRoomRateWriteAttributesRentalTypeEnum = typeof GuestRoomRateWriteAttributesRentalTypeEnum[keyof typeof GuestRoomRateWriteAttributesRentalTypeEnum];

/**
 * 
 * @export
 * @interface GuestRoomRead
 */
export interface GuestRoomRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GuestRoomRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GuestRoomRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GuestRoomRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomReadAttributes}
     * @memberof GuestRoomRead
     */
    'attributes'?: GuestRoomReadAttributes;
    /**
     * 
     * @type {CreateBookingCartRequestDataRelationships}
     * @memberof GuestRoomRead
     */
    'relationships'?: CreateBookingCartRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface GuestRoomReadAttributes
 */
export interface GuestRoomReadAttributes {
    /**
     * 
     * @type {number}
     * @memberof GuestRoomReadAttributes
     */
    'availabilityQuota': number | null;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributes
     */
    'immersiveUrl': string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributes
     */
    'name'?: string;
    /**
     * 
     * @type {Array<GenericOrderActivityReadAttributesFrozenChargeType>}
     * @memberof GuestRoomReadAttributes
     */
    'occupancyTypes'?: Array<GenericOrderActivityReadAttributesFrozenChargeType>;
    /**
     * 
     * @type {Array<GuestRoomReadAttributesPricesInner>}
     * @memberof GuestRoomReadAttributes
     */
    'prices'?: Array<GuestRoomReadAttributesPricesInner>;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributes
     */
    'rackPrice'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributes
     */
    'shortUuid'?: string;
    /**
     * 
     * @type {GuestRoomReadAttributesThumbnail}
     * @memberof GuestRoomReadAttributes
     */
    'thumbnail': GuestRoomReadAttributesThumbnail;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomReadAttributes
     */
    'totalMinNights': number | null;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributes
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface GuestRoomReadAttributesPricesInner
 */
export interface GuestRoomReadAttributesPricesInner {
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributesPricesInner
     */
    'occupancyType': GuestRoomReadAttributesPricesInnerOccupancyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributesPricesInner
     */
    'price': string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributesPricesInner
     */
    'rentalType': GuestRoomReadAttributesPricesInnerRentalTypeEnum;
}

export const GuestRoomReadAttributesPricesInnerOccupancyTypeEnum = {
    Single10: 'single-1-0',
    Double20: 'double-2-0',
    Double11: 'double-1-1',
    Triple30: 'triple-3-0',
    Triple21: 'triple-2-1',
    Triple12: 'triple-1-2',
    Quadruple40: 'quadruple-4-0',
    Quadruple31: 'quadruple-3-1',
    Quadruple22: 'quadruple-2-2',
    Quadruple13: 'quadruple-1-3',
    Quintuple50: 'quintuple-5-0',
    Quintuple41: 'quintuple-4-1',
    Quintuple32: 'quintuple-3-2',
    Quintuple23: 'quintuple-2-3',
    Quintuple14: 'quintuple-1-4'
} as const;

export type GuestRoomReadAttributesPricesInnerOccupancyTypeEnum = typeof GuestRoomReadAttributesPricesInnerOccupancyTypeEnum[keyof typeof GuestRoomReadAttributesPricesInnerOccupancyTypeEnum];
export const GuestRoomReadAttributesPricesInnerRentalTypeEnum = {
    Accommodation: 'accommodation',
    Breakfast: 'breakfast',
    FullBoard: 'full-board',
    HalfBoard: 'half-board',
    AllInclusive: 'all-inclusive'
} as const;

export type GuestRoomReadAttributesPricesInnerRentalTypeEnum = typeof GuestRoomReadAttributesPricesInnerRentalTypeEnum[keyof typeof GuestRoomReadAttributesPricesInnerRentalTypeEnum];

/**
 * 
 * @export
 * @interface GuestRoomReadAttributesThumbnail
 */
export interface GuestRoomReadAttributesThumbnail {
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributesThumbnail
     */
    'fullSize'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributesThumbnail
     */
    'thumbnail'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributesThumbnail
     */
    'thumbnailRetina'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributesThumbnail
     */
    'thumbnailBig'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomReadAttributesThumbnail
     */
    'thumbnailRetinaBig'?: string;
}
/**
 * 
 * @export
 * @interface GuestRoomThumbnailWrite
 */
export interface GuestRoomThumbnailWrite {
    /**
     * 
     * @type {File}
     * @memberof GuestRoomThumbnailWrite
     */
    'thumbnail'?: File;
}
/**
 * 
 * @export
 * @interface GuestRoomTranslationRead
 */
export interface GuestRoomTranslationRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GuestRoomTranslationRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GuestRoomTranslationRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GuestRoomTranslationRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomTranslationReadAttributes}
     * @memberof GuestRoomTranslationRead
     */
    'attributes'?: GuestRoomTranslationReadAttributes;
    /**
     * 
     * @type {GuestRoomTranslationReadRelationships}
     * @memberof GuestRoomTranslationRead
     */
    'relationships'?: GuestRoomTranslationReadRelationships;
}
/**
 * 
 * @export
 * @interface GuestRoomTranslationReadAttributes
 */
export interface GuestRoomTranslationReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof GuestRoomTranslationReadAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomTranslationReadAttributes
     */
    'languageCode': GuestRoomTranslationReadAttributesLanguageCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomTranslationReadAttributes
     */
    'name'?: string;
}

export const GuestRoomTranslationReadAttributesLanguageCodeEnum = {
    En: 'en',
    It: 'it',
    Es: 'es',
    Fr: 'fr',
    Pt: 'pt',
    De: 'de'
} as const;

export type GuestRoomTranslationReadAttributesLanguageCodeEnum = typeof GuestRoomTranslationReadAttributesLanguageCodeEnum[keyof typeof GuestRoomTranslationReadAttributesLanguageCodeEnum];

/**
 * 
 * @export
 * @interface GuestRoomTranslationReadRelationships
 */
export interface GuestRoomTranslationReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof GuestRoomTranslationReadRelationships
     */
    'guestRoom': Reltoone;
}
/**
 * 
 * @export
 * @interface GuestRoomTranslationWrite
 */
export interface GuestRoomTranslationWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GuestRoomTranslationWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GuestRoomTranslationWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GuestRoomTranslationWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomTranslationWriteAttributes}
     * @memberof GuestRoomTranslationWrite
     */
    'attributes'?: GuestRoomTranslationWriteAttributes;
    /**
     * 
     * @type {GuestRoomTranslationReadRelationships}
     * @memberof GuestRoomTranslationWrite
     */
    'relationships'?: GuestRoomTranslationReadRelationships;
}
/**
 * 
 * @export
 * @interface GuestRoomTranslationWriteAttributes
 */
export interface GuestRoomTranslationWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof GuestRoomTranslationWriteAttributes
     */
    'languageCode': GuestRoomTranslationWriteAttributesLanguageCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomTranslationWriteAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomTranslationWriteAttributes
     */
    'name'?: string;
}

export const GuestRoomTranslationWriteAttributesLanguageCodeEnum = {
    En: 'en',
    It: 'it',
    Es: 'es',
    Fr: 'fr',
    Pt: 'pt',
    De: 'de'
} as const;

export type GuestRoomTranslationWriteAttributesLanguageCodeEnum = typeof GuestRoomTranslationWriteAttributesLanguageCodeEnum[keyof typeof GuestRoomTranslationWriteAttributesLanguageCodeEnum];

/**
 * 
 * @export
 * @interface GuestRoomWrite
 */
export interface GuestRoomWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof GuestRoomWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof GuestRoomWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof GuestRoomWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomWriteAttributes}
     * @memberof GuestRoomWrite
     */
    'attributes'?: GuestRoomWriteAttributes;
    /**
     * 
     * @type {CreateBookingCartRequestDataRelationships}
     * @memberof GuestRoomWrite
     */
    'relationships'?: CreateBookingCartRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface GuestRoomWriteAttributes
 */
export interface GuestRoomWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof GuestRoomWriteAttributes
     */
    'availabilityStatus'?: GuestRoomWriteAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomWriteAttributes
     */
    'count'?: number;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomWriteAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GuestRoomWriteAttributes
     */
    'fictitious'?: boolean;
    /**
     * Custom object ordering position
     * @type {number}
     * @memberof GuestRoomWriteAttributes
     */
    'index'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomWriteAttributes
     */
    'immersiveUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomWriteAttributes
     */
    'minNights'?: number;
    /**
     * 
     * @type {string}
     * @memberof GuestRoomWriteAttributes
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GuestRoomWriteAttributes
     */
    'occupancyTypes': Array<GuestRoomWriteAttributesOccupancyTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomWriteAttributes
     */
    'roomHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomWriteAttributes
     */
    'roomLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomWriteAttributes
     */
    'roomWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof GuestRoomWriteAttributes
     */
    'surfaceMeters'?: number;
    /**
     * 
     * @type {File}
     * @memberof GuestRoomWriteAttributes
     */
    'thumbnail'?: File;
    /**
     * 
     * @type {Array<string>}
     * @memberof GuestRoomWriteAttributes
     */
    'segmentationTypes'?: Array<GuestRoomWriteAttributesSegmentationTypesEnum>;
}

export const GuestRoomWriteAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type GuestRoomWriteAttributesAvailabilityStatusEnum = typeof GuestRoomWriteAttributesAvailabilityStatusEnum[keyof typeof GuestRoomWriteAttributesAvailabilityStatusEnum];
export const GuestRoomWriteAttributesOccupancyTypesEnum = {
    Single10: 'single-1-0',
    Double20: 'double-2-0',
    Double11: 'double-1-1',
    Triple30: 'triple-3-0',
    Triple21: 'triple-2-1',
    Triple12: 'triple-1-2',
    Quadruple40: 'quadruple-4-0',
    Quadruple31: 'quadruple-3-1',
    Quadruple22: 'quadruple-2-2',
    Quadruple13: 'quadruple-1-3',
    Quintuple50: 'quintuple-5-0',
    Quintuple41: 'quintuple-4-1',
    Quintuple32: 'quintuple-3-2',
    Quintuple23: 'quintuple-2-3',
    Quintuple14: 'quintuple-1-4'
} as const;

export type GuestRoomWriteAttributesOccupancyTypesEnum = typeof GuestRoomWriteAttributesOccupancyTypesEnum[keyof typeof GuestRoomWriteAttributesOccupancyTypesEnum];
export const GuestRoomWriteAttributesSegmentationTypesEnum = {
    Congress: 'CONGRESS',
    GroupTravel: 'GROUP_TRAVEL',
    Incentives: 'INCENTIVES',
    MeetingOrConference: 'MEETING_OR_CONFERENCE',
    SocialEvent: 'SOCIAL_EVENT',
    Wedding: 'WEDDING'
} as const;

export type GuestRoomWriteAttributesSegmentationTypesEnum = typeof GuestRoomWriteAttributesSegmentationTypesEnum[keyof typeof GuestRoomWriteAttributesSegmentationTypesEnum];

/**
 * 
 * @export
 * @interface HotelChainRead
 */
export interface HotelChainRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof HotelChainRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof HotelChainRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof HotelChainRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {HotelChainReadAttributes}
     * @memberof HotelChainRead
     */
    'attributes'?: HotelChainReadAttributes;
}
/**
 * 
 * @export
 * @interface HotelChainReadAttributes
 */
export interface HotelChainReadAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof HotelChainReadAttributes
     */
    'allowGuestroomBooking'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HotelChainReadAttributes
     */
    'allowGuestroomOnlyBooking'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'facebookUrl'?: string;
    /**
     * 
     * @type {File}
     * @memberof HotelChainReadAttributes
     */
    'favicon'?: File;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'gaTrackingId'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'instagramUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'linkedinUrl'?: string;
    /**
     * 
     * @type {File}
     * @memberof HotelChainReadAttributes
     */
    'logoNegative'?: File;
    /**
     * 
     * @type {File}
     * @memberof HotelChainReadAttributes
     */
    'logoPositive'?: File;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'mainTypography'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'pinterestUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'primaryColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'quaternaryColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'secondaryColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'secondaryTypography'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'shortUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'tertiaryColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'tripadvisorUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'twitterUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'youtubeUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'privacyPolicyUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'cookiesPolicyUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelChainReadAttributes
     */
    'legalNoticeUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HotelChainReadAttributes
     */
    'hasPublicMeetingRooms'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HotelChainReadAttributes
     */
    'hasPublicGuestRooms'?: boolean;
}
/**
 * 
 * @export
 * @interface HotelRead
 */
export interface HotelRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof HotelRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof HotelRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof HotelRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {HotelReadAttributes}
     * @memberof HotelRead
     */
    'attributes'?: HotelReadAttributes;
    /**
     * 
     * @type {HotelReadRelationships}
     * @memberof HotelRead
     */
    'relationships'?: HotelReadRelationships;
}
/**
 * 
 * @export
 * @interface HotelReadAttributes
 */
export interface HotelReadAttributes {
    /**
     * 
     * @type {number}
     * @memberof HotelReadAttributes
     */
    'acceptCcPayments'?: number;
    /**
     * 
     * @type {number}
     * @memberof HotelReadAttributes
     */
    'acceptRfp'?: number;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'address'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HotelReadAttributes
     */
    'bookGuestRooms'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HotelReadAttributes
     */
    'capacity'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'customDomain'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof HotelReadAttributes
     */
    'distanceToAirport'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HotelReadAttributes
     */
    'guestRoomsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'location'?: string | null;
    /**
     * 
     * @type {GuestRoomReadAttributesThumbnail}
     * @memberof HotelReadAttributes
     */
    'logoNegative': GuestRoomReadAttributesThumbnail;
    /**
     * 
     * @type {GuestRoomReadAttributesThumbnail}
     * @memberof HotelReadAttributes
     */
    'logoPositive': GuestRoomReadAttributesThumbnail;
    /**
     * 
     * @type {number}
     * @memberof HotelReadAttributes
     */
    'meetingRoomsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'phone'?: string;
    /**
     * 
     * @type {number}
     * @memberof HotelReadAttributes
     */
    'priceDurationDays'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'primaryColor'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HotelReadAttributes
     */
    'rackPrice'?: number;
    /**
     * 
     * @type {Array<GenericOrderActivityReadAttributesFrozenChargeType>}
     * @memberof HotelReadAttributes
     */
    'rentalTypes'?: Array<GenericOrderActivityReadAttributesFrozenChargeType>;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'secondaryColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'shortUuid'?: string;
    /**
     * If disabled, Meeting Room prices having 0.0 amount will be displayed as --.
     * @type {boolean}
     * @memberof HotelReadAttributes
     */
    'showZeroPrices'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'slug'?: string;
    /**
     * 
     * @type {number}
     * @memberof HotelReadAttributes
     */
    'stars'?: HotelReadAttributesStarsEnum;
    /**
     * 
     * @type {boolean}
     * @memberof HotelReadAttributes
     */
    'taxesIncluded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'termsAndConditions'?: string;
    /**
     * 
     * @type {GuestRoomReadAttributesThumbnail}
     * @memberof HotelReadAttributes
     */
    'thumbnail': GuestRoomReadAttributesThumbnail;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'touristTaxInformation'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'zipcode'?: string;
    /**
     * 
     * @type {string}
     * @memberof HotelReadAttributes
     */
    'floorplanUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HotelReadAttributes
     */
    'hasPublicMeetingRooms'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HotelReadAttributes
     */
    'hasPublicGuestRooms'?: boolean;
}

export const HotelReadAttributesStarsEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;

export type HotelReadAttributesStarsEnum = typeof HotelReadAttributesStarsEnum[keyof typeof HotelReadAttributesStarsEnum];

/**
 * 
 * @export
 * @interface HotelReadRelationships
 */
export interface HotelReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof HotelReadRelationships
     */
    'brand': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof HotelReadRelationships
     */
    'city'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof HotelReadRelationships
     */
    'country'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof HotelReadRelationships
     */
    'currency'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof HotelReadRelationships
     */
    'hotelChain': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof HotelReadRelationships
     */
    'region'?: Reltoone;
    /**
     * 
     * @type {Reltomany}
     * @memberof HotelReadRelationships
     */
    'virtualObjects': Reltomany;
}
/**
 * 
 * @export
 * @interface HotelRoomSetup
 */
export interface HotelRoomSetup {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof HotelRoomSetup
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof HotelRoomSetup
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof HotelRoomSetup
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {HotelRoomSetupAttributes}
     * @memberof HotelRoomSetup
     */
    'attributes'?: HotelRoomSetupAttributes;
}
/**
 * 
 * @export
 * @interface HotelRoomSetupAttributes
 */
export interface HotelRoomSetupAttributes {
    /**
     * 
     * @type {string}
     * @memberof HotelRoomSetupAttributes
     */
    'setupType': string;
    /**
     * 
     * @type {string}
     * @memberof HotelRoomSetupAttributes
     */
    'setupTypeDisplay': string;
}
/**
 * 
 * @export
 * @interface Include
 */
export interface Include {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof Include
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof Include
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Include
     */
    'attributes'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Include
     */
    'relationships'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof Include
     */
    'links'?: { [key: string]: Link; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Include
     */
    'meta'?: { [key: string]: any; };
}
/**
 * The server\'s implementation
 * @export
 * @interface Jsonapi
 */
export interface Jsonapi {
    /**
     * 
     * @type {string}
     * @memberof Jsonapi
     */
    'version'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Jsonapi
     */
    'meta'?: { [key: string]: any; };
}
/**
 * @type Link
 * @export
 */
export type Link = LinkOneOf | string;

/**
 * 
 * @export
 * @interface LinkOneOf
 */
export interface LinkOneOf {
    /**
     * a string containing the link\'s URL
     * @type {string}
     * @memberof LinkOneOf
     */
    'href': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof LinkOneOf
     */
    'meta'?: { [key: string]: any; };
}
/**
 * the \'type\' and \'id\'
 * @export
 * @interface Linkage
 */
export interface Linkage {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof Linkage
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof Linkage
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Linkage
     */
    'meta'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ListCommonCities200Response
 */
export interface ListCommonCities200Response {
    /**
     * 
     * @type {Array<CityRead>}
     * @memberof ListCommonCities200Response
     */
    'data': Array<CityRead>;
    /**
     * 
     * @type {Set<Include>}
     * @memberof ListCommonCities200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof ListCommonCities200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof ListCommonCities200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface ListDiagrammingDollhouseSchemas200Response
 */
export interface ListDiagrammingDollhouseSchemas200Response {
    /**
     * 
     * @type {Array<DollhouseSchemaRead>}
     * @memberof ListDiagrammingDollhouseSchemas200Response
     */
    'data': Array<DollhouseSchemaRead>;
    /**
     * 
     * @type {Set<Include>}
     * @memberof ListDiagrammingDollhouseSchemas200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof ListDiagrammingDollhouseSchemas200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof ListDiagrammingDollhouseSchemas200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface ListDiagrammingVirtualFurnitures200Response
 */
export interface ListDiagrammingVirtualFurnitures200Response {
    /**
     * 
     * @type {Array<VirtualFurniture>}
     * @memberof ListDiagrammingVirtualFurnitures200Response
     */
    'data': Array<VirtualFurniture>;
    /**
     * 
     * @type {Set<Include>}
     * @memberof ListDiagrammingVirtualFurnitures200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof ListDiagrammingVirtualFurnitures200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof ListDiagrammingVirtualFurnitures200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface ListDiagrammingVirtualMeetingRoomSetupTemplates200Response
 */
export interface ListDiagrammingVirtualMeetingRoomSetupTemplates200Response {
    /**
     * 
     * @type {Array<VirtualMeetingRoomSetupTemplateRead>}
     * @memberof ListDiagrammingVirtualMeetingRoomSetupTemplates200Response
     */
    'data': Array<VirtualMeetingRoomSetupTemplateRead>;
    /**
     * 
     * @type {Set<Include>}
     * @memberof ListDiagrammingVirtualMeetingRoomSetupTemplates200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof ListDiagrammingVirtualMeetingRoomSetupTemplates200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof ListDiagrammingVirtualMeetingRoomSetupTemplates200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface ListDiagrammingVirtualObjects200Response
 */
export interface ListDiagrammingVirtualObjects200Response {
    /**
     * 
     * @type {Array<VirtualObject>}
     * @memberof ListDiagrammingVirtualObjects200Response
     */
    'data': Array<VirtualObject>;
    /**
     * 
     * @type {Set<Include>}
     * @memberof ListDiagrammingVirtualObjects200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof ListDiagrammingVirtualObjects200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof ListDiagrammingVirtualObjects200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface ListInventoryEventPackages200Response
 */
export interface ListInventoryEventPackages200Response {
    /**
     * 
     * @type {Array<EventPackageRead>}
     * @memberof ListInventoryEventPackages200Response
     */
    'data': Array<EventPackageRead>;
    /**
     * 
     * @type {Set<Include>}
     * @memberof ListInventoryEventPackages200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof ListInventoryEventPackages200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof ListInventoryEventPackages200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface ListInventoryGuestRooms200Response
 */
export interface ListInventoryGuestRooms200Response {
    /**
     * 
     * @type {Array<GuestRoomRead>}
     * @memberof ListInventoryGuestRooms200Response
     */
    'data': Array<GuestRoomRead>;
    /**
     * 
     * @type {Set<Include>}
     * @memberof ListInventoryGuestRooms200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof ListInventoryGuestRooms200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof ListInventoryGuestRooms200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * Link members related to primary data
 * @export
 * @interface ListInventoryGuestRooms200ResponseLinks
 */
export interface ListInventoryGuestRooms200ResponseLinks {
    /**
     * 
     * @type {Pageref}
     * @memberof ListInventoryGuestRooms200ResponseLinks
     */
    'first'?: Pageref;
    /**
     * 
     * @type {Pageref}
     * @memberof ListInventoryGuestRooms200ResponseLinks
     */
    'last'?: Pageref;
    /**
     * 
     * @type {Pageref}
     * @memberof ListInventoryGuestRooms200ResponseLinks
     */
    'prev'?: Pageref;
    /**
     * 
     * @type {Pageref}
     * @memberof ListInventoryGuestRooms200ResponseLinks
     */
    'next'?: Pageref;
}
/**
 * 
 * @export
 * @interface ListInventoryHotelRoomSetups200Response
 */
export interface ListInventoryHotelRoomSetups200Response {
    /**
     * 
     * @type {Array<HotelRoomSetup>}
     * @memberof ListInventoryHotelRoomSetups200Response
     */
    'data': Array<HotelRoomSetup>;
    /**
     * 
     * @type {Set<Include>}
     * @memberof ListInventoryHotelRoomSetups200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof ListInventoryHotelRoomSetups200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof ListInventoryHotelRoomSetups200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface ListInventoryHotels200Response
 */
export interface ListInventoryHotels200Response {
    /**
     * 
     * @type {Array<HotelRead>}
     * @memberof ListInventoryHotels200Response
     */
    'data': Array<HotelRead>;
    /**
     * 
     * @type {Set<Include>}
     * @memberof ListInventoryHotels200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof ListInventoryHotels200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof ListInventoryHotels200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface ListInventoryMeetingRooms200Response
 */
export interface ListInventoryMeetingRooms200Response {
    /**
     * 
     * @type {Array<MeetingRoomRead>}
     * @memberof ListInventoryMeetingRooms200Response
     */
    'data': Array<MeetingRoomRead>;
    /**
     * 
     * @type {Set<Include>}
     * @memberof ListInventoryMeetingRooms200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof ListInventoryMeetingRooms200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof ListInventoryMeetingRooms200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface ListInventoryServices200Response
 */
export interface ListInventoryServices200Response {
    /**
     * 
     * @type {Array<ServiceRead>}
     * @memberof ListInventoryServices200Response
     */
    'data': Array<ServiceRead>;
    /**
     * 
     * @type {Set<Include>}
     * @memberof ListInventoryServices200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof ListInventoryServices200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof ListInventoryServices200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface MeetingRoomBlockBase
 */
export interface MeetingRoomBlockBase {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomBlockBase
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomBlockBase
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomBlockBase
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {MeetingRoomBlockBaseAttributes}
     * @memberof MeetingRoomBlockBase
     */
    'attributes'?: MeetingRoomBlockBaseAttributes;
    /**
     * 
     * @type {MeetingRoomTranslationReadRelationships}
     * @memberof MeetingRoomBlockBase
     */
    'relationships'?: MeetingRoomTranslationReadRelationships;
}
/**
 * 
 * @export
 * @interface MeetingRoomBlockBaseAttributes
 */
export interface MeetingRoomBlockBaseAttributes {
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomBlockBaseAttributes
     */
    'endsAt': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomBlockBaseAttributes
     */
    'internalNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomBlockBaseAttributes
     */
    'startsAt': string;
}
/**
 * 
 * @export
 * @interface MeetingRoomBlockRead
 */
export interface MeetingRoomBlockRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomBlockRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomBlockRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomBlockRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {MeetingRoomBlockReadAttributes}
     * @memberof MeetingRoomBlockRead
     */
    'attributes'?: MeetingRoomBlockReadAttributes;
    /**
     * 
     * @type {MeetingRoomTranslationReadRelationships}
     * @memberof MeetingRoomBlockRead
     */
    'relationships'?: MeetingRoomTranslationReadRelationships;
}
/**
 * 
 * @export
 * @interface MeetingRoomBlockReadAttributes
 */
export interface MeetingRoomBlockReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomBlockReadAttributes
     */
    'endsAt': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomBlockReadAttributes
     */
    'internalNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomBlockReadAttributes
     */
    'startsAt': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomBlockReadAttributes
     */
    'blockReason'?: MeetingRoomBlockReadAttributesBlockReasonEnum;
}

export const MeetingRoomBlockReadAttributesBlockReasonEnum = {
    Automatic: 'automatic',
    Manual: 'manual'
} as const;

export type MeetingRoomBlockReadAttributesBlockReasonEnum = typeof MeetingRoomBlockReadAttributesBlockReasonEnum[keyof typeof MeetingRoomBlockReadAttributesBlockReasonEnum];

/**
 * 
 * @export
 * @interface MeetingRoomBookingSetupRead
 */
export interface MeetingRoomBookingSetupRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomBookingSetupRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomBookingSetupRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomBookingSetupRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {MeetingRoomBookingSetupReadAttributes}
     * @memberof MeetingRoomBookingSetupRead
     */
    'attributes'?: MeetingRoomBookingSetupReadAttributes;
}
/**
 * 
 * @export
 * @interface MeetingRoomBookingSetupReadAttributes
 */
export interface MeetingRoomBookingSetupReadAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'monday'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'tuesday'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'wednesday'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'thursday'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'friday'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'saturday'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'sunday'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'startHour'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'endHour'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'preparationMinutes'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'minPreDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'minPreHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'minHoursDuration'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'minPax'?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomBookingSetupReadAttributes
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface MeetingRoomBookingSetupWrite
 */
export interface MeetingRoomBookingSetupWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomBookingSetupWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomBookingSetupWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomBookingSetupWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {MeetingRoomBookingSetupWriteAttributes}
     * @memberof MeetingRoomBookingSetupWrite
     */
    'attributes'?: MeetingRoomBookingSetupWriteAttributes;
}
/**
 * 
 * @export
 * @interface MeetingRoomBookingSetupWriteAttributes
 */
export interface MeetingRoomBookingSetupWriteAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomBookingSetupWriteAttributes
     */
    'monday'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomBookingSetupWriteAttributes
     */
    'tuesday'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomBookingSetupWriteAttributes
     */
    'wednesday'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomBookingSetupWriteAttributes
     */
    'thursday'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomBookingSetupWriteAttributes
     */
    'friday'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomBookingSetupWriteAttributes
     */
    'saturday'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomBookingSetupWriteAttributes
     */
    'sunday'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomBookingSetupWriteAttributes
     */
    'startHour'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomBookingSetupWriteAttributes
     */
    'endHour'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomBookingSetupWriteAttributes
     */
    'preparationMinutes'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomBookingSetupWriteAttributes
     */
    'minPreDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomBookingSetupWriteAttributes
     */
    'minPreHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomBookingSetupWriteAttributes
     */
    'minHoursDuration'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomBookingSetupWriteAttributes
     */
    'minPax'?: number;
}
/**
 * 
 * @export
 * @interface MeetingRoomRateCurrencyRead
 */
export interface MeetingRoomRateCurrencyRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomRateCurrencyRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomRateCurrencyRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomRateCurrencyRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomRateCurrencyReadAttributes}
     * @memberof MeetingRoomRateCurrencyRead
     */
    'attributes'?: GuestRoomRateCurrencyReadAttributes;
    /**
     * 
     * @type {MeetingRoomRateCurrencyReadRelationships}
     * @memberof MeetingRoomRateCurrencyRead
     */
    'relationships'?: MeetingRoomRateCurrencyReadRelationships;
}
/**
 * 
 * @export
 * @interface MeetingRoomRateCurrencyReadRelationships
 */
export interface MeetingRoomRateCurrencyReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof MeetingRoomRateCurrencyReadRelationships
     */
    'currency': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof MeetingRoomRateCurrencyReadRelationships
     */
    'meetingRoomRate': Reltoone;
}
/**
 * 
 * @export
 * @interface MeetingRoomRateCurrencyWrite
 */
export interface MeetingRoomRateCurrencyWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomRateCurrencyWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomRateCurrencyWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomRateCurrencyWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomRateCurrencyWriteAttributes}
     * @memberof MeetingRoomRateCurrencyWrite
     */
    'attributes'?: GuestRoomRateCurrencyWriteAttributes;
    /**
     * 
     * @type {MeetingRoomRateCurrencyReadRelationships}
     * @memberof MeetingRoomRateCurrencyWrite
     */
    'relationships'?: MeetingRoomRateCurrencyReadRelationships;
}
/**
 * 
 * @export
 * @interface MeetingRoomRateRead
 */
export interface MeetingRoomRateRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomRateRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomRateRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomRateRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {MeetingRoomRateReadAttributes}
     * @memberof MeetingRoomRateRead
     */
    'attributes'?: MeetingRoomRateReadAttributes;
    /**
     * 
     * @type {MeetingRoomRateReadRelationships}
     * @memberof MeetingRoomRateRead
     */
    'relationships'?: MeetingRoomRateReadRelationships;
}
/**
 * 
 * @export
 * @interface MeetingRoomRateReadAttributes
 */
export interface MeetingRoomRateReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateReadAttributes
     */
    'activityEndsTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateReadAttributes
     */
    'activityStartsTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateReadAttributes
     */
    'chargeType': MeetingRoomRateReadAttributesChargeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateReadAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomRateReadAttributes
     */
    'maxHoursDuration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomRateReadAttributes
     */
    'minHoursDuration'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateReadAttributes
     */
    'price': string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateReadAttributes
     */
    'travelWindowEndDate': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateReadAttributes
     */
    'travelWindowStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateReadAttributes
     */
    'uuid'?: string;
}

export const MeetingRoomRateReadAttributesChargeTypeEnum = {
    Day: 'day',
    Hour: 'hour',
    Person: 'person'
} as const;

export type MeetingRoomRateReadAttributesChargeTypeEnum = typeof MeetingRoomRateReadAttributesChargeTypeEnum[keyof typeof MeetingRoomRateReadAttributesChargeTypeEnum];

/**
 * 
 * @export
 * @interface MeetingRoomRateReadRelationships
 */
export interface MeetingRoomRateReadRelationships {
    /**
     * 
     * @type {Reltomany}
     * @memberof MeetingRoomRateReadRelationships
     */
    'meetingRoomRateCurrencies': Reltomany;
    /**
     * 
     * @type {Reltomany}
     * @memberof MeetingRoomRateReadRelationships
     */
    'meetingRoomRateRestrictions': Reltomany;
    /**
     * 
     * @type {Reltoone}
     * @memberof MeetingRoomRateReadRelationships
     */
    'meetingRoom': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof MeetingRoomRateReadRelationships
     */
    'rateCode': Reltoone;
}
/**
 * 
 * @export
 * @interface MeetingRoomRateRestrictionRead
 */
export interface MeetingRoomRateRestrictionRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomRateRestrictionRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomRateRestrictionRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomRateRestrictionRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {MeetingRoomRateRestrictionReadAttributes}
     * @memberof MeetingRoomRateRestrictionRead
     */
    'attributes'?: MeetingRoomRateRestrictionReadAttributes;
    /**
     * 
     * @type {MeetingRoomRateRestrictionReadRelationships}
     * @memberof MeetingRoomRateRestrictionRead
     */
    'relationships'?: MeetingRoomRateRestrictionReadRelationships;
}
/**
 * 
 * @export
 * @interface MeetingRoomRateRestrictionReadAttributes
 */
export interface MeetingRoomRateRestrictionReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateRestrictionReadAttributes
     */
    'restrictionType': MeetingRoomRateRestrictionReadAttributesRestrictionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateRestrictionReadAttributes
     */
    'validationType': MeetingRoomRateRestrictionReadAttributesValidationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomRateRestrictionReadAttributes
     */
    'minValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomRateRestrictionReadAttributes
     */
    'maxValue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateRestrictionReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateRestrictionReadAttributes
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateRestrictionReadAttributes
     */
    'updatedAt'?: string;
}

export const MeetingRoomRateRestrictionReadAttributesRestrictionTypeEnum = {
    GuestRooms: 'guest-rooms',
    FoodBeverages: 'food-beverages'
} as const;

export type MeetingRoomRateRestrictionReadAttributesRestrictionTypeEnum = typeof MeetingRoomRateRestrictionReadAttributesRestrictionTypeEnum[keyof typeof MeetingRoomRateRestrictionReadAttributesRestrictionTypeEnum];
export const MeetingRoomRateRestrictionReadAttributesValidationTypeEnum = {
    Units: 'units'
} as const;

export type MeetingRoomRateRestrictionReadAttributesValidationTypeEnum = typeof MeetingRoomRateRestrictionReadAttributesValidationTypeEnum[keyof typeof MeetingRoomRateRestrictionReadAttributesValidationTypeEnum];

/**
 * 
 * @export
 * @interface MeetingRoomRateRestrictionReadRelationships
 */
export interface MeetingRoomRateRestrictionReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof MeetingRoomRateRestrictionReadRelationships
     */
    'meetingRoomRate': Reltoone;
}
/**
 * 
 * @export
 * @interface MeetingRoomRateRestrictionWrite
 */
export interface MeetingRoomRateRestrictionWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomRateRestrictionWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomRateRestrictionWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomRateRestrictionWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {MeetingRoomRateRestrictionWriteAttributes}
     * @memberof MeetingRoomRateRestrictionWrite
     */
    'attributes'?: MeetingRoomRateRestrictionWriteAttributes;
    /**
     * 
     * @type {MeetingRoomRateRestrictionReadRelationships}
     * @memberof MeetingRoomRateRestrictionWrite
     */
    'relationships'?: MeetingRoomRateRestrictionReadRelationships;
}
/**
 * 
 * @export
 * @interface MeetingRoomRateRestrictionWriteAttributes
 */
export interface MeetingRoomRateRestrictionWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateRestrictionWriteAttributes
     */
    'restrictionType': MeetingRoomRateRestrictionWriteAttributesRestrictionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateRestrictionWriteAttributes
     */
    'validationType': MeetingRoomRateRestrictionWriteAttributesValidationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomRateRestrictionWriteAttributes
     */
    'minValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomRateRestrictionWriteAttributes
     */
    'maxValue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateRestrictionWriteAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateRestrictionWriteAttributes
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateRestrictionWriteAttributes
     */
    'updatedAt'?: string;
}

export const MeetingRoomRateRestrictionWriteAttributesRestrictionTypeEnum = {
    GuestRooms: 'guest-rooms',
    FoodBeverages: 'food-beverages'
} as const;

export type MeetingRoomRateRestrictionWriteAttributesRestrictionTypeEnum = typeof MeetingRoomRateRestrictionWriteAttributesRestrictionTypeEnum[keyof typeof MeetingRoomRateRestrictionWriteAttributesRestrictionTypeEnum];
export const MeetingRoomRateRestrictionWriteAttributesValidationTypeEnum = {
    Units: 'units'
} as const;

export type MeetingRoomRateRestrictionWriteAttributesValidationTypeEnum = typeof MeetingRoomRateRestrictionWriteAttributesValidationTypeEnum[keyof typeof MeetingRoomRateRestrictionWriteAttributesValidationTypeEnum];

/**
 * 
 * @export
 * @interface MeetingRoomRateWrite
 */
export interface MeetingRoomRateWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomRateWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomRateWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomRateWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {MeetingRoomRateWriteAttributes}
     * @memberof MeetingRoomRateWrite
     */
    'attributes'?: MeetingRoomRateWriteAttributes;
    /**
     * 
     * @type {MeetingRoomRateWriteRelationships}
     * @memberof MeetingRoomRateWrite
     */
    'relationships'?: MeetingRoomRateWriteRelationships;
}
/**
 * 
 * @export
 * @interface MeetingRoomRateWriteAttributes
 */
export interface MeetingRoomRateWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateWriteAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateWriteAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateWriteAttributes
     */
    'activityStartsTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateWriteAttributes
     */
    'activityEndsTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateWriteAttributes
     */
    'price': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateWriteAttributes
     */
    'chargeType': MeetingRoomRateWriteAttributesChargeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateWriteAttributes
     */
    'travelWindowStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateWriteAttributes
     */
    'travelWindowEndDate': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomRateWriteAttributes
     */
    'minHoursDuration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomRateWriteAttributes
     */
    'maxHoursDuration'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateWriteAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateWriteAttributes
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomRateWriteAttributes
     */
    'updatedAt'?: string;
}

export const MeetingRoomRateWriteAttributesChargeTypeEnum = {
    Day: 'day',
    Hour: 'hour',
    Person: 'person'
} as const;

export type MeetingRoomRateWriteAttributesChargeTypeEnum = typeof MeetingRoomRateWriteAttributesChargeTypeEnum[keyof typeof MeetingRoomRateWriteAttributesChargeTypeEnum];

/**
 * 
 * @export
 * @interface MeetingRoomRateWriteRelationships
 */
export interface MeetingRoomRateWriteRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof MeetingRoomRateWriteRelationships
     */
    'meetingRoom': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof MeetingRoomRateWriteRelationships
     */
    'rateCode': Reltoone;
}
/**
 * 
 * @export
 * @interface MeetingRoomRead
 */
export interface MeetingRoomRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {MeetingRoomReadAttributes}
     * @memberof MeetingRoomRead
     */
    'attributes'?: MeetingRoomReadAttributes;
    /**
     * 
     * @type {MeetingRoomReadRelationships}
     * @memberof MeetingRoomRead
     */
    'relationships'?: MeetingRoomReadRelationships;
}
/**
 * 
 * @export
 * @interface MeetingRoomReadAttributes
 */
export interface MeetingRoomReadAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomReadAttributes
     */
    'available': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    'capacity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    'ceilingHeight'?: number | null;
    /**
     * 
     * @type {GenericOrderActivityReadAttributesFrozenChargeType}
     * @memberof MeetingRoomReadAttributes
     */
    'chargeType': GenericOrderActivityReadAttributesFrozenChargeType;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomReadAttributes
     */
    'diagramming'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomReadAttributes
     */
    'exterior'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    'floor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    'immersiveUrl': string;
    /**
     * Custom object ordering position
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    'index'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    'minCapacity'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    'rackPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    'roomHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    'roomLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    'roomWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    'shortUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    'slug'?: string;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    'surfaceMeters'?: number;
    /**
     * 
     * @type {GuestRoomReadAttributesThumbnail}
     * @memberof MeetingRoomReadAttributes
     */
    'thumbnail': GuestRoomReadAttributesThumbnail;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {MeetingRoomReadAttributesRate}
     * @memberof MeetingRoomReadAttributes
     */
    'rate'?: MeetingRoomReadAttributesRate;
}
/**
 * 
 * @export
 * @interface MeetingRoomReadAttributesRate
 */
export interface MeetingRoomReadAttributesRate {
    /**
     * 
     * @type {GenericOrderActivityReadAttributesFrozenChargeType}
     * @memberof MeetingRoomReadAttributesRate
     */
    'chargeType': GenericOrderActivityReadAttributesFrozenChargeType;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributesRate
     */
    'price': string;
}
/**
 * 
 * @export
 * @interface MeetingRoomReadRelationships
 */
export interface MeetingRoomReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof MeetingRoomReadRelationships
     */
    'hotel': Reltoone;
    /**
     * 
     * @type {Reltomany}
     * @memberof MeetingRoomReadRelationships
     */
    'meetingRoomSetups': Reltomany;
    /**
     * 
     * @type {Reltomany}
     * @memberof MeetingRoomReadRelationships
     */
    'virtualMeetingRooms': Reltomany;
}
/**
 * 
 * @export
 * @interface MeetingRoomSetupRead
 */
export interface MeetingRoomSetupRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomSetupRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomSetupRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomSetupRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {MeetingRoomSetupReadAttributes}
     * @memberof MeetingRoomSetupRead
     */
    'attributes'?: MeetingRoomSetupReadAttributes;
    /**
     * 
     * @type {MeetingRoomSetupReadRelationships}
     * @memberof MeetingRoomSetupRead
     */
    'relationships'?: MeetingRoomSetupReadRelationships;
}
/**
 * 
 * @export
 * @interface MeetingRoomSetupReadAttributes
 */
export interface MeetingRoomSetupReadAttributes {
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'capacity'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'chairTableGap'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'columnGap'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'columns'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'defaultChairsPerTable'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'distanceBetweenChairAndTable'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'distanceBetweenChairs'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'distanceBetweenTables'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'fcarpetOffset'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'hGapBetweenChairs'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'hGapBetweenTables'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'maxCalculatedCapacity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'maxChairsPerTable'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'maxColumns'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'rowGap'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'tablesPerColumnRow'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'vGapBetweenChairsAndTables'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomSetupReadAttributes
     */
    'vGapBetweenTables'?: number | null;
}
/**
 * 
 * @export
 * @interface MeetingRoomSetupReadRelationships
 */
export interface MeetingRoomSetupReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof MeetingRoomSetupReadRelationships
     */
    'meetingRoom'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof MeetingRoomSetupReadRelationships
     */
    'setupType'?: Reltoone;
}
/**
 * 
 * @export
 * @interface MeetingRoomSetupWrite
 */
export interface MeetingRoomSetupWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomSetupWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomSetupWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomSetupWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {MeetingRoomSetupReadAttributes}
     * @memberof MeetingRoomSetupWrite
     */
    'attributes'?: MeetingRoomSetupReadAttributes;
}
/**
 * 
 * @export
 * @interface MeetingRoomThumbnailWrite
 */
export interface MeetingRoomThumbnailWrite {
    /**
     * 
     * @type {File}
     * @memberof MeetingRoomThumbnailWrite
     */
    'thumbnail'?: File;
}
/**
 * 
 * @export
 * @interface MeetingRoomTranslationRead
 */
export interface MeetingRoomTranslationRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomTranslationRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomTranslationRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomTranslationRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {MeetingRoomTranslationReadAttributes}
     * @memberof MeetingRoomTranslationRead
     */
    'attributes'?: MeetingRoomTranslationReadAttributes;
    /**
     * 
     * @type {MeetingRoomTranslationReadRelationships}
     * @memberof MeetingRoomTranslationRead
     */
    'relationships'?: MeetingRoomTranslationReadRelationships;
}
/**
 * 
 * @export
 * @interface MeetingRoomTranslationReadAttributes
 */
export interface MeetingRoomTranslationReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomTranslationReadAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomTranslationReadAttributes
     */
    'languageCode': MeetingRoomTranslationReadAttributesLanguageCodeEnum;
}

export const MeetingRoomTranslationReadAttributesLanguageCodeEnum = {
    En: 'en',
    It: 'it',
    Es: 'es',
    Fr: 'fr',
    Pt: 'pt',
    De: 'de'
} as const;

export type MeetingRoomTranslationReadAttributesLanguageCodeEnum = typeof MeetingRoomTranslationReadAttributesLanguageCodeEnum[keyof typeof MeetingRoomTranslationReadAttributesLanguageCodeEnum];

/**
 * 
 * @export
 * @interface MeetingRoomTranslationReadRelationships
 */
export interface MeetingRoomTranslationReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof MeetingRoomTranslationReadRelationships
     */
    'meetingRoom': Reltoone;
}
/**
 * 
 * @export
 * @interface MeetingRoomTranslationWrite
 */
export interface MeetingRoomTranslationWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomTranslationWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomTranslationWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomTranslationWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {MeetingRoomTranslationWriteAttributes}
     * @memberof MeetingRoomTranslationWrite
     */
    'attributes'?: MeetingRoomTranslationWriteAttributes;
    /**
     * 
     * @type {MeetingRoomTranslationReadRelationships}
     * @memberof MeetingRoomTranslationWrite
     */
    'relationships'?: MeetingRoomTranslationReadRelationships;
}
/**
 * 
 * @export
 * @interface MeetingRoomTranslationWriteAttributes
 */
export interface MeetingRoomTranslationWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomTranslationWriteAttributes
     */
    'languageCode': MeetingRoomTranslationWriteAttributesLanguageCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomTranslationWriteAttributes
     */
    'description'?: string;
}

export const MeetingRoomTranslationWriteAttributesLanguageCodeEnum = {
    En: 'en',
    It: 'it',
    Es: 'es',
    Fr: 'fr',
    Pt: 'pt',
    De: 'de'
} as const;

export type MeetingRoomTranslationWriteAttributesLanguageCodeEnum = typeof MeetingRoomTranslationWriteAttributesLanguageCodeEnum[keyof typeof MeetingRoomTranslationWriteAttributesLanguageCodeEnum];

/**
 * 
 * @export
 * @interface MeetingRoomWrite
 */
export interface MeetingRoomWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof MeetingRoomWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof MeetingRoomWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof MeetingRoomWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {MeetingRoomWriteAttributes}
     * @memberof MeetingRoomWrite
     */
    'attributes'?: MeetingRoomWriteAttributes;
    /**
     * 
     * @type {CreateBookingCartRequestDataRelationships}
     * @memberof MeetingRoomWrite
     */
    'relationships'?: CreateBookingCartRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface MeetingRoomWriteAttributes
 */
export interface MeetingRoomWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomWriteAttributes
     */
    'availabilityStatus'?: MeetingRoomWriteAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomWriteAttributes
     */
    'capacity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomWriteAttributes
     */
    'ceilingHeight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomWriteAttributes
     */
    'chargeType'?: MeetingRoomWriteAttributesChargeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomWriteAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomWriteAttributes
     */
    'exterior'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomWriteAttributes
     */
    'floor'?: string | null;
    /**
     * Custom object ordering position
     * @type {number}
     * @memberof MeetingRoomWriteAttributes
     */
    'index'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomWriteAttributes
     */
    'immersiveUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomWriteAttributes
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomWriteAttributes
     */
    'roomHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomWriteAttributes
     */
    'roomLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomWriteAttributes
     */
    'roomWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomWriteAttributes
     */
    'surfaceMeters'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MeetingRoomWriteAttributes
     */
    'segmentationTypes'?: Array<MeetingRoomWriteAttributesSegmentationTypesEnum>;
}

export const MeetingRoomWriteAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type MeetingRoomWriteAttributesAvailabilityStatusEnum = typeof MeetingRoomWriteAttributesAvailabilityStatusEnum[keyof typeof MeetingRoomWriteAttributesAvailabilityStatusEnum];
export const MeetingRoomWriteAttributesChargeTypeEnum = {
    Day: 'day',
    Hour: 'hour',
    Person: 'person'
} as const;

export type MeetingRoomWriteAttributesChargeTypeEnum = typeof MeetingRoomWriteAttributesChargeTypeEnum[keyof typeof MeetingRoomWriteAttributesChargeTypeEnum];
export const MeetingRoomWriteAttributesSegmentationTypesEnum = {
    Congress: 'CONGRESS',
    GroupTravel: 'GROUP_TRAVEL',
    Incentives: 'INCENTIVES',
    MeetingOrConference: 'MEETING_OR_CONFERENCE',
    SocialEvent: 'SOCIAL_EVENT',
    Wedding: 'WEDDING'
} as const;

export type MeetingRoomWriteAttributesSegmentationTypesEnum = typeof MeetingRoomWriteAttributesSegmentationTypesEnum[keyof typeof MeetingRoomWriteAttributesSegmentationTypesEnum];

/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'status'?: string;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof ModelError
     */
    'links'?: { [key: string]: Link; };
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'detail'?: string;
    /**
     * 
     * @type {ErrorSource}
     * @memberof ModelError
     */
    'source'?: ErrorSource;
}
/**
 * 
 * @export
 * @interface Onlymeta
 */
export interface Onlymeta {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Onlymeta
     */
    'meta'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface OrderAttachmentRead
 */
export interface OrderAttachmentRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderAttachmentRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderAttachmentRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderAttachmentRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderAttachmentReadAttributes}
     * @memberof OrderAttachmentRead
     */
    'attributes'?: OrderAttachmentReadAttributes;
    /**
     * 
     * @type {OrderAttachmentReadRelationships}
     * @memberof OrderAttachmentRead
     */
    'relationships'?: OrderAttachmentReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderAttachmentReadAttributes
 */
export interface OrderAttachmentReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderAttachmentReadAttributes
     */
    'attachmentType': OrderAttachmentReadAttributesAttachmentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachmentReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachmentReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachmentReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachmentReadAttributes
     */
    'fileContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachmentReadAttributes
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachmentReadAttributes
     */
    'fileExtension'?: string;
}

export const OrderAttachmentReadAttributesAttachmentTypeEnum = {
    Beo: 'beo',
    Contract: 'contract',
    Proposal: 'proposal',
    Proforma: 'proforma',
    Other: 'other'
} as const;

export type OrderAttachmentReadAttributesAttachmentTypeEnum = typeof OrderAttachmentReadAttributesAttachmentTypeEnum[keyof typeof OrderAttachmentReadAttributesAttachmentTypeEnum];

/**
 * 
 * @export
 * @interface OrderAttachmentReadRelationships
 */
export interface OrderAttachmentReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderAttachmentReadRelationships
     */
    'order': Reltoone;
}
/**
 * 
 * @export
 * @interface OrderAttachmentUpload
 */
export interface OrderAttachmentUpload {
    /**
     * 
     * @type {string}
     * @memberof OrderAttachmentUpload
     */
    'attachment_type': OrderAttachmentUploadAttachmentTypeEnum;
    /**
     * 
     * @type {File}
     * @memberof OrderAttachmentUpload
     */
    'file': File;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachmentUpload
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof OrderAttachmentUpload
     */
    'order': number;
}

export const OrderAttachmentUploadAttachmentTypeEnum = {
    Beo: 'beo',
    Contract: 'contract',
    Proposal: 'proposal',
    Proforma: 'proforma',
    Other: 'other'
} as const;

export type OrderAttachmentUploadAttachmentTypeEnum = typeof OrderAttachmentUploadAttachmentTypeEnum[keyof typeof OrderAttachmentUploadAttachmentTypeEnum];

/**
 * 
 * @export
 * @interface OrderAttachmentWrite
 */
export interface OrderAttachmentWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderAttachmentWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderAttachmentWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderAttachmentWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderAttachmentWriteAttributes}
     * @memberof OrderAttachmentWrite
     */
    'attributes'?: OrderAttachmentWriteAttributes;
    /**
     * 
     * @type {OrderAttachmentWriteRelationships}
     * @memberof OrderAttachmentWrite
     */
    'relationships'?: OrderAttachmentWriteRelationships;
}
/**
 * 
 * @export
 * @interface OrderAttachmentWriteAttributes
 */
export interface OrderAttachmentWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderAttachmentWriteAttributes
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrderAttachmentWriteRelationships
 */
export interface OrderAttachmentWriteRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderAttachmentWriteRelationships
     */
    'order'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderAttachmentWriteRelationships
     */
    'template'?: Reltoone;
}
/**
 * 
 * @export
 * @interface OrderCancelReasonChoiceRead
 */
export interface OrderCancelReasonChoiceRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderCancelReasonChoiceRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderCancelReasonChoiceRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderCancelReasonChoiceRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderCancelReasonChoiceReadAttributes}
     * @memberof OrderCancelReasonChoiceRead
     */
    'attributes'?: OrderCancelReasonChoiceReadAttributes;
    /**
     * 
     * @type {OrderCancelReasonChoiceReadRelationships}
     * @memberof OrderCancelReasonChoiceRead
     */
    'relationships'?: OrderCancelReasonChoiceReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderCancelReasonChoiceReadAttributes
 */
export interface OrderCancelReasonChoiceReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderCancelReasonChoiceReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderCancelReasonChoiceReadAttributes
     */
    'code': OrderCancelReasonChoiceReadAttributesCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderCancelReasonChoiceReadAttributes
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderCancelReasonChoiceReadAttributes
     */
    'updatedAt'?: string;
}

export const OrderCancelReasonChoiceReadAttributesCodeEnum = {
    AlternativeDatesDenied: 'alternative-dates-denied',
    CapacityGuestRooms: 'capacity-guest-rooms',
    CapacityMeetingRooms: 'capacity-meeting-rooms',
    ContractedAnotherHotel: 'contracted-another-hotel',
    DestinationChange: 'destination-change',
    Intermediary: 'intermediary',
    Others: 'others',
    Rates: 'rates'
} as const;

export type OrderCancelReasonChoiceReadAttributesCodeEnum = typeof OrderCancelReasonChoiceReadAttributesCodeEnum[keyof typeof OrderCancelReasonChoiceReadAttributesCodeEnum];

/**
 * 
 * @export
 * @interface OrderCancelReasonChoiceReadRelationships
 */
export interface OrderCancelReasonChoiceReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderCancelReasonChoiceReadRelationships
     */
    'hotelChain': Reltoone;
}
/**
 * 
 * @export
 * @interface OrderChannelChoiceRead
 */
export interface OrderChannelChoiceRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderChannelChoiceRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderChannelChoiceRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderChannelChoiceRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderChannelChoiceReadAttributes}
     * @memberof OrderChannelChoiceRead
     */
    'attributes'?: OrderChannelChoiceReadAttributes;
    /**
     * 
     * @type {OrderCancelReasonChoiceReadRelationships}
     * @memberof OrderChannelChoiceRead
     */
    'relationships'?: OrderCancelReasonChoiceReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderChannelChoiceReadAttributes
 */
export interface OrderChannelChoiceReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderChannelChoiceReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderChannelChoiceReadAttributes
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderChannelChoiceReadAttributes
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface OrderChannelChoiceWrite
 */
export interface OrderChannelChoiceWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderChannelChoiceWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderChannelChoiceWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderChannelChoiceWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderChannelChoiceWriteAttributes}
     * @memberof OrderChannelChoiceWrite
     */
    'attributes'?: OrderChannelChoiceWriteAttributes;
    /**
     * 
     * @type {OrderCancelReasonChoiceReadRelationships}
     * @memberof OrderChannelChoiceWrite
     */
    'relationships'?: OrderCancelReasonChoiceReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderChannelChoiceWriteAttributes
 */
export interface OrderChannelChoiceWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderChannelChoiceWriteAttributes
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface OrderEventPackageApplyCommission
 */
export interface OrderEventPackageApplyCommission {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderEventPackageApplyCommission
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderEventPackageApplyCommission
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderEventPackageApplyCommission
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderActivityApplyCommissionAttributes}
     * @memberof OrderEventPackageApplyCommission
     */
    'attributes'?: GenericOrderActivityApplyCommissionAttributes;
}
/**
 * 
 * @export
 * @interface OrderEventPackageApplyDiscount
 */
export interface OrderEventPackageApplyDiscount {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderEventPackageApplyDiscount
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderEventPackageApplyDiscount
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderEventPackageApplyDiscount
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderActivityApplyDiscountAttributes}
     * @memberof OrderEventPackageApplyDiscount
     */
    'attributes'?: GenericOrderActivityApplyDiscountAttributes;
}
/**
 * 
 * @export
 * @interface OrderEventPackageCreate
 */
export interface OrderEventPackageCreate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderEventPackageCreate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderEventPackageCreate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderEventPackageCreate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderEventPackageCreateAttributes}
     * @memberof OrderEventPackageCreate
     */
    'attributes'?: OrderEventPackageCreateAttributes;
    /**
     * 
     * @type {CreateBookingCartEventPackagesRequestDataRelationships}
     * @memberof OrderEventPackageCreate
     */
    'relationships'?: CreateBookingCartEventPackagesRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface OrderEventPackageCreateAttributes
 */
export interface OrderEventPackageCreateAttributes {
    /**
     * 
     * @type {number}
     * @memberof OrderEventPackageCreateAttributes
     */
    'attendees'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderEventPackageCreateAttributes
     */
    'chargeType'?: OrderEventPackageCreateAttributesChargeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderEventPackageCreateAttributes
     */
    'rackPrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderEventPackageCreateAttributes
     */
    'startDate': string;
}

export const OrderEventPackageCreateAttributesChargeTypeEnum = {
    Fixed: 'fixed',
    Mix: 'mix',
    Person: 'person'
} as const;

export type OrderEventPackageCreateAttributesChargeTypeEnum = typeof OrderEventPackageCreateAttributesChargeTypeEnum[keyof typeof OrderEventPackageCreateAttributesChargeTypeEnum];

/**
 * 
 * @export
 * @interface OrderEventPackageOverridePrice
 */
export interface OrderEventPackageOverridePrice {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderEventPackageOverridePrice
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderEventPackageOverridePrice
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderEventPackageOverridePrice
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderEventPackageOverridePriceAttributes}
     * @memberof OrderEventPackageOverridePrice
     */
    'attributes'?: OrderEventPackageOverridePriceAttributes;
}
/**
 * 
 * @export
 * @interface OrderEventPackageOverridePriceAttributes
 */
export interface OrderEventPackageOverridePriceAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderEventPackageOverridePriceAttributes
     */
    'rackPrice'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrderEventPackageOverridePriceAttributes
     */
    'rackPriceAttendeesThreshold'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrderEventPackageOverridePriceAttributes
     */
    'extraPersonPrice'?: string | null;
}
/**
 * 
 * @export
 * @interface OrderEventPackageRead
 */
export interface OrderEventPackageRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderEventPackageRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderEventPackageRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderEventPackageRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderEventPackageReadAttributes}
     * @memberof OrderEventPackageRead
     */
    'attributes'?: OrderEventPackageReadAttributes;
    /**
     * 
     * @type {CreateBookingCartEventPackagesRequestDataRelationships}
     * @memberof OrderEventPackageRead
     */
    'relationships'?: CreateBookingCartEventPackagesRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface OrderEventPackageReadAttributes
 */
export interface OrderEventPackageReadAttributes {
    /**
     * 
     * @type {number}
     * @memberof OrderEventPackageReadAttributes
     */
    'attendees'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderEventPackageReadAttributes
     */
    'chargeType'?: OrderEventPackageReadAttributesChargeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderEventPackageReadAttributes
     */
    'commission'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderEventPackageReadAttributes
     */
    'extraPersonPrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderEventPackageReadAttributes
     */
    'rackPrice'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrderEventPackageReadAttributes
     */
    'rackPriceAttendeesThreshold'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrderEventPackageReadAttributes
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof OrderEventPackageReadAttributes
     */
    'total'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderEventPackageReadAttributes
     */
    'uuid'?: string;
}

export const OrderEventPackageReadAttributesChargeTypeEnum = {
    Fixed: 'fixed',
    Mix: 'mix',
    Person: 'person'
} as const;

export type OrderEventPackageReadAttributesChargeTypeEnum = typeof OrderEventPackageReadAttributesChargeTypeEnum[keyof typeof OrderEventPackageReadAttributesChargeTypeEnum];

/**
 * 
 * @export
 * @interface OrderEventPackageRefreshPrices
 */
export interface OrderEventPackageRefreshPrices {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderEventPackageRefreshPrices
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderEventPackageRefreshPrices
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderEventPackageRefreshPrices
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
}
/**
 * 
 * @export
 * @interface OrderEventPackageUpdate
 */
export interface OrderEventPackageUpdate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderEventPackageUpdate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderEventPackageUpdate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderEventPackageUpdate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderEventPackageCreateAttributes}
     * @memberof OrderEventPackageUpdate
     */
    'attributes'?: OrderEventPackageCreateAttributes;
    /**
     * 
     * @type {CreateBookingCartEventPackagesRequestDataRelationships}
     * @memberof OrderEventPackageUpdate
     */
    'relationships'?: CreateBookingCartEventPackagesRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface OrderEventPackageWrite
 */
export interface OrderEventPackageWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderEventPackageWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderEventPackageWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderEventPackageWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderEventPackageWriteAttributes}
     * @memberof OrderEventPackageWrite
     */
    'attributes'?: OrderEventPackageWriteAttributes;
    /**
     * 
     * @type {CreateBookingCartEventPackagesRequestDataRelationships}
     * @memberof OrderEventPackageWrite
     */
    'relationships'?: CreateBookingCartEventPackagesRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface OrderEventPackageWriteAttributes
 */
export interface OrderEventPackageWriteAttributes {
    /**
     * 
     * @type {number}
     * @memberof OrderEventPackageWriteAttributes
     */
    'attendees'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderEventPackageWriteAttributes
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof OrderEventPackageWriteAttributes
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface OrderHotelCreate
 */
export interface OrderHotelCreate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderHotelCreate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderHotelCreate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderHotelCreate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderHotelCreateRelationships}
     * @memberof OrderHotelCreate
     */
    'relationships'?: OrderHotelCreateRelationships;
}
/**
 * 
 * @export
 * @interface OrderHotelCreateRelationships
 */
export interface OrderHotelCreateRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderHotelCreateRelationships
     */
    'order': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderHotelCreateRelationships
     */
    'hotel': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderHotelCreateRelationships
     */
    'rateCode'?: Reltoone;
}
/**
 * 
 * @export
 * @interface OrderHotelNoteRead
 */
export interface OrderHotelNoteRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderHotelNoteRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderHotelNoteRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderHotelNoteRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderHotelNoteReadAttributes}
     * @memberof OrderHotelNoteRead
     */
    'attributes'?: OrderHotelNoteReadAttributes;
    /**
     * 
     * @type {OrderHotelNoteReadRelationships}
     * @memberof OrderHotelNoteRead
     */
    'relationships'?: OrderHotelNoteReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderHotelNoteReadAttributes
 */
export interface OrderHotelNoteReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderHotelNoteReadAttributes
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderHotelNoteReadAttributes
     */
    'noteDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderHotelNoteReadAttributes
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface OrderHotelNoteReadRelationships
 */
export interface OrderHotelNoteReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderHotelNoteReadRelationships
     */
    'orderHotel': Reltoone;
}
/**
 * 
 * @export
 * @interface OrderHotelNoteWrite
 */
export interface OrderHotelNoteWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderHotelNoteWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderHotelNoteWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderHotelNoteWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderHotelNoteReadAttributes}
     * @memberof OrderHotelNoteWrite
     */
    'attributes'?: OrderHotelNoteReadAttributes;
    /**
     * 
     * @type {OrderHotelNoteReadRelationships}
     * @memberof OrderHotelNoteWrite
     */
    'relationships'?: OrderHotelNoteReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderHotelRateCode
 */
export interface OrderHotelRateCode {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderHotelRateCode
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderHotelRateCode
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderHotelRateCode
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderRefreshPricesAttributes}
     * @memberof OrderHotelRateCode
     */
    'attributes'?: GenericOrderRefreshPricesAttributes;
    /**
     * 
     * @type {OrderHotelRateCodeRelationships}
     * @memberof OrderHotelRateCode
     */
    'relationships'?: OrderHotelRateCodeRelationships;
}
/**
 * 
 * @export
 * @interface OrderHotelRateCodeRelationships
 */
export interface OrderHotelRateCodeRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderHotelRateCodeRelationships
     */
    'rateCode': Reltoone;
}
/**
 * 
 * @export
 * @interface OrderHotelRead
 */
export interface OrderHotelRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderHotelRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderHotelRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderHotelRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderHotelReadAttributes}
     * @memberof OrderHotelRead
     */
    'attributes'?: OrderHotelReadAttributes;
    /**
     * 
     * @type {OrderHotelReadRelationships}
     * @memberof OrderHotelRead
     */
    'relationships'?: OrderHotelReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderHotelReadAttributes
 */
export interface OrderHotelReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderHotelReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderHotelReadAttributes
     */
    'shortUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderHotelReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderHotelReadAttributes
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface OrderHotelReadRelationships
 */
export interface OrderHotelReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderHotelReadRelationships
     */
    'hotel': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderHotelReadRelationships
     */
    'order': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderHotelReadRelationships
     */
    'rateCode'?: Reltoone;
    /**
     * 
     * @type {Reltomany}
     * @memberof OrderHotelReadRelationships
     */
    'notes': Reltomany;
}
/**
 * 
 * @export
 * @interface OrderIndustryTypeChoiceRead
 */
export interface OrderIndustryTypeChoiceRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderIndustryTypeChoiceRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderIndustryTypeChoiceRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderIndustryTypeChoiceRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderIndustryTypeChoiceReadAttributes}
     * @memberof OrderIndustryTypeChoiceRead
     */
    'attributes'?: OrderIndustryTypeChoiceReadAttributes;
    /**
     * 
     * @type {OrderCancelReasonChoiceReadRelationships}
     * @memberof OrderIndustryTypeChoiceRead
     */
    'relationships'?: OrderCancelReasonChoiceReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderIndustryTypeChoiceReadAttributes
 */
export interface OrderIndustryTypeChoiceReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderIndustryTypeChoiceReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderIndustryTypeChoiceReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrderIndustryTypeChoiceReadAttributes
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface OrderIndustryTypeChoiceWrite
 */
export interface OrderIndustryTypeChoiceWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderIndustryTypeChoiceWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderIndustryTypeChoiceWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderIndustryTypeChoiceWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderIndustryTypeChoiceWriteAttributes}
     * @memberof OrderIndustryTypeChoiceWrite
     */
    'attributes'?: OrderIndustryTypeChoiceWriteAttributes;
    /**
     * 
     * @type {OrderCancelReasonChoiceReadRelationships}
     * @memberof OrderIndustryTypeChoiceWrite
     */
    'relationships'?: OrderCancelReasonChoiceReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderIndustryTypeChoiceWriteAttributes
 */
export interface OrderIndustryTypeChoiceWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderIndustryTypeChoiceWriteAttributes
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrderSourceChoiceRead
 */
export interface OrderSourceChoiceRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderSourceChoiceRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderSourceChoiceRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderSourceChoiceRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderChannelChoiceReadAttributes}
     * @memberof OrderSourceChoiceRead
     */
    'attributes'?: OrderChannelChoiceReadAttributes;
    /**
     * 
     * @type {OrderCancelReasonChoiceReadRelationships}
     * @memberof OrderSourceChoiceRead
     */
    'relationships'?: OrderCancelReasonChoiceReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderSourceChoiceWrite
 */
export interface OrderSourceChoiceWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderSourceChoiceWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderSourceChoiceWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderSourceChoiceWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderChannelChoiceWriteAttributes}
     * @memberof OrderSourceChoiceWrite
     */
    'attributes'?: OrderChannelChoiceWriteAttributes;
    /**
     * 
     * @type {OrderCancelReasonChoiceReadRelationships}
     * @memberof OrderSourceChoiceWrite
     */
    'relationships'?: OrderCancelReasonChoiceReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderSubsegmentationChoiceRead
 */
export interface OrderSubsegmentationChoiceRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderSubsegmentationChoiceRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderSubsegmentationChoiceRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderSubsegmentationChoiceRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderSubsegmentationChoiceReadAttributes}
     * @memberof OrderSubsegmentationChoiceRead
     */
    'attributes'?: OrderSubsegmentationChoiceReadAttributes;
    /**
     * 
     * @type {OrderCancelReasonChoiceReadRelationships}
     * @memberof OrderSubsegmentationChoiceRead
     */
    'relationships'?: OrderCancelReasonChoiceReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderSubsegmentationChoiceReadAttributes
 */
export interface OrderSubsegmentationChoiceReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderSubsegmentationChoiceReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSubsegmentationChoiceReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrderSubsegmentationChoiceReadAttributes
     */
    'segmentationType': OrderSubsegmentationChoiceReadAttributesSegmentationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderSubsegmentationChoiceReadAttributes
     */
    'updatedAt'?: string;
}

export const OrderSubsegmentationChoiceReadAttributesSegmentationTypeEnum = {
    Congress: 'CONGRESS',
    GroupTravel: 'GROUP_TRAVEL',
    Incentives: 'INCENTIVES',
    MeetingOrConference: 'MEETING_OR_CONFERENCE',
    SocialEvent: 'SOCIAL_EVENT',
    Wedding: 'WEDDING'
} as const;

export type OrderSubsegmentationChoiceReadAttributesSegmentationTypeEnum = typeof OrderSubsegmentationChoiceReadAttributesSegmentationTypeEnum[keyof typeof OrderSubsegmentationChoiceReadAttributesSegmentationTypeEnum];

/**
 * 
 * @export
 * @interface OrderSubsegmentationChoiceWrite
 */
export interface OrderSubsegmentationChoiceWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderSubsegmentationChoiceWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderSubsegmentationChoiceWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderSubsegmentationChoiceWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderSubsegmentationChoiceWriteAttributes}
     * @memberof OrderSubsegmentationChoiceWrite
     */
    'attributes'?: OrderSubsegmentationChoiceWriteAttributes;
    /**
     * 
     * @type {OrderCancelReasonChoiceReadRelationships}
     * @memberof OrderSubsegmentationChoiceWrite
     */
    'relationships'?: OrderCancelReasonChoiceReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderSubsegmentationChoiceWriteAttributes
 */
export interface OrderSubsegmentationChoiceWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderSubsegmentationChoiceWriteAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrderSubsegmentationChoiceWriteAttributes
     */
    'segmentationType': OrderSubsegmentationChoiceWriteAttributesSegmentationTypeEnum;
}

export const OrderSubsegmentationChoiceWriteAttributesSegmentationTypeEnum = {
    Congress: 'CONGRESS',
    GroupTravel: 'GROUP_TRAVEL',
    Incentives: 'INCENTIVES',
    MeetingOrConference: 'MEETING_OR_CONFERENCE',
    SocialEvent: 'SOCIAL_EVENT',
    Wedding: 'WEDDING'
} as const;

export type OrderSubsegmentationChoiceWriteAttributesSegmentationTypeEnum = typeof OrderSubsegmentationChoiceWriteAttributesSegmentationTypeEnum[keyof typeof OrderSubsegmentationChoiceWriteAttributesSegmentationTypeEnum];

/**
 * 
 * @export
 * @interface OrderTaskRead
 */
export interface OrderTaskRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderTaskRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderTaskRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderTaskRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderTaskReadAttributes}
     * @memberof OrderTaskRead
     */
    'attributes'?: OrderTaskReadAttributes;
    /**
     * 
     * @type {OrderTaskReadRelationships}
     * @memberof OrderTaskRead
     */
    'relationships'?: OrderTaskReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderTaskReadAttributes
 */
export interface OrderTaskReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderTaskReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTaskReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTaskReadAttributes
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof OrderTaskReadAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderTaskReadAttributes
     */
    'isDone'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderTaskReadAttributes
     */
    'dueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderTaskReadAttributes
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface OrderTaskReadRelationships
 */
export interface OrderTaskReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderTaskReadRelationships
     */
    'orderTaskType': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderTaskReadRelationships
     */
    'order': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof OrderTaskReadRelationships
     */
    'assignee'?: Reltoone;
}
/**
 * 
 * @export
 * @interface OrderTaskTypeChoiceRead
 */
export interface OrderTaskTypeChoiceRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderTaskTypeChoiceRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderTaskTypeChoiceRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderTaskTypeChoiceRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderTaskTypeChoiceReadAttributes}
     * @memberof OrderTaskTypeChoiceRead
     */
    'attributes'?: OrderTaskTypeChoiceReadAttributes;
    /**
     * 
     * @type {OrderCancelReasonChoiceReadRelationships}
     * @memberof OrderTaskTypeChoiceRead
     */
    'relationships'?: OrderCancelReasonChoiceReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderTaskTypeChoiceReadAttributes
 */
export interface OrderTaskTypeChoiceReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderTaskTypeChoiceReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTaskTypeChoiceReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrderTaskTypeChoiceReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTaskTypeChoiceReadAttributes
     */
    'color'?: string;
}
/**
 * 
 * @export
 * @interface OrderTaskTypeChoiceWrite
 */
export interface OrderTaskTypeChoiceWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderTaskTypeChoiceWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderTaskTypeChoiceWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderTaskTypeChoiceWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderTaskTypeChoiceWriteAttributes}
     * @memberof OrderTaskTypeChoiceWrite
     */
    'attributes'?: OrderTaskTypeChoiceWriteAttributes;
    /**
     * 
     * @type {OrderCancelReasonChoiceReadRelationships}
     * @memberof OrderTaskTypeChoiceWrite
     */
    'relationships'?: OrderCancelReasonChoiceReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderTaskTypeChoiceWriteAttributes
 */
export interface OrderTaskTypeChoiceWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderTaskTypeChoiceWriteAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrderTaskTypeChoiceWriteAttributes
     */
    'color'?: string;
}
/**
 * 
 * @export
 * @interface OrderTaskWrite
 */
export interface OrderTaskWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof OrderTaskWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof OrderTaskWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof OrderTaskWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {OrderTaskWriteAttributes}
     * @memberof OrderTaskWrite
     */
    'attributes'?: OrderTaskWriteAttributes;
    /**
     * 
     * @type {OrderTaskReadRelationships}
     * @memberof OrderTaskWrite
     */
    'relationships'?: OrderTaskReadRelationships;
}
/**
 * 
 * @export
 * @interface OrderTaskWriteAttributes
 */
export interface OrderTaskWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof OrderTaskWriteAttributes
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof OrderTaskWriteAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderTaskWriteAttributes
     */
    'isDone'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderTaskWriteAttributes
     */
    'dueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderTaskWriteAttributes
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface OrdersKPIs
 */
export interface OrdersKPIs {
    /**
     * 
     * @type {number}
     * @memberof OrdersKPIs
     */
    'total_amount': number;
    /**
     * 
     * @type {number}
     * @memberof OrdersKPIs
     */
    'total_count': number;
    /**
     * 
     * @type {number}
     * @memberof OrdersKPIs
     */
    'confirmed_count': number;
    /**
     * 
     * @type {string}
     * @memberof OrdersKPIs
     */
    'confirmed_amount': string;
    /**
     * 
     * @type {string}
     * @memberof OrdersKPIs
     */
    'average_daily_rate': string;
    /**
     * 
     * @type {string}
     * @memberof OrdersKPIs
     */
    'lead_time': string;
    /**
     * 
     * @type {string}
     * @memberof OrdersKPIs
     */
    'booking_pase': string;
    /**
     * 
     * @type {string}
     * @memberof OrdersKPIs
     */
    'response_time': string;
    /**
     * 
     * @type {string}
     * @memberof OrdersKPIs
     */
    'conversion_rate': string;
    /**
     * 
     * @type {string}
     * @memberof OrdersKPIs
     */
    'conversion_rate_sales': string;
}
/**
 * 
 * @export
 * @interface OrdersPerformanceHistory
 */
export interface OrdersPerformanceHistory {
    /**
     * 
     * @type {string}
     * @memberof OrdersPerformanceHistory
     */
    'truncated_date': string;
    /**
     * 
     * @type {number}
     * @memberof OrdersPerformanceHistory
     */
    'total_amount': number;
    /**
     * 
     * @type {number}
     * @memberof OrdersPerformanceHistory
     */
    'total_count': number;
}
/**
 * @type Pageref
 * @export
 */
export type Pageref = object | string;

/**
 * 
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     * 
     * @type {Pageref}
     * @memberof Pagination
     */
    'first'?: Pageref;
    /**
     * 
     * @type {Pageref}
     * @memberof Pagination
     */
    'last'?: Pageref;
    /**
     * 
     * @type {Pageref}
     * @memberof Pagination
     */
    'prev'?: Pageref;
    /**
     * 
     * @type {Pageref}
     * @memberof Pagination
     */
    'next'?: Pageref;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartActivitiesId200Response
 */
export interface PartialUpdateBookingCartActivitiesId200Response {
    /**
     * 
     * @type {GenericOrderActivityWrite}
     * @memberof PartialUpdateBookingCartActivitiesId200Response
     */
    'data': GenericOrderActivityWrite;
    /**
     * 
     * @type {Set<Include>}
     * @memberof PartialUpdateBookingCartActivitiesId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof PartialUpdateBookingCartActivitiesId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof PartialUpdateBookingCartActivitiesId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartActivitiesIdRequest
 */
export interface PartialUpdateBookingCartActivitiesIdRequest {
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestData}
     * @memberof PartialUpdateBookingCartActivitiesIdRequest
     */
    'data': PartialUpdateBookingCartActivitiesIdRequestData;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartActivitiesIdRequestData
 */
export interface PartialUpdateBookingCartActivitiesIdRequestData {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestData
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestData
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestData
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataAttributes}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestData
     */
    'attributes'?: PartialUpdateBookingCartActivitiesIdRequestDataAttributes;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataRelationships}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestData
     */
    'relationships'?: PartialUpdateBookingCartActivitiesIdRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartActivitiesIdRequestDataAttributes
 */
export interface PartialUpdateBookingCartActivitiesIdRequestDataAttributes {
    /**
     * 
     * @type {number}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestDataAttributes
     */
    'attendees'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestDataAttributes
     */
    'checkInAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestDataAttributes
     */
    'checkOutAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestDataAttributes
     */
    'customerNotes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestDataAttributes
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartActivitiesIdRequestDataLinks
 */
export interface PartialUpdateBookingCartActivitiesIdRequestDataLinks {
    /**
     * 
     * @type {Link}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestDataLinks
     */
    'self'?: Link;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartActivitiesIdRequestDataRelationships
 */
export interface PartialUpdateBookingCartActivitiesIdRequestDataRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestDataRelationships
     */
    'hotel'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestDataRelationships
     */
    'meetingRoom'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestDataRelationships
     */
    'meetingRoomSetup'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestDataRelationships
     */
    'order'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof PartialUpdateBookingCartActivitiesIdRequestDataRelationships
     */
    'roomDiagram'?: Reltoone;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartEventPackagesId200Response
 */
export interface PartialUpdateBookingCartEventPackagesId200Response {
    /**
     * 
     * @type {OrderEventPackageWrite}
     * @memberof PartialUpdateBookingCartEventPackagesId200Response
     */
    'data': OrderEventPackageWrite;
    /**
     * 
     * @type {Set<Include>}
     * @memberof PartialUpdateBookingCartEventPackagesId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof PartialUpdateBookingCartEventPackagesId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof PartialUpdateBookingCartEventPackagesId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartEventPackagesIdRequest
 */
export interface PartialUpdateBookingCartEventPackagesIdRequest {
    /**
     * 
     * @type {PartialUpdateBookingCartEventPackagesIdRequestData}
     * @memberof PartialUpdateBookingCartEventPackagesIdRequest
     */
    'data': PartialUpdateBookingCartEventPackagesIdRequestData;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartEventPackagesIdRequestData
 */
export interface PartialUpdateBookingCartEventPackagesIdRequestData {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof PartialUpdateBookingCartEventPackagesIdRequestData
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof PartialUpdateBookingCartEventPackagesIdRequestData
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof PartialUpdateBookingCartEventPackagesIdRequestData
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {PartialUpdateBookingCartEventPackagesIdRequestDataAttributes}
     * @memberof PartialUpdateBookingCartEventPackagesIdRequestData
     */
    'attributes'?: PartialUpdateBookingCartEventPackagesIdRequestDataAttributes;
    /**
     * 
     * @type {PartialUpdateBookingCartEventPackagesIdRequestDataRelationships}
     * @memberof PartialUpdateBookingCartEventPackagesIdRequestData
     */
    'relationships'?: PartialUpdateBookingCartEventPackagesIdRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartEventPackagesIdRequestDataAttributes
 */
export interface PartialUpdateBookingCartEventPackagesIdRequestDataAttributes {
    /**
     * 
     * @type {number}
     * @memberof PartialUpdateBookingCartEventPackagesIdRequestDataAttributes
     */
    'attendees'?: number;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateBookingCartEventPackagesIdRequestDataAttributes
     */
    'startDate'?: string;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartEventPackagesIdRequestDataRelationships
 */
export interface PartialUpdateBookingCartEventPackagesIdRequestDataRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof PartialUpdateBookingCartEventPackagesIdRequestDataRelationships
     */
    'eventPackage'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof PartialUpdateBookingCartEventPackagesIdRequestDataRelationships
     */
    'order'?: Reltoone;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartGuestRoomsId200Response
 */
export interface PartialUpdateBookingCartGuestRoomsId200Response {
    /**
     * 
     * @type {GenericGuestRoomRequestWrite}
     * @memberof PartialUpdateBookingCartGuestRoomsId200Response
     */
    'data': GenericGuestRoomRequestWrite;
    /**
     * 
     * @type {Set<Include>}
     * @memberof PartialUpdateBookingCartGuestRoomsId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof PartialUpdateBookingCartGuestRoomsId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof PartialUpdateBookingCartGuestRoomsId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartGuestRoomsIdRequest
 */
export interface PartialUpdateBookingCartGuestRoomsIdRequest {
    /**
     * 
     * @type {PartialUpdateBookingCartGuestRoomsIdRequestData}
     * @memberof PartialUpdateBookingCartGuestRoomsIdRequest
     */
    'data': PartialUpdateBookingCartGuestRoomsIdRequestData;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartGuestRoomsIdRequestData
 */
export interface PartialUpdateBookingCartGuestRoomsIdRequestData {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof PartialUpdateBookingCartGuestRoomsIdRequestData
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof PartialUpdateBookingCartGuestRoomsIdRequestData
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof PartialUpdateBookingCartGuestRoomsIdRequestData
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {PartialUpdateBookingCartGuestRoomsIdRequestDataAttributes}
     * @memberof PartialUpdateBookingCartGuestRoomsIdRequestData
     */
    'attributes'?: PartialUpdateBookingCartGuestRoomsIdRequestDataAttributes;
    /**
     * 
     * @type {PartialUpdateBookingCartGuestRoomsIdRequestDataRelationships}
     * @memberof PartialUpdateBookingCartGuestRoomsIdRequestData
     */
    'relationships'?: PartialUpdateBookingCartGuestRoomsIdRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartGuestRoomsIdRequestDataAttributes
 */
export interface PartialUpdateBookingCartGuestRoomsIdRequestDataAttributes {
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateBookingCartGuestRoomsIdRequestDataAttributes
     */
    'checkIn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateBookingCartGuestRoomsIdRequestDataAttributes
     */
    'checkOut'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateBookingCartGuestRoomsIdRequestDataAttributes
     */
    'occupancyType'?: PartialUpdateBookingCartGuestRoomsIdRequestDataAttributesOccupancyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateBookingCartGuestRoomsIdRequestDataAttributes
     */
    'rentalType'?: PartialUpdateBookingCartGuestRoomsIdRequestDataAttributesRentalTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PartialUpdateBookingCartGuestRoomsIdRequestDataAttributes
     */
    'units'?: number;
}

export const PartialUpdateBookingCartGuestRoomsIdRequestDataAttributesOccupancyTypeEnum = {
    Single10: 'single-1-0',
    Double20: 'double-2-0',
    Double11: 'double-1-1',
    Triple30: 'triple-3-0',
    Triple21: 'triple-2-1',
    Triple12: 'triple-1-2',
    Quadruple40: 'quadruple-4-0',
    Quadruple31: 'quadruple-3-1',
    Quadruple22: 'quadruple-2-2',
    Quadruple13: 'quadruple-1-3',
    Quintuple50: 'quintuple-5-0',
    Quintuple41: 'quintuple-4-1',
    Quintuple32: 'quintuple-3-2',
    Quintuple23: 'quintuple-2-3',
    Quintuple14: 'quintuple-1-4'
} as const;

export type PartialUpdateBookingCartGuestRoomsIdRequestDataAttributesOccupancyTypeEnum = typeof PartialUpdateBookingCartGuestRoomsIdRequestDataAttributesOccupancyTypeEnum[keyof typeof PartialUpdateBookingCartGuestRoomsIdRequestDataAttributesOccupancyTypeEnum];
export const PartialUpdateBookingCartGuestRoomsIdRequestDataAttributesRentalTypeEnum = {
    Accommodation: 'accommodation',
    Breakfast: 'breakfast',
    FullBoard: 'full-board',
    HalfBoard: 'half-board',
    AllInclusive: 'all-inclusive'
} as const;

export type PartialUpdateBookingCartGuestRoomsIdRequestDataAttributesRentalTypeEnum = typeof PartialUpdateBookingCartGuestRoomsIdRequestDataAttributesRentalTypeEnum[keyof typeof PartialUpdateBookingCartGuestRoomsIdRequestDataAttributesRentalTypeEnum];

/**
 * 
 * @export
 * @interface PartialUpdateBookingCartGuestRoomsIdRequestDataRelationships
 */
export interface PartialUpdateBookingCartGuestRoomsIdRequestDataRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof PartialUpdateBookingCartGuestRoomsIdRequestDataRelationships
     */
    'guestRoom'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof PartialUpdateBookingCartGuestRoomsIdRequestDataRelationships
     */
    'order'?: Reltoone;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartServicesId200Response
 */
export interface PartialUpdateBookingCartServicesId200Response {
    /**
     * 
     * @type {GenericServiceWrite}
     * @memberof PartialUpdateBookingCartServicesId200Response
     */
    'data': GenericServiceWrite;
    /**
     * 
     * @type {Set<Include>}
     * @memberof PartialUpdateBookingCartServicesId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof PartialUpdateBookingCartServicesId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof PartialUpdateBookingCartServicesId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartServicesIdRequest
 */
export interface PartialUpdateBookingCartServicesIdRequest {
    /**
     * 
     * @type {PartialUpdateBookingCartServicesIdRequestData}
     * @memberof PartialUpdateBookingCartServicesIdRequest
     */
    'data': PartialUpdateBookingCartServicesIdRequestData;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartServicesIdRequestData
 */
export interface PartialUpdateBookingCartServicesIdRequestData {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof PartialUpdateBookingCartServicesIdRequestData
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof PartialUpdateBookingCartServicesIdRequestData
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof PartialUpdateBookingCartServicesIdRequestData
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {PartialUpdateBookingCartServicesIdRequestDataAttributes}
     * @memberof PartialUpdateBookingCartServicesIdRequestData
     */
    'attributes'?: PartialUpdateBookingCartServicesIdRequestDataAttributes;
    /**
     * 
     * @type {PartialUpdateBookingCartServicesIdRequestDataRelationships}
     * @memberof PartialUpdateBookingCartServicesIdRequestData
     */
    'relationships'?: PartialUpdateBookingCartServicesIdRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartServicesIdRequestDataAttributes
 */
export interface PartialUpdateBookingCartServicesIdRequestDataAttributes {
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateBookingCartServicesIdRequestDataAttributes
     */
    'endsAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateBookingCartServicesIdRequestDataAttributes
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateBookingCartServicesIdRequestDataAttributes
     */
    'startsAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof PartialUpdateBookingCartServicesIdRequestDataAttributes
     */
    'units'?: number;
}
/**
 * 
 * @export
 * @interface PartialUpdateBookingCartServicesIdRequestDataRelationships
 */
export interface PartialUpdateBookingCartServicesIdRequestDataRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof PartialUpdateBookingCartServicesIdRequestDataRelationships
     */
    'activity'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof PartialUpdateBookingCartServicesIdRequestDataRelationships
     */
    'hotel'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof PartialUpdateBookingCartServicesIdRequestDataRelationships
     */
    'order'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof PartialUpdateBookingCartServicesIdRequestDataRelationships
     */
    'service'?: Reltoone;
}
/**
 * 
 * @export
 * @interface PartialUpdateDiagrammingVirtualMeetingRoomSetupsId200Response
 */
export interface PartialUpdateDiagrammingVirtualMeetingRoomSetupsId200Response {
    /**
     * 
     * @type {VirtualMeetingRoomSetupWrite}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsId200Response
     */
    'data': VirtualMeetingRoomSetupWrite;
    /**
     * 
     * @type {Set<Include>}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest
 */
export interface PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest {
    /**
     * 
     * @type {PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestData}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest
     */
    'data': PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestData;
}
/**
 * 
 * @export
 * @interface PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestData
 */
export interface PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestData {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestData
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestData
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestData
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributes}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestData
     */
    'attributes'?: PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributes;
    /**
     * 
     * @type {PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataRelationships}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestData
     */
    'relationships'?: PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributes
 */
export interface PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributes {
    /**
     * 
     * @type {Array<PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributesFurnituresInner>}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributes
     */
    'furnitures'?: Array<PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributesFurnituresInner>;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributes
     */
    'graph'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributes
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributesFurnituresInner
 */
export interface PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributesFurnituresInner {
    /**
     * 
     * @type {number}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributesFurnituresInner
     */
    'furniture': number;
    /**
     * 
     * @type {number}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributesFurnituresInner
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataRelationships
 */
export interface PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataRelationships
     */
    'virtualMeetingRoom'?: Reltoone;
}
/**
 * 
 * @export
 * @interface PayBookingPaymentsIdPay201Response
 */
export interface PayBookingPaymentsIdPay201Response {
    /**
     * 
     * @type {PaymentPay}
     * @memberof PayBookingPaymentsIdPay201Response
     */
    'data': PaymentPay;
    /**
     * 
     * @type {Set<Include>}
     * @memberof PayBookingPaymentsIdPay201Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof PayBookingPaymentsIdPay201Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof PayBookingPaymentsIdPay201Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface PayBookingPaymentsIdPayRequest
 */
export interface PayBookingPaymentsIdPayRequest {
    /**
     * 
     * @type {PayBookingPaymentsIdPayRequestData}
     * @memberof PayBookingPaymentsIdPayRequest
     */
    'data': PayBookingPaymentsIdPayRequestData;
}
/**
 * 
 * @export
 * @interface PayBookingPaymentsIdPayRequestData
 */
export interface PayBookingPaymentsIdPayRequestData {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof PayBookingPaymentsIdPayRequestData
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof PayBookingPaymentsIdPayRequestData
     */
    'id'?: string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof PayBookingPaymentsIdPayRequestData
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {object}
     * @memberof PayBookingPaymentsIdPayRequestData
     */
    'attributes'?: object;
}
/**
 * 
 * @export
 * @interface PaymentPay
 */
export interface PaymentPay {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof PaymentPay
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof PaymentPay
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof PaymentPay
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {PaymentPayAttributes}
     * @memberof PaymentPay
     */
    'attributes'?: PaymentPayAttributes;
}
/**
 * 
 * @export
 * @interface PaymentPayAttributes
 */
export interface PaymentPayAttributes {
    /**
     * 
     * @type {string}
     * @memberof PaymentPayAttributes
     */
    'paymentIframe'?: string;
    /**
     * 
     * @type {object}
     * @memberof PaymentPayAttributes
     */
    'paymentIntegrationData'?: object;
    /**
     * 
     * @type {string}
     * @memberof PaymentPayAttributes
     */
    'paymentIntegrationType'?: PaymentPayAttributesPaymentIntegrationTypeEnum;
}

export const PaymentPayAttributesPaymentIntegrationTypeEnum = {
    Paycomet: 'paycomet',
    Freedompay: 'freedompay',
    Stripe: 'stripe'
} as const;

export type PaymentPayAttributesPaymentIntegrationTypeEnum = typeof PaymentPayAttributesPaymentIntegrationTypeEnum[keyof typeof PaymentPayAttributesPaymentIntegrationTypeEnum];

/**
 * 
 * @export
 * @interface PaymentRead
 */
export interface PaymentRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof PaymentRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof PaymentRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof PaymentRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {PaymentReadAttributes}
     * @memberof PaymentRead
     */
    'attributes'?: PaymentReadAttributes;
    /**
     * 
     * @type {PaymentReadRelationships}
     * @memberof PaymentRead
     */
    'relationships'?: PaymentReadRelationships;
}
/**
 * 
 * @export
 * @interface PaymentReadAttributes
 */
export interface PaymentReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof PaymentReadAttributes
     */
    'amount': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentReadAttributes
     */
    'dueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentReadAttributes
     */
    'internalNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentReadAttributes
     */
    'paymentStatus'?: PaymentReadAttributesPaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentReadAttributes
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentReadAttributes
     */
    'updatedAt'?: string;
}

export const PaymentReadAttributesPaymentStatusEnum = {
    Canceled: 'canceled',
    Confirmed: 'confirmed',
    Pending: 'pending',
    Refunded: 'refunded'
} as const;

export type PaymentReadAttributesPaymentStatusEnum = typeof PaymentReadAttributesPaymentStatusEnum[keyof typeof PaymentReadAttributesPaymentStatusEnum];

/**
 * 
 * @export
 * @interface PaymentReadRelationships
 */
export interface PaymentReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof PaymentReadRelationships
     */
    'account'?: Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof PaymentReadRelationships
     */
    'order': Reltoone;
}
/**
 * 
 * @export
 * @interface PaymentStatus
 */
export interface PaymentStatus {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof PaymentStatus
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof PaymentStatus
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof PaymentStatus
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {PaymentStatusAttributes}
     * @memberof PaymentStatus
     */
    'attributes'?: PaymentStatusAttributes;
}
/**
 * 
 * @export
 * @interface PaymentStatusAttributes
 */
export interface PaymentStatusAttributes {
    /**
     * 
     * @type {string}
     * @memberof PaymentStatusAttributes
     */
    'paymentStatus': PaymentStatusAttributesPaymentStatusEnum;
}

export const PaymentStatusAttributesPaymentStatusEnum = {
    Canceled: 'canceled',
    Confirmed: 'confirmed',
    Pending: 'pending',
    Refunded: 'refunded'
} as const;

export type PaymentStatusAttributesPaymentStatusEnum = typeof PaymentStatusAttributesPaymentStatusEnum[keyof typeof PaymentStatusAttributesPaymentStatusEnum];

/**
 * 
 * @export
 * @interface PaymentWrite
 */
export interface PaymentWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof PaymentWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof PaymentWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof PaymentWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {PaymentWriteAttributes}
     * @memberof PaymentWrite
     */
    'attributes'?: PaymentWriteAttributes;
    /**
     * 
     * @type {OrderAttachmentReadRelationships}
     * @memberof PaymentWrite
     */
    'relationships'?: OrderAttachmentReadRelationships;
}
/**
 * 
 * @export
 * @interface PaymentWriteAttributes
 */
export interface PaymentWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof PaymentWriteAttributes
     */
    'amount': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentWriteAttributes
     */
    'dueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentWriteAttributes
     */
    'internalNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentWriteAttributes
     */
    'subject'?: string;
}
/**
 * 
 * @export
 * @interface PlannerRFP
 */
export interface PlannerRFP {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof PlannerRFP
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof PlannerRFP
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof PlannerRFP
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {PlannerRFPAttributes}
     * @memberof PlannerRFP
     */
    'attributes'?: PlannerRFPAttributes;
    /**
     * 
     * @type {CreateBookingPlannerRfpRequestDataRelationships}
     * @memberof PlannerRFP
     */
    'relationships'?: CreateBookingPlannerRfpRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface PlannerRFPAttributes
 */
export interface PlannerRFPAttributes {
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    'accountName': string;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    'accountType': PlannerRFPAttributesAccountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PlannerRFPAttributes
     */
    'attendees'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {Array<PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributesFurnituresInner>}
     * @memberof PlannerRFPAttributes
     */
    'furnitures'?: Array<PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributesFurnituresInner>;
    /**
     * 
     * @type {object}
     * @memberof PlannerRFPAttributes
     */
    'graph': object;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    'segmentationType'?: PlannerRFPAttributesSegmentationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    'uuid'?: string;
    /**
     * 
     * @type {Array<CreateBookingPlannerRfpRequestDataAttributesVirtualObjectsInner>}
     * @memberof PlannerRFPAttributes
     */
    'virtualObjects'?: Array<CreateBookingPlannerRfpRequestDataAttributesVirtualObjectsInner>;
    /**
     * 
     * @type {string}
     * @memberof PlannerRFPAttributes
     */
    'virtualMeetingRoomSetup'?: string;
}

export const PlannerRFPAttributesAccountTypeEnum = {
    Agency: 'agency',
    Company: 'company',
    Individual: 'individual'
} as const;

export type PlannerRFPAttributesAccountTypeEnum = typeof PlannerRFPAttributesAccountTypeEnum[keyof typeof PlannerRFPAttributesAccountTypeEnum];
export const PlannerRFPAttributesSegmentationTypeEnum = {
    Congress: 'CONGRESS',
    GroupTravel: 'GROUP_TRAVEL',
    Incentives: 'INCENTIVES',
    MeetingOrConference: 'MEETING_OR_CONFERENCE',
    SocialEvent: 'SOCIAL_EVENT',
    Wedding: 'WEDDING'
} as const;

export type PlannerRFPAttributesSegmentationTypeEnum = typeof PlannerRFPAttributesSegmentationTypeEnum[keyof typeof PlannerRFPAttributesSegmentationTypeEnum];

/**
 * 
 * @export
 * @interface RateCodeCreate
 */
export interface RateCodeCreate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof RateCodeCreate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof RateCodeCreate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof RateCodeCreate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {RateCodeCreateAttributes}
     * @memberof RateCodeCreate
     */
    'attributes'?: RateCodeCreateAttributes;
    /**
     * 
     * @type {CreateBookingCartRequestDataRelationships}
     * @memberof RateCodeCreate
     */
    'relationships'?: CreateBookingCartRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface RateCodeCreateAttributes
 */
export interface RateCodeCreateAttributes {
    /**
     * 
     * @type {string}
     * @memberof RateCodeCreateAttributes
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof RateCodeCreateAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RateCodeCreateAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RateCodeCreateAttributes
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof RateCodeCreateAttributes
     */
    'availabilityStatus': RateCodeCreateAttributesAvailabilityStatusEnum;
}

export const RateCodeCreateAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type RateCodeCreateAttributesAvailabilityStatusEnum = typeof RateCodeCreateAttributesAvailabilityStatusEnum[keyof typeof RateCodeCreateAttributesAvailabilityStatusEnum];

/**
 * 
 * @export
 * @interface RateCodeHotelRead
 */
export interface RateCodeHotelRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof RateCodeHotelRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof RateCodeHotelRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof RateCodeHotelRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {RateCodeHotelReadAttributes}
     * @memberof RateCodeHotelRead
     */
    'attributes'?: RateCodeHotelReadAttributes;
    /**
     * 
     * @type {CreateBookingCartRequestDataRelationships}
     * @memberof RateCodeHotelRead
     */
    'relationships'?: CreateBookingCartRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface RateCodeHotelReadAttributes
 */
export interface RateCodeHotelReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof RateCodeHotelReadAttributes
     */
    'availabilityStatus'?: RateCodeHotelReadAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RateCodeHotelReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RateCodeHotelReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RateCodeHotelReadAttributes
     */
    'uuid'?: string;
}

export const RateCodeHotelReadAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type RateCodeHotelReadAttributesAvailabilityStatusEnum = typeof RateCodeHotelReadAttributesAvailabilityStatusEnum[keyof typeof RateCodeHotelReadAttributesAvailabilityStatusEnum];

/**
 * 
 * @export
 * @interface RateCodeHotelWrite
 */
export interface RateCodeHotelWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof RateCodeHotelWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof RateCodeHotelWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof RateCodeHotelWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {RateCodeHotelWriteAttributes}
     * @memberof RateCodeHotelWrite
     */
    'attributes'?: RateCodeHotelWriteAttributes;
    /**
     * 
     * @type {RateCodeHotelWriteRelationships}
     * @memberof RateCodeHotelWrite
     */
    'relationships'?: RateCodeHotelWriteRelationships;
}
/**
 * 
 * @export
 * @interface RateCodeHotelWriteAttributes
 */
export interface RateCodeHotelWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof RateCodeHotelWriteAttributes
     */
    'availabilityStatus'?: RateCodeHotelWriteAttributesAvailabilityStatusEnum;
}

export const RateCodeHotelWriteAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type RateCodeHotelWriteAttributesAvailabilityStatusEnum = typeof RateCodeHotelWriteAttributesAvailabilityStatusEnum[keyof typeof RateCodeHotelWriteAttributesAvailabilityStatusEnum];

/**
 * 
 * @export
 * @interface RateCodeHotelWriteRelationships
 */
export interface RateCodeHotelWriteRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof RateCodeHotelWriteRelationships
     */
    'hotel': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof RateCodeHotelWriteRelationships
     */
    'rateCode': Reltoone;
}
/**
 * 
 * @export
 * @interface RateCodeRead
 */
export interface RateCodeRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof RateCodeRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof RateCodeRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof RateCodeRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {RateCodeReadAttributes}
     * @memberof RateCodeRead
     */
    'attributes'?: RateCodeReadAttributes;
    /**
     * 
     * @type {RateCodeReadRelationships}
     * @memberof RateCodeRead
     */
    'relationships'?: RateCodeReadRelationships;
}
/**
 * 
 * @export
 * @interface RateCodeReadAttributes
 */
export interface RateCodeReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof RateCodeReadAttributes
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof RateCodeReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RateCodeReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RateCodeReadAttributes
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface RateCodeReadRelationships
 */
export interface RateCodeReadRelationships {
    /**
     * 
     * @type {Reltomany}
     * @memberof RateCodeReadRelationships
     */
    'rateCodeHotels': Reltomany;
    /**
     * 
     * @type {Reltomany}
     * @memberof RateCodeReadRelationships
     */
    'hotels'?: Reltomany;
}
/**
 * 
 * @export
 * @interface RateCodeUpdate
 */
export interface RateCodeUpdate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof RateCodeUpdate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof RateCodeUpdate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof RateCodeUpdate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {RateCodeUpdateAttributes}
     * @memberof RateCodeUpdate
     */
    'attributes'?: RateCodeUpdateAttributes;
}
/**
 * 
 * @export
 * @interface RateCodeUpdateAttributes
 */
export interface RateCodeUpdateAttributes {
    /**
     * 
     * @type {string}
     * @memberof RateCodeUpdateAttributes
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof RateCodeUpdateAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RateCodeUpdateAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RateCodeUpdateAttributes
     */
    'uuid'?: string;
}
/**
 * optional references to other resource objects
 * @export
 * @interface RelationshipLinks
 */
export interface RelationshipLinks {
    [key: string]: any;

    /**
     * 
     * @type {Link}
     * @memberof RelationshipLinks
     */
    'self'?: Link;
    /**
     * 
     * @type {Link}
     * @memberof RelationshipLinks
     */
    'related'?: Link;
}
/**
 * reference to other resource in a to-one relationship
 * @export
 * @interface RelationshipToOne
 */
export interface RelationshipToOne {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof RelationshipToOne
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof RelationshipToOne
     */
    'id': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RelationshipToOne
     */
    'meta'?: { [key: string]: any; };
}
/**
 * a multiple \'to-many\' relationship
 * @export
 * @interface Reltomany
 */
export interface Reltomany {
    /**
     * 
     * @type {RelationshipLinks}
     * @memberof Reltomany
     */
    'links'?: RelationshipLinks;
    /**
     * An array of objects each containing the \'type\' and \'id\' for to-many relationships
     * @type {Set<Linkage>}
     * @memberof Reltomany
     */
    'data'?: Set<Linkage>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Reltomany
     */
    'meta'?: { [key: string]: any; };
}
/**
 * a singular \'to-one\' relationship
 * @export
 * @interface Reltoone
 */
export interface Reltoone {
    /**
     * 
     * @type {RelationshipLinks}
     * @memberof Reltoone
     */
    'links'?: RelationshipLinks;
    /**
     * 
     * @type {RelationshipToOne}
     * @memberof Reltoone
     */
    'data'?: RelationshipToOne;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Reltoone
     */
    'meta'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface Resource
 */
export interface Resource {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof Resource
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof Resource
     */
    'id': string;
    /**
     * 
     * @type {object}
     * @memberof Resource
     */
    'attributes'?: object;
    /**
     * 
     * @type {object}
     * @memberof Resource
     */
    'relationships'?: object;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof Resource
     */
    'links'?: { [key: string]: Link; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Resource
     */
    'meta'?: { [key: string]: any; };
}
/**
 * @type ResourceIdentifierObject
 * @export
 */
export type ResourceIdentifierObject = RelationshipToOne | Set<Linkage>;

/**
 * 
 * @export
 * @interface RetrieveBookingCartActivitiesId200Response
 */
export interface RetrieveBookingCartActivitiesId200Response {
    /**
     * 
     * @type {GenericOrderActivityRead}
     * @memberof RetrieveBookingCartActivitiesId200Response
     */
    'data': GenericOrderActivityRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveBookingCartActivitiesId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveBookingCartActivitiesId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveBookingCartActivitiesId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveBookingCartEventPackagesId200Response
 */
export interface RetrieveBookingCartEventPackagesId200Response {
    /**
     * 
     * @type {OrderEventPackageRead}
     * @memberof RetrieveBookingCartEventPackagesId200Response
     */
    'data': OrderEventPackageRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveBookingCartEventPackagesId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveBookingCartEventPackagesId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveBookingCartEventPackagesId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveBookingCartGuestRoomsId200Response
 */
export interface RetrieveBookingCartGuestRoomsId200Response {
    /**
     * 
     * @type {GenericGuestRoomRequestRead}
     * @memberof RetrieveBookingCartGuestRoomsId200Response
     */
    'data': GenericGuestRoomRequestRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveBookingCartGuestRoomsId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveBookingCartGuestRoomsId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveBookingCartGuestRoomsId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveBookingCartId200Response
 */
export interface RetrieveBookingCartId200Response {
    /**
     * 
     * @type {GenericOrderRead}
     * @memberof RetrieveBookingCartId200Response
     */
    'data': GenericOrderRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveBookingCartId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveBookingCartId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveBookingCartId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveBookingCartServicesId200Response
 */
export interface RetrieveBookingCartServicesId200Response {
    /**
     * 
     * @type {GenericServiceRead}
     * @memberof RetrieveBookingCartServicesId200Response
     */
    'data': GenericServiceRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveBookingCartServicesId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveBookingCartServicesId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveBookingCartServicesId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveDiagrammingDollhouseSchemasId200Response
 */
export interface RetrieveDiagrammingDollhouseSchemasId200Response {
    /**
     * 
     * @type {DollhouseSchemaRead}
     * @memberof RetrieveDiagrammingDollhouseSchemasId200Response
     */
    'data': DollhouseSchemaRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveDiagrammingDollhouseSchemasId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveDiagrammingDollhouseSchemasId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveDiagrammingDollhouseSchemasId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveDiagrammingVirtualFurnituresId200Response
 */
export interface RetrieveDiagrammingVirtualFurnituresId200Response {
    /**
     * 
     * @type {VirtualFurniture}
     * @memberof RetrieveDiagrammingVirtualFurnituresId200Response
     */
    'data': VirtualFurniture;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveDiagrammingVirtualFurnituresId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveDiagrammingVirtualFurnituresId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveDiagrammingVirtualFurnituresId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveDiagrammingVirtualMeetingRoomId200Response
 */
export interface RetrieveDiagrammingVirtualMeetingRoomId200Response {
    /**
     * 
     * @type {VirtualMeetingRoomRead}
     * @memberof RetrieveDiagrammingVirtualMeetingRoomId200Response
     */
    'data': VirtualMeetingRoomRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveDiagrammingVirtualMeetingRoomId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveDiagrammingVirtualMeetingRoomId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveDiagrammingVirtualMeetingRoomId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId200Response
 */
export interface RetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId200Response {
    /**
     * 
     * @type {VirtualMeetingRoomSetupTemplateRead}
     * @memberof RetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId200Response
     */
    'data': VirtualMeetingRoomSetupTemplateRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveDiagrammingVirtualMeetingRoomSetupsId200Response
 */
export interface RetrieveDiagrammingVirtualMeetingRoomSetupsId200Response {
    /**
     * 
     * @type {VirtualMeetingRoomSetupRead}
     * @memberof RetrieveDiagrammingVirtualMeetingRoomSetupsId200Response
     */
    'data': VirtualMeetingRoomSetupRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveDiagrammingVirtualMeetingRoomSetupsId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveDiagrammingVirtualMeetingRoomSetupsId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveDiagrammingVirtualMeetingRoomSetupsId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveDiagrammingVirtualObjectsId200Response
 */
export interface RetrieveDiagrammingVirtualObjectsId200Response {
    /**
     * 
     * @type {VirtualObject}
     * @memberof RetrieveDiagrammingVirtualObjectsId200Response
     */
    'data': VirtualObject;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveDiagrammingVirtualObjectsId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveDiagrammingVirtualObjectsId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveDiagrammingVirtualObjectsId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveInventoryEventPackagesId200Response
 */
export interface RetrieveInventoryEventPackagesId200Response {
    /**
     * 
     * @type {EventPackageRead}
     * @memberof RetrieveInventoryEventPackagesId200Response
     */
    'data': EventPackageRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveInventoryEventPackagesId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveInventoryEventPackagesId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveInventoryEventPackagesId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveInventoryGuestRoomsId200Response
 */
export interface RetrieveInventoryGuestRoomsId200Response {
    /**
     * 
     * @type {GuestRoomRead}
     * @memberof RetrieveInventoryGuestRoomsId200Response
     */
    'data': GuestRoomRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveInventoryGuestRoomsId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveInventoryGuestRoomsId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveInventoryGuestRoomsId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveInventoryHotelChainsSlug200Response
 */
export interface RetrieveInventoryHotelChainsSlug200Response {
    /**
     * 
     * @type {HotelChainRead}
     * @memberof RetrieveInventoryHotelChainsSlug200Response
     */
    'data': HotelChainRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveInventoryHotelChainsSlug200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveInventoryHotelChainsSlug200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveInventoryHotelChainsSlug200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveInventoryHotelRoomSetupsId200Response
 */
export interface RetrieveInventoryHotelRoomSetupsId200Response {
    /**
     * 
     * @type {HotelRoomSetup}
     * @memberof RetrieveInventoryHotelRoomSetupsId200Response
     */
    'data': HotelRoomSetup;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveInventoryHotelRoomSetupsId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveInventoryHotelRoomSetupsId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveInventoryHotelRoomSetupsId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveInventoryHotelsId200Response
 */
export interface RetrieveInventoryHotelsId200Response {
    /**
     * 
     * @type {HotelRead}
     * @memberof RetrieveInventoryHotelsId200Response
     */
    'data': HotelRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveInventoryHotelsId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveInventoryHotelsId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveInventoryHotelsId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveInventoryMeetingRoomsId200Response
 */
export interface RetrieveInventoryMeetingRoomsId200Response {
    /**
     * 
     * @type {MeetingRoomRead}
     * @memberof RetrieveInventoryMeetingRoomsId200Response
     */
    'data': MeetingRoomRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveInventoryMeetingRoomsId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveInventoryMeetingRoomsId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveInventoryMeetingRoomsId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface RetrieveInventoryServicesId200Response
 */
export interface RetrieveInventoryServicesId200Response {
    /**
     * 
     * @type {ServiceRead}
     * @memberof RetrieveInventoryServicesId200Response
     */
    'data': ServiceRead;
    /**
     * 
     * @type {Set<Include>}
     * @memberof RetrieveInventoryServicesId200Response
     */
    'included'?: Set<Include>;
    /**
     * 
     * @type {ListInventoryGuestRooms200ResponseLinks}
     * @memberof RetrieveInventoryServicesId200Response
     */
    'links'?: ListInventoryGuestRooms200ResponseLinks;
    /**
     * 
     * @type {Jsonapi}
     * @memberof RetrieveInventoryServicesId200Response
     */
    'jsonapi'?: Jsonapi;
}
/**
 * 
 * @export
 * @interface ServiceDuplicate
 */
export interface ServiceDuplicate {
    /**
     * 
     * @type {Array<number>}
     * @memberof ServiceDuplicate
     */
    'services': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ServiceDuplicate
     */
    'hotels': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceDuplicate
     */
    'duplicate_rates'?: boolean;
}
/**
 * 
 * @export
 * @interface ServiceRateCurrencyRead
 */
export interface ServiceRateCurrencyRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof ServiceRateCurrencyRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof ServiceRateCurrencyRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof ServiceRateCurrencyRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomRateCurrencyReadAttributes}
     * @memberof ServiceRateCurrencyRead
     */
    'attributes'?: GuestRoomRateCurrencyReadAttributes;
    /**
     * 
     * @type {ServiceRateCurrencyReadRelationships}
     * @memberof ServiceRateCurrencyRead
     */
    'relationships'?: ServiceRateCurrencyReadRelationships;
}
/**
 * 
 * @export
 * @interface ServiceRateCurrencyReadRelationships
 */
export interface ServiceRateCurrencyReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof ServiceRateCurrencyReadRelationships
     */
    'currency': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof ServiceRateCurrencyReadRelationships
     */
    'serviceRate': Reltoone;
}
/**
 * 
 * @export
 * @interface ServiceRateCurrencyWrite
 */
export interface ServiceRateCurrencyWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof ServiceRateCurrencyWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof ServiceRateCurrencyWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof ServiceRateCurrencyWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomRateCurrencyWriteAttributes}
     * @memberof ServiceRateCurrencyWrite
     */
    'attributes'?: GuestRoomRateCurrencyWriteAttributes;
    /**
     * 
     * @type {ServiceRateCurrencyReadRelationships}
     * @memberof ServiceRateCurrencyWrite
     */
    'relationships'?: ServiceRateCurrencyReadRelationships;
}
/**
 * 
 * @export
 * @interface ServiceRateRead
 */
export interface ServiceRateRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof ServiceRateRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof ServiceRateRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof ServiceRateRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {ServiceRateReadAttributes}
     * @memberof ServiceRateRead
     */
    'attributes'?: ServiceRateReadAttributes;
    /**
     * 
     * @type {ServiceRateReadRelationships}
     * @memberof ServiceRateRead
     */
    'relationships'?: ServiceRateReadRelationships;
}
/**
 * 
 * @export
 * @interface ServiceRateReadAttributes
 */
export interface ServiceRateReadAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof ServiceRateReadAttributes
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServiceRateReadAttributes
     */
    'price': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceRateReadAttributes
     */
    'startsDate': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRateReadAttributes
     */
    'endsDate': string;
}
/**
 * 
 * @export
 * @interface ServiceRateReadRelationships
 */
export interface ServiceRateReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof ServiceRateReadRelationships
     */
    'service': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof ServiceRateReadRelationships
     */
    'rateCode': Reltoone;
}
/**
 * 
 * @export
 * @interface ServiceRateWrite
 */
export interface ServiceRateWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof ServiceRateWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof ServiceRateWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof ServiceRateWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {ServiceRateWriteAttributes}
     * @memberof ServiceRateWrite
     */
    'attributes'?: ServiceRateWriteAttributes;
    /**
     * 
     * @type {ServiceRateReadRelationships}
     * @memberof ServiceRateWrite
     */
    'relationships'?: ServiceRateReadRelationships;
}
/**
 * 
 * @export
 * @interface ServiceRateWriteAttributes
 */
export interface ServiceRateWriteAttributes {
    /**
     * 
     * @type {boolean}
     * @memberof ServiceRateWriteAttributes
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServiceRateWriteAttributes
     */
    'price': string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceRateWriteAttributes
     */
    'startsDate': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceRateWriteAttributes
     */
    'endsDate': string;
}
/**
 * 
 * @export
 * @interface ServiceRead
 */
export interface ServiceRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof ServiceRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof ServiceRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof ServiceRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {ServiceReadAttributes}
     * @memberof ServiceRead
     */
    'attributes'?: ServiceReadAttributes;
    /**
     * 
     * @type {ServiceReadRelationships}
     * @memberof ServiceRead
     */
    'relationships'?: ServiceReadRelationships;
}
/**
 * 
 * @export
 * @interface ServiceReadAttributes
 */
export interface ServiceReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof ServiceReadAttributes
     */
    'category'?: ServiceReadAttributesCategoryEnum;
    /**
     * 
     * @type {GenericOrderActivityReadAttributesFrozenChargeType}
     * @memberof ServiceReadAttributes
     */
    'chargeType': GenericOrderActivityReadAttributesFrozenChargeType;
    /**
     * 
     * @type {string}
     * @memberof ServiceReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceReadAttributes
     */
    'description'?: string;
    /**
     * Custom object ordering position
     * @type {number}
     * @memberof ServiceReadAttributes
     */
    'index'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceReadAttributes
     */
    'maxDuration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceReadAttributes
     */
    'minDuration'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceReadAttributes
     */
    'minPax'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceReadAttributes
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceReadAttributes
     */
    'price'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceReadAttributes
     */
    'serviceType': ServiceReadAttributesServiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ServiceReadAttributes
     */
    'shortUuid'?: string;
    /**
     * 
     * @type {GuestRoomReadAttributesThumbnail}
     * @memberof ServiceReadAttributes
     */
    'thumbnail': GuestRoomReadAttributesThumbnail;
    /**
     * 
     * @type {string}
     * @memberof ServiceReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<ServiceReadAttributesDailyPricesInner>}
     * @memberof ServiceReadAttributes
     */
    'dailyPrices'?: Array<ServiceReadAttributesDailyPricesInner>;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceReadAttributes
     */
    'available'?: boolean;
}

export const ServiceReadAttributesCategoryEnum = {
    Buffet: 'buffet',
    Cocktail: 'cocktail',
    CoffeeBreak: 'coffee-break',
    Menu: 'menu',
    Others: 'others',
    Audio: 'audio',
    Illumination: 'illumination',
    Video: 'video'
} as const;

export type ServiceReadAttributesCategoryEnum = typeof ServiceReadAttributesCategoryEnum[keyof typeof ServiceReadAttributesCategoryEnum];
export const ServiceReadAttributesServiceTypeEnum = {
    Audiovisual: 'audiovisual',
    FoodBeverage: 'food-beverage',
    Other: 'other'
} as const;

export type ServiceReadAttributesServiceTypeEnum = typeof ServiceReadAttributesServiceTypeEnum[keyof typeof ServiceReadAttributesServiceTypeEnum];

/**
 * 
 * @export
 * @interface ServiceReadAttributesDailyPricesInner
 */
export interface ServiceReadAttributesDailyPricesInner {
    /**
     * 
     * @type {string}
     * @memberof ServiceReadAttributesDailyPricesInner
     */
    'day': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceReadAttributesDailyPricesInner
     */
    'price': string;
}
/**
 * 
 * @export
 * @interface ServiceReadRelationships
 */
export interface ServiceReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof ServiceReadRelationships
     */
    'hotel'?: Reltoone;
}
/**
 * 
 * @export
 * @interface ServiceThumbnailWrite
 */
export interface ServiceThumbnailWrite {
    /**
     * 
     * @type {File}
     * @memberof ServiceThumbnailWrite
     */
    'thumbnail'?: File;
}
/**
 * 
 * @export
 * @interface ServiceTranslationRead
 */
export interface ServiceTranslationRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof ServiceTranslationRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof ServiceTranslationRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof ServiceTranslationRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomTranslationReadAttributes}
     * @memberof ServiceTranslationRead
     */
    'attributes'?: GuestRoomTranslationReadAttributes;
    /**
     * 
     * @type {ServiceTranslationReadRelationships}
     * @memberof ServiceTranslationRead
     */
    'relationships'?: ServiceTranslationReadRelationships;
}
/**
 * 
 * @export
 * @interface ServiceTranslationReadRelationships
 */
export interface ServiceTranslationReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof ServiceTranslationReadRelationships
     */
    'service': Reltoone;
}
/**
 * 
 * @export
 * @interface ServiceTranslationWrite
 */
export interface ServiceTranslationWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof ServiceTranslationWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof ServiceTranslationWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof ServiceTranslationWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GuestRoomTranslationWriteAttributes}
     * @memberof ServiceTranslationWrite
     */
    'attributes'?: GuestRoomTranslationWriteAttributes;
    /**
     * 
     * @type {ServiceTranslationReadRelationships}
     * @memberof ServiceTranslationWrite
     */
    'relationships'?: ServiceTranslationReadRelationships;
}
/**
 * 
 * @export
 * @interface ServiceWrite
 */
export interface ServiceWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof ServiceWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof ServiceWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof ServiceWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {ServiceWriteAttributes}
     * @memberof ServiceWrite
     */
    'attributes'?: ServiceWriteAttributes;
    /**
     * 
     * @type {ServiceReadRelationships}
     * @memberof ServiceWrite
     */
    'relationships'?: ServiceReadRelationships;
}
/**
 * 
 * @export
 * @interface ServiceWriteAttributes
 */
export interface ServiceWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof ServiceWriteAttributes
     */
    'availabilityStatus'?: ServiceWriteAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ServiceWriteAttributes
     */
    'category'?: ServiceWriteAttributesCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof ServiceWriteAttributes
     */
    'chargeType': ServiceWriteAttributesChargeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ServiceWriteAttributes
     */
    'description'?: string;
    /**
     * Custom object ordering position
     * @type {number}
     * @memberof ServiceWriteAttributes
     */
    'index'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceWriteAttributes
     */
    'maxDuration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceWriteAttributes
     */
    'minDuration'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceWriteAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceWriteAttributes
     */
    'serviceType': ServiceWriteAttributesServiceTypeEnum;
    /**
     * 
     * @type {File}
     * @memberof ServiceWriteAttributes
     */
    'thumbnail'?: File | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServiceWriteAttributes
     */
    'segmentationTypes'?: Array<ServiceWriteAttributesSegmentationTypesEnum>;
}

export const ServiceWriteAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type ServiceWriteAttributesAvailabilityStatusEnum = typeof ServiceWriteAttributesAvailabilityStatusEnum[keyof typeof ServiceWriteAttributesAvailabilityStatusEnum];
export const ServiceWriteAttributesCategoryEnum = {
    Buffet: 'buffet',
    Cocktail: 'cocktail',
    CoffeeBreak: 'coffee-break',
    Menu: 'menu',
    Others: 'others',
    Audio: 'audio',
    Illumination: 'illumination',
    Video: 'video'
} as const;

export type ServiceWriteAttributesCategoryEnum = typeof ServiceWriteAttributesCategoryEnum[keyof typeof ServiceWriteAttributesCategoryEnum];
export const ServiceWriteAttributesChargeTypeEnum = {
    Day: 'day',
    Hour: 'hour',
    Person: 'person',
    Unit: 'unit'
} as const;

export type ServiceWriteAttributesChargeTypeEnum = typeof ServiceWriteAttributesChargeTypeEnum[keyof typeof ServiceWriteAttributesChargeTypeEnum];
export const ServiceWriteAttributesServiceTypeEnum = {
    Audiovisual: 'audiovisual',
    FoodBeverage: 'food-beverage',
    Other: 'other'
} as const;

export type ServiceWriteAttributesServiceTypeEnum = typeof ServiceWriteAttributesServiceTypeEnum[keyof typeof ServiceWriteAttributesServiceTypeEnum];
export const ServiceWriteAttributesSegmentationTypesEnum = {
    Congress: 'CONGRESS',
    GroupTravel: 'GROUP_TRAVEL',
    Incentives: 'INCENTIVES',
    MeetingOrConference: 'MEETING_OR_CONFERENCE',
    SocialEvent: 'SOCIAL_EVENT',
    Wedding: 'WEDDING'
} as const;

export type ServiceWriteAttributesSegmentationTypesEnum = typeof ServiceWriteAttributesSegmentationTypesEnum[keyof typeof ServiceWriteAttributesSegmentationTypesEnum];

/**
 * 
 * @export
 * @interface SetupsPerformanceHistory
 */
export interface SetupsPerformanceHistory {
    /**
     * 
     * @type {string}
     * @memberof SetupsPerformanceHistory
     */
    'truncated_date': string;
    /**
     * 
     * @type {number}
     * @memberof SetupsPerformanceHistory
     */
    'total_count': number;
}
/**
 * 
 * @export
 * @interface StateHistoryRead
 */
export interface StateHistoryRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof StateHistoryRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof StateHistoryRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof StateHistoryRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {StateHistoryReadAttributes}
     * @memberof StateHistoryRead
     */
    'attributes'?: StateHistoryReadAttributes;
    /**
     * 
     * @type {StateHistoryReadRelationships}
     * @memberof StateHistoryRead
     */
    'relationships'?: StateHistoryReadRelationships;
}
/**
 * 
 * @export
 * @interface StateHistoryReadAttributes
 */
export interface StateHistoryReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof StateHistoryReadAttributes
     */
    'fromState': string;
    /**
     * 
     * @type {string}
     * @memberof StateHistoryReadAttributes
     */
    'toState': string;
    /**
     * 
     * @type {string}
     * @memberof StateHistoryReadAttributes
     */
    'transitionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof StateHistoryReadAttributes
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface StateHistoryReadRelationships
 */
export interface StateHistoryReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof StateHistoryReadRelationships
     */
    'order': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof StateHistoryReadRelationships
     */
    'user'?: Reltoone;
}
/**
 * 
 * @export
 * @interface StateHistoryWrite
 */
export interface StateHistoryWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof StateHistoryWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof StateHistoryWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof StateHistoryWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {StateHistoryWriteAttributes}
     * @memberof StateHistoryWrite
     */
    'attributes'?: StateHistoryWriteAttributes;
}
/**
 * 
 * @export
 * @interface StateHistoryWriteAttributes
 */
export interface StateHistoryWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof StateHistoryWriteAttributes
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface TaskAttachmentRead
 */
export interface TaskAttachmentRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof TaskAttachmentRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof TaskAttachmentRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof TaskAttachmentRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {TaskAttachmentReadAttributes}
     * @memberof TaskAttachmentRead
     */
    'attributes'?: TaskAttachmentReadAttributes;
    /**
     * 
     * @type {TaskAttachmentReadRelationships}
     * @memberof TaskAttachmentRead
     */
    'relationships'?: TaskAttachmentReadRelationships;
}
/**
 * 
 * @export
 * @interface TaskAttachmentReadAttributes
 */
export interface TaskAttachmentReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof TaskAttachmentReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {File}
     * @memberof TaskAttachmentReadAttributes
     */
    'file': File;
    /**
     * 
     * @type {string}
     * @memberof TaskAttachmentReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskAttachmentReadAttributes
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TaskAttachmentReadRelationships
 */
export interface TaskAttachmentReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof TaskAttachmentReadRelationships
     */
    'hotelChain': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof TaskAttachmentReadRelationships
     */
    'user': Reltoone;
}
/**
 * 
 * @export
 * @interface TemplateRead
 */
export interface TemplateRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof TemplateRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof TemplateRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof TemplateRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {TemplateReadAttributes}
     * @memberof TemplateRead
     */
    'attributes'?: TemplateReadAttributes;
}
/**
 * 
 * @export
 * @interface TemplateReadAttributes
 */
export interface TemplateReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof TemplateReadAttributes
     */
    'language'?: TemplateReadAttributesLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof TemplateReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TemplateReadAttributes
     */
    'templateType': TemplateReadAttributesTemplateTypeEnum;
}

export const TemplateReadAttributesLanguageEnum = {
    En: 'en',
    De: 'de',
    It: 'it',
    Fr: 'fr',
    Pt: 'pt',
    Es: 'es'
} as const;

export type TemplateReadAttributesLanguageEnum = typeof TemplateReadAttributesLanguageEnum[keyof typeof TemplateReadAttributesLanguageEnum];
export const TemplateReadAttributesTemplateTypeEnum = {
    Beo: 'beo',
    DiagrammingBeo: 'diagramming-beo',
    Proposal: 'proposal',
    Proforma: 'proforma',
    Contract: 'contract'
} as const;

export type TemplateReadAttributesTemplateTypeEnum = typeof TemplateReadAttributesTemplateTypeEnum[keyof typeof TemplateReadAttributesTemplateTypeEnum];

/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof Token
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof Token
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof Token
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {TokenAttributes}
     * @memberof Token
     */
    'attributes'?: TokenAttributes;
}
/**
 * 
 * @export
 * @interface TokenAttributes
 */
export interface TokenAttributes {
    /**
     * 
     * @type {string}
     * @memberof TokenAttributes
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof TokenAttributes
     */
    'password': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TokenAttributes
     */
    'scopes'?: Array<TokenAttributesScopesEnum>;
    /**
     * 
     * @type {string}
     * @memberof TokenAttributes
     */
    'token'?: string;
}

export const TokenAttributesScopesEnum = {
    Readcrm: 'read:crm',
    Writecrm: 'write:crm',
    Updatecrm: 'update:crm',
    Deletecrm: 'delete:crm',
    SendEmailaccount: 'send_email:account',
    UpdateCommissionaccount: 'update_commission:account',
    Mergeaccount: 'merge:account',
    MoveContactAccountcontact: 'move-contact-account:contact',
    ReadgenericOrders: 'read:generic-orders',
    WritegenericOrders: 'write:generic-orders',
    UpdategenericOrders: 'update:generic-orders',
    DeletegenericOrders: 'delete:generic-orders',
    ApplyDiscountgenericOrders: 'apply-discount:generic-orders',
    RefreshPricesgenericOrders: 'refresh-prices:generic-orders',
    ChangeRateCodegenericOrders: 'change-rate-code:generic-orders',
    ChangeCurrencygenericOrders: 'change-currency:generic-orders',
    ChangeStatusCompleteTransitionsgenericOrders: 'change-status-complete-transitions:generic-orders',
    ChangeStatusNoBackTransitionsgenericOrders: 'change-status-no-back-transitions:generic-orders',
    ChangeStatusCancelTransitionsgenericOrders: 'change-status-cancel-transitions:generic-orders',
    ReadgenericOrderActivities: 'read:generic-order-activities',
    WritegenericOrderActivities: 'write:generic-order-activities',
    UpdategenericOrderActivities: 'update:generic-order-activities',
    DeletegenericOrderActivities: 'delete:generic-order-activities',
    ApplyDiscountgenericOrderActivities: 'apply-discount:generic-order-activities',
    ApplyCommissiongenericOrderActivities: 'apply-commission:generic-order-activities',
    OverridePricegenericOrderActivities: 'override-price:generic-order-activities',
    RefreshPricegenericOrderActivities: 'refresh-price:generic-order-activities',
    ReadgenericGuestRoomRequest: 'read:generic-guest-room-request',
    WritegenericGuestRoomRequest: 'write:generic-guest-room-request',
    UpdategenericGuestRoomRequest: 'update:generic-guest-room-request',
    DeletegenericGuestRoomRequest: 'delete:generic-guest-room-request',
    ApplyDiscountgenericGuestRoomRequest: 'apply-discount:generic-guest-room-request',
    ApplyCommissiongenericGuestRoomRequest: 'apply-commission:generic-guest-room-request',
    OverridePricegenericGuestRoomRequest: 'override-price:generic-guest-room-request',
    RefreshPricegenericGuestRoomRequest: 'refresh-price:generic-guest-room-request',
    ReadgenericService: 'read:generic-service',
    WritegenericService: 'write:generic-service',
    UpdategenericService: 'update:generic-service',
    DeletegenericService: 'delete:generic-service',
    ApplyDiscountgenericService: 'apply-discount:generic-service',
    ApplyCommissiongenericService: 'apply-commission:generic-service',
    OverridePricegenericService: 'override-price:generic-service',
    RefreshPricegenericService: 'refresh-price:generic-service',
    ReadorderEventPackages: 'read:order-event-packages',
    WriteorderEventPackages: 'write:order-event-packages',
    UpdateorderEventPackages: 'update:order-event-packages',
    DeleteorderEventPackages: 'delete:order-event-packages',
    ApplyDiscountorderEventPackages: 'apply-discount:order-event-packages',
    ApplyCommissionorderEventPackages: 'apply-commission:order-event-packages',
    OverridePriceorderEventPackages: 'override-price:order-event-packages',
    RefreshPriceorderEventPackages: 'refresh-price:order-event-packages',
    Readusers: 'read:users',
    Readpayments: 'read:payments',
    Writepayments: 'write:payments',
    Updatepayments: 'update:payments',
    Deletepayments: 'delete:payments',
    ChangeStatuspayments: 'change-status:payments',
    Writepricing: 'write:pricing',
    ReadguestRoomAllotments: 'read:guest-room-allotments',
    WriteguestRoomAllotments: 'write:guest-room-allotments',
    UpdateguestRoomAllotments: 'update:guest-room-allotments',
    DeleteguestRoomAllotments: 'delete:guest-room-allotments',
    ReadguestRoomRates: 'read:guest-room-rates',
    WriteguestRoomRates: 'write:guest-room-rates',
    UpdateguestRoomRates: 'update:guest-room-rates',
    DeleteguestRoomRates: 'delete:guest-room-rates',
    WriteorderAttachments: 'write:order-attachments',
    UpdateorderAttachments: 'update:order-attachments',
    DeleteorderAttachments: 'delete:order-attachments',
    ReadorderAttachments: 'read:order-attachments',
    WriteorderNote: 'write:order-note',
    UpdateorderNote: 'update:order-note',
    DeleteorderNote: 'delete:order-note',
    ReadorderNote: 'read:order-note',
    Readtemplates: 'read:templates',
    Readhotels: 'read:hotels',
    Readservices: 'read:services',
    Deleteservices: 'delete:services',
    Updateservices: 'update:services',
    Writeservices: 'write:services',
    ReadserviceRates: 'read:service-rates',
    DeleteserviceRates: 'delete:service-rates',
    UpdateserviceRates: 'update:service-rates',
    WriteserviceRates: 'write:service-rates',
    ReadmeetingRooms: 'read:meeting-rooms',
    WritemeetingRooms: 'write:meeting-rooms',
    DeletemeetingRooms: 'delete:meeting-rooms',
    UpdatemeetingRooms: 'update:meeting-rooms',
    ReadmeetingRoomRates: 'read:meeting-room-rates',
    WritemeetingRoomRates: 'write:meeting-room-rates',
    DeletemeetingRoomRates: 'delete:meeting-room-rates',
    UpdatemeetingRoomRates: 'update:meeting-room-rates',
    ReadmeetingRoomBlocks: 'read:meeting-room-blocks',
    WritemeetingRoomBlocks: 'write:meeting-room-blocks',
    UpdatemeetingRoomBlocks: 'update:meeting-room-blocks',
    DeletemeetingRoomBlocks: 'delete:meeting-room-blocks',
    ReadmeetingRoomSetups: 'read:meeting-room-setups',
    WritemeetingRoomSetups: 'write:meeting-room-setups',
    UpdatemeetingRoomSetups: 'update:meeting-room-setups',
    DeletemeetingRoomSetups: 'delete:meeting-room-setups',
    ReadguestRooms: 'read:guest-rooms',
    WriteguestRooms: 'write:guest-rooms',
    UpdateguestRooms: 'update:guest-rooms',
    DeleteguestRooms: 'delete:guest-rooms',
    Readdiagramming: 'read:diagramming',
    Writediagramming: 'write:diagramming',
    Updatediagramming: 'update:diagramming',
    Deletediagramming: 'delete:diagramming',
    ReadvirtualMeetingRoomSetupLink: 'read:virtual-meeting-room-setup-link',
    WritevirtualMeetingRoomSetupLink: 'write:virtual-meeting-room-setup-link',
    UpdatevirtualMeetingRoomSetupLink: 'update:virtual-meeting-room-setup-link',
    DeletevirtualMeetingRoomSetupLink: 'delete:virtual-meeting-room-setup-link',
    ReadrateCodes: 'read:rate-codes',
    WriterateCodes: 'write:rate-codes',
    UpdaterateCodes: 'update:rate-codes',
    DeleterateCodes: 'delete:rate-codes',
    ReadorderReporting: 'read:order-reporting',
    ReaddiagrammingReporting: 'read:diagramming-reporting',
    ReadvirtualMeetingRoom: 'read:virtual-meeting-room',
    WritevirtualMeetingRoom: 'write:virtual-meeting-room',
    UpdatevirtualMeetingRoom: 'update:virtual-meeting-room',
    DeletevirtualMeetingRoom: 'delete:virtual-meeting-room',
    ReadvirtualFurniture: 'read:virtual-furniture',
    WritevirtualFurniture: 'write:virtual-furniture',
    UpdatevirtualFurniture: 'update:virtual-furniture',
    DeletevirtualFurniture: 'delete:virtual-furniture',
    ReadvirtualMeetingRoomSetup: 'read:virtual-meeting-room-setup',
    WritevirtualMeetingRoomSetup: 'write:virtual-meeting-room-setup',
    UpdatevirtualMeetingRoomSetup: 'update:virtual-meeting-room-setup',
    DeletevirtualMeetingRoomSetup: 'delete:virtual-meeting-room-setup',
    Readpackages: 'read:packages',
    Writepackages: 'write:packages',
    Updatepackages: 'update:packages',
    Deletepackages: 'delete:packages',
    ReadvirtualMeetingRoomSetupTemplate: 'read:virtual-meeting-room-setup-template',
    WritevirtualMeetingRoomSetupTemplate: 'write:virtual-meeting-room-setup-template',
    UpdatevirtualMeetingRoomSetupTemplate: 'update:virtual-meeting-room-setup-template',
    DeletevirtualMeetingRoomSetupTemplate: 'delete:virtual-meeting-room-setup-template',
    ReadhotelChainChoices: 'read:hotel-chain-choices',
    WritehotelChainChoices: 'write:hotel-chain-choices',
    UpdatehotelChainChoices: 'update:hotel-chain-choices',
    DeletehotelChainChoices: 'delete:hotel-chain-choices',
    ReadorderTasks: 'read:order-tasks',
    WriteorderTasks: 'write:order-tasks',
    UpdateorderTasks: 'update:order-tasks',
    DeleteorderTasks: 'delete:order-tasks',
    ReadvirtualObject: 'read:virtual-object',
    WritevirtualObject: 'write:virtual-object',
    UpdatevirtualObject: 'update:virtual-object',
    DeletevirtualObject: 'delete:virtual-object',
    Readcurrencies: 'read:currencies',
    ReadtaskAttachment: 'read:task-attachment',
    WritetaskAttachment: 'write:task-attachment',
    UpdatetaskAttachment: 'update:task-attachment',
    DeletetaskAttachment: 'delete:task-attachment',
    ReadeventPackageRates: 'read:event-package-rates',
    WriteeventPackageRates: 'write:event-package-rates',
    UpdateeventPackageRates: 'update:event-package-rates',
    DeleteeventPackageRates: 'delete:event-package-rates',
    WritevirtualMeetingRoomSetupScreenshot: 'write:virtual-meeting-room-setup-screenshot',
    DeletevirtualMeetingRoomSetupScreenshot: 'delete:virtual-meeting-room-setup-screenshot'
} as const;

export type TokenAttributesScopesEnum = typeof TokenAttributesScopesEnum[keyof typeof TokenAttributesScopesEnum];

/**
 * 
 * @export
 * @interface UserRead
 */
export interface UserRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof UserRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof UserRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof UserRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {UserReadAttributes}
     * @memberof UserRead
     */
    'attributes'?: UserReadAttributes;
    /**
     * 
     * @type {UserReadRelationships}
     * @memberof UserRead
     */
    'relationships'?: UserReadRelationships;
}
/**
 * 
 * @export
 * @interface UserReadAttributes
 */
export interface UserReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof UserReadAttributes
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserReadAttributes
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserReadAttributes
     */
    'lastName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserReadAttributes
     */
    'segmentationTypes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UserReadRelationships
 */
export interface UserReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof UserReadRelationships
     */
    'profile': Reltoone;
}
/**
 * 
 * @export
 * @interface VirtualFurniture
 */
export interface VirtualFurniture {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualFurniture
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualFurniture
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualFurniture
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {VirtualFurnitureAttributes}
     * @memberof VirtualFurniture
     */
    'attributes'?: VirtualFurnitureAttributes;
    /**
     * 
     * @type {CreateBookingCartRequestDataRelationships}
     * @memberof VirtualFurniture
     */
    'relationships'?: CreateBookingCartRequestDataRelationships;
}
/**
 * 
 * @export
 * @interface VirtualFurnitureAttributes
 */
export interface VirtualFurnitureAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureAttributes
     */
    'availabilityStatus'?: VirtualFurnitureAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureAttributes
     */
    'furnitureType': VirtualFurnitureAttributesFurnitureTypeEnum;
    /**
     * 
     * @type {File}
     * @memberof VirtualFurnitureAttributes
     */
    'asset': File;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureAttributes
     */
    'height'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureAttributes
     */
    'length'?: string | null;
    /**
     * 
     * @type {File}
     * @memberof VirtualFurnitureAttributes
     */
    'thumbnail'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureAttributes
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureAttributes
     */
    'width'?: string | null;
}

export const VirtualFurnitureAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type VirtualFurnitureAttributesAvailabilityStatusEnum = typeof VirtualFurnitureAttributesAvailabilityStatusEnum[keyof typeof VirtualFurnitureAttributesAvailabilityStatusEnum];
export const VirtualFurnitureAttributesFurnitureTypeEnum = {
    Chair: 'chair',
    RoundedTable: 'rounded-table',
    SquareTable: 'square-table',
    CocktailTable: 'cocktail-table',
    BoardroomTable: 'boardroom-table'
} as const;

export type VirtualFurnitureAttributesFurnitureTypeEnum = typeof VirtualFurnitureAttributesFurnitureTypeEnum[keyof typeof VirtualFurnitureAttributesFurnitureTypeEnum];

/**
 * 
 * @export
 * @interface VirtualFurnitureRead
 */
export interface VirtualFurnitureRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualFurnitureRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualFurnitureRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualFurnitureRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {VirtualFurnitureReadAttributes}
     * @memberof VirtualFurnitureRead
     */
    'attributes'?: VirtualFurnitureReadAttributes;
    /**
     * 
     * @type {VirtualFurnitureReadRelationships}
     * @memberof VirtualFurnitureRead
     */
    'relationships'?: VirtualFurnitureReadRelationships;
}
/**
 * 
 * @export
 * @interface VirtualFurnitureReadAttributes
 */
export interface VirtualFurnitureReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    'availabilityStatus'?: VirtualFurnitureReadAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    'furnitureType': VirtualFurnitureReadAttributesFurnitureTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {File}
     * @memberof VirtualFurnitureReadAttributes
     */
    'asset': File;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    'height'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    'length'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VirtualFurnitureReadAttributes
     */
    'inventory'?: number;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {File}
     * @memberof VirtualFurnitureReadAttributes
     */
    'thumbnail'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributes
     */
    'width'?: string | null;
    /**
     * 
     * @type {Array<VirtualFurnitureReadAttributesFurnitureInventoryInner>}
     * @memberof VirtualFurnitureReadAttributes
     */
    'furnitureInventory'?: Array<VirtualFurnitureReadAttributesFurnitureInventoryInner>;
}

export const VirtualFurnitureReadAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type VirtualFurnitureReadAttributesAvailabilityStatusEnum = typeof VirtualFurnitureReadAttributesAvailabilityStatusEnum[keyof typeof VirtualFurnitureReadAttributesAvailabilityStatusEnum];
export const VirtualFurnitureReadAttributesFurnitureTypeEnum = {
    Chair: 'chair',
    RoundedTable: 'rounded-table',
    SquareTable: 'square-table',
    CocktailTable: 'cocktail-table',
    BoardroomTable: 'boardroom-table'
} as const;

export type VirtualFurnitureReadAttributesFurnitureTypeEnum = typeof VirtualFurnitureReadAttributesFurnitureTypeEnum[keyof typeof VirtualFurnitureReadAttributesFurnitureTypeEnum];

/**
 * 
 * @export
 * @interface VirtualFurnitureReadAttributesFurnitureInventoryInner
 */
export interface VirtualFurnitureReadAttributesFurnitureInventoryInner {
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureReadAttributesFurnitureInventoryInner
     */
    'inventoryDate': string;
    /**
     * 
     * @type {number}
     * @memberof VirtualFurnitureReadAttributesFurnitureInventoryInner
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface VirtualFurnitureReadRelationships
 */
export interface VirtualFurnitureReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof VirtualFurnitureReadRelationships
     */
    'hotel': Reltoone;
    /**
     * 
     * @type {Reltomany}
     * @memberof VirtualFurnitureReadRelationships
     */
    'virtualMeetingRooms'?: Reltomany;
}
/**
 * 
 * @export
 * @interface VirtualFurnitureWrite
 */
export interface VirtualFurnitureWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualFurnitureWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualFurnitureWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualFurnitureWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {VirtualFurnitureWriteAttributes}
     * @memberof VirtualFurnitureWrite
     */
    'attributes'?: VirtualFurnitureWriteAttributes;
    /**
     * 
     * @type {VirtualFurnitureWriteRelationships}
     * @memberof VirtualFurnitureWrite
     */
    'relationships'?: VirtualFurnitureWriteRelationships;
}
/**
 * 
 * @export
 * @interface VirtualFurnitureWriteAttributes
 */
export interface VirtualFurnitureWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureWriteAttributes
     */
    'availabilityStatus'?: VirtualFurnitureWriteAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureWriteAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {File}
     * @memberof VirtualFurnitureWriteAttributes
     */
    'asset': File;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureWriteAttributes
     */
    'height'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VirtualFurnitureWriteAttributes
     */
    'inventory'?: number;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureWriteAttributes
     */
    'length'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureWriteAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureWriteAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureWriteAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureWriteAttributes
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualFurnitureWriteAttributes
     */
    'width'?: string | null;
}

export const VirtualFurnitureWriteAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type VirtualFurnitureWriteAttributesAvailabilityStatusEnum = typeof VirtualFurnitureWriteAttributesAvailabilityStatusEnum[keyof typeof VirtualFurnitureWriteAttributesAvailabilityStatusEnum];

/**
 * 
 * @export
 * @interface VirtualFurnitureWriteRelationships
 */
export interface VirtualFurnitureWriteRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof VirtualFurnitureWriteRelationships
     */
    'hotel': Reltoone;
    /**
     * 
     * @type {Reltomany}
     * @memberof VirtualFurnitureWriteRelationships
     */
    'virtualMeetingRooms': Reltomany;
}
/**
 * 
 * @export
 * @interface VirtualFurnitureWriteThumbnail
 */
export interface VirtualFurnitureWriteThumbnail {
    /**
     * 
     * @type {File}
     * @memberof VirtualFurnitureWriteThumbnail
     */
    'thumbnail'?: File | null;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomRead
 */
export interface VirtualMeetingRoomRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualMeetingRoomRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualMeetingRoomRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualMeetingRoomRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {VirtualMeetingRoomReadAttributes}
     * @memberof VirtualMeetingRoomRead
     */
    'attributes'?: VirtualMeetingRoomReadAttributes;
    /**
     * 
     * @type {VirtualMeetingRoomReadRelationships}
     * @memberof VirtualMeetingRoomRead
     */
    'relationships'?: VirtualMeetingRoomReadRelationships;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomReadAttributes
 */
export interface VirtualMeetingRoomReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomReadAttributes
     */
    'availabilityStatus'?: VirtualMeetingRoomReadAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {File}
     * @memberof VirtualMeetingRoomReadAttributes
     */
    'asset': File;
    /**
     * 
     * @type {File}
     * @memberof VirtualMeetingRoomReadAttributes
     */
    'assetPlaceholder': File;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomReadAttributes
     */
    'initialGraph': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomReadAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomReadAttributes
     */
    'uuid'?: string;
}

export const VirtualMeetingRoomReadAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type VirtualMeetingRoomReadAttributesAvailabilityStatusEnum = typeof VirtualMeetingRoomReadAttributesAvailabilityStatusEnum[keyof typeof VirtualMeetingRoomReadAttributesAvailabilityStatusEnum];

/**
 * 
 * @export
 * @interface VirtualMeetingRoomReadRelationships
 */
export interface VirtualMeetingRoomReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof VirtualMeetingRoomReadRelationships
     */
    'meetingRoom': Reltoone;
    /**
     * 
     * @type {Reltomany}
     * @memberof VirtualMeetingRoomReadRelationships
     */
    'furnitures'?: Reltomany;
    /**
     * 
     * @type {Reltomany}
     * @memberof VirtualMeetingRoomReadRelationships
     */
    'dollhouseSchemas': Reltomany;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupDuplicate
 */
export interface VirtualMeetingRoomSetupDuplicate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupDuplicate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupDuplicate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualMeetingRoomSetupDuplicate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderDuplicateAttributes}
     * @memberof VirtualMeetingRoomSetupDuplicate
     */
    'attributes'?: GenericOrderDuplicateAttributes;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupLinkRead
 */
export interface VirtualMeetingRoomSetupLinkRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupLinkRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupLinkRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualMeetingRoomSetupLinkRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {VirtualMeetingRoomSetupLinkReadAttributes}
     * @memberof VirtualMeetingRoomSetupLinkRead
     */
    'attributes'?: VirtualMeetingRoomSetupLinkReadAttributes;
    /**
     * 
     * @type {VirtualMeetingRoomSetupLinkReadRelationships}
     * @memberof VirtualMeetingRoomSetupLinkRead
     */
    'relationships'?: VirtualMeetingRoomSetupLinkReadRelationships;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupLinkReadAttributes
 */
export interface VirtualMeetingRoomSetupLinkReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupLinkReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupLinkReadAttributes
     */
    'internalNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupLinkReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupLinkReadAttributes
     */
    'permission': VirtualMeetingRoomSetupLinkReadAttributesPermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupLinkReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupLinkReadAttributes
     */
    'uuid'?: string;
}

export const VirtualMeetingRoomSetupLinkReadAttributesPermissionEnum = {
    Edit: 'edit',
    Readonly: 'readonly'
} as const;

export type VirtualMeetingRoomSetupLinkReadAttributesPermissionEnum = typeof VirtualMeetingRoomSetupLinkReadAttributesPermissionEnum[keyof typeof VirtualMeetingRoomSetupLinkReadAttributesPermissionEnum];

/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupLinkReadRelationships
 */
export interface VirtualMeetingRoomSetupLinkReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof VirtualMeetingRoomSetupLinkReadRelationships
     */
    'virtualMeetingRoomSetup': Reltoone;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupLinkWrite
 */
export interface VirtualMeetingRoomSetupLinkWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupLinkWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupLinkWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualMeetingRoomSetupLinkWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {VirtualMeetingRoomSetupLinkWriteAttributes}
     * @memberof VirtualMeetingRoomSetupLinkWrite
     */
    'attributes'?: VirtualMeetingRoomSetupLinkWriteAttributes;
    /**
     * 
     * @type {VirtualMeetingRoomSetupLinkReadRelationships}
     * @memberof VirtualMeetingRoomSetupLinkWrite
     */
    'relationships'?: VirtualMeetingRoomSetupLinkReadRelationships;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupLinkWriteAttributes
 */
export interface VirtualMeetingRoomSetupLinkWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupLinkWriteAttributes
     */
    'internalNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupLinkWriteAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupLinkWriteAttributes
     */
    'permission': VirtualMeetingRoomSetupLinkWriteAttributesPermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupLinkWriteAttributes
     */
    'uuid'?: string;
}

export const VirtualMeetingRoomSetupLinkWriteAttributesPermissionEnum = {
    Edit: 'edit',
    Readonly: 'readonly'
} as const;

export type VirtualMeetingRoomSetupLinkWriteAttributesPermissionEnum = typeof VirtualMeetingRoomSetupLinkWriteAttributesPermissionEnum[keyof typeof VirtualMeetingRoomSetupLinkWriteAttributesPermissionEnum];

/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupRead
 */
export interface VirtualMeetingRoomSetupRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualMeetingRoomSetupRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {VirtualMeetingRoomSetupReadAttributes}
     * @memberof VirtualMeetingRoomSetupRead
     */
    'attributes'?: VirtualMeetingRoomSetupReadAttributes;
    /**
     * 
     * @type {VirtualMeetingRoomSetupReadRelationships}
     * @memberof VirtualMeetingRoomSetupRead
     */
    'relationships'?: VirtualMeetingRoomSetupReadRelationships;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupReadAttributes
 */
export interface VirtualMeetingRoomSetupReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupReadAttributes
     */
    'graph': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupReadAttributes
     */
    'permission': VirtualMeetingRoomSetupReadAttributesPermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupReadAttributes
     */
    'uuid'?: string;
}

export const VirtualMeetingRoomSetupReadAttributesPermissionEnum = {
    Edit: 'edit',
    Readonly: 'readonly'
} as const;

export type VirtualMeetingRoomSetupReadAttributesPermissionEnum = typeof VirtualMeetingRoomSetupReadAttributesPermissionEnum[keyof typeof VirtualMeetingRoomSetupReadAttributesPermissionEnum];

/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupReadRelationships
 */
export interface VirtualMeetingRoomSetupReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof VirtualMeetingRoomSetupReadRelationships
     */
    'virtualMeetingRoom': Reltoone;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupScreenshotWrite
 */
export interface VirtualMeetingRoomSetupScreenshotWrite {
    /**
     * 
     * @type {number}
     * @memberof VirtualMeetingRoomSetupScreenshotWrite
     */
    'virtual_meeting_room_setup': number;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupScreenshotWrite
     */
    'title'?: string | null;
    /**
     * 
     * @type {File}
     * @memberof VirtualMeetingRoomSetupScreenshotWrite
     */
    'screenshot'?: File;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupTemplateDuplicate
 */
export interface VirtualMeetingRoomSetupTemplateDuplicate {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateDuplicate
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateDuplicate
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualMeetingRoomSetupTemplateDuplicate
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {GenericOrderDuplicateAttributes}
     * @memberof VirtualMeetingRoomSetupTemplateDuplicate
     */
    'attributes'?: GenericOrderDuplicateAttributes;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupTemplateRead
 */
export interface VirtualMeetingRoomSetupTemplateRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualMeetingRoomSetupTemplateRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {VirtualMeetingRoomSetupTemplateReadAttributes}
     * @memberof VirtualMeetingRoomSetupTemplateRead
     */
    'attributes'?: VirtualMeetingRoomSetupTemplateReadAttributes;
    /**
     * 
     * @type {VirtualMeetingRoomSetupReadRelationships}
     * @memberof VirtualMeetingRoomSetupTemplateRead
     */
    'relationships'?: VirtualMeetingRoomSetupReadRelationships;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupTemplateReadAttributes
 */
export interface VirtualMeetingRoomSetupTemplateReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateReadAttributes
     */
    'graph': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateReadAttributes
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupTemplateWrite
 */
export interface VirtualMeetingRoomSetupTemplateWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualMeetingRoomSetupTemplateWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {VirtualMeetingRoomSetupTemplateWriteAttributes}
     * @memberof VirtualMeetingRoomSetupTemplateWrite
     */
    'attributes'?: VirtualMeetingRoomSetupTemplateWriteAttributes;
    /**
     * 
     * @type {VirtualMeetingRoomSetupReadRelationships}
     * @memberof VirtualMeetingRoomSetupTemplateWrite
     */
    'relationships'?: VirtualMeetingRoomSetupReadRelationships;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupTemplateWriteAttributes
 */
export interface VirtualMeetingRoomSetupTemplateWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateWriteAttributes
     */
    'availabilityStatus'?: VirtualMeetingRoomSetupTemplateWriteAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateWriteAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateWriteAttributes
     */
    'graph': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateWriteAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateWriteAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupTemplateWriteAttributes
     */
    'uuid'?: string;
}

export const VirtualMeetingRoomSetupTemplateWriteAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type VirtualMeetingRoomSetupTemplateWriteAttributesAvailabilityStatusEnum = typeof VirtualMeetingRoomSetupTemplateWriteAttributesAvailabilityStatusEnum[keyof typeof VirtualMeetingRoomSetupTemplateWriteAttributesAvailabilityStatusEnum];

/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupWrite
 */
export interface VirtualMeetingRoomSetupWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualMeetingRoomSetupWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualMeetingRoomSetupWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {VirtualMeetingRoomSetupWriteAttributes}
     * @memberof VirtualMeetingRoomSetupWrite
     */
    'attributes'?: VirtualMeetingRoomSetupWriteAttributes;
    /**
     * 
     * @type {VirtualMeetingRoomSetupReadRelationships}
     * @memberof VirtualMeetingRoomSetupWrite
     */
    'relationships'?: VirtualMeetingRoomSetupReadRelationships;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomSetupWriteAttributes
 */
export interface VirtualMeetingRoomSetupWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupWriteAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {Array<PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributesFurnituresInner>}
     * @memberof VirtualMeetingRoomSetupWriteAttributes
     */
    'furnitures'?: Array<PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequestDataAttributesFurnituresInner>;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupWriteAttributes
     */
    'graph': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupWriteAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupWriteAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomSetupWriteAttributes
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomWrite
 */
export interface VirtualMeetingRoomWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualMeetingRoomWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualMeetingRoomWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualMeetingRoomWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {VirtualMeetingRoomWriteAttributes}
     * @memberof VirtualMeetingRoomWrite
     */
    'attributes'?: VirtualMeetingRoomWriteAttributes;
    /**
     * 
     * @type {VirtualMeetingRoomWriteRelationships}
     * @memberof VirtualMeetingRoomWrite
     */
    'relationships'?: VirtualMeetingRoomWriteRelationships;
}
/**
 * 
 * @export
 * @interface VirtualMeetingRoomWriteAttributes
 */
export interface VirtualMeetingRoomWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomWriteAttributes
     */
    'availabilityStatus'?: VirtualMeetingRoomWriteAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomWriteAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {File}
     * @memberof VirtualMeetingRoomWriteAttributes
     */
    'asset': File;
    /**
     * 
     * @type {File}
     * @memberof VirtualMeetingRoomWriteAttributes
     */
    'assetPlaceholder': File;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomWriteAttributes
     */
    'initialGraph': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomWriteAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomWriteAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomWriteAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualMeetingRoomWriteAttributes
     */
    'uuid'?: string;
}

export const VirtualMeetingRoomWriteAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type VirtualMeetingRoomWriteAttributesAvailabilityStatusEnum = typeof VirtualMeetingRoomWriteAttributesAvailabilityStatusEnum[keyof typeof VirtualMeetingRoomWriteAttributesAvailabilityStatusEnum];

/**
 * 
 * @export
 * @interface VirtualMeetingRoomWriteRelationships
 */
export interface VirtualMeetingRoomWriteRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof VirtualMeetingRoomWriteRelationships
     */
    'meetingRoom': Reltoone;
    /**
     * 
     * @type {Reltomany}
     * @memberof VirtualMeetingRoomWriteRelationships
     */
    'furnitures': Reltomany;
}
/**
 * 
 * @export
 * @interface VirtualObject
 */
export interface VirtualObject {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualObject
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualObject
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualObject
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {VirtualObjectAttributes}
     * @memberof VirtualObject
     */
    'attributes'?: VirtualObjectAttributes;
    /**
     * 
     * @type {VirtualObjectReadRelationships}
     * @memberof VirtualObject
     */
    'relationships'?: VirtualObjectReadRelationships;
}
/**
 * 
 * @export
 * @interface VirtualObjectAttributes
 */
export interface VirtualObjectAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectAttributes
     */
    'availabilityStatus'?: VirtualObjectAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectAttributes
     */
    'objectType': VirtualObjectAttributesObjectTypeEnum;
    /**
     * 
     * @type {File}
     * @memberof VirtualObjectAttributes
     */
    'asset': File;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectAttributes
     */
    'name': string;
    /**
     * 
     * @type {File}
     * @memberof VirtualObjectAttributes
     */
    'thumbnail'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectAttributes
     */
    'uuid'?: string;
}

export const VirtualObjectAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type VirtualObjectAttributesAvailabilityStatusEnum = typeof VirtualObjectAttributesAvailabilityStatusEnum[keyof typeof VirtualObjectAttributesAvailabilityStatusEnum];
export const VirtualObjectAttributesObjectTypeEnum = {
    Audiovisual: 'audiovisual',
    BarRestaurant: 'bar-restaurant',
    Outdoor: 'outdoor',
    Others: 'others',
    Wedding: 'wedding'
} as const;

export type VirtualObjectAttributesObjectTypeEnum = typeof VirtualObjectAttributesObjectTypeEnum[keyof typeof VirtualObjectAttributesObjectTypeEnum];

/**
 * 
 * @export
 * @interface VirtualObjectRead
 */
export interface VirtualObjectRead {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualObjectRead
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualObjectRead
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualObjectRead
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {VirtualObjectReadAttributes}
     * @memberof VirtualObjectRead
     */
    'attributes'?: VirtualObjectReadAttributes;
    /**
     * 
     * @type {VirtualObjectReadRelationships}
     * @memberof VirtualObjectRead
     */
    'relationships'?: VirtualObjectReadRelationships;
}
/**
 * 
 * @export
 * @interface VirtualObjectReadAttributes
 */
export interface VirtualObjectReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectReadAttributes
     */
    'availabilityStatus'?: VirtualObjectReadAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectReadAttributes
     */
    'objectType': VirtualObjectReadAttributesObjectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectReadAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {File}
     * @memberof VirtualObjectReadAttributes
     */
    'asset': File;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectReadAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectReadAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {File}
     * @memberof VirtualObjectReadAttributes
     */
    'thumbnail'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectReadAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectReadAttributes
     */
    'uuid'?: string;
}

export const VirtualObjectReadAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type VirtualObjectReadAttributesAvailabilityStatusEnum = typeof VirtualObjectReadAttributesAvailabilityStatusEnum[keyof typeof VirtualObjectReadAttributesAvailabilityStatusEnum];
export const VirtualObjectReadAttributesObjectTypeEnum = {
    Audiovisual: 'audiovisual',
    BarRestaurant: 'bar-restaurant',
    Outdoor: 'outdoor',
    Others: 'others',
    Wedding: 'wedding'
} as const;

export type VirtualObjectReadAttributesObjectTypeEnum = typeof VirtualObjectReadAttributesObjectTypeEnum[keyof typeof VirtualObjectReadAttributesObjectTypeEnum];

/**
 * 
 * @export
 * @interface VirtualObjectReadRelationships
 */
export interface VirtualObjectReadRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof VirtualObjectReadRelationships
     */
    'hotel': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof VirtualObjectReadRelationships
     */
    'service'?: Reltoone;
}
/**
 * 
 * @export
 * @interface VirtualObjectWrite
 */
export interface VirtualObjectWrite {
    /**
     * The [type](https://jsonapi.org/format/#document-resource-object-identification) member is used to describe resource objects that share common attributes and relationships.
     * @type {string}
     * @memberof VirtualObjectWrite
     */
    'type': string;
    /**
     * Each resource object’s type and id pair MUST [identify](https://jsonapi.org/format/#document-resource-object-identification) a single, unique resource.
     * @type {string}
     * @memberof VirtualObjectWrite
     */
    'id': string;
    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequestDataLinks}
     * @memberof VirtualObjectWrite
     */
    'links'?: PartialUpdateBookingCartActivitiesIdRequestDataLinks;
    /**
     * 
     * @type {VirtualObjectWriteAttributes}
     * @memberof VirtualObjectWrite
     */
    'attributes'?: VirtualObjectWriteAttributes;
    /**
     * 
     * @type {VirtualObjectWriteRelationships}
     * @memberof VirtualObjectWrite
     */
    'relationships'?: VirtualObjectWriteRelationships;
}
/**
 * 
 * @export
 * @interface VirtualObjectWriteAttributes
 */
export interface VirtualObjectWriteAttributes {
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectWriteAttributes
     */
    'availabilityStatus'?: VirtualObjectWriteAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectWriteAttributes
     */
    'createdAt'?: string;
    /**
     * 
     * @type {File}
     * @memberof VirtualObjectWriteAttributes
     */
    'asset': File;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectWriteAttributes
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectWriteAttributes
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectWriteAttributes
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualObjectWriteAttributes
     */
    'uuid'?: string;
}

export const VirtualObjectWriteAttributesAvailabilityStatusEnum = {
    Disabled: 'disabled',
    Private: 'private',
    Public: 'public'
} as const;

export type VirtualObjectWriteAttributesAvailabilityStatusEnum = typeof VirtualObjectWriteAttributesAvailabilityStatusEnum[keyof typeof VirtualObjectWriteAttributesAvailabilityStatusEnum];

/**
 * 
 * @export
 * @interface VirtualObjectWriteRelationships
 */
export interface VirtualObjectWriteRelationships {
    /**
     * 
     * @type {Reltoone}
     * @memberof VirtualObjectWriteRelationships
     */
    'hotel': Reltoone;
    /**
     * 
     * @type {Reltoone}
     * @memberof VirtualObjectWriteRelationships
     */
    'service': Reltoone;
}

/**
 * BookingApi - axios parameter creator
 * @export
 */
export const BookingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id A unique integer value identifying this generic order.
         * @param {ConfirmBookingCartIdConfirmRequest} [confirmBookingCartIdConfirmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmBookingCartIdConfirm: async (id: string, confirmBookingCartIdConfirmRequest?: ConfirmBookingCartIdConfirmRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('confirmBookingCartIdConfirm', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/{id}/confirm/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmBookingCartIdConfirmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBookingCartRequest} [createBookingCartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingCart: async (createBookingCartRequest?: CreateBookingCartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/booking/cart/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingCartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBookingCartActivitiesRequest} [createBookingCartActivitiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingCartActivities: async (createBookingCartActivitiesRequest?: CreateBookingCartActivitiesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/booking/cart/activities/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingCartActivitiesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBookingCartEventPackagesRequest} [createBookingCartEventPackagesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingCartEventPackages: async (createBookingCartEventPackagesRequest?: CreateBookingCartEventPackagesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/booking/cart/event-packages/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingCartEventPackagesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBookingCartGuestRoomsRequest} [createBookingCartGuestRoomsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingCartGuestRooms: async (createBookingCartGuestRoomsRequest?: CreateBookingCartGuestRoomsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/booking/cart/guest-rooms/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingCartGuestRoomsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBookingCartServicesRequest} [createBookingCartServicesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingCartServices: async (createBookingCartServicesRequest?: CreateBookingCartServicesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/booking/cart/services/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingCartServicesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBookingPlannerRfpRequest} [createBookingPlannerRfpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingPlannerRfp: async (createBookingPlannerRfpRequest?: CreateBookingPlannerRfpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/booking/planner-rfp/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBookingPlannerRfpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic order activity.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyBookingCartActivitiesId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyBookingCartActivitiesId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/activities/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this order event package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyBookingCartEventPackagesId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyBookingCartEventPackagesId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/event-packages/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic guest room request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyBookingCartGuestRoomsId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyBookingCartGuestRoomsId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/guest-rooms/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyBookingCartId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyBookingCartId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyBookingCartServicesId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyBookingCartServicesId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/services/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic order activity.
         * @param {PartialUpdateBookingCartActivitiesIdRequest} [partialUpdateBookingCartActivitiesIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateBookingCartActivitiesId: async (id: string, partialUpdateBookingCartActivitiesIdRequest?: PartialUpdateBookingCartActivitiesIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partialUpdateBookingCartActivitiesId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/activities/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialUpdateBookingCartActivitiesIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this order event package.
         * @param {PartialUpdateBookingCartEventPackagesIdRequest} [partialUpdateBookingCartEventPackagesIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateBookingCartEventPackagesId: async (id: string, partialUpdateBookingCartEventPackagesIdRequest?: PartialUpdateBookingCartEventPackagesIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partialUpdateBookingCartEventPackagesId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/event-packages/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialUpdateBookingCartEventPackagesIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic guest room request.
         * @param {PartialUpdateBookingCartGuestRoomsIdRequest} [partialUpdateBookingCartGuestRoomsIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateBookingCartGuestRoomsId: async (id: string, partialUpdateBookingCartGuestRoomsIdRequest?: PartialUpdateBookingCartGuestRoomsIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partialUpdateBookingCartGuestRoomsId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/guest-rooms/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialUpdateBookingCartGuestRoomsIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic service.
         * @param {PartialUpdateBookingCartServicesIdRequest} [partialUpdateBookingCartServicesIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateBookingCartServicesId: async (id: string, partialUpdateBookingCartServicesIdRequest?: PartialUpdateBookingCartServicesIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partialUpdateBookingCartServicesId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/services/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialUpdateBookingCartServicesIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this payment.
         * @param {PayBookingPaymentsIdPayRequest} [payBookingPaymentsIdPayRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payBookingPaymentsIdPay: async (id: string, payBookingPaymentsIdPayRequest?: PayBookingPaymentsIdPayRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('payBookingPaymentsIdPay', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/payments/{id}/pay/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payBookingPaymentsIdPayRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic order activity.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBookingCartActivitiesId: async (id: string, include?: string, fields?: object, sort?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveBookingCartActivitiesId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/activities/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this order event package.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBookingCartEventPackagesId: async (id: string, include?: string, fields?: object, sort?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveBookingCartEventPackagesId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/event-packages/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic guest room request.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBookingCartGuestRoomsId: async (id: string, include?: string, fields?: object, sort?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveBookingCartGuestRoomsId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/guest-rooms/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic order.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotel] hotel
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBookingCartId: async (id: string, include?: string, fields?: object, sort?: string, filterHotel?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveBookingCartId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic service.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBookingCartServicesId: async (id: string, include?: string, fields?: object, sort?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveBookingCartServicesId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/booking/cart/services/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBookingOrdersUuid: async (uuid: string, include?: string, fields?: object, sort?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('retrieveBookingOrdersUuid', 'uuid', uuid)
            const localVarPath = `/api/v3/instant-booking/booking/orders/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingApi - functional programming interface
 * @export
 */
export const BookingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id A unique integer value identifying this generic order.
         * @param {ConfirmBookingCartIdConfirmRequest} [confirmBookingCartIdConfirmRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmBookingCartIdConfirm(id: string, confirmBookingCartIdConfirmRequest?: ConfirmBookingCartIdConfirmRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmBookingCartIdConfirm201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmBookingCartIdConfirm(id, confirmBookingCartIdConfirmRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.confirmBookingCartIdConfirm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateBookingCartRequest} [createBookingCartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBookingCart(createBookingCartRequest?: CreateBookingCartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBookingCart201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBookingCart(createBookingCartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.createBookingCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateBookingCartActivitiesRequest} [createBookingCartActivitiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBookingCartActivities(createBookingCartActivitiesRequest?: CreateBookingCartActivitiesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartialUpdateBookingCartActivitiesId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBookingCartActivities(createBookingCartActivitiesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.createBookingCartActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateBookingCartEventPackagesRequest} [createBookingCartEventPackagesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBookingCartEventPackages(createBookingCartEventPackagesRequest?: CreateBookingCartEventPackagesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartialUpdateBookingCartEventPackagesId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBookingCartEventPackages(createBookingCartEventPackagesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.createBookingCartEventPackages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateBookingCartGuestRoomsRequest} [createBookingCartGuestRoomsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBookingCartGuestRooms(createBookingCartGuestRoomsRequest?: CreateBookingCartGuestRoomsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartialUpdateBookingCartGuestRoomsId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBookingCartGuestRooms(createBookingCartGuestRoomsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.createBookingCartGuestRooms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateBookingCartServicesRequest} [createBookingCartServicesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBookingCartServices(createBookingCartServicesRequest?: CreateBookingCartServicesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartialUpdateBookingCartServicesId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBookingCartServices(createBookingCartServicesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.createBookingCartServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateBookingPlannerRfpRequest} [createBookingPlannerRfpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBookingPlannerRfp(createBookingPlannerRfpRequest?: CreateBookingPlannerRfpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBookingPlannerRfp201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBookingPlannerRfp(createBookingPlannerRfpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.createBookingPlannerRfp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic order activity.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyBookingCartActivitiesId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Onlymeta>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyBookingCartActivitiesId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.destroyBookingCartActivitiesId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this order event package.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyBookingCartEventPackagesId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Onlymeta>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyBookingCartEventPackagesId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.destroyBookingCartEventPackagesId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic guest room request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyBookingCartGuestRoomsId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Onlymeta>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyBookingCartGuestRoomsId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.destroyBookingCartGuestRoomsId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyBookingCartId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Onlymeta>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyBookingCartId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.destroyBookingCartId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic service.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyBookingCartServicesId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Onlymeta>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyBookingCartServicesId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.destroyBookingCartServicesId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic order activity.
         * @param {PartialUpdateBookingCartActivitiesIdRequest} [partialUpdateBookingCartActivitiesIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partialUpdateBookingCartActivitiesId(id: string, partialUpdateBookingCartActivitiesIdRequest?: PartialUpdateBookingCartActivitiesIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartialUpdateBookingCartActivitiesId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partialUpdateBookingCartActivitiesId(id, partialUpdateBookingCartActivitiesIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.partialUpdateBookingCartActivitiesId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this order event package.
         * @param {PartialUpdateBookingCartEventPackagesIdRequest} [partialUpdateBookingCartEventPackagesIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partialUpdateBookingCartEventPackagesId(id: string, partialUpdateBookingCartEventPackagesIdRequest?: PartialUpdateBookingCartEventPackagesIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartialUpdateBookingCartEventPackagesId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partialUpdateBookingCartEventPackagesId(id, partialUpdateBookingCartEventPackagesIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.partialUpdateBookingCartEventPackagesId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic guest room request.
         * @param {PartialUpdateBookingCartGuestRoomsIdRequest} [partialUpdateBookingCartGuestRoomsIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partialUpdateBookingCartGuestRoomsId(id: string, partialUpdateBookingCartGuestRoomsIdRequest?: PartialUpdateBookingCartGuestRoomsIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartialUpdateBookingCartGuestRoomsId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partialUpdateBookingCartGuestRoomsId(id, partialUpdateBookingCartGuestRoomsIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.partialUpdateBookingCartGuestRoomsId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic service.
         * @param {PartialUpdateBookingCartServicesIdRequest} [partialUpdateBookingCartServicesIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partialUpdateBookingCartServicesId(id: string, partialUpdateBookingCartServicesIdRequest?: PartialUpdateBookingCartServicesIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartialUpdateBookingCartServicesId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partialUpdateBookingCartServicesId(id, partialUpdateBookingCartServicesIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.partialUpdateBookingCartServicesId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this payment.
         * @param {PayBookingPaymentsIdPayRequest} [payBookingPaymentsIdPayRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async payBookingPaymentsIdPay(id: string, payBookingPaymentsIdPayRequest?: PayBookingPaymentsIdPayRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayBookingPaymentsIdPay201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.payBookingPaymentsIdPay(id, payBookingPaymentsIdPayRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.payBookingPaymentsIdPay']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic order activity.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveBookingCartActivitiesId(id: string, include?: string, fields?: object, sort?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveBookingCartActivitiesId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveBookingCartActivitiesId(id, include, fields, sort, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.retrieveBookingCartActivitiesId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this order event package.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveBookingCartEventPackagesId(id: string, include?: string, fields?: object, sort?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveBookingCartEventPackagesId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveBookingCartEventPackagesId(id, include, fields, sort, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.retrieveBookingCartEventPackagesId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic guest room request.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveBookingCartGuestRoomsId(id: string, include?: string, fields?: object, sort?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveBookingCartGuestRoomsId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveBookingCartGuestRoomsId(id, include, fields, sort, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.retrieveBookingCartGuestRoomsId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic order.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotel] hotel
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveBookingCartId(id: string, include?: string, fields?: object, sort?: string, filterHotel?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveBookingCartId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveBookingCartId(id, include, fields, sort, filterHotel, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.retrieveBookingCartId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this generic service.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveBookingCartServicesId(id: string, include?: string, fields?: object, sort?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveBookingCartServicesId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveBookingCartServicesId(id, include, fields, sort, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.retrieveBookingCartServicesId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveBookingOrdersUuid(uuid: string, include?: string, fields?: object, sort?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveBookingCartId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveBookingOrdersUuid(uuid, include, fields, sort, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingApi.retrieveBookingOrdersUuid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BookingApi - factory interface
 * @export
 */
export const BookingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingApiFp(configuration)
    return {
        /**
         * 
         * @param {BookingApiConfirmBookingCartIdConfirmRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmBookingCartIdConfirm(requestParameters: BookingApiConfirmBookingCartIdConfirmRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConfirmBookingCartIdConfirm201Response> {
            return localVarFp.confirmBookingCartIdConfirm(requestParameters.id, requestParameters.confirmBookingCartIdConfirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiCreateBookingCartRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingCart(requestParameters: BookingApiCreateBookingCartRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CreateBookingCart201Response> {
            return localVarFp.createBookingCart(requestParameters.createBookingCartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiCreateBookingCartActivitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingCartActivities(requestParameters: BookingApiCreateBookingCartActivitiesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PartialUpdateBookingCartActivitiesId200Response> {
            return localVarFp.createBookingCartActivities(requestParameters.createBookingCartActivitiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiCreateBookingCartEventPackagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingCartEventPackages(requestParameters: BookingApiCreateBookingCartEventPackagesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PartialUpdateBookingCartEventPackagesId200Response> {
            return localVarFp.createBookingCartEventPackages(requestParameters.createBookingCartEventPackagesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiCreateBookingCartGuestRoomsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingCartGuestRooms(requestParameters: BookingApiCreateBookingCartGuestRoomsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PartialUpdateBookingCartGuestRoomsId200Response> {
            return localVarFp.createBookingCartGuestRooms(requestParameters.createBookingCartGuestRoomsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiCreateBookingCartServicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingCartServices(requestParameters: BookingApiCreateBookingCartServicesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PartialUpdateBookingCartServicesId200Response> {
            return localVarFp.createBookingCartServices(requestParameters.createBookingCartServicesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiCreateBookingPlannerRfpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingPlannerRfp(requestParameters: BookingApiCreateBookingPlannerRfpRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CreateBookingPlannerRfp201Response> {
            return localVarFp.createBookingPlannerRfp(requestParameters.createBookingPlannerRfpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiDestroyBookingCartActivitiesIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyBookingCartActivitiesId(requestParameters: BookingApiDestroyBookingCartActivitiesIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Onlymeta> {
            return localVarFp.destroyBookingCartActivitiesId(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiDestroyBookingCartEventPackagesIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyBookingCartEventPackagesId(requestParameters: BookingApiDestroyBookingCartEventPackagesIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Onlymeta> {
            return localVarFp.destroyBookingCartEventPackagesId(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiDestroyBookingCartGuestRoomsIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyBookingCartGuestRoomsId(requestParameters: BookingApiDestroyBookingCartGuestRoomsIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Onlymeta> {
            return localVarFp.destroyBookingCartGuestRoomsId(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiDestroyBookingCartIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyBookingCartId(requestParameters: BookingApiDestroyBookingCartIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Onlymeta> {
            return localVarFp.destroyBookingCartId(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiDestroyBookingCartServicesIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyBookingCartServicesId(requestParameters: BookingApiDestroyBookingCartServicesIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Onlymeta> {
            return localVarFp.destroyBookingCartServicesId(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiPartialUpdateBookingCartActivitiesIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateBookingCartActivitiesId(requestParameters: BookingApiPartialUpdateBookingCartActivitiesIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartialUpdateBookingCartActivitiesId200Response> {
            return localVarFp.partialUpdateBookingCartActivitiesId(requestParameters.id, requestParameters.partialUpdateBookingCartActivitiesIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiPartialUpdateBookingCartEventPackagesIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateBookingCartEventPackagesId(requestParameters: BookingApiPartialUpdateBookingCartEventPackagesIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartialUpdateBookingCartEventPackagesId200Response> {
            return localVarFp.partialUpdateBookingCartEventPackagesId(requestParameters.id, requestParameters.partialUpdateBookingCartEventPackagesIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiPartialUpdateBookingCartGuestRoomsIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateBookingCartGuestRoomsId(requestParameters: BookingApiPartialUpdateBookingCartGuestRoomsIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartialUpdateBookingCartGuestRoomsId200Response> {
            return localVarFp.partialUpdateBookingCartGuestRoomsId(requestParameters.id, requestParameters.partialUpdateBookingCartGuestRoomsIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiPartialUpdateBookingCartServicesIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateBookingCartServicesId(requestParameters: BookingApiPartialUpdateBookingCartServicesIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartialUpdateBookingCartServicesId200Response> {
            return localVarFp.partialUpdateBookingCartServicesId(requestParameters.id, requestParameters.partialUpdateBookingCartServicesIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiPayBookingPaymentsIdPayRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payBookingPaymentsIdPay(requestParameters: BookingApiPayBookingPaymentsIdPayRequest, options?: RawAxiosRequestConfig): AxiosPromise<PayBookingPaymentsIdPay201Response> {
            return localVarFp.payBookingPaymentsIdPay(requestParameters.id, requestParameters.payBookingPaymentsIdPayRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiRetrieveBookingCartActivitiesIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBookingCartActivitiesId(requestParameters: BookingApiRetrieveBookingCartActivitiesIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveBookingCartActivitiesId200Response> {
            return localVarFp.retrieveBookingCartActivitiesId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiRetrieveBookingCartEventPackagesIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBookingCartEventPackagesId(requestParameters: BookingApiRetrieveBookingCartEventPackagesIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveBookingCartEventPackagesId200Response> {
            return localVarFp.retrieveBookingCartEventPackagesId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiRetrieveBookingCartGuestRoomsIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBookingCartGuestRoomsId(requestParameters: BookingApiRetrieveBookingCartGuestRoomsIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveBookingCartGuestRoomsId200Response> {
            return localVarFp.retrieveBookingCartGuestRoomsId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiRetrieveBookingCartIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBookingCartId(requestParameters: BookingApiRetrieveBookingCartIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveBookingCartId200Response> {
            return localVarFp.retrieveBookingCartId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterHotel, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiRetrieveBookingCartServicesIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBookingCartServicesId(requestParameters: BookingApiRetrieveBookingCartServicesIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveBookingCartServicesId200Response> {
            return localVarFp.retrieveBookingCartServicesId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BookingApiRetrieveBookingOrdersUuidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBookingOrdersUuid(requestParameters: BookingApiRetrieveBookingOrdersUuidRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveBookingCartId200Response> {
            return localVarFp.retrieveBookingOrdersUuid(requestParameters.uuid, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for confirmBookingCartIdConfirm operation in BookingApi.
 * @export
 * @interface BookingApiConfirmBookingCartIdConfirmRequest
 */
export interface BookingApiConfirmBookingCartIdConfirmRequest {
    /**
     * A unique integer value identifying this generic order.
     * @type {string}
     * @memberof BookingApiConfirmBookingCartIdConfirm
     */
    readonly id: string

    /**
     * 
     * @type {ConfirmBookingCartIdConfirmRequest}
     * @memberof BookingApiConfirmBookingCartIdConfirm
     */
    readonly confirmBookingCartIdConfirmRequest?: ConfirmBookingCartIdConfirmRequest
}

/**
 * Request parameters for createBookingCart operation in BookingApi.
 * @export
 * @interface BookingApiCreateBookingCartRequest
 */
export interface BookingApiCreateBookingCartRequest {
    /**
     * 
     * @type {CreateBookingCartRequest}
     * @memberof BookingApiCreateBookingCart
     */
    readonly createBookingCartRequest?: CreateBookingCartRequest
}

/**
 * Request parameters for createBookingCartActivities operation in BookingApi.
 * @export
 * @interface BookingApiCreateBookingCartActivitiesRequest
 */
export interface BookingApiCreateBookingCartActivitiesRequest {
    /**
     * 
     * @type {CreateBookingCartActivitiesRequest}
     * @memberof BookingApiCreateBookingCartActivities
     */
    readonly createBookingCartActivitiesRequest?: CreateBookingCartActivitiesRequest
}

/**
 * Request parameters for createBookingCartEventPackages operation in BookingApi.
 * @export
 * @interface BookingApiCreateBookingCartEventPackagesRequest
 */
export interface BookingApiCreateBookingCartEventPackagesRequest {
    /**
     * 
     * @type {CreateBookingCartEventPackagesRequest}
     * @memberof BookingApiCreateBookingCartEventPackages
     */
    readonly createBookingCartEventPackagesRequest?: CreateBookingCartEventPackagesRequest
}

/**
 * Request parameters for createBookingCartGuestRooms operation in BookingApi.
 * @export
 * @interface BookingApiCreateBookingCartGuestRoomsRequest
 */
export interface BookingApiCreateBookingCartGuestRoomsRequest {
    /**
     * 
     * @type {CreateBookingCartGuestRoomsRequest}
     * @memberof BookingApiCreateBookingCartGuestRooms
     */
    readonly createBookingCartGuestRoomsRequest?: CreateBookingCartGuestRoomsRequest
}

/**
 * Request parameters for createBookingCartServices operation in BookingApi.
 * @export
 * @interface BookingApiCreateBookingCartServicesRequest
 */
export interface BookingApiCreateBookingCartServicesRequest {
    /**
     * 
     * @type {CreateBookingCartServicesRequest}
     * @memberof BookingApiCreateBookingCartServices
     */
    readonly createBookingCartServicesRequest?: CreateBookingCartServicesRequest
}

/**
 * Request parameters for createBookingPlannerRfp operation in BookingApi.
 * @export
 * @interface BookingApiCreateBookingPlannerRfpRequest
 */
export interface BookingApiCreateBookingPlannerRfpRequest {
    /**
     * 
     * @type {CreateBookingPlannerRfpRequest}
     * @memberof BookingApiCreateBookingPlannerRfp
     */
    readonly createBookingPlannerRfpRequest?: CreateBookingPlannerRfpRequest
}

/**
 * Request parameters for destroyBookingCartActivitiesId operation in BookingApi.
 * @export
 * @interface BookingApiDestroyBookingCartActivitiesIdRequest
 */
export interface BookingApiDestroyBookingCartActivitiesIdRequest {
    /**
     * A unique integer value identifying this generic order activity.
     * @type {string}
     * @memberof BookingApiDestroyBookingCartActivitiesId
     */
    readonly id: string
}

/**
 * Request parameters for destroyBookingCartEventPackagesId operation in BookingApi.
 * @export
 * @interface BookingApiDestroyBookingCartEventPackagesIdRequest
 */
export interface BookingApiDestroyBookingCartEventPackagesIdRequest {
    /**
     * A unique integer value identifying this order event package.
     * @type {string}
     * @memberof BookingApiDestroyBookingCartEventPackagesId
     */
    readonly id: string
}

/**
 * Request parameters for destroyBookingCartGuestRoomsId operation in BookingApi.
 * @export
 * @interface BookingApiDestroyBookingCartGuestRoomsIdRequest
 */
export interface BookingApiDestroyBookingCartGuestRoomsIdRequest {
    /**
     * A unique integer value identifying this generic guest room request.
     * @type {string}
     * @memberof BookingApiDestroyBookingCartGuestRoomsId
     */
    readonly id: string
}

/**
 * Request parameters for destroyBookingCartId operation in BookingApi.
 * @export
 * @interface BookingApiDestroyBookingCartIdRequest
 */
export interface BookingApiDestroyBookingCartIdRequest {
    /**
     * A unique integer value identifying this generic order.
     * @type {string}
     * @memberof BookingApiDestroyBookingCartId
     */
    readonly id: string
}

/**
 * Request parameters for destroyBookingCartServicesId operation in BookingApi.
 * @export
 * @interface BookingApiDestroyBookingCartServicesIdRequest
 */
export interface BookingApiDestroyBookingCartServicesIdRequest {
    /**
     * A unique integer value identifying this generic service.
     * @type {string}
     * @memberof BookingApiDestroyBookingCartServicesId
     */
    readonly id: string
}

/**
 * Request parameters for partialUpdateBookingCartActivitiesId operation in BookingApi.
 * @export
 * @interface BookingApiPartialUpdateBookingCartActivitiesIdRequest
 */
export interface BookingApiPartialUpdateBookingCartActivitiesIdRequest {
    /**
     * A unique integer value identifying this generic order activity.
     * @type {string}
     * @memberof BookingApiPartialUpdateBookingCartActivitiesId
     */
    readonly id: string

    /**
     * 
     * @type {PartialUpdateBookingCartActivitiesIdRequest}
     * @memberof BookingApiPartialUpdateBookingCartActivitiesId
     */
    readonly partialUpdateBookingCartActivitiesIdRequest?: PartialUpdateBookingCartActivitiesIdRequest
}

/**
 * Request parameters for partialUpdateBookingCartEventPackagesId operation in BookingApi.
 * @export
 * @interface BookingApiPartialUpdateBookingCartEventPackagesIdRequest
 */
export interface BookingApiPartialUpdateBookingCartEventPackagesIdRequest {
    /**
     * A unique integer value identifying this order event package.
     * @type {string}
     * @memberof BookingApiPartialUpdateBookingCartEventPackagesId
     */
    readonly id: string

    /**
     * 
     * @type {PartialUpdateBookingCartEventPackagesIdRequest}
     * @memberof BookingApiPartialUpdateBookingCartEventPackagesId
     */
    readonly partialUpdateBookingCartEventPackagesIdRequest?: PartialUpdateBookingCartEventPackagesIdRequest
}

/**
 * Request parameters for partialUpdateBookingCartGuestRoomsId operation in BookingApi.
 * @export
 * @interface BookingApiPartialUpdateBookingCartGuestRoomsIdRequest
 */
export interface BookingApiPartialUpdateBookingCartGuestRoomsIdRequest {
    /**
     * A unique integer value identifying this generic guest room request.
     * @type {string}
     * @memberof BookingApiPartialUpdateBookingCartGuestRoomsId
     */
    readonly id: string

    /**
     * 
     * @type {PartialUpdateBookingCartGuestRoomsIdRequest}
     * @memberof BookingApiPartialUpdateBookingCartGuestRoomsId
     */
    readonly partialUpdateBookingCartGuestRoomsIdRequest?: PartialUpdateBookingCartGuestRoomsIdRequest
}

/**
 * Request parameters for partialUpdateBookingCartServicesId operation in BookingApi.
 * @export
 * @interface BookingApiPartialUpdateBookingCartServicesIdRequest
 */
export interface BookingApiPartialUpdateBookingCartServicesIdRequest {
    /**
     * A unique integer value identifying this generic service.
     * @type {string}
     * @memberof BookingApiPartialUpdateBookingCartServicesId
     */
    readonly id: string

    /**
     * 
     * @type {PartialUpdateBookingCartServicesIdRequest}
     * @memberof BookingApiPartialUpdateBookingCartServicesId
     */
    readonly partialUpdateBookingCartServicesIdRequest?: PartialUpdateBookingCartServicesIdRequest
}

/**
 * Request parameters for payBookingPaymentsIdPay operation in BookingApi.
 * @export
 * @interface BookingApiPayBookingPaymentsIdPayRequest
 */
export interface BookingApiPayBookingPaymentsIdPayRequest {
    /**
     * A unique integer value identifying this payment.
     * @type {string}
     * @memberof BookingApiPayBookingPaymentsIdPay
     */
    readonly id: string

    /**
     * 
     * @type {PayBookingPaymentsIdPayRequest}
     * @memberof BookingApiPayBookingPaymentsIdPay
     */
    readonly payBookingPaymentsIdPayRequest?: PayBookingPaymentsIdPayRequest
}

/**
 * Request parameters for retrieveBookingCartActivitiesId operation in BookingApi.
 * @export
 * @interface BookingApiRetrieveBookingCartActivitiesIdRequest
 */
export interface BookingApiRetrieveBookingCartActivitiesIdRequest {
    /**
     * A unique integer value identifying this generic order activity.
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartActivitiesId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartActivitiesId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof BookingApiRetrieveBookingCartActivitiesId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartActivitiesId
     */
    readonly sort?: string

    /**
     * A search term.
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartActivitiesId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveBookingCartEventPackagesId operation in BookingApi.
 * @export
 * @interface BookingApiRetrieveBookingCartEventPackagesIdRequest
 */
export interface BookingApiRetrieveBookingCartEventPackagesIdRequest {
    /**
     * A unique integer value identifying this order event package.
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartEventPackagesId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartEventPackagesId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof BookingApiRetrieveBookingCartEventPackagesId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartEventPackagesId
     */
    readonly sort?: string

    /**
     * A search term.
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartEventPackagesId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveBookingCartGuestRoomsId operation in BookingApi.
 * @export
 * @interface BookingApiRetrieveBookingCartGuestRoomsIdRequest
 */
export interface BookingApiRetrieveBookingCartGuestRoomsIdRequest {
    /**
     * A unique integer value identifying this generic guest room request.
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartGuestRoomsId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartGuestRoomsId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof BookingApiRetrieveBookingCartGuestRoomsId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartGuestRoomsId
     */
    readonly sort?: string

    /**
     * A search term.
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartGuestRoomsId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveBookingCartId operation in BookingApi.
 * @export
 * @interface BookingApiRetrieveBookingCartIdRequest
 */
export interface BookingApiRetrieveBookingCartIdRequest {
    /**
     * A unique integer value identifying this generic order.
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof BookingApiRetrieveBookingCartId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartId
     */
    readonly sort?: string

    /**
     * hotel
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartId
     */
    readonly filterHotel?: string

    /**
     * A search term.
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveBookingCartServicesId operation in BookingApi.
 * @export
 * @interface BookingApiRetrieveBookingCartServicesIdRequest
 */
export interface BookingApiRetrieveBookingCartServicesIdRequest {
    /**
     * A unique integer value identifying this generic service.
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartServicesId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartServicesId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof BookingApiRetrieveBookingCartServicesId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartServicesId
     */
    readonly sort?: string

    /**
     * A search term.
     * @type {string}
     * @memberof BookingApiRetrieveBookingCartServicesId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveBookingOrdersUuid operation in BookingApi.
 * @export
 * @interface BookingApiRetrieveBookingOrdersUuidRequest
 */
export interface BookingApiRetrieveBookingOrdersUuidRequest {
    /**
     * 
     * @type {string}
     * @memberof BookingApiRetrieveBookingOrdersUuid
     */
    readonly uuid: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof BookingApiRetrieveBookingOrdersUuid
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof BookingApiRetrieveBookingOrdersUuid
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof BookingApiRetrieveBookingOrdersUuid
     */
    readonly sort?: string

    /**
     * A search term.
     * @type {string}
     * @memberof BookingApiRetrieveBookingOrdersUuid
     */
    readonly filterSearch?: string
}

/**
 * BookingApi - object-oriented interface
 * @export
 * @class BookingApi
 * @extends {BaseAPI}
 */
export class BookingApi extends BaseAPI {
    /**
     * 
     * @param {BookingApiConfirmBookingCartIdConfirmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public confirmBookingCartIdConfirm(requestParameters: BookingApiConfirmBookingCartIdConfirmRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).confirmBookingCartIdConfirm(requestParameters.id, requestParameters.confirmBookingCartIdConfirmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiCreateBookingCartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public createBookingCart(requestParameters: BookingApiCreateBookingCartRequest = {}, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).createBookingCart(requestParameters.createBookingCartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiCreateBookingCartActivitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public createBookingCartActivities(requestParameters: BookingApiCreateBookingCartActivitiesRequest = {}, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).createBookingCartActivities(requestParameters.createBookingCartActivitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiCreateBookingCartEventPackagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public createBookingCartEventPackages(requestParameters: BookingApiCreateBookingCartEventPackagesRequest = {}, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).createBookingCartEventPackages(requestParameters.createBookingCartEventPackagesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiCreateBookingCartGuestRoomsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public createBookingCartGuestRooms(requestParameters: BookingApiCreateBookingCartGuestRoomsRequest = {}, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).createBookingCartGuestRooms(requestParameters.createBookingCartGuestRoomsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiCreateBookingCartServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public createBookingCartServices(requestParameters: BookingApiCreateBookingCartServicesRequest = {}, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).createBookingCartServices(requestParameters.createBookingCartServicesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiCreateBookingPlannerRfpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public createBookingPlannerRfp(requestParameters: BookingApiCreateBookingPlannerRfpRequest = {}, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).createBookingPlannerRfp(requestParameters.createBookingPlannerRfpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiDestroyBookingCartActivitiesIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public destroyBookingCartActivitiesId(requestParameters: BookingApiDestroyBookingCartActivitiesIdRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).destroyBookingCartActivitiesId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiDestroyBookingCartEventPackagesIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public destroyBookingCartEventPackagesId(requestParameters: BookingApiDestroyBookingCartEventPackagesIdRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).destroyBookingCartEventPackagesId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiDestroyBookingCartGuestRoomsIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public destroyBookingCartGuestRoomsId(requestParameters: BookingApiDestroyBookingCartGuestRoomsIdRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).destroyBookingCartGuestRoomsId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiDestroyBookingCartIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public destroyBookingCartId(requestParameters: BookingApiDestroyBookingCartIdRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).destroyBookingCartId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiDestroyBookingCartServicesIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public destroyBookingCartServicesId(requestParameters: BookingApiDestroyBookingCartServicesIdRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).destroyBookingCartServicesId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiPartialUpdateBookingCartActivitiesIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public partialUpdateBookingCartActivitiesId(requestParameters: BookingApiPartialUpdateBookingCartActivitiesIdRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).partialUpdateBookingCartActivitiesId(requestParameters.id, requestParameters.partialUpdateBookingCartActivitiesIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiPartialUpdateBookingCartEventPackagesIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public partialUpdateBookingCartEventPackagesId(requestParameters: BookingApiPartialUpdateBookingCartEventPackagesIdRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).partialUpdateBookingCartEventPackagesId(requestParameters.id, requestParameters.partialUpdateBookingCartEventPackagesIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiPartialUpdateBookingCartGuestRoomsIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public partialUpdateBookingCartGuestRoomsId(requestParameters: BookingApiPartialUpdateBookingCartGuestRoomsIdRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).partialUpdateBookingCartGuestRoomsId(requestParameters.id, requestParameters.partialUpdateBookingCartGuestRoomsIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiPartialUpdateBookingCartServicesIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public partialUpdateBookingCartServicesId(requestParameters: BookingApiPartialUpdateBookingCartServicesIdRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).partialUpdateBookingCartServicesId(requestParameters.id, requestParameters.partialUpdateBookingCartServicesIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiPayBookingPaymentsIdPayRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public payBookingPaymentsIdPay(requestParameters: BookingApiPayBookingPaymentsIdPayRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).payBookingPaymentsIdPay(requestParameters.id, requestParameters.payBookingPaymentsIdPayRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiRetrieveBookingCartActivitiesIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public retrieveBookingCartActivitiesId(requestParameters: BookingApiRetrieveBookingCartActivitiesIdRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).retrieveBookingCartActivitiesId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiRetrieveBookingCartEventPackagesIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public retrieveBookingCartEventPackagesId(requestParameters: BookingApiRetrieveBookingCartEventPackagesIdRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).retrieveBookingCartEventPackagesId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiRetrieveBookingCartGuestRoomsIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public retrieveBookingCartGuestRoomsId(requestParameters: BookingApiRetrieveBookingCartGuestRoomsIdRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).retrieveBookingCartGuestRoomsId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiRetrieveBookingCartIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public retrieveBookingCartId(requestParameters: BookingApiRetrieveBookingCartIdRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).retrieveBookingCartId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterHotel, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiRetrieveBookingCartServicesIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public retrieveBookingCartServicesId(requestParameters: BookingApiRetrieveBookingCartServicesIdRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).retrieveBookingCartServicesId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BookingApiRetrieveBookingOrdersUuidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public retrieveBookingOrdersUuid(requestParameters: BookingApiRetrieveBookingOrdersUuidRequest, options?: RawAxiosRequestConfig) {
        return BookingApiFp(this.configuration).retrieveBookingOrdersUuid(requestParameters.uuid, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommonApi - axios parameter creator
 * @export
 */
export const CommonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterNameIcontains] name__icontains
         * @param {string} [filterHotelChainSlug] hotel_chain__slug
         * @param {string} [filterHotelChain] hotel_chain
         * @param {string} [filterHotelsHasPublicMeetingRooms] hotels_has_public_meeting_rooms
         * @param {string} [filterHotelsHasPublicGuestRooms] hotels_has_public_guest_rooms
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommonCities: async (include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterNameIcontains?: string, filterHotelChainSlug?: string, filterHotelChain?: string, filterHotelsHasPublicMeetingRooms?: string, filterHotelsHasPublicGuestRooms?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/common/cities/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page[number]'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterNameIcontains !== undefined) {
                localVarQueryParameter['filter[name.icontains]'] = filterNameIcontains;
            }

            if (filterHotelChainSlug !== undefined) {
                localVarQueryParameter['filter[hotelChain.slug]'] = filterHotelChainSlug;
            }

            if (filterHotelChain !== undefined) {
                localVarQueryParameter['filter[hotelChain]'] = filterHotelChain;
            }

            if (filterHotelsHasPublicMeetingRooms !== undefined) {
                localVarQueryParameter['filter[hotelsHasPublicMeetingRooms]'] = filterHotelsHasPublicMeetingRooms;
            }

            if (filterHotelsHasPublicGuestRooms !== undefined) {
                localVarQueryParameter['filter[hotelsHasPublicGuestRooms]'] = filterHotelsHasPublicGuestRooms;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommonApi - functional programming interface
 * @export
 */
export const CommonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommonApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterNameIcontains] name__icontains
         * @param {string} [filterHotelChainSlug] hotel_chain__slug
         * @param {string} [filterHotelChain] hotel_chain
         * @param {string} [filterHotelsHasPublicMeetingRooms] hotels_has_public_meeting_rooms
         * @param {string} [filterHotelsHasPublicGuestRooms] hotels_has_public_guest_rooms
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCommonCities(include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterNameIcontains?: string, filterHotelChainSlug?: string, filterHotelChain?: string, filterHotelsHasPublicMeetingRooms?: string, filterHotelsHasPublicGuestRooms?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCommonCities200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCommonCities(include, fields, pageNumber, pageSize, sort, filterNameIcontains, filterHotelChainSlug, filterHotelChain, filterHotelsHasPublicMeetingRooms, filterHotelsHasPublicGuestRooms, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommonApi.listCommonCities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommonApi - factory interface
 * @export
 */
export const CommonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommonApiFp(configuration)
    return {
        /**
         * 
         * @param {CommonApiListCommonCitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommonCities(requestParameters: CommonApiListCommonCitiesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListCommonCities200Response> {
            return localVarFp.listCommonCities(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterNameIcontains, requestParameters.filterHotelChainSlug, requestParameters.filterHotelChain, requestParameters.filterHotelsHasPublicMeetingRooms, requestParameters.filterHotelsHasPublicGuestRooms, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for listCommonCities operation in CommonApi.
 * @export
 * @interface CommonApiListCommonCitiesRequest
 */
export interface CommonApiListCommonCitiesRequest {
    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof CommonApiListCommonCities
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof CommonApiListCommonCities
     */
    readonly fields?: object

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof CommonApiListCommonCities
     */
    readonly pageNumber?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof CommonApiListCommonCities
     */
    readonly pageSize?: number

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof CommonApiListCommonCities
     */
    readonly sort?: string

    /**
     * name__icontains
     * @type {string}
     * @memberof CommonApiListCommonCities
     */
    readonly filterNameIcontains?: string

    /**
     * hotel_chain__slug
     * @type {string}
     * @memberof CommonApiListCommonCities
     */
    readonly filterHotelChainSlug?: string

    /**
     * hotel_chain
     * @type {string}
     * @memberof CommonApiListCommonCities
     */
    readonly filterHotelChain?: string

    /**
     * hotels_has_public_meeting_rooms
     * @type {string}
     * @memberof CommonApiListCommonCities
     */
    readonly filterHotelsHasPublicMeetingRooms?: string

    /**
     * hotels_has_public_guest_rooms
     * @type {string}
     * @memberof CommonApiListCommonCities
     */
    readonly filterHotelsHasPublicGuestRooms?: string

    /**
     * A search term.
     * @type {string}
     * @memberof CommonApiListCommonCities
     */
    readonly filterSearch?: string
}

/**
 * CommonApi - object-oriented interface
 * @export
 * @class CommonApi
 * @extends {BaseAPI}
 */
export class CommonApi extends BaseAPI {
    /**
     * 
     * @param {CommonApiListCommonCitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonApi
     */
    public listCommonCities(requestParameters: CommonApiListCommonCitiesRequest = {}, options?: RawAxiosRequestConfig) {
        return CommonApiFp(this.configuration).listCommonCities(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterNameIcontains, requestParameters.filterHotelChainSlug, requestParameters.filterHotelChain, requestParameters.filterHotelsHasPublicMeetingRooms, requestParameters.filterHotelsHasPublicGuestRooms, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DiagrammingApi - axios parameter creator
 * @export
 */
export const DiagrammingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterActive] active
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterSchemaTypeIn] schema_type__in
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDiagrammingDollhouseSchemas: async (include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterActive?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterSchemaTypeIn?: string, filterVirtualMeetingRoom?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/diagramming/dollhouse-schemas/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page[number]'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterActive !== undefined) {
                localVarQueryParameter['filter[active]'] = filterActive;
            }

            if (filterCreatedAtGte !== undefined) {
                localVarQueryParameter['filter[createdAt.gte]'] = filterCreatedAtGte;
            }

            if (filterCreatedAtLte !== undefined) {
                localVarQueryParameter['filter[createdAt.lte]'] = filterCreatedAtLte;
            }

            if (filterUpdatedAtGte !== undefined) {
                localVarQueryParameter['filter[updatedAt.gte]'] = filterUpdatedAtGte;
            }

            if (filterUpdatedAtLte !== undefined) {
                localVarQueryParameter['filter[updatedAt.lte]'] = filterUpdatedAtLte;
            }

            if (filterSchemaTypeIn !== undefined) {
                localVarQueryParameter['filter[schemaType.in]'] = filterSchemaTypeIn;
            }

            if (filterVirtualMeetingRoom !== undefined) {
                localVarQueryParameter['filter[virtualMeetingRoom]'] = filterVirtualMeetingRoom;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterAvailabilityStatusIn] availability_status__in
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterHotel] hotel
         * @param {string} [filterFurnitureTypes] furniture_types
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDiagrammingVirtualFurnitures: async (fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterAvailabilityStatusIn?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterHotel?: string, filterFurnitureTypes?: string, filterVirtualMeetingRoom?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/diagramming/virtual-furnitures/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page[number]'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterAvailabilityStatusIn !== undefined) {
                localVarQueryParameter['filter[availabilityStatus.in]'] = filterAvailabilityStatusIn;
            }

            if (filterCreatedAtGte !== undefined) {
                localVarQueryParameter['filter[createdAt.gte]'] = filterCreatedAtGte;
            }

            if (filterCreatedAtLte !== undefined) {
                localVarQueryParameter['filter[createdAt.lte]'] = filterCreatedAtLte;
            }

            if (filterUpdatedAtGte !== undefined) {
                localVarQueryParameter['filter[updatedAt.gte]'] = filterUpdatedAtGte;
            }

            if (filterUpdatedAtLte !== undefined) {
                localVarQueryParameter['filter[updatedAt.lte]'] = filterUpdatedAtLte;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterFurnitureTypes !== undefined) {
                localVarQueryParameter['filter[furnitureTypes]'] = filterFurnitureTypes;
            }

            if (filterVirtualMeetingRoom !== undefined) {
                localVarQueryParameter['filter[virtualMeetingRoom]'] = filterVirtualMeetingRoom;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterMeetingRoom] meeting_room
         * @param {string} [filterHotel] hotel
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDiagrammingVirtualMeetingRoomSetupTemplates: async (include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterVirtualMeetingRoom?: string, filterMeetingRoom?: string, filterHotel?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/diagramming/virtual-meeting-room-setup-templates/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page[number]'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterCreatedAtGte !== undefined) {
                localVarQueryParameter['filter[createdAt.gte]'] = filterCreatedAtGte;
            }

            if (filterCreatedAtLte !== undefined) {
                localVarQueryParameter['filter[createdAt.lte]'] = filterCreatedAtLte;
            }

            if (filterUpdatedAtGte !== undefined) {
                localVarQueryParameter['filter[updatedAt.gte]'] = filterUpdatedAtGte;
            }

            if (filterUpdatedAtLte !== undefined) {
                localVarQueryParameter['filter[updatedAt.lte]'] = filterUpdatedAtLte;
            }

            if (filterVirtualMeetingRoom !== undefined) {
                localVarQueryParameter['filter[virtualMeetingRoom]'] = filterVirtualMeetingRoom;
            }

            if (filterMeetingRoom !== undefined) {
                localVarQueryParameter['filter[meetingRoom]'] = filterMeetingRoom;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterAvailabilityStatusIn] availability_status__in
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterHotel] hotel
         * @param {string} [filterService] service
         * @param {string} [filterObjectTypes] object_types
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDiagrammingVirtualObjects: async (include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterAvailabilityStatusIn?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterHotel?: string, filterService?: string, filterObjectTypes?: string, filterVirtualMeetingRoom?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/diagramming/virtual-objects/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page[number]'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterAvailabilityStatusIn !== undefined) {
                localVarQueryParameter['filter[availabilityStatus.in]'] = filterAvailabilityStatusIn;
            }

            if (filterCreatedAtGte !== undefined) {
                localVarQueryParameter['filter[createdAt.gte]'] = filterCreatedAtGte;
            }

            if (filterCreatedAtLte !== undefined) {
                localVarQueryParameter['filter[createdAt.lte]'] = filterCreatedAtLte;
            }

            if (filterUpdatedAtGte !== undefined) {
                localVarQueryParameter['filter[updatedAt.gte]'] = filterUpdatedAtGte;
            }

            if (filterUpdatedAtLte !== undefined) {
                localVarQueryParameter['filter[updatedAt.lte]'] = filterUpdatedAtLte;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterService !== undefined) {
                localVarQueryParameter['filter[service]'] = filterService;
            }

            if (filterObjectTypes !== undefined) {
                localVarQueryParameter['filter[objectTypes]'] = filterObjectTypes;
            }

            if (filterVirtualMeetingRoom !== undefined) {
                localVarQueryParameter['filter[virtualMeetingRoom]'] = filterVirtualMeetingRoom;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this virtual meeting room setup.
         * @param {PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest} [partialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateDiagrammingVirtualMeetingRoomSetupsId: async (id: string, partialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest?: PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partialUpdateDiagrammingVirtualMeetingRoomSetupsId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/diagramming/virtual-meeting-room-setups/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/vnd.api+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this dollhouse schema.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterActive] active
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterSchemaTypeIn] schema_type__in
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDiagrammingDollhouseSchemasId: async (id: string, include?: string, fields?: object, sort?: string, filterActive?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterSchemaTypeIn?: string, filterVirtualMeetingRoom?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveDiagrammingDollhouseSchemasId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/diagramming/dollhouse-schemas/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterActive !== undefined) {
                localVarQueryParameter['filter[active]'] = filterActive;
            }

            if (filterCreatedAtGte !== undefined) {
                localVarQueryParameter['filter[createdAt.gte]'] = filterCreatedAtGte;
            }

            if (filterCreatedAtLte !== undefined) {
                localVarQueryParameter['filter[createdAt.lte]'] = filterCreatedAtLte;
            }

            if (filterUpdatedAtGte !== undefined) {
                localVarQueryParameter['filter[updatedAt.gte]'] = filterUpdatedAtGte;
            }

            if (filterUpdatedAtLte !== undefined) {
                localVarQueryParameter['filter[updatedAt.lte]'] = filterUpdatedAtLte;
            }

            if (filterSchemaTypeIn !== undefined) {
                localVarQueryParameter['filter[schemaType.in]'] = filterSchemaTypeIn;
            }

            if (filterVirtualMeetingRoom !== undefined) {
                localVarQueryParameter['filter[virtualMeetingRoom]'] = filterVirtualMeetingRoom;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this virtual furniture.
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterAvailabilityStatusIn] availability_status__in
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterHotel] hotel
         * @param {string} [filterFurnitureTypes] furniture_types
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDiagrammingVirtualFurnituresId: async (id: string, fields?: object, sort?: string, filterAvailabilityStatusIn?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterHotel?: string, filterFurnitureTypes?: string, filterVirtualMeetingRoom?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveDiagrammingVirtualFurnituresId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/diagramming/virtual-furnitures/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterAvailabilityStatusIn !== undefined) {
                localVarQueryParameter['filter[availabilityStatus.in]'] = filterAvailabilityStatusIn;
            }

            if (filterCreatedAtGte !== undefined) {
                localVarQueryParameter['filter[createdAt.gte]'] = filterCreatedAtGte;
            }

            if (filterCreatedAtLte !== undefined) {
                localVarQueryParameter['filter[createdAt.lte]'] = filterCreatedAtLte;
            }

            if (filterUpdatedAtGte !== undefined) {
                localVarQueryParameter['filter[updatedAt.gte]'] = filterUpdatedAtGte;
            }

            if (filterUpdatedAtLte !== undefined) {
                localVarQueryParameter['filter[updatedAt.lte]'] = filterUpdatedAtLte;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterFurnitureTypes !== undefined) {
                localVarQueryParameter['filter[furnitureTypes]'] = filterFurnitureTypes;
            }

            if (filterVirtualMeetingRoom !== undefined) {
                localVarQueryParameter['filter[virtualMeetingRoom]'] = filterVirtualMeetingRoom;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this virtual meeting room.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterMeetingRoom] meeting_room
         * @param {string} [filterHotel] hotel
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDiagrammingVirtualMeetingRoomId: async (id: string, include?: string, fields?: object, sort?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterMeetingRoom?: string, filterHotel?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveDiagrammingVirtualMeetingRoomId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/diagramming/virtual-meeting-room/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterCreatedAtGte !== undefined) {
                localVarQueryParameter['filter[createdAt.gte]'] = filterCreatedAtGte;
            }

            if (filterCreatedAtLte !== undefined) {
                localVarQueryParameter['filter[createdAt.lte]'] = filterCreatedAtLte;
            }

            if (filterUpdatedAtGte !== undefined) {
                localVarQueryParameter['filter[updatedAt.gte]'] = filterUpdatedAtGte;
            }

            if (filterUpdatedAtLte !== undefined) {
                localVarQueryParameter['filter[updatedAt.lte]'] = filterUpdatedAtLte;
            }

            if (filterMeetingRoom !== undefined) {
                localVarQueryParameter['filter[meetingRoom]'] = filterMeetingRoom;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this virtual meeting room setup template.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterMeetingRoom] meeting_room
         * @param {string} [filterHotel] hotel
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDiagrammingVirtualMeetingRoomSetupTemplatesId: async (id: string, include?: string, fields?: object, sort?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterVirtualMeetingRoom?: string, filterMeetingRoom?: string, filterHotel?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveDiagrammingVirtualMeetingRoomSetupTemplatesId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/diagramming/virtual-meeting-room-setup-templates/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterCreatedAtGte !== undefined) {
                localVarQueryParameter['filter[createdAt.gte]'] = filterCreatedAtGte;
            }

            if (filterCreatedAtLte !== undefined) {
                localVarQueryParameter['filter[createdAt.lte]'] = filterCreatedAtLte;
            }

            if (filterUpdatedAtGte !== undefined) {
                localVarQueryParameter['filter[updatedAt.gte]'] = filterUpdatedAtGte;
            }

            if (filterUpdatedAtLte !== undefined) {
                localVarQueryParameter['filter[updatedAt.lte]'] = filterUpdatedAtLte;
            }

            if (filterVirtualMeetingRoom !== undefined) {
                localVarQueryParameter['filter[virtualMeetingRoom]'] = filterVirtualMeetingRoom;
            }

            if (filterMeetingRoom !== undefined) {
                localVarQueryParameter['filter[meetingRoom]'] = filterMeetingRoom;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this virtual meeting room setup.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterMeetingRoom] meeting_room
         * @param {string} [filterHotel] hotel
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDiagrammingVirtualMeetingRoomSetupsId: async (id: string, include?: string, fields?: object, sort?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterMeetingRoom?: string, filterHotel?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveDiagrammingVirtualMeetingRoomSetupsId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/diagramming/virtual-meeting-room-setups/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterCreatedAtGte !== undefined) {
                localVarQueryParameter['filter[createdAt.gte]'] = filterCreatedAtGte;
            }

            if (filterCreatedAtLte !== undefined) {
                localVarQueryParameter['filter[createdAt.lte]'] = filterCreatedAtLte;
            }

            if (filterUpdatedAtGte !== undefined) {
                localVarQueryParameter['filter[updatedAt.gte]'] = filterUpdatedAtGte;
            }

            if (filterUpdatedAtLte !== undefined) {
                localVarQueryParameter['filter[updatedAt.lte]'] = filterUpdatedAtLte;
            }

            if (filterMeetingRoom !== undefined) {
                localVarQueryParameter['filter[meetingRoom]'] = filterMeetingRoom;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this virtual object.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterAvailabilityStatusIn] availability_status__in
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterHotel] hotel
         * @param {string} [filterService] service
         * @param {string} [filterObjectTypes] object_types
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDiagrammingVirtualObjectsId: async (id: string, include?: string, fields?: object, sort?: string, filterAvailabilityStatusIn?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterHotel?: string, filterService?: string, filterObjectTypes?: string, filterVirtualMeetingRoom?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveDiagrammingVirtualObjectsId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/diagramming/virtual-objects/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterAvailabilityStatusIn !== undefined) {
                localVarQueryParameter['filter[availabilityStatus.in]'] = filterAvailabilityStatusIn;
            }

            if (filterCreatedAtGte !== undefined) {
                localVarQueryParameter['filter[createdAt.gte]'] = filterCreatedAtGte;
            }

            if (filterCreatedAtLte !== undefined) {
                localVarQueryParameter['filter[createdAt.lte]'] = filterCreatedAtLte;
            }

            if (filterUpdatedAtGte !== undefined) {
                localVarQueryParameter['filter[updatedAt.gte]'] = filterUpdatedAtGte;
            }

            if (filterUpdatedAtLte !== undefined) {
                localVarQueryParameter['filter[updatedAt.lte]'] = filterUpdatedAtLte;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterService !== undefined) {
                localVarQueryParameter['filter[service]'] = filterService;
            }

            if (filterObjectTypes !== undefined) {
                localVarQueryParameter['filter[objectTypes]'] = filterObjectTypes;
            }

            if (filterVirtualMeetingRoom !== undefined) {
                localVarQueryParameter['filter[virtualMeetingRoom]'] = filterVirtualMeetingRoom;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiagrammingApi - functional programming interface
 * @export
 */
export const DiagrammingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiagrammingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterActive] active
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterSchemaTypeIn] schema_type__in
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDiagrammingDollhouseSchemas(include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterActive?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterSchemaTypeIn?: string, filterVirtualMeetingRoom?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiagrammingDollhouseSchemas200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDiagrammingDollhouseSchemas(include, fields, pageNumber, pageSize, sort, filterActive, filterCreatedAtGte, filterCreatedAtLte, filterUpdatedAtGte, filterUpdatedAtLte, filterSchemaTypeIn, filterVirtualMeetingRoom, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiagrammingApi.listDiagrammingDollhouseSchemas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterAvailabilityStatusIn] availability_status__in
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterHotel] hotel
         * @param {string} [filterFurnitureTypes] furniture_types
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDiagrammingVirtualFurnitures(fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterAvailabilityStatusIn?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterHotel?: string, filterFurnitureTypes?: string, filterVirtualMeetingRoom?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiagrammingVirtualFurnitures200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDiagrammingVirtualFurnitures(fields, pageNumber, pageSize, sort, filterAvailabilityStatusIn, filterCreatedAtGte, filterCreatedAtLte, filterUpdatedAtGte, filterUpdatedAtLte, filterHotel, filterFurnitureTypes, filterVirtualMeetingRoom, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiagrammingApi.listDiagrammingVirtualFurnitures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterMeetingRoom] meeting_room
         * @param {string} [filterHotel] hotel
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDiagrammingVirtualMeetingRoomSetupTemplates(include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterVirtualMeetingRoom?: string, filterMeetingRoom?: string, filterHotel?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiagrammingVirtualMeetingRoomSetupTemplates200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDiagrammingVirtualMeetingRoomSetupTemplates(include, fields, pageNumber, pageSize, sort, filterCreatedAtGte, filterCreatedAtLte, filterUpdatedAtGte, filterUpdatedAtLte, filterVirtualMeetingRoom, filterMeetingRoom, filterHotel, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiagrammingApi.listDiagrammingVirtualMeetingRoomSetupTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterAvailabilityStatusIn] availability_status__in
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterHotel] hotel
         * @param {string} [filterService] service
         * @param {string} [filterObjectTypes] object_types
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDiagrammingVirtualObjects(include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterAvailabilityStatusIn?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterHotel?: string, filterService?: string, filterObjectTypes?: string, filterVirtualMeetingRoom?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiagrammingVirtualObjects200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDiagrammingVirtualObjects(include, fields, pageNumber, pageSize, sort, filterAvailabilityStatusIn, filterCreatedAtGte, filterCreatedAtLte, filterUpdatedAtGte, filterUpdatedAtLte, filterHotel, filterService, filterObjectTypes, filterVirtualMeetingRoom, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiagrammingApi.listDiagrammingVirtualObjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this virtual meeting room setup.
         * @param {PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest} [partialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partialUpdateDiagrammingVirtualMeetingRoomSetupsId(id: string, partialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest?: PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartialUpdateDiagrammingVirtualMeetingRoomSetupsId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partialUpdateDiagrammingVirtualMeetingRoomSetupsId(id, partialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiagrammingApi.partialUpdateDiagrammingVirtualMeetingRoomSetupsId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this dollhouse schema.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterActive] active
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterSchemaTypeIn] schema_type__in
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveDiagrammingDollhouseSchemasId(id: string, include?: string, fields?: object, sort?: string, filterActive?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterSchemaTypeIn?: string, filterVirtualMeetingRoom?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveDiagrammingDollhouseSchemasId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveDiagrammingDollhouseSchemasId(id, include, fields, sort, filterActive, filterCreatedAtGte, filterCreatedAtLte, filterUpdatedAtGte, filterUpdatedAtLte, filterSchemaTypeIn, filterVirtualMeetingRoom, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiagrammingApi.retrieveDiagrammingDollhouseSchemasId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this virtual furniture.
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterAvailabilityStatusIn] availability_status__in
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterHotel] hotel
         * @param {string} [filterFurnitureTypes] furniture_types
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveDiagrammingVirtualFurnituresId(id: string, fields?: object, sort?: string, filterAvailabilityStatusIn?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterHotel?: string, filterFurnitureTypes?: string, filterVirtualMeetingRoom?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveDiagrammingVirtualFurnituresId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveDiagrammingVirtualFurnituresId(id, fields, sort, filterAvailabilityStatusIn, filterCreatedAtGte, filterCreatedAtLte, filterUpdatedAtGte, filterUpdatedAtLte, filterHotel, filterFurnitureTypes, filterVirtualMeetingRoom, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiagrammingApi.retrieveDiagrammingVirtualFurnituresId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this virtual meeting room.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterMeetingRoom] meeting_room
         * @param {string} [filterHotel] hotel
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveDiagrammingVirtualMeetingRoomId(id: string, include?: string, fields?: object, sort?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterMeetingRoom?: string, filterHotel?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveDiagrammingVirtualMeetingRoomId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveDiagrammingVirtualMeetingRoomId(id, include, fields, sort, filterCreatedAtGte, filterCreatedAtLte, filterUpdatedAtGte, filterUpdatedAtLte, filterMeetingRoom, filterHotel, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiagrammingApi.retrieveDiagrammingVirtualMeetingRoomId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this virtual meeting room setup template.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterMeetingRoom] meeting_room
         * @param {string} [filterHotel] hotel
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveDiagrammingVirtualMeetingRoomSetupTemplatesId(id: string, include?: string, fields?: object, sort?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterVirtualMeetingRoom?: string, filterMeetingRoom?: string, filterHotel?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveDiagrammingVirtualMeetingRoomSetupTemplatesId(id, include, fields, sort, filterCreatedAtGte, filterCreatedAtLte, filterUpdatedAtGte, filterUpdatedAtLte, filterVirtualMeetingRoom, filterMeetingRoom, filterHotel, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiagrammingApi.retrieveDiagrammingVirtualMeetingRoomSetupTemplatesId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this virtual meeting room setup.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterMeetingRoom] meeting_room
         * @param {string} [filterHotel] hotel
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveDiagrammingVirtualMeetingRoomSetupsId(id: string, include?: string, fields?: object, sort?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterMeetingRoom?: string, filterHotel?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveDiagrammingVirtualMeetingRoomSetupsId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveDiagrammingVirtualMeetingRoomSetupsId(id, include, fields, sort, filterCreatedAtGte, filterCreatedAtLte, filterUpdatedAtGte, filterUpdatedAtLte, filterMeetingRoom, filterHotel, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiagrammingApi.retrieveDiagrammingVirtualMeetingRoomSetupsId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this virtual object.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterAvailabilityStatusIn] availability_status__in
         * @param {string} [filterCreatedAtGte] created_at__gte
         * @param {string} [filterCreatedAtLte] created_at__lte
         * @param {string} [filterUpdatedAtGte] updated_at__gte
         * @param {string} [filterUpdatedAtLte] updated_at__lte
         * @param {string} [filterHotel] hotel
         * @param {string} [filterService] service
         * @param {string} [filterObjectTypes] object_types
         * @param {string} [filterVirtualMeetingRoom] virtual_meeting_room
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveDiagrammingVirtualObjectsId(id: string, include?: string, fields?: object, sort?: string, filterAvailabilityStatusIn?: string, filterCreatedAtGte?: string, filterCreatedAtLte?: string, filterUpdatedAtGte?: string, filterUpdatedAtLte?: string, filterHotel?: string, filterService?: string, filterObjectTypes?: string, filterVirtualMeetingRoom?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveDiagrammingVirtualObjectsId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveDiagrammingVirtualObjectsId(id, include, fields, sort, filterAvailabilityStatusIn, filterCreatedAtGte, filterCreatedAtLte, filterUpdatedAtGte, filterUpdatedAtLte, filterHotel, filterService, filterObjectTypes, filterVirtualMeetingRoom, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiagrammingApi.retrieveDiagrammingVirtualObjectsId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DiagrammingApi - factory interface
 * @export
 */
export const DiagrammingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiagrammingApiFp(configuration)
    return {
        /**
         * 
         * @param {DiagrammingApiListDiagrammingDollhouseSchemasRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDiagrammingDollhouseSchemas(requestParameters: DiagrammingApiListDiagrammingDollhouseSchemasRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListDiagrammingDollhouseSchemas200Response> {
            return localVarFp.listDiagrammingDollhouseSchemas(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterActive, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterSchemaTypeIn, requestParameters.filterVirtualMeetingRoom, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DiagrammingApiListDiagrammingVirtualFurnituresRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDiagrammingVirtualFurnitures(requestParameters: DiagrammingApiListDiagrammingVirtualFurnituresRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListDiagrammingVirtualFurnitures200Response> {
            return localVarFp.listDiagrammingVirtualFurnitures(requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterAvailabilityStatusIn, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterHotel, requestParameters.filterFurnitureTypes, requestParameters.filterVirtualMeetingRoom, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDiagrammingVirtualMeetingRoomSetupTemplates(requestParameters: DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplatesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListDiagrammingVirtualMeetingRoomSetupTemplates200Response> {
            return localVarFp.listDiagrammingVirtualMeetingRoomSetupTemplates(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterVirtualMeetingRoom, requestParameters.filterMeetingRoom, requestParameters.filterHotel, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DiagrammingApiListDiagrammingVirtualObjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDiagrammingVirtualObjects(requestParameters: DiagrammingApiListDiagrammingVirtualObjectsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListDiagrammingVirtualObjects200Response> {
            return localVarFp.listDiagrammingVirtualObjects(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterAvailabilityStatusIn, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterHotel, requestParameters.filterService, requestParameters.filterObjectTypes, requestParameters.filterVirtualMeetingRoom, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DiagrammingApiPartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateDiagrammingVirtualMeetingRoomSetupsId(requestParameters: DiagrammingApiPartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartialUpdateDiagrammingVirtualMeetingRoomSetupsId200Response> {
            return localVarFp.partialUpdateDiagrammingVirtualMeetingRoomSetupsId(requestParameters.id, requestParameters.partialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DiagrammingApiRetrieveDiagrammingDollhouseSchemasIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDiagrammingDollhouseSchemasId(requestParameters: DiagrammingApiRetrieveDiagrammingDollhouseSchemasIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveDiagrammingDollhouseSchemasId200Response> {
            return localVarFp.retrieveDiagrammingDollhouseSchemasId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterActive, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterSchemaTypeIn, requestParameters.filterVirtualMeetingRoom, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DiagrammingApiRetrieveDiagrammingVirtualFurnituresIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDiagrammingVirtualFurnituresId(requestParameters: DiagrammingApiRetrieveDiagrammingVirtualFurnituresIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveDiagrammingVirtualFurnituresId200Response> {
            return localVarFp.retrieveDiagrammingVirtualFurnituresId(requestParameters.id, requestParameters.fields, requestParameters.sort, requestParameters.filterAvailabilityStatusIn, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterHotel, requestParameters.filterFurnitureTypes, requestParameters.filterVirtualMeetingRoom, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDiagrammingVirtualMeetingRoomId(requestParameters: DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveDiagrammingVirtualMeetingRoomId200Response> {
            return localVarFp.retrieveDiagrammingVirtualMeetingRoomId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterMeetingRoom, requestParameters.filterHotel, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDiagrammingVirtualMeetingRoomSetupTemplatesId(requestParameters: DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId200Response> {
            return localVarFp.retrieveDiagrammingVirtualMeetingRoomSetupTemplatesId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterVirtualMeetingRoom, requestParameters.filterMeetingRoom, requestParameters.filterHotel, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDiagrammingVirtualMeetingRoomSetupsId(requestParameters: DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveDiagrammingVirtualMeetingRoomSetupsId200Response> {
            return localVarFp.retrieveDiagrammingVirtualMeetingRoomSetupsId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterMeetingRoom, requestParameters.filterHotel, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DiagrammingApiRetrieveDiagrammingVirtualObjectsIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDiagrammingVirtualObjectsId(requestParameters: DiagrammingApiRetrieveDiagrammingVirtualObjectsIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveDiagrammingVirtualObjectsId200Response> {
            return localVarFp.retrieveDiagrammingVirtualObjectsId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterAvailabilityStatusIn, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterHotel, requestParameters.filterService, requestParameters.filterObjectTypes, requestParameters.filterVirtualMeetingRoom, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for listDiagrammingDollhouseSchemas operation in DiagrammingApi.
 * @export
 * @interface DiagrammingApiListDiagrammingDollhouseSchemasRequest
 */
export interface DiagrammingApiListDiagrammingDollhouseSchemasRequest {
    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingDollhouseSchemas
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof DiagrammingApiListDiagrammingDollhouseSchemas
     */
    readonly fields?: object

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof DiagrammingApiListDiagrammingDollhouseSchemas
     */
    readonly pageNumber?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof DiagrammingApiListDiagrammingDollhouseSchemas
     */
    readonly pageSize?: number

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingDollhouseSchemas
     */
    readonly sort?: string

    /**
     * active
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingDollhouseSchemas
     */
    readonly filterActive?: string

    /**
     * created_at__gte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingDollhouseSchemas
     */
    readonly filterCreatedAtGte?: string

    /**
     * created_at__lte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingDollhouseSchemas
     */
    readonly filterCreatedAtLte?: string

    /**
     * updated_at__gte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingDollhouseSchemas
     */
    readonly filterUpdatedAtGte?: string

    /**
     * updated_at__lte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingDollhouseSchemas
     */
    readonly filterUpdatedAtLte?: string

    /**
     * schema_type__in
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingDollhouseSchemas
     */
    readonly filterSchemaTypeIn?: string

    /**
     * virtual_meeting_room
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingDollhouseSchemas
     */
    readonly filterVirtualMeetingRoom?: string

    /**
     * A search term.
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingDollhouseSchemas
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for listDiagrammingVirtualFurnitures operation in DiagrammingApi.
 * @export
 * @interface DiagrammingApiListDiagrammingVirtualFurnituresRequest
 */
export interface DiagrammingApiListDiagrammingVirtualFurnituresRequest {
    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof DiagrammingApiListDiagrammingVirtualFurnitures
     */
    readonly fields?: object

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof DiagrammingApiListDiagrammingVirtualFurnitures
     */
    readonly pageNumber?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof DiagrammingApiListDiagrammingVirtualFurnitures
     */
    readonly pageSize?: number

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualFurnitures
     */
    readonly sort?: string

    /**
     * availability_status__in
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualFurnitures
     */
    readonly filterAvailabilityStatusIn?: string

    /**
     * created_at__gte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualFurnitures
     */
    readonly filterCreatedAtGte?: string

    /**
     * created_at__lte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualFurnitures
     */
    readonly filterCreatedAtLte?: string

    /**
     * updated_at__gte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualFurnitures
     */
    readonly filterUpdatedAtGte?: string

    /**
     * updated_at__lte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualFurnitures
     */
    readonly filterUpdatedAtLte?: string

    /**
     * hotel
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualFurnitures
     */
    readonly filterHotel?: string

    /**
     * furniture_types
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualFurnitures
     */
    readonly filterFurnitureTypes?: string

    /**
     * virtual_meeting_room
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualFurnitures
     */
    readonly filterVirtualMeetingRoom?: string

    /**
     * A search term.
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualFurnitures
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for listDiagrammingVirtualMeetingRoomSetupTemplates operation in DiagrammingApi.
 * @export
 * @interface DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplatesRequest
 */
export interface DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplatesRequest {
    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplates
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplates
     */
    readonly fields?: object

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplates
     */
    readonly pageNumber?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplates
     */
    readonly pageSize?: number

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplates
     */
    readonly sort?: string

    /**
     * created_at__gte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplates
     */
    readonly filterCreatedAtGte?: string

    /**
     * created_at__lte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplates
     */
    readonly filterCreatedAtLte?: string

    /**
     * updated_at__gte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplates
     */
    readonly filterUpdatedAtGte?: string

    /**
     * updated_at__lte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplates
     */
    readonly filterUpdatedAtLte?: string

    /**
     * virtual_meeting_room
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplates
     */
    readonly filterVirtualMeetingRoom?: string

    /**
     * meeting_room
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplates
     */
    readonly filterMeetingRoom?: string

    /**
     * hotel
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplates
     */
    readonly filterHotel?: string

    /**
     * A search term.
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplates
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for listDiagrammingVirtualObjects operation in DiagrammingApi.
 * @export
 * @interface DiagrammingApiListDiagrammingVirtualObjectsRequest
 */
export interface DiagrammingApiListDiagrammingVirtualObjectsRequest {
    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly fields?: object

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly pageNumber?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly pageSize?: number

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly sort?: string

    /**
     * availability_status__in
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly filterAvailabilityStatusIn?: string

    /**
     * created_at__gte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly filterCreatedAtGte?: string

    /**
     * created_at__lte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly filterCreatedAtLte?: string

    /**
     * updated_at__gte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly filterUpdatedAtGte?: string

    /**
     * updated_at__lte
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly filterUpdatedAtLte?: string

    /**
     * hotel
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly filterHotel?: string

    /**
     * service
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly filterService?: string

    /**
     * object_types
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly filterObjectTypes?: string

    /**
     * virtual_meeting_room
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly filterVirtualMeetingRoom?: string

    /**
     * A search term.
     * @type {string}
     * @memberof DiagrammingApiListDiagrammingVirtualObjects
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for partialUpdateDiagrammingVirtualMeetingRoomSetupsId operation in DiagrammingApi.
 * @export
 * @interface DiagrammingApiPartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest
 */
export interface DiagrammingApiPartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest {
    /**
     * A unique integer value identifying this virtual meeting room setup.
     * @type {string}
     * @memberof DiagrammingApiPartialUpdateDiagrammingVirtualMeetingRoomSetupsId
     */
    readonly id: string

    /**
     * 
     * @type {PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest}
     * @memberof DiagrammingApiPartialUpdateDiagrammingVirtualMeetingRoomSetupsId
     */
    readonly partialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest?: PartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest
}

/**
 * Request parameters for retrieveDiagrammingDollhouseSchemasId operation in DiagrammingApi.
 * @export
 * @interface DiagrammingApiRetrieveDiagrammingDollhouseSchemasIdRequest
 */
export interface DiagrammingApiRetrieveDiagrammingDollhouseSchemasIdRequest {
    /**
     * A unique integer value identifying this dollhouse schema.
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingDollhouseSchemasId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingDollhouseSchemasId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof DiagrammingApiRetrieveDiagrammingDollhouseSchemasId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingDollhouseSchemasId
     */
    readonly sort?: string

    /**
     * active
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingDollhouseSchemasId
     */
    readonly filterActive?: string

    /**
     * created_at__gte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingDollhouseSchemasId
     */
    readonly filterCreatedAtGte?: string

    /**
     * created_at__lte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingDollhouseSchemasId
     */
    readonly filterCreatedAtLte?: string

    /**
     * updated_at__gte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingDollhouseSchemasId
     */
    readonly filterUpdatedAtGte?: string

    /**
     * updated_at__lte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingDollhouseSchemasId
     */
    readonly filterUpdatedAtLte?: string

    /**
     * schema_type__in
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingDollhouseSchemasId
     */
    readonly filterSchemaTypeIn?: string

    /**
     * virtual_meeting_room
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingDollhouseSchemasId
     */
    readonly filterVirtualMeetingRoom?: string

    /**
     * A search term.
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingDollhouseSchemasId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveDiagrammingVirtualFurnituresId operation in DiagrammingApi.
 * @export
 * @interface DiagrammingApiRetrieveDiagrammingVirtualFurnituresIdRequest
 */
export interface DiagrammingApiRetrieveDiagrammingVirtualFurnituresIdRequest {
    /**
     * A unique integer value identifying this virtual furniture.
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualFurnituresId
     */
    readonly id: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualFurnituresId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualFurnituresId
     */
    readonly sort?: string

    /**
     * availability_status__in
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualFurnituresId
     */
    readonly filterAvailabilityStatusIn?: string

    /**
     * created_at__gte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualFurnituresId
     */
    readonly filterCreatedAtGte?: string

    /**
     * created_at__lte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualFurnituresId
     */
    readonly filterCreatedAtLte?: string

    /**
     * updated_at__gte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualFurnituresId
     */
    readonly filterUpdatedAtGte?: string

    /**
     * updated_at__lte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualFurnituresId
     */
    readonly filterUpdatedAtLte?: string

    /**
     * hotel
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualFurnituresId
     */
    readonly filterHotel?: string

    /**
     * furniture_types
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualFurnituresId
     */
    readonly filterFurnitureTypes?: string

    /**
     * virtual_meeting_room
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualFurnituresId
     */
    readonly filterVirtualMeetingRoom?: string

    /**
     * A search term.
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualFurnituresId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveDiagrammingVirtualMeetingRoomId operation in DiagrammingApi.
 * @export
 * @interface DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomIdRequest
 */
export interface DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomIdRequest {
    /**
     * A unique integer value identifying this virtual meeting room.
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomId
     */
    readonly sort?: string

    /**
     * created_at__gte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomId
     */
    readonly filterCreatedAtGte?: string

    /**
     * created_at__lte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomId
     */
    readonly filterCreatedAtLte?: string

    /**
     * updated_at__gte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomId
     */
    readonly filterUpdatedAtGte?: string

    /**
     * updated_at__lte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomId
     */
    readonly filterUpdatedAtLte?: string

    /**
     * meeting_room
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomId
     */
    readonly filterMeetingRoom?: string

    /**
     * hotel
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomId
     */
    readonly filterHotel?: string

    /**
     * A search term.
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveDiagrammingVirtualMeetingRoomSetupTemplatesId operation in DiagrammingApi.
 * @export
 * @interface DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesIdRequest
 */
export interface DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesIdRequest {
    /**
     * A unique integer value identifying this virtual meeting room setup template.
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId
     */
    readonly sort?: string

    /**
     * created_at__gte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId
     */
    readonly filterCreatedAtGte?: string

    /**
     * created_at__lte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId
     */
    readonly filterCreatedAtLte?: string

    /**
     * updated_at__gte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId
     */
    readonly filterUpdatedAtGte?: string

    /**
     * updated_at__lte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId
     */
    readonly filterUpdatedAtLte?: string

    /**
     * virtual_meeting_room
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId
     */
    readonly filterVirtualMeetingRoom?: string

    /**
     * meeting_room
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId
     */
    readonly filterMeetingRoom?: string

    /**
     * hotel
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId
     */
    readonly filterHotel?: string

    /**
     * A search term.
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveDiagrammingVirtualMeetingRoomSetupsId operation in DiagrammingApi.
 * @export
 * @interface DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsIdRequest
 */
export interface DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsIdRequest {
    /**
     * A unique integer value identifying this virtual meeting room setup.
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsId
     */
    readonly sort?: string

    /**
     * created_at__gte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsId
     */
    readonly filterCreatedAtGte?: string

    /**
     * created_at__lte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsId
     */
    readonly filterCreatedAtLte?: string

    /**
     * updated_at__gte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsId
     */
    readonly filterUpdatedAtGte?: string

    /**
     * updated_at__lte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsId
     */
    readonly filterUpdatedAtLte?: string

    /**
     * meeting_room
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsId
     */
    readonly filterMeetingRoom?: string

    /**
     * hotel
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsId
     */
    readonly filterHotel?: string

    /**
     * A search term.
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveDiagrammingVirtualObjectsId operation in DiagrammingApi.
 * @export
 * @interface DiagrammingApiRetrieveDiagrammingVirtualObjectsIdRequest
 */
export interface DiagrammingApiRetrieveDiagrammingVirtualObjectsIdRequest {
    /**
     * A unique integer value identifying this virtual object.
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualObjectsId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualObjectsId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualObjectsId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualObjectsId
     */
    readonly sort?: string

    /**
     * availability_status__in
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualObjectsId
     */
    readonly filterAvailabilityStatusIn?: string

    /**
     * created_at__gte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualObjectsId
     */
    readonly filterCreatedAtGte?: string

    /**
     * created_at__lte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualObjectsId
     */
    readonly filterCreatedAtLte?: string

    /**
     * updated_at__gte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualObjectsId
     */
    readonly filterUpdatedAtGte?: string

    /**
     * updated_at__lte
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualObjectsId
     */
    readonly filterUpdatedAtLte?: string

    /**
     * hotel
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualObjectsId
     */
    readonly filterHotel?: string

    /**
     * service
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualObjectsId
     */
    readonly filterService?: string

    /**
     * object_types
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualObjectsId
     */
    readonly filterObjectTypes?: string

    /**
     * virtual_meeting_room
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualObjectsId
     */
    readonly filterVirtualMeetingRoom?: string

    /**
     * A search term.
     * @type {string}
     * @memberof DiagrammingApiRetrieveDiagrammingVirtualObjectsId
     */
    readonly filterSearch?: string
}

/**
 * DiagrammingApi - object-oriented interface
 * @export
 * @class DiagrammingApi
 * @extends {BaseAPI}
 */
export class DiagrammingApi extends BaseAPI {
    /**
     * 
     * @param {DiagrammingApiListDiagrammingDollhouseSchemasRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagrammingApi
     */
    public listDiagrammingDollhouseSchemas(requestParameters: DiagrammingApiListDiagrammingDollhouseSchemasRequest = {}, options?: RawAxiosRequestConfig) {
        return DiagrammingApiFp(this.configuration).listDiagrammingDollhouseSchemas(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterActive, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterSchemaTypeIn, requestParameters.filterVirtualMeetingRoom, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DiagrammingApiListDiagrammingVirtualFurnituresRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagrammingApi
     */
    public listDiagrammingVirtualFurnitures(requestParameters: DiagrammingApiListDiagrammingVirtualFurnituresRequest = {}, options?: RawAxiosRequestConfig) {
        return DiagrammingApiFp(this.configuration).listDiagrammingVirtualFurnitures(requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterAvailabilityStatusIn, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterHotel, requestParameters.filterFurnitureTypes, requestParameters.filterVirtualMeetingRoom, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagrammingApi
     */
    public listDiagrammingVirtualMeetingRoomSetupTemplates(requestParameters: DiagrammingApiListDiagrammingVirtualMeetingRoomSetupTemplatesRequest = {}, options?: RawAxiosRequestConfig) {
        return DiagrammingApiFp(this.configuration).listDiagrammingVirtualMeetingRoomSetupTemplates(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterVirtualMeetingRoom, requestParameters.filterMeetingRoom, requestParameters.filterHotel, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DiagrammingApiListDiagrammingVirtualObjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagrammingApi
     */
    public listDiagrammingVirtualObjects(requestParameters: DiagrammingApiListDiagrammingVirtualObjectsRequest = {}, options?: RawAxiosRequestConfig) {
        return DiagrammingApiFp(this.configuration).listDiagrammingVirtualObjects(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterAvailabilityStatusIn, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterHotel, requestParameters.filterService, requestParameters.filterObjectTypes, requestParameters.filterVirtualMeetingRoom, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DiagrammingApiPartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagrammingApi
     */
    public partialUpdateDiagrammingVirtualMeetingRoomSetupsId(requestParameters: DiagrammingApiPartialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest, options?: RawAxiosRequestConfig) {
        return DiagrammingApiFp(this.configuration).partialUpdateDiagrammingVirtualMeetingRoomSetupsId(requestParameters.id, requestParameters.partialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DiagrammingApiRetrieveDiagrammingDollhouseSchemasIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagrammingApi
     */
    public retrieveDiagrammingDollhouseSchemasId(requestParameters: DiagrammingApiRetrieveDiagrammingDollhouseSchemasIdRequest, options?: RawAxiosRequestConfig) {
        return DiagrammingApiFp(this.configuration).retrieveDiagrammingDollhouseSchemasId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterActive, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterSchemaTypeIn, requestParameters.filterVirtualMeetingRoom, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DiagrammingApiRetrieveDiagrammingVirtualFurnituresIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagrammingApi
     */
    public retrieveDiagrammingVirtualFurnituresId(requestParameters: DiagrammingApiRetrieveDiagrammingVirtualFurnituresIdRequest, options?: RawAxiosRequestConfig) {
        return DiagrammingApiFp(this.configuration).retrieveDiagrammingVirtualFurnituresId(requestParameters.id, requestParameters.fields, requestParameters.sort, requestParameters.filterAvailabilityStatusIn, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterHotel, requestParameters.filterFurnitureTypes, requestParameters.filterVirtualMeetingRoom, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagrammingApi
     */
    public retrieveDiagrammingVirtualMeetingRoomId(requestParameters: DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomIdRequest, options?: RawAxiosRequestConfig) {
        return DiagrammingApiFp(this.configuration).retrieveDiagrammingVirtualMeetingRoomId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterMeetingRoom, requestParameters.filterHotel, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagrammingApi
     */
    public retrieveDiagrammingVirtualMeetingRoomSetupTemplatesId(requestParameters: DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupTemplatesIdRequest, options?: RawAxiosRequestConfig) {
        return DiagrammingApiFp(this.configuration).retrieveDiagrammingVirtualMeetingRoomSetupTemplatesId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterVirtualMeetingRoom, requestParameters.filterMeetingRoom, requestParameters.filterHotel, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagrammingApi
     */
    public retrieveDiagrammingVirtualMeetingRoomSetupsId(requestParameters: DiagrammingApiRetrieveDiagrammingVirtualMeetingRoomSetupsIdRequest, options?: RawAxiosRequestConfig) {
        return DiagrammingApiFp(this.configuration).retrieveDiagrammingVirtualMeetingRoomSetupsId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterMeetingRoom, requestParameters.filterHotel, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DiagrammingApiRetrieveDiagrammingVirtualObjectsIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiagrammingApi
     */
    public retrieveDiagrammingVirtualObjectsId(requestParameters: DiagrammingApiRetrieveDiagrammingVirtualObjectsIdRequest, options?: RawAxiosRequestConfig) {
        return DiagrammingApiFp(this.configuration).retrieveDiagrammingVirtualObjectsId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterAvailabilityStatusIn, requestParameters.filterCreatedAtGte, requestParameters.filterCreatedAtLte, requestParameters.filterUpdatedAtGte, requestParameters.filterUpdatedAtLte, requestParameters.filterHotel, requestParameters.filterService, requestParameters.filterObjectTypes, requestParameters.filterVirtualMeetingRoom, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InventoryApi - axios parameter creator
 * @export
 */
export const InventoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotel] hotel
         * @param {string} [filterAttendees] attendees
         * @param {string} [filterAvailable] available
         * @param {string} [filterStartDate] start_date
         * @param {string} [filterOrder] order
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInventoryEventPackages: async (include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterHotel?: string, filterAttendees?: string, filterAvailable?: string, filterStartDate?: string, filterOrder?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/inventory/event-packages/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page[number]'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterAttendees !== undefined) {
                localVarQueryParameter['filter[attendees]'] = filterAttendees;
            }

            if (filterAvailable !== undefined) {
                localVarQueryParameter['filter[available]'] = filterAvailable;
            }

            if (filterStartDate !== undefined) {
                localVarQueryParameter['filter[startDate]'] = filterStartDate;
            }

            if (filterOrder !== undefined) {
                localVarQueryParameter['filter[order]'] = filterOrder;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotel] hotel
         * @param {string} [filterDateBefore] date_before
         * @param {string} [filterDateAfter] date_after
         * @param {string} [filterOrder] order
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInventoryGuestRooms: async (include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterHotelShortUuid?: string, filterHotel?: string, filterDateBefore?: string, filterDateAfter?: string, filterOrder?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/inventory/guest-rooms/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page[number]'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterHotelShortUuid !== undefined) {
                localVarQueryParameter['filter[hotel.shortUuid]'] = filterHotelShortUuid;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterDateBefore !== undefined) {
                localVarQueryParameter['filter[dateBefore]'] = filterDateBefore;
            }

            if (filterDateAfter !== undefined) {
                localVarQueryParameter['filter[dateAfter]'] = filterDateAfter;
            }

            if (filterOrder !== undefined) {
                localVarQueryParameter['filter[order]'] = filterOrder;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotelSlug] hotel__slug
         * @param {string} [filterHotel] hotel
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInventoryHotelRoomSetups: async (fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterHotelShortUuid?: string, filterHotelSlug?: string, filterHotel?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/inventory/hotel-room-setups/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page[number]'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterHotelShortUuid !== undefined) {
                localVarQueryParameter['filter[hotel.shortUuid]'] = filterHotelShortUuid;
            }

            if (filterHotelSlug !== undefined) {
                localVarQueryParameter['filter[hotel.slug]'] = filterHotelSlug;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterBrandNameIcontains] brand__name__icontains
         * @param {string} [filterCityNameIcontains] city__name__icontains
         * @param {string} [filterCountryNameIcontains] country__name__icontains
         * @param {string} [filterBrandSlugIcontains] brand__slug__icontains
         * @param {string} [filterCitySlugIcontains] city__slug__icontains
         * @param {string} [filterCountrySlugIcontains] country__slug__icontains
         * @param {string} [filterHotelChainNameIcontains] hotel_chain__name__icontains
         * @param {string} [filterHotelChainShortUuid] hotel_chain__short_uuid
         * @param {string} [filterHotelChainSlug] hotel_chain__slug
         * @param {string} [filterRegionNameIcontains] region__name__icontains
         * @param {string} [filterBrand] brand
         * @param {string} [filterCity] city
         * @param {string} [filterCountry] country
         * @param {string} [filterHotelChain] hotel_chain
         * @param {string} [filterNameIcontains] name__icontains
         * @param {string} [filterHasPublicMeetingRooms] has_public_meeting_rooms
         * @param {string} [filterHasPublicGuestRooms] has_public_guest_rooms
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInventoryHotels: async (include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterBrandNameIcontains?: string, filterCityNameIcontains?: string, filterCountryNameIcontains?: string, filterBrandSlugIcontains?: string, filterCitySlugIcontains?: string, filterCountrySlugIcontains?: string, filterHotelChainNameIcontains?: string, filterHotelChainShortUuid?: string, filterHotelChainSlug?: string, filterRegionNameIcontains?: string, filterBrand?: string, filterCity?: string, filterCountry?: string, filterHotelChain?: string, filterNameIcontains?: string, filterHasPublicMeetingRooms?: string, filterHasPublicGuestRooms?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/inventory/hotels/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page[number]'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterBrandNameIcontains !== undefined) {
                localVarQueryParameter['filter[brand.name.icontains]'] = filterBrandNameIcontains;
            }

            if (filterCityNameIcontains !== undefined) {
                localVarQueryParameter['filter[city.name.icontains]'] = filterCityNameIcontains;
            }

            if (filterCountryNameIcontains !== undefined) {
                localVarQueryParameter['filter[country.name.icontains]'] = filterCountryNameIcontains;
            }

            if (filterBrandSlugIcontains !== undefined) {
                localVarQueryParameter['filter[brand.slug.icontains]'] = filterBrandSlugIcontains;
            }

            if (filterCitySlugIcontains !== undefined) {
                localVarQueryParameter['filter[city.slug.icontains]'] = filterCitySlugIcontains;
            }

            if (filterCountrySlugIcontains !== undefined) {
                localVarQueryParameter['filter[country.slug.icontains]'] = filterCountrySlugIcontains;
            }

            if (filterHotelChainNameIcontains !== undefined) {
                localVarQueryParameter['filter[hotelChain.name.icontains]'] = filterHotelChainNameIcontains;
            }

            if (filterHotelChainShortUuid !== undefined) {
                localVarQueryParameter['filter[hotelChain.shortUuid]'] = filterHotelChainShortUuid;
            }

            if (filterHotelChainSlug !== undefined) {
                localVarQueryParameter['filter[hotelChain.slug]'] = filterHotelChainSlug;
            }

            if (filterRegionNameIcontains !== undefined) {
                localVarQueryParameter['filter[region.name.icontains]'] = filterRegionNameIcontains;
            }

            if (filterBrand !== undefined) {
                localVarQueryParameter['filter[brand]'] = filterBrand;
            }

            if (filterCity !== undefined) {
                localVarQueryParameter['filter[city]'] = filterCity;
            }

            if (filterCountry !== undefined) {
                localVarQueryParameter['filter[country]'] = filterCountry;
            }

            if (filterHotelChain !== undefined) {
                localVarQueryParameter['filter[hotelChain]'] = filterHotelChain;
            }

            if (filterNameIcontains !== undefined) {
                localVarQueryParameter['filter[name.icontains]'] = filterNameIcontains;
            }

            if (filterHasPublicMeetingRooms !== undefined) {
                localVarQueryParameter['filter[hasPublicMeetingRooms]'] = filterHasPublicMeetingRooms;
            }

            if (filterHasPublicGuestRooms !== undefined) {
                localVarQueryParameter['filter[hasPublicGuestRooms]'] = filterHasPublicGuestRooms;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotelHotelChainSlug] hotel__hotel_chain__slug
         * @param {ListInventoryMeetingRoomsFilterMeetingRoomSetupsTypeTypeEnum} [filterMeetingRoomSetupsTypeType] meeting_room_setups__type__type
         * @param {string} [filterHotel] hotel
         * @param {string} [filterAttendees] attendees
         * @param {string} [filterAvailable] available
         * @param {string} [filterDateBefore] date_before
         * @param {string} [filterDateAfter] date_after
         * @param {string} [filterCapacityGte] capacity__gte
         * @param {string} [filterCapacityLte] capacity__lte
         * @param {string} [filterDiagramming] diagramming
         * @param {string} [filterOrder] order
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInventoryMeetingRooms: async (include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterHotelShortUuid?: string, filterHotelHotelChainSlug?: string, filterMeetingRoomSetupsTypeType?: ListInventoryMeetingRoomsFilterMeetingRoomSetupsTypeTypeEnum, filterHotel?: string, filterAttendees?: string, filterAvailable?: string, filterDateBefore?: string, filterDateAfter?: string, filterCapacityGte?: string, filterCapacityLte?: string, filterDiagramming?: string, filterOrder?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/inventory/meeting-rooms/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page[number]'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterHotelShortUuid !== undefined) {
                localVarQueryParameter['filter[hotel.shortUuid]'] = filterHotelShortUuid;
            }

            if (filterHotelHotelChainSlug !== undefined) {
                localVarQueryParameter['filter[hotel.hotelChain.slug]'] = filterHotelHotelChainSlug;
            }

            if (filterMeetingRoomSetupsTypeType !== undefined) {
                localVarQueryParameter['filter[meetingRoomSetups.type.type]'] = filterMeetingRoomSetupsTypeType;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterAttendees !== undefined) {
                localVarQueryParameter['filter[attendees]'] = filterAttendees;
            }

            if (filterAvailable !== undefined) {
                localVarQueryParameter['filter[available]'] = filterAvailable;
            }

            if (filterDateBefore !== undefined) {
                localVarQueryParameter['filter[dateBefore]'] = filterDateBefore;
            }

            if (filterDateAfter !== undefined) {
                localVarQueryParameter['filter[dateAfter]'] = filterDateAfter;
            }

            if (filterCapacityGte !== undefined) {
                localVarQueryParameter['filter[capacity.gte]'] = filterCapacityGte;
            }

            if (filterCapacityLte !== undefined) {
                localVarQueryParameter['filter[capacity.lte]'] = filterCapacityLte;
            }

            if (filterDiagramming !== undefined) {
                localVarQueryParameter['filter[diagramming]'] = filterDiagramming;
            }

            if (filterOrder !== undefined) {
                localVarQueryParameter['filter[order]'] = filterOrder;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {ListInventoryServicesFilterCategoryEnum} [filterCategory] category
         * @param {ListInventoryServicesFilterServiceTypeEnum} [filterServiceType] service_type
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotel] hotel
         * @param {string} [filterStartsAt] starts_at
         * @param {string} [filterEndsAt] ends_at
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInventoryServices: async (include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterCategory?: ListInventoryServicesFilterCategoryEnum, filterServiceType?: ListInventoryServicesFilterServiceTypeEnum, filterHotelShortUuid?: string, filterHotel?: string, filterStartsAt?: string, filterEndsAt?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/instant-booking/inventory/services/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page[number]'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page[size]'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterCategory !== undefined) {
                localVarQueryParameter['filter[category]'] = filterCategory;
            }

            if (filterServiceType !== undefined) {
                localVarQueryParameter['filter[serviceType]'] = filterServiceType;
            }

            if (filterHotelShortUuid !== undefined) {
                localVarQueryParameter['filter[hotel.shortUuid]'] = filterHotelShortUuid;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterStartsAt !== undefined) {
                localVarQueryParameter['filter[startsAt]'] = filterStartsAt;
            }

            if (filterEndsAt !== undefined) {
                localVarQueryParameter['filter[endsAt]'] = filterEndsAt;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this event package.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotel] hotel
         * @param {string} [filterAttendees] attendees
         * @param {string} [filterAvailable] available
         * @param {string} [filterStartDate] start_date
         * @param {string} [filterOrder] order
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInventoryEventPackagesId: async (id: string, include?: string, fields?: object, sort?: string, filterHotel?: string, filterAttendees?: string, filterAvailable?: string, filterStartDate?: string, filterOrder?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveInventoryEventPackagesId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/inventory/event-packages/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterAttendees !== undefined) {
                localVarQueryParameter['filter[attendees]'] = filterAttendees;
            }

            if (filterAvailable !== undefined) {
                localVarQueryParameter['filter[available]'] = filterAvailable;
            }

            if (filterStartDate !== undefined) {
                localVarQueryParameter['filter[startDate]'] = filterStartDate;
            }

            if (filterOrder !== undefined) {
                localVarQueryParameter['filter[order]'] = filterOrder;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this guest room.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotel] hotel
         * @param {string} [filterDateBefore] date_before
         * @param {string} [filterDateAfter] date_after
         * @param {string} [filterOrder] order
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInventoryGuestRoomsId: async (id: string, include?: string, fields?: object, sort?: string, filterHotelShortUuid?: string, filterHotel?: string, filterDateBefore?: string, filterDateAfter?: string, filterOrder?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveInventoryGuestRoomsId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/inventory/guest-rooms/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterHotelShortUuid !== undefined) {
                localVarQueryParameter['filter[hotel.shortUuid]'] = filterHotelShortUuid;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterDateBefore !== undefined) {
                localVarQueryParameter['filter[dateBefore]'] = filterDateBefore;
            }

            if (filterDateAfter !== undefined) {
                localVarQueryParameter['filter[dateAfter]'] = filterDateAfter;
            }

            if (filterOrder !== undefined) {
                localVarQueryParameter['filter[order]'] = filterOrder;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInventoryHotelChainsSlug: async (slug: string, fields?: object, sort?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('retrieveInventoryHotelChainsSlug', 'slug', slug)
            const localVarPath = `/api/v3/instant-booking/inventory/hotel-chains/{slug}/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this Hotel setup.
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotelSlug] hotel__slug
         * @param {string} [filterHotel] hotel
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInventoryHotelRoomSetupsId: async (id: string, fields?: object, sort?: string, filterHotelShortUuid?: string, filterHotelSlug?: string, filterHotel?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveInventoryHotelRoomSetupsId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/inventory/hotel-room-setups/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterHotelShortUuid !== undefined) {
                localVarQueryParameter['filter[hotel.shortUuid]'] = filterHotelShortUuid;
            }

            if (filterHotelSlug !== undefined) {
                localVarQueryParameter['filter[hotel.slug]'] = filterHotelSlug;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this hotel.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterBrandNameIcontains] brand__name__icontains
         * @param {string} [filterCityNameIcontains] city__name__icontains
         * @param {string} [filterCountryNameIcontains] country__name__icontains
         * @param {string} [filterBrandSlugIcontains] brand__slug__icontains
         * @param {string} [filterCitySlugIcontains] city__slug__icontains
         * @param {string} [filterCountrySlugIcontains] country__slug__icontains
         * @param {string} [filterHotelChainNameIcontains] hotel_chain__name__icontains
         * @param {string} [filterHotelChainShortUuid] hotel_chain__short_uuid
         * @param {string} [filterHotelChainSlug] hotel_chain__slug
         * @param {string} [filterRegionNameIcontains] region__name__icontains
         * @param {string} [filterBrand] brand
         * @param {string} [filterCity] city
         * @param {string} [filterCountry] country
         * @param {string} [filterHotelChain] hotel_chain
         * @param {string} [filterNameIcontains] name__icontains
         * @param {string} [filterHasPublicMeetingRooms] has_public_meeting_rooms
         * @param {string} [filterHasPublicGuestRooms] has_public_guest_rooms
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInventoryHotelsId: async (id: string, include?: string, fields?: object, sort?: string, filterBrandNameIcontains?: string, filterCityNameIcontains?: string, filterCountryNameIcontains?: string, filterBrandSlugIcontains?: string, filterCitySlugIcontains?: string, filterCountrySlugIcontains?: string, filterHotelChainNameIcontains?: string, filterHotelChainShortUuid?: string, filterHotelChainSlug?: string, filterRegionNameIcontains?: string, filterBrand?: string, filterCity?: string, filterCountry?: string, filterHotelChain?: string, filterNameIcontains?: string, filterHasPublicMeetingRooms?: string, filterHasPublicGuestRooms?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveInventoryHotelsId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/inventory/hotels/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterBrandNameIcontains !== undefined) {
                localVarQueryParameter['filter[brand.name.icontains]'] = filterBrandNameIcontains;
            }

            if (filterCityNameIcontains !== undefined) {
                localVarQueryParameter['filter[city.name.icontains]'] = filterCityNameIcontains;
            }

            if (filterCountryNameIcontains !== undefined) {
                localVarQueryParameter['filter[country.name.icontains]'] = filterCountryNameIcontains;
            }

            if (filterBrandSlugIcontains !== undefined) {
                localVarQueryParameter['filter[brand.slug.icontains]'] = filterBrandSlugIcontains;
            }

            if (filterCitySlugIcontains !== undefined) {
                localVarQueryParameter['filter[city.slug.icontains]'] = filterCitySlugIcontains;
            }

            if (filterCountrySlugIcontains !== undefined) {
                localVarQueryParameter['filter[country.slug.icontains]'] = filterCountrySlugIcontains;
            }

            if (filterHotelChainNameIcontains !== undefined) {
                localVarQueryParameter['filter[hotelChain.name.icontains]'] = filterHotelChainNameIcontains;
            }

            if (filterHotelChainShortUuid !== undefined) {
                localVarQueryParameter['filter[hotelChain.shortUuid]'] = filterHotelChainShortUuid;
            }

            if (filterHotelChainSlug !== undefined) {
                localVarQueryParameter['filter[hotelChain.slug]'] = filterHotelChainSlug;
            }

            if (filterRegionNameIcontains !== undefined) {
                localVarQueryParameter['filter[region.name.icontains]'] = filterRegionNameIcontains;
            }

            if (filterBrand !== undefined) {
                localVarQueryParameter['filter[brand]'] = filterBrand;
            }

            if (filterCity !== undefined) {
                localVarQueryParameter['filter[city]'] = filterCity;
            }

            if (filterCountry !== undefined) {
                localVarQueryParameter['filter[country]'] = filterCountry;
            }

            if (filterHotelChain !== undefined) {
                localVarQueryParameter['filter[hotelChain]'] = filterHotelChain;
            }

            if (filterNameIcontains !== undefined) {
                localVarQueryParameter['filter[name.icontains]'] = filterNameIcontains;
            }

            if (filterHasPublicMeetingRooms !== undefined) {
                localVarQueryParameter['filter[hasPublicMeetingRooms]'] = filterHasPublicMeetingRooms;
            }

            if (filterHasPublicGuestRooms !== undefined) {
                localVarQueryParameter['filter[hasPublicGuestRooms]'] = filterHasPublicGuestRooms;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this meeting room.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotelHotelChainSlug] hotel__hotel_chain__slug
         * @param {RetrieveInventoryMeetingRoomsIdFilterMeetingRoomSetupsTypeTypeEnum} [filterMeetingRoomSetupsTypeType] meeting_room_setups__type__type
         * @param {string} [filterHotel] hotel
         * @param {string} [filterAttendees] attendees
         * @param {string} [filterAvailable] available
         * @param {string} [filterDateBefore] date_before
         * @param {string} [filterDateAfter] date_after
         * @param {string} [filterCapacityGte] capacity__gte
         * @param {string} [filterCapacityLte] capacity__lte
         * @param {string} [filterDiagramming] diagramming
         * @param {string} [filterOrder] order
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInventoryMeetingRoomsId: async (id: string, include?: string, fields?: object, sort?: string, filterHotelShortUuid?: string, filterHotelHotelChainSlug?: string, filterMeetingRoomSetupsTypeType?: RetrieveInventoryMeetingRoomsIdFilterMeetingRoomSetupsTypeTypeEnum, filterHotel?: string, filterAttendees?: string, filterAvailable?: string, filterDateBefore?: string, filterDateAfter?: string, filterCapacityGte?: string, filterCapacityLte?: string, filterDiagramming?: string, filterOrder?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveInventoryMeetingRoomsId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/inventory/meeting-rooms/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterHotelShortUuid !== undefined) {
                localVarQueryParameter['filter[hotel.shortUuid]'] = filterHotelShortUuid;
            }

            if (filterHotelHotelChainSlug !== undefined) {
                localVarQueryParameter['filter[hotel.hotelChain.slug]'] = filterHotelHotelChainSlug;
            }

            if (filterMeetingRoomSetupsTypeType !== undefined) {
                localVarQueryParameter['filter[meetingRoomSetups.type.type]'] = filterMeetingRoomSetupsTypeType;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterAttendees !== undefined) {
                localVarQueryParameter['filter[attendees]'] = filterAttendees;
            }

            if (filterAvailable !== undefined) {
                localVarQueryParameter['filter[available]'] = filterAvailable;
            }

            if (filterDateBefore !== undefined) {
                localVarQueryParameter['filter[dateBefore]'] = filterDateBefore;
            }

            if (filterDateAfter !== undefined) {
                localVarQueryParameter['filter[dateAfter]'] = filterDateAfter;
            }

            if (filterCapacityGte !== undefined) {
                localVarQueryParameter['filter[capacity.gte]'] = filterCapacityGte;
            }

            if (filterCapacityLte !== undefined) {
                localVarQueryParameter['filter[capacity.lte]'] = filterCapacityLte;
            }

            if (filterDiagramming !== undefined) {
                localVarQueryParameter['filter[diagramming]'] = filterDiagramming;
            }

            if (filterOrder !== undefined) {
                localVarQueryParameter['filter[order]'] = filterOrder;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this service.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {RetrieveInventoryServicesIdFilterCategoryEnum} [filterCategory] category
         * @param {RetrieveInventoryServicesIdFilterServiceTypeEnum} [filterServiceType] service_type
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotel] hotel
         * @param {string} [filterStartsAt] starts_at
         * @param {string} [filterEndsAt] ends_at
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInventoryServicesId: async (id: string, include?: string, fields?: object, sort?: string, filterCategory?: RetrieveInventoryServicesIdFilterCategoryEnum, filterServiceType?: RetrieveInventoryServicesIdFilterServiceTypeEnum, filterHotelShortUuid?: string, filterHotel?: string, filterStartsAt?: string, filterEndsAt?: string, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrieveInventoryServicesId', 'id', id)
            const localVarPath = `/api/v3/instant-booking/inventory/services/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (fields !== undefined) {
                for (const [key, value] of Object.entries(fields)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterCategory !== undefined) {
                localVarQueryParameter['filter[category]'] = filterCategory;
            }

            if (filterServiceType !== undefined) {
                localVarQueryParameter['filter[serviceType]'] = filterServiceType;
            }

            if (filterHotelShortUuid !== undefined) {
                localVarQueryParameter['filter[hotel.shortUuid]'] = filterHotelShortUuid;
            }

            if (filterHotel !== undefined) {
                localVarQueryParameter['filter[hotel]'] = filterHotel;
            }

            if (filterStartsAt !== undefined) {
                localVarQueryParameter['filter[startsAt]'] = filterStartsAt;
            }

            if (filterEndsAt !== undefined) {
                localVarQueryParameter['filter[endsAt]'] = filterEndsAt;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter[search]'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoryApi - functional programming interface
 * @export
 */
export const InventoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InventoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotel] hotel
         * @param {string} [filterAttendees] attendees
         * @param {string} [filterAvailable] available
         * @param {string} [filterStartDate] start_date
         * @param {string} [filterOrder] order
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInventoryEventPackages(include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterHotel?: string, filterAttendees?: string, filterAvailable?: string, filterStartDate?: string, filterOrder?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListInventoryEventPackages200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInventoryEventPackages(include, fields, pageNumber, pageSize, sort, filterHotel, filterAttendees, filterAvailable, filterStartDate, filterOrder, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.listInventoryEventPackages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotel] hotel
         * @param {string} [filterDateBefore] date_before
         * @param {string} [filterDateAfter] date_after
         * @param {string} [filterOrder] order
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInventoryGuestRooms(include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterHotelShortUuid?: string, filterHotel?: string, filterDateBefore?: string, filterDateAfter?: string, filterOrder?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListInventoryGuestRooms200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInventoryGuestRooms(include, fields, pageNumber, pageSize, sort, filterHotelShortUuid, filterHotel, filterDateBefore, filterDateAfter, filterOrder, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.listInventoryGuestRooms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotelSlug] hotel__slug
         * @param {string} [filterHotel] hotel
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInventoryHotelRoomSetups(fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterHotelShortUuid?: string, filterHotelSlug?: string, filterHotel?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListInventoryHotelRoomSetups200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInventoryHotelRoomSetups(fields, pageNumber, pageSize, sort, filterHotelShortUuid, filterHotelSlug, filterHotel, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.listInventoryHotelRoomSetups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterBrandNameIcontains] brand__name__icontains
         * @param {string} [filterCityNameIcontains] city__name__icontains
         * @param {string} [filterCountryNameIcontains] country__name__icontains
         * @param {string} [filterBrandSlugIcontains] brand__slug__icontains
         * @param {string} [filterCitySlugIcontains] city__slug__icontains
         * @param {string} [filterCountrySlugIcontains] country__slug__icontains
         * @param {string} [filterHotelChainNameIcontains] hotel_chain__name__icontains
         * @param {string} [filterHotelChainShortUuid] hotel_chain__short_uuid
         * @param {string} [filterHotelChainSlug] hotel_chain__slug
         * @param {string} [filterRegionNameIcontains] region__name__icontains
         * @param {string} [filterBrand] brand
         * @param {string} [filterCity] city
         * @param {string} [filterCountry] country
         * @param {string} [filterHotelChain] hotel_chain
         * @param {string} [filterNameIcontains] name__icontains
         * @param {string} [filterHasPublicMeetingRooms] has_public_meeting_rooms
         * @param {string} [filterHasPublicGuestRooms] has_public_guest_rooms
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInventoryHotels(include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterBrandNameIcontains?: string, filterCityNameIcontains?: string, filterCountryNameIcontains?: string, filterBrandSlugIcontains?: string, filterCitySlugIcontains?: string, filterCountrySlugIcontains?: string, filterHotelChainNameIcontains?: string, filterHotelChainShortUuid?: string, filterHotelChainSlug?: string, filterRegionNameIcontains?: string, filterBrand?: string, filterCity?: string, filterCountry?: string, filterHotelChain?: string, filterNameIcontains?: string, filterHasPublicMeetingRooms?: string, filterHasPublicGuestRooms?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListInventoryHotels200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInventoryHotels(include, fields, pageNumber, pageSize, sort, filterBrandNameIcontains, filterCityNameIcontains, filterCountryNameIcontains, filterBrandSlugIcontains, filterCitySlugIcontains, filterCountrySlugIcontains, filterHotelChainNameIcontains, filterHotelChainShortUuid, filterHotelChainSlug, filterRegionNameIcontains, filterBrand, filterCity, filterCountry, filterHotelChain, filterNameIcontains, filterHasPublicMeetingRooms, filterHasPublicGuestRooms, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.listInventoryHotels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotelHotelChainSlug] hotel__hotel_chain__slug
         * @param {ListInventoryMeetingRoomsFilterMeetingRoomSetupsTypeTypeEnum} [filterMeetingRoomSetupsTypeType] meeting_room_setups__type__type
         * @param {string} [filterHotel] hotel
         * @param {string} [filterAttendees] attendees
         * @param {string} [filterAvailable] available
         * @param {string} [filterDateBefore] date_before
         * @param {string} [filterDateAfter] date_after
         * @param {string} [filterCapacityGte] capacity__gte
         * @param {string} [filterCapacityLte] capacity__lte
         * @param {string} [filterDiagramming] diagramming
         * @param {string} [filterOrder] order
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInventoryMeetingRooms(include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterHotelShortUuid?: string, filterHotelHotelChainSlug?: string, filterMeetingRoomSetupsTypeType?: ListInventoryMeetingRoomsFilterMeetingRoomSetupsTypeTypeEnum, filterHotel?: string, filterAttendees?: string, filterAvailable?: string, filterDateBefore?: string, filterDateAfter?: string, filterCapacityGte?: string, filterCapacityLte?: string, filterDiagramming?: string, filterOrder?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListInventoryMeetingRooms200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInventoryMeetingRooms(include, fields, pageNumber, pageSize, sort, filterHotelShortUuid, filterHotelHotelChainSlug, filterMeetingRoomSetupsTypeType, filterHotel, filterAttendees, filterAvailable, filterDateBefore, filterDateAfter, filterCapacityGte, filterCapacityLte, filterDiagramming, filterOrder, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.listInventoryMeetingRooms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {number} [pageNumber] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {ListInventoryServicesFilterCategoryEnum} [filterCategory] category
         * @param {ListInventoryServicesFilterServiceTypeEnum} [filterServiceType] service_type
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotel] hotel
         * @param {string} [filterStartsAt] starts_at
         * @param {string} [filterEndsAt] ends_at
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInventoryServices(include?: string, fields?: object, pageNumber?: number, pageSize?: number, sort?: string, filterCategory?: ListInventoryServicesFilterCategoryEnum, filterServiceType?: ListInventoryServicesFilterServiceTypeEnum, filterHotelShortUuid?: string, filterHotel?: string, filterStartsAt?: string, filterEndsAt?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListInventoryServices200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInventoryServices(include, fields, pageNumber, pageSize, sort, filterCategory, filterServiceType, filterHotelShortUuid, filterHotel, filterStartsAt, filterEndsAt, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.listInventoryServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this event package.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotel] hotel
         * @param {string} [filterAttendees] attendees
         * @param {string} [filterAvailable] available
         * @param {string} [filterStartDate] start_date
         * @param {string} [filterOrder] order
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveInventoryEventPackagesId(id: string, include?: string, fields?: object, sort?: string, filterHotel?: string, filterAttendees?: string, filterAvailable?: string, filterStartDate?: string, filterOrder?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveInventoryEventPackagesId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveInventoryEventPackagesId(id, include, fields, sort, filterHotel, filterAttendees, filterAvailable, filterStartDate, filterOrder, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.retrieveInventoryEventPackagesId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this guest room.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotel] hotel
         * @param {string} [filterDateBefore] date_before
         * @param {string} [filterDateAfter] date_after
         * @param {string} [filterOrder] order
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveInventoryGuestRoomsId(id: string, include?: string, fields?: object, sort?: string, filterHotelShortUuid?: string, filterHotel?: string, filterDateBefore?: string, filterDateAfter?: string, filterOrder?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveInventoryGuestRoomsId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveInventoryGuestRoomsId(id, include, fields, sort, filterHotelShortUuid, filterHotel, filterDateBefore, filterDateAfter, filterOrder, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.retrieveInventoryGuestRoomsId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveInventoryHotelChainsSlug(slug: string, fields?: object, sort?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveInventoryHotelChainsSlug200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveInventoryHotelChainsSlug(slug, fields, sort, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.retrieveInventoryHotelChainsSlug']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this Hotel setup.
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotelSlug] hotel__slug
         * @param {string} [filterHotel] hotel
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveInventoryHotelRoomSetupsId(id: string, fields?: object, sort?: string, filterHotelShortUuid?: string, filterHotelSlug?: string, filterHotel?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveInventoryHotelRoomSetupsId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveInventoryHotelRoomSetupsId(id, fields, sort, filterHotelShortUuid, filterHotelSlug, filterHotel, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.retrieveInventoryHotelRoomSetupsId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this hotel.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterBrandNameIcontains] brand__name__icontains
         * @param {string} [filterCityNameIcontains] city__name__icontains
         * @param {string} [filterCountryNameIcontains] country__name__icontains
         * @param {string} [filterBrandSlugIcontains] brand__slug__icontains
         * @param {string} [filterCitySlugIcontains] city__slug__icontains
         * @param {string} [filterCountrySlugIcontains] country__slug__icontains
         * @param {string} [filterHotelChainNameIcontains] hotel_chain__name__icontains
         * @param {string} [filterHotelChainShortUuid] hotel_chain__short_uuid
         * @param {string} [filterHotelChainSlug] hotel_chain__slug
         * @param {string} [filterRegionNameIcontains] region__name__icontains
         * @param {string} [filterBrand] brand
         * @param {string} [filterCity] city
         * @param {string} [filterCountry] country
         * @param {string} [filterHotelChain] hotel_chain
         * @param {string} [filterNameIcontains] name__icontains
         * @param {string} [filterHasPublicMeetingRooms] has_public_meeting_rooms
         * @param {string} [filterHasPublicGuestRooms] has_public_guest_rooms
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveInventoryHotelsId(id: string, include?: string, fields?: object, sort?: string, filterBrandNameIcontains?: string, filterCityNameIcontains?: string, filterCountryNameIcontains?: string, filterBrandSlugIcontains?: string, filterCitySlugIcontains?: string, filterCountrySlugIcontains?: string, filterHotelChainNameIcontains?: string, filterHotelChainShortUuid?: string, filterHotelChainSlug?: string, filterRegionNameIcontains?: string, filterBrand?: string, filterCity?: string, filterCountry?: string, filterHotelChain?: string, filterNameIcontains?: string, filterHasPublicMeetingRooms?: string, filterHasPublicGuestRooms?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveInventoryHotelsId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveInventoryHotelsId(id, include, fields, sort, filterBrandNameIcontains, filterCityNameIcontains, filterCountryNameIcontains, filterBrandSlugIcontains, filterCitySlugIcontains, filterCountrySlugIcontains, filterHotelChainNameIcontains, filterHotelChainShortUuid, filterHotelChainSlug, filterRegionNameIcontains, filterBrand, filterCity, filterCountry, filterHotelChain, filterNameIcontains, filterHasPublicMeetingRooms, filterHasPublicGuestRooms, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.retrieveInventoryHotelsId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this meeting room.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotelHotelChainSlug] hotel__hotel_chain__slug
         * @param {RetrieveInventoryMeetingRoomsIdFilterMeetingRoomSetupsTypeTypeEnum} [filterMeetingRoomSetupsTypeType] meeting_room_setups__type__type
         * @param {string} [filterHotel] hotel
         * @param {string} [filterAttendees] attendees
         * @param {string} [filterAvailable] available
         * @param {string} [filterDateBefore] date_before
         * @param {string} [filterDateAfter] date_after
         * @param {string} [filterCapacityGte] capacity__gte
         * @param {string} [filterCapacityLte] capacity__lte
         * @param {string} [filterDiagramming] diagramming
         * @param {string} [filterOrder] order
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveInventoryMeetingRoomsId(id: string, include?: string, fields?: object, sort?: string, filterHotelShortUuid?: string, filterHotelHotelChainSlug?: string, filterMeetingRoomSetupsTypeType?: RetrieveInventoryMeetingRoomsIdFilterMeetingRoomSetupsTypeTypeEnum, filterHotel?: string, filterAttendees?: string, filterAvailable?: string, filterDateBefore?: string, filterDateAfter?: string, filterCapacityGte?: string, filterCapacityLte?: string, filterDiagramming?: string, filterOrder?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveInventoryMeetingRoomsId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveInventoryMeetingRoomsId(id, include, fields, sort, filterHotelShortUuid, filterHotelHotelChainSlug, filterMeetingRoomSetupsTypeType, filterHotel, filterAttendees, filterAvailable, filterDateBefore, filterDateAfter, filterCapacityGte, filterCapacityLte, filterDiagramming, filterOrder, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.retrieveInventoryMeetingRoomsId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A unique integer value identifying this service.
         * @param {string} [include] [list of included related resources](https://jsonapi.org/format/#fetching-includes)
         * @param {object} [fields] [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
         * @param {string} [sort] [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
         * @param {RetrieveInventoryServicesIdFilterCategoryEnum} [filterCategory] category
         * @param {RetrieveInventoryServicesIdFilterServiceTypeEnum} [filterServiceType] service_type
         * @param {string} [filterHotelShortUuid] hotel__short_uuid
         * @param {string} [filterHotel] hotel
         * @param {string} [filterStartsAt] starts_at
         * @param {string} [filterEndsAt] ends_at
         * @param {string} [filterSearch] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveInventoryServicesId(id: string, include?: string, fields?: object, sort?: string, filterCategory?: RetrieveInventoryServicesIdFilterCategoryEnum, filterServiceType?: RetrieveInventoryServicesIdFilterServiceTypeEnum, filterHotelShortUuid?: string, filterHotel?: string, filterStartsAt?: string, filterEndsAt?: string, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetrieveInventoryServicesId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveInventoryServicesId(id, include, fields, sort, filterCategory, filterServiceType, filterHotelShortUuid, filterHotel, filterStartsAt, filterEndsAt, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InventoryApi.retrieveInventoryServicesId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InventoryApi - factory interface
 * @export
 */
export const InventoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InventoryApiFp(configuration)
    return {
        /**
         * 
         * @param {InventoryApiListInventoryEventPackagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInventoryEventPackages(requestParameters: InventoryApiListInventoryEventPackagesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListInventoryEventPackages200Response> {
            return localVarFp.listInventoryEventPackages(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterHotel, requestParameters.filterAttendees, requestParameters.filterAvailable, requestParameters.filterStartDate, requestParameters.filterOrder, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InventoryApiListInventoryGuestRoomsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInventoryGuestRooms(requestParameters: InventoryApiListInventoryGuestRoomsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListInventoryGuestRooms200Response> {
            return localVarFp.listInventoryGuestRooms(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterHotelShortUuid, requestParameters.filterHotel, requestParameters.filterDateBefore, requestParameters.filterDateAfter, requestParameters.filterOrder, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InventoryApiListInventoryHotelRoomSetupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInventoryHotelRoomSetups(requestParameters: InventoryApiListInventoryHotelRoomSetupsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListInventoryHotelRoomSetups200Response> {
            return localVarFp.listInventoryHotelRoomSetups(requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterHotelShortUuid, requestParameters.filterHotelSlug, requestParameters.filterHotel, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InventoryApiListInventoryHotelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInventoryHotels(requestParameters: InventoryApiListInventoryHotelsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListInventoryHotels200Response> {
            return localVarFp.listInventoryHotels(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterBrandNameIcontains, requestParameters.filterCityNameIcontains, requestParameters.filterCountryNameIcontains, requestParameters.filterBrandSlugIcontains, requestParameters.filterCitySlugIcontains, requestParameters.filterCountrySlugIcontains, requestParameters.filterHotelChainNameIcontains, requestParameters.filterHotelChainShortUuid, requestParameters.filterHotelChainSlug, requestParameters.filterRegionNameIcontains, requestParameters.filterBrand, requestParameters.filterCity, requestParameters.filterCountry, requestParameters.filterHotelChain, requestParameters.filterNameIcontains, requestParameters.filterHasPublicMeetingRooms, requestParameters.filterHasPublicGuestRooms, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InventoryApiListInventoryMeetingRoomsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInventoryMeetingRooms(requestParameters: InventoryApiListInventoryMeetingRoomsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListInventoryMeetingRooms200Response> {
            return localVarFp.listInventoryMeetingRooms(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterHotelShortUuid, requestParameters.filterHotelHotelChainSlug, requestParameters.filterMeetingRoomSetupsTypeType, requestParameters.filterHotel, requestParameters.filterAttendees, requestParameters.filterAvailable, requestParameters.filterDateBefore, requestParameters.filterDateAfter, requestParameters.filterCapacityGte, requestParameters.filterCapacityLte, requestParameters.filterDiagramming, requestParameters.filterOrder, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InventoryApiListInventoryServicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInventoryServices(requestParameters: InventoryApiListInventoryServicesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListInventoryServices200Response> {
            return localVarFp.listInventoryServices(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterCategory, requestParameters.filterServiceType, requestParameters.filterHotelShortUuid, requestParameters.filterHotel, requestParameters.filterStartsAt, requestParameters.filterEndsAt, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InventoryApiRetrieveInventoryEventPackagesIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInventoryEventPackagesId(requestParameters: InventoryApiRetrieveInventoryEventPackagesIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveInventoryEventPackagesId200Response> {
            return localVarFp.retrieveInventoryEventPackagesId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterHotel, requestParameters.filterAttendees, requestParameters.filterAvailable, requestParameters.filterStartDate, requestParameters.filterOrder, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InventoryApiRetrieveInventoryGuestRoomsIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInventoryGuestRoomsId(requestParameters: InventoryApiRetrieveInventoryGuestRoomsIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveInventoryGuestRoomsId200Response> {
            return localVarFp.retrieveInventoryGuestRoomsId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterHotelShortUuid, requestParameters.filterHotel, requestParameters.filterDateBefore, requestParameters.filterDateAfter, requestParameters.filterOrder, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InventoryApiRetrieveInventoryHotelChainsSlugRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInventoryHotelChainsSlug(requestParameters: InventoryApiRetrieveInventoryHotelChainsSlugRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveInventoryHotelChainsSlug200Response> {
            return localVarFp.retrieveInventoryHotelChainsSlug(requestParameters.slug, requestParameters.fields, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InventoryApiRetrieveInventoryHotelRoomSetupsIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInventoryHotelRoomSetupsId(requestParameters: InventoryApiRetrieveInventoryHotelRoomSetupsIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveInventoryHotelRoomSetupsId200Response> {
            return localVarFp.retrieveInventoryHotelRoomSetupsId(requestParameters.id, requestParameters.fields, requestParameters.sort, requestParameters.filterHotelShortUuid, requestParameters.filterHotelSlug, requestParameters.filterHotel, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InventoryApiRetrieveInventoryHotelsIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInventoryHotelsId(requestParameters: InventoryApiRetrieveInventoryHotelsIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveInventoryHotelsId200Response> {
            return localVarFp.retrieveInventoryHotelsId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterBrandNameIcontains, requestParameters.filterCityNameIcontains, requestParameters.filterCountryNameIcontains, requestParameters.filterBrandSlugIcontains, requestParameters.filterCitySlugIcontains, requestParameters.filterCountrySlugIcontains, requestParameters.filterHotelChainNameIcontains, requestParameters.filterHotelChainShortUuid, requestParameters.filterHotelChainSlug, requestParameters.filterRegionNameIcontains, requestParameters.filterBrand, requestParameters.filterCity, requestParameters.filterCountry, requestParameters.filterHotelChain, requestParameters.filterNameIcontains, requestParameters.filterHasPublicMeetingRooms, requestParameters.filterHasPublicGuestRooms, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InventoryApiRetrieveInventoryMeetingRoomsIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInventoryMeetingRoomsId(requestParameters: InventoryApiRetrieveInventoryMeetingRoomsIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveInventoryMeetingRoomsId200Response> {
            return localVarFp.retrieveInventoryMeetingRoomsId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterHotelShortUuid, requestParameters.filterHotelHotelChainSlug, requestParameters.filterMeetingRoomSetupsTypeType, requestParameters.filterHotel, requestParameters.filterAttendees, requestParameters.filterAvailable, requestParameters.filterDateBefore, requestParameters.filterDateAfter, requestParameters.filterCapacityGte, requestParameters.filterCapacityLte, requestParameters.filterDiagramming, requestParameters.filterOrder, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InventoryApiRetrieveInventoryServicesIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveInventoryServicesId(requestParameters: InventoryApiRetrieveInventoryServicesIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetrieveInventoryServicesId200Response> {
            return localVarFp.retrieveInventoryServicesId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterCategory, requestParameters.filterServiceType, requestParameters.filterHotelShortUuid, requestParameters.filterHotel, requestParameters.filterStartsAt, requestParameters.filterEndsAt, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for listInventoryEventPackages operation in InventoryApi.
 * @export
 * @interface InventoryApiListInventoryEventPackagesRequest
 */
export interface InventoryApiListInventoryEventPackagesRequest {
    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof InventoryApiListInventoryEventPackages
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof InventoryApiListInventoryEventPackages
     */
    readonly fields?: object

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof InventoryApiListInventoryEventPackages
     */
    readonly pageNumber?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof InventoryApiListInventoryEventPackages
     */
    readonly pageSize?: number

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof InventoryApiListInventoryEventPackages
     */
    readonly sort?: string

    /**
     * hotel
     * @type {string}
     * @memberof InventoryApiListInventoryEventPackages
     */
    readonly filterHotel?: string

    /**
     * attendees
     * @type {string}
     * @memberof InventoryApiListInventoryEventPackages
     */
    readonly filterAttendees?: string

    /**
     * available
     * @type {string}
     * @memberof InventoryApiListInventoryEventPackages
     */
    readonly filterAvailable?: string

    /**
     * start_date
     * @type {string}
     * @memberof InventoryApiListInventoryEventPackages
     */
    readonly filterStartDate?: string

    /**
     * order
     * @type {string}
     * @memberof InventoryApiListInventoryEventPackages
     */
    readonly filterOrder?: string

    /**
     * A search term.
     * @type {string}
     * @memberof InventoryApiListInventoryEventPackages
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for listInventoryGuestRooms operation in InventoryApi.
 * @export
 * @interface InventoryApiListInventoryGuestRoomsRequest
 */
export interface InventoryApiListInventoryGuestRoomsRequest {
    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof InventoryApiListInventoryGuestRooms
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof InventoryApiListInventoryGuestRooms
     */
    readonly fields?: object

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof InventoryApiListInventoryGuestRooms
     */
    readonly pageNumber?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof InventoryApiListInventoryGuestRooms
     */
    readonly pageSize?: number

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof InventoryApiListInventoryGuestRooms
     */
    readonly sort?: string

    /**
     * hotel__short_uuid
     * @type {string}
     * @memberof InventoryApiListInventoryGuestRooms
     */
    readonly filterHotelShortUuid?: string

    /**
     * hotel
     * @type {string}
     * @memberof InventoryApiListInventoryGuestRooms
     */
    readonly filterHotel?: string

    /**
     * date_before
     * @type {string}
     * @memberof InventoryApiListInventoryGuestRooms
     */
    readonly filterDateBefore?: string

    /**
     * date_after
     * @type {string}
     * @memberof InventoryApiListInventoryGuestRooms
     */
    readonly filterDateAfter?: string

    /**
     * order
     * @type {string}
     * @memberof InventoryApiListInventoryGuestRooms
     */
    readonly filterOrder?: string

    /**
     * A search term.
     * @type {string}
     * @memberof InventoryApiListInventoryGuestRooms
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for listInventoryHotelRoomSetups operation in InventoryApi.
 * @export
 * @interface InventoryApiListInventoryHotelRoomSetupsRequest
 */
export interface InventoryApiListInventoryHotelRoomSetupsRequest {
    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof InventoryApiListInventoryHotelRoomSetups
     */
    readonly fields?: object

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof InventoryApiListInventoryHotelRoomSetups
     */
    readonly pageNumber?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof InventoryApiListInventoryHotelRoomSetups
     */
    readonly pageSize?: number

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof InventoryApiListInventoryHotelRoomSetups
     */
    readonly sort?: string

    /**
     * hotel__short_uuid
     * @type {string}
     * @memberof InventoryApiListInventoryHotelRoomSetups
     */
    readonly filterHotelShortUuid?: string

    /**
     * hotel__slug
     * @type {string}
     * @memberof InventoryApiListInventoryHotelRoomSetups
     */
    readonly filterHotelSlug?: string

    /**
     * hotel
     * @type {string}
     * @memberof InventoryApiListInventoryHotelRoomSetups
     */
    readonly filterHotel?: string

    /**
     * A search term.
     * @type {string}
     * @memberof InventoryApiListInventoryHotelRoomSetups
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for listInventoryHotels operation in InventoryApi.
 * @export
 * @interface InventoryApiListInventoryHotelsRequest
 */
export interface InventoryApiListInventoryHotelsRequest {
    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly fields?: object

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly pageNumber?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly pageSize?: number

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly sort?: string

    /**
     * brand__name__icontains
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterBrandNameIcontains?: string

    /**
     * city__name__icontains
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterCityNameIcontains?: string

    /**
     * country__name__icontains
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterCountryNameIcontains?: string

    /**
     * brand__slug__icontains
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterBrandSlugIcontains?: string

    /**
     * city__slug__icontains
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterCitySlugIcontains?: string

    /**
     * country__slug__icontains
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterCountrySlugIcontains?: string

    /**
     * hotel_chain__name__icontains
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterHotelChainNameIcontains?: string

    /**
     * hotel_chain__short_uuid
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterHotelChainShortUuid?: string

    /**
     * hotel_chain__slug
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterHotelChainSlug?: string

    /**
     * region__name__icontains
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterRegionNameIcontains?: string

    /**
     * brand
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterBrand?: string

    /**
     * city
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterCity?: string

    /**
     * country
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterCountry?: string

    /**
     * hotel_chain
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterHotelChain?: string

    /**
     * name__icontains
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterNameIcontains?: string

    /**
     * has_public_meeting_rooms
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterHasPublicMeetingRooms?: string

    /**
     * has_public_guest_rooms
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterHasPublicGuestRooms?: string

    /**
     * A search term.
     * @type {string}
     * @memberof InventoryApiListInventoryHotels
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for listInventoryMeetingRooms operation in InventoryApi.
 * @export
 * @interface InventoryApiListInventoryMeetingRoomsRequest
 */
export interface InventoryApiListInventoryMeetingRoomsRequest {
    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly fields?: object

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly pageNumber?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly pageSize?: number

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly sort?: string

    /**
     * hotel__short_uuid
     * @type {string}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly filterHotelShortUuid?: string

    /**
     * hotel__hotel_chain__slug
     * @type {string}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly filterHotelHotelChainSlug?: string

    /**
     * meeting_room_setups__type__type
     * @type {'boardroom' | 'cabaret' | 'classroom' | 'cocktail' | 'custom' | 'round' | 'theater' | 'u-shape'}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly filterMeetingRoomSetupsTypeType?: ListInventoryMeetingRoomsFilterMeetingRoomSetupsTypeTypeEnum

    /**
     * hotel
     * @type {string}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly filterHotel?: string

    /**
     * attendees
     * @type {string}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly filterAttendees?: string

    /**
     * available
     * @type {string}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly filterAvailable?: string

    /**
     * date_before
     * @type {string}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly filterDateBefore?: string

    /**
     * date_after
     * @type {string}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly filterDateAfter?: string

    /**
     * capacity__gte
     * @type {string}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly filterCapacityGte?: string

    /**
     * capacity__lte
     * @type {string}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly filterCapacityLte?: string

    /**
     * diagramming
     * @type {string}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly filterDiagramming?: string

    /**
     * order
     * @type {string}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly filterOrder?: string

    /**
     * A search term.
     * @type {string}
     * @memberof InventoryApiListInventoryMeetingRooms
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for listInventoryServices operation in InventoryApi.
 * @export
 * @interface InventoryApiListInventoryServicesRequest
 */
export interface InventoryApiListInventoryServicesRequest {
    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof InventoryApiListInventoryServices
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof InventoryApiListInventoryServices
     */
    readonly fields?: object

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof InventoryApiListInventoryServices
     */
    readonly pageNumber?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof InventoryApiListInventoryServices
     */
    readonly pageSize?: number

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof InventoryApiListInventoryServices
     */
    readonly sort?: string

    /**
     * category
     * @type {'Food and Beverage' | 'Audiovisual' | 'Others'}
     * @memberof InventoryApiListInventoryServices
     */
    readonly filterCategory?: ListInventoryServicesFilterCategoryEnum

    /**
     * service_type
     * @type {'audiovisual' | 'food-beverage' | 'other'}
     * @memberof InventoryApiListInventoryServices
     */
    readonly filterServiceType?: ListInventoryServicesFilterServiceTypeEnum

    /**
     * hotel__short_uuid
     * @type {string}
     * @memberof InventoryApiListInventoryServices
     */
    readonly filterHotelShortUuid?: string

    /**
     * hotel
     * @type {string}
     * @memberof InventoryApiListInventoryServices
     */
    readonly filterHotel?: string

    /**
     * starts_at
     * @type {string}
     * @memberof InventoryApiListInventoryServices
     */
    readonly filterStartsAt?: string

    /**
     * ends_at
     * @type {string}
     * @memberof InventoryApiListInventoryServices
     */
    readonly filterEndsAt?: string

    /**
     * A search term.
     * @type {string}
     * @memberof InventoryApiListInventoryServices
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveInventoryEventPackagesId operation in InventoryApi.
 * @export
 * @interface InventoryApiRetrieveInventoryEventPackagesIdRequest
 */
export interface InventoryApiRetrieveInventoryEventPackagesIdRequest {
    /**
     * A unique integer value identifying this event package.
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryEventPackagesId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryEventPackagesId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof InventoryApiRetrieveInventoryEventPackagesId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryEventPackagesId
     */
    readonly sort?: string

    /**
     * hotel
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryEventPackagesId
     */
    readonly filterHotel?: string

    /**
     * attendees
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryEventPackagesId
     */
    readonly filterAttendees?: string

    /**
     * available
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryEventPackagesId
     */
    readonly filterAvailable?: string

    /**
     * start_date
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryEventPackagesId
     */
    readonly filterStartDate?: string

    /**
     * order
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryEventPackagesId
     */
    readonly filterOrder?: string

    /**
     * A search term.
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryEventPackagesId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveInventoryGuestRoomsId operation in InventoryApi.
 * @export
 * @interface InventoryApiRetrieveInventoryGuestRoomsIdRequest
 */
export interface InventoryApiRetrieveInventoryGuestRoomsIdRequest {
    /**
     * A unique integer value identifying this guest room.
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryGuestRoomsId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryGuestRoomsId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof InventoryApiRetrieveInventoryGuestRoomsId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryGuestRoomsId
     */
    readonly sort?: string

    /**
     * hotel__short_uuid
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryGuestRoomsId
     */
    readonly filterHotelShortUuid?: string

    /**
     * hotel
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryGuestRoomsId
     */
    readonly filterHotel?: string

    /**
     * date_before
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryGuestRoomsId
     */
    readonly filterDateBefore?: string

    /**
     * date_after
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryGuestRoomsId
     */
    readonly filterDateAfter?: string

    /**
     * order
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryGuestRoomsId
     */
    readonly filterOrder?: string

    /**
     * A search term.
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryGuestRoomsId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveInventoryHotelChainsSlug operation in InventoryApi.
 * @export
 * @interface InventoryApiRetrieveInventoryHotelChainsSlugRequest
 */
export interface InventoryApiRetrieveInventoryHotelChainsSlugRequest {
    /**
     * 
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelChainsSlug
     */
    readonly slug: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof InventoryApiRetrieveInventoryHotelChainsSlug
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelChainsSlug
     */
    readonly sort?: string

    /**
     * A search term.
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelChainsSlug
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveInventoryHotelRoomSetupsId operation in InventoryApi.
 * @export
 * @interface InventoryApiRetrieveInventoryHotelRoomSetupsIdRequest
 */
export interface InventoryApiRetrieveInventoryHotelRoomSetupsIdRequest {
    /**
     * A unique integer value identifying this Hotel setup.
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelRoomSetupsId
     */
    readonly id: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof InventoryApiRetrieveInventoryHotelRoomSetupsId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelRoomSetupsId
     */
    readonly sort?: string

    /**
     * hotel__short_uuid
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelRoomSetupsId
     */
    readonly filterHotelShortUuid?: string

    /**
     * hotel__slug
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelRoomSetupsId
     */
    readonly filterHotelSlug?: string

    /**
     * hotel
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelRoomSetupsId
     */
    readonly filterHotel?: string

    /**
     * A search term.
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelRoomSetupsId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveInventoryHotelsId operation in InventoryApi.
 * @export
 * @interface InventoryApiRetrieveInventoryHotelsIdRequest
 */
export interface InventoryApiRetrieveInventoryHotelsIdRequest {
    /**
     * A unique integer value identifying this hotel.
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly sort?: string

    /**
     * brand__name__icontains
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterBrandNameIcontains?: string

    /**
     * city__name__icontains
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterCityNameIcontains?: string

    /**
     * country__name__icontains
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterCountryNameIcontains?: string

    /**
     * brand__slug__icontains
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterBrandSlugIcontains?: string

    /**
     * city__slug__icontains
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterCitySlugIcontains?: string

    /**
     * country__slug__icontains
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterCountrySlugIcontains?: string

    /**
     * hotel_chain__name__icontains
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterHotelChainNameIcontains?: string

    /**
     * hotel_chain__short_uuid
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterHotelChainShortUuid?: string

    /**
     * hotel_chain__slug
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterHotelChainSlug?: string

    /**
     * region__name__icontains
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterRegionNameIcontains?: string

    /**
     * brand
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterBrand?: string

    /**
     * city
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterCity?: string

    /**
     * country
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterCountry?: string

    /**
     * hotel_chain
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterHotelChain?: string

    /**
     * name__icontains
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterNameIcontains?: string

    /**
     * has_public_meeting_rooms
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterHasPublicMeetingRooms?: string

    /**
     * has_public_guest_rooms
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterHasPublicGuestRooms?: string

    /**
     * A search term.
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryHotelsId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveInventoryMeetingRoomsId operation in InventoryApi.
 * @export
 * @interface InventoryApiRetrieveInventoryMeetingRoomsIdRequest
 */
export interface InventoryApiRetrieveInventoryMeetingRoomsIdRequest {
    /**
     * A unique integer value identifying this meeting room.
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly sort?: string

    /**
     * hotel__short_uuid
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly filterHotelShortUuid?: string

    /**
     * hotel__hotel_chain__slug
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly filterHotelHotelChainSlug?: string

    /**
     * meeting_room_setups__type__type
     * @type {'boardroom' | 'cabaret' | 'classroom' | 'cocktail' | 'custom' | 'round' | 'theater' | 'u-shape'}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly filterMeetingRoomSetupsTypeType?: RetrieveInventoryMeetingRoomsIdFilterMeetingRoomSetupsTypeTypeEnum

    /**
     * hotel
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly filterHotel?: string

    /**
     * attendees
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly filterAttendees?: string

    /**
     * available
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly filterAvailable?: string

    /**
     * date_before
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly filterDateBefore?: string

    /**
     * date_after
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly filterDateAfter?: string

    /**
     * capacity__gte
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly filterCapacityGte?: string

    /**
     * capacity__lte
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly filterCapacityLte?: string

    /**
     * diagramming
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly filterDiagramming?: string

    /**
     * order
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly filterOrder?: string

    /**
     * A search term.
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryMeetingRoomsId
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for retrieveInventoryServicesId operation in InventoryApi.
 * @export
 * @interface InventoryApiRetrieveInventoryServicesIdRequest
 */
export interface InventoryApiRetrieveInventoryServicesIdRequest {
    /**
     * A unique integer value identifying this service.
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryServicesId
     */
    readonly id: string

    /**
     * [list of included related resources](https://jsonapi.org/format/#fetching-includes)
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryServicesId
     */
    readonly include?: string

    /**
     * [sparse fieldsets](https://jsonapi.org/format/#fetching-sparse-fieldsets). Use fields[\\&lt;typename\\&gt;]&#x3D;field1,field2,...,fieldN
     * @type {object}
     * @memberof InventoryApiRetrieveInventoryServicesId
     */
    readonly fields?: object

    /**
     * [list of fields to sort by](https://jsonapi.org/format/#fetching-sorting)
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryServicesId
     */
    readonly sort?: string

    /**
     * category
     * @type {'Food and Beverage' | 'Audiovisual' | 'Others'}
     * @memberof InventoryApiRetrieveInventoryServicesId
     */
    readonly filterCategory?: RetrieveInventoryServicesIdFilterCategoryEnum

    /**
     * service_type
     * @type {'audiovisual' | 'food-beverage' | 'other'}
     * @memberof InventoryApiRetrieveInventoryServicesId
     */
    readonly filterServiceType?: RetrieveInventoryServicesIdFilterServiceTypeEnum

    /**
     * hotel__short_uuid
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryServicesId
     */
    readonly filterHotelShortUuid?: string

    /**
     * hotel
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryServicesId
     */
    readonly filterHotel?: string

    /**
     * starts_at
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryServicesId
     */
    readonly filterStartsAt?: string

    /**
     * ends_at
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryServicesId
     */
    readonly filterEndsAt?: string

    /**
     * A search term.
     * @type {string}
     * @memberof InventoryApiRetrieveInventoryServicesId
     */
    readonly filterSearch?: string
}

/**
 * InventoryApi - object-oriented interface
 * @export
 * @class InventoryApi
 * @extends {BaseAPI}
 */
export class InventoryApi extends BaseAPI {
    /**
     * 
     * @param {InventoryApiListInventoryEventPackagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public listInventoryEventPackages(requestParameters: InventoryApiListInventoryEventPackagesRequest = {}, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).listInventoryEventPackages(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterHotel, requestParameters.filterAttendees, requestParameters.filterAvailable, requestParameters.filterStartDate, requestParameters.filterOrder, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InventoryApiListInventoryGuestRoomsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public listInventoryGuestRooms(requestParameters: InventoryApiListInventoryGuestRoomsRequest = {}, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).listInventoryGuestRooms(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterHotelShortUuid, requestParameters.filterHotel, requestParameters.filterDateBefore, requestParameters.filterDateAfter, requestParameters.filterOrder, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InventoryApiListInventoryHotelRoomSetupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public listInventoryHotelRoomSetups(requestParameters: InventoryApiListInventoryHotelRoomSetupsRequest = {}, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).listInventoryHotelRoomSetups(requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterHotelShortUuid, requestParameters.filterHotelSlug, requestParameters.filterHotel, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InventoryApiListInventoryHotelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public listInventoryHotels(requestParameters: InventoryApiListInventoryHotelsRequest = {}, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).listInventoryHotels(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterBrandNameIcontains, requestParameters.filterCityNameIcontains, requestParameters.filterCountryNameIcontains, requestParameters.filterBrandSlugIcontains, requestParameters.filterCitySlugIcontains, requestParameters.filterCountrySlugIcontains, requestParameters.filterHotelChainNameIcontains, requestParameters.filterHotelChainShortUuid, requestParameters.filterHotelChainSlug, requestParameters.filterRegionNameIcontains, requestParameters.filterBrand, requestParameters.filterCity, requestParameters.filterCountry, requestParameters.filterHotelChain, requestParameters.filterNameIcontains, requestParameters.filterHasPublicMeetingRooms, requestParameters.filterHasPublicGuestRooms, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InventoryApiListInventoryMeetingRoomsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public listInventoryMeetingRooms(requestParameters: InventoryApiListInventoryMeetingRoomsRequest = {}, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).listInventoryMeetingRooms(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterHotelShortUuid, requestParameters.filterHotelHotelChainSlug, requestParameters.filterMeetingRoomSetupsTypeType, requestParameters.filterHotel, requestParameters.filterAttendees, requestParameters.filterAvailable, requestParameters.filterDateBefore, requestParameters.filterDateAfter, requestParameters.filterCapacityGte, requestParameters.filterCapacityLte, requestParameters.filterDiagramming, requestParameters.filterOrder, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InventoryApiListInventoryServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public listInventoryServices(requestParameters: InventoryApiListInventoryServicesRequest = {}, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).listInventoryServices(requestParameters.include, requestParameters.fields, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.sort, requestParameters.filterCategory, requestParameters.filterServiceType, requestParameters.filterHotelShortUuid, requestParameters.filterHotel, requestParameters.filterStartsAt, requestParameters.filterEndsAt, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InventoryApiRetrieveInventoryEventPackagesIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public retrieveInventoryEventPackagesId(requestParameters: InventoryApiRetrieveInventoryEventPackagesIdRequest, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).retrieveInventoryEventPackagesId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterHotel, requestParameters.filterAttendees, requestParameters.filterAvailable, requestParameters.filterStartDate, requestParameters.filterOrder, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InventoryApiRetrieveInventoryGuestRoomsIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public retrieveInventoryGuestRoomsId(requestParameters: InventoryApiRetrieveInventoryGuestRoomsIdRequest, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).retrieveInventoryGuestRoomsId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterHotelShortUuid, requestParameters.filterHotel, requestParameters.filterDateBefore, requestParameters.filterDateAfter, requestParameters.filterOrder, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InventoryApiRetrieveInventoryHotelChainsSlugRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public retrieveInventoryHotelChainsSlug(requestParameters: InventoryApiRetrieveInventoryHotelChainsSlugRequest, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).retrieveInventoryHotelChainsSlug(requestParameters.slug, requestParameters.fields, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InventoryApiRetrieveInventoryHotelRoomSetupsIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public retrieveInventoryHotelRoomSetupsId(requestParameters: InventoryApiRetrieveInventoryHotelRoomSetupsIdRequest, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).retrieveInventoryHotelRoomSetupsId(requestParameters.id, requestParameters.fields, requestParameters.sort, requestParameters.filterHotelShortUuid, requestParameters.filterHotelSlug, requestParameters.filterHotel, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InventoryApiRetrieveInventoryHotelsIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public retrieveInventoryHotelsId(requestParameters: InventoryApiRetrieveInventoryHotelsIdRequest, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).retrieveInventoryHotelsId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterBrandNameIcontains, requestParameters.filterCityNameIcontains, requestParameters.filterCountryNameIcontains, requestParameters.filterBrandSlugIcontains, requestParameters.filterCitySlugIcontains, requestParameters.filterCountrySlugIcontains, requestParameters.filterHotelChainNameIcontains, requestParameters.filterHotelChainShortUuid, requestParameters.filterHotelChainSlug, requestParameters.filterRegionNameIcontains, requestParameters.filterBrand, requestParameters.filterCity, requestParameters.filterCountry, requestParameters.filterHotelChain, requestParameters.filterNameIcontains, requestParameters.filterHasPublicMeetingRooms, requestParameters.filterHasPublicGuestRooms, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InventoryApiRetrieveInventoryMeetingRoomsIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public retrieveInventoryMeetingRoomsId(requestParameters: InventoryApiRetrieveInventoryMeetingRoomsIdRequest, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).retrieveInventoryMeetingRoomsId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterHotelShortUuid, requestParameters.filterHotelHotelChainSlug, requestParameters.filterMeetingRoomSetupsTypeType, requestParameters.filterHotel, requestParameters.filterAttendees, requestParameters.filterAvailable, requestParameters.filterDateBefore, requestParameters.filterDateAfter, requestParameters.filterCapacityGte, requestParameters.filterCapacityLte, requestParameters.filterDiagramming, requestParameters.filterOrder, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InventoryApiRetrieveInventoryServicesIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    public retrieveInventoryServicesId(requestParameters: InventoryApiRetrieveInventoryServicesIdRequest, options?: RawAxiosRequestConfig) {
        return InventoryApiFp(this.configuration).retrieveInventoryServicesId(requestParameters.id, requestParameters.include, requestParameters.fields, requestParameters.sort, requestParameters.filterCategory, requestParameters.filterServiceType, requestParameters.filterHotelShortUuid, requestParameters.filterHotel, requestParameters.filterStartsAt, requestParameters.filterEndsAt, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListInventoryMeetingRoomsFilterMeetingRoomSetupsTypeTypeEnum = {
    Boardroom: 'boardroom',
    Cabaret: 'cabaret',
    Classroom: 'classroom',
    Cocktail: 'cocktail',
    Custom: 'custom',
    Round: 'round',
    Theater: 'theater',
    UShape: 'u-shape'
} as const;
export type ListInventoryMeetingRoomsFilterMeetingRoomSetupsTypeTypeEnum = typeof ListInventoryMeetingRoomsFilterMeetingRoomSetupsTypeTypeEnum[keyof typeof ListInventoryMeetingRoomsFilterMeetingRoomSetupsTypeTypeEnum];
/**
 * @export
 */
export const ListInventoryServicesFilterCategoryEnum = {
    FoodAndBeverage: 'Food and Beverage',
    Audiovisual: 'Audiovisual',
    Others: 'Others'
} as const;
export type ListInventoryServicesFilterCategoryEnum = typeof ListInventoryServicesFilterCategoryEnum[keyof typeof ListInventoryServicesFilterCategoryEnum];
/**
 * @export
 */
export const ListInventoryServicesFilterServiceTypeEnum = {
    Audiovisual: 'audiovisual',
    FoodBeverage: 'food-beverage',
    Other: 'other'
} as const;
export type ListInventoryServicesFilterServiceTypeEnum = typeof ListInventoryServicesFilterServiceTypeEnum[keyof typeof ListInventoryServicesFilterServiceTypeEnum];
/**
 * @export
 */
export const RetrieveInventoryMeetingRoomsIdFilterMeetingRoomSetupsTypeTypeEnum = {
    Boardroom: 'boardroom',
    Cabaret: 'cabaret',
    Classroom: 'classroom',
    Cocktail: 'cocktail',
    Custom: 'custom',
    Round: 'round',
    Theater: 'theater',
    UShape: 'u-shape'
} as const;
export type RetrieveInventoryMeetingRoomsIdFilterMeetingRoomSetupsTypeTypeEnum = typeof RetrieveInventoryMeetingRoomsIdFilterMeetingRoomSetupsTypeTypeEnum[keyof typeof RetrieveInventoryMeetingRoomsIdFilterMeetingRoomSetupsTypeTypeEnum];
/**
 * @export
 */
export const RetrieveInventoryServicesIdFilterCategoryEnum = {
    FoodAndBeverage: 'Food and Beverage',
    Audiovisual: 'Audiovisual',
    Others: 'Others'
} as const;
export type RetrieveInventoryServicesIdFilterCategoryEnum = typeof RetrieveInventoryServicesIdFilterCategoryEnum[keyof typeof RetrieveInventoryServicesIdFilterCategoryEnum];
/**
 * @export
 */
export const RetrieveInventoryServicesIdFilterServiceTypeEnum = {
    Audiovisual: 'audiovisual',
    FoodBeverage: 'food-beverage',
    Other: 'other'
} as const;
export type RetrieveInventoryServicesIdFilterServiceTypeEnum = typeof RetrieveInventoryServicesIdFilterServiceTypeEnum[keyof typeof RetrieveInventoryServicesIdFilterServiceTypeEnum];


